import React__default, { createElement, createContext, Fragment as Fragment$1, forwardRef, Component, PureComponent, useCallback, useState, useEffect, useRef, useContext, useImperativeHandle, useReducer, useMemo } from 'react';
import ReactDOM, { createPortal, findDOMNode } from 'react-dom';
import { Field, Formik, Form } from 'formik';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

var IconName;
(function (IconName) {
    IconName["AdAccounts"] = "ad-accounts";
    IconName["AndroidTv"] = "android-tv";
    IconName["Android"] = "android";
    IconName["Apps"] = "apps";
    IconName["Audience"] = "audience";
    IconName["BannerComputer"] = "banner-computer";
    IconName["BannerSearch"] = "banner-search";
    IconName["Checkmark"] = "checkmark";
    IconName["Clipboard"] = "clipboard";
    IconName["Cog"] = "cog";
    IconName["ControlCenter"] = "control-center";
    IconName["DataCanvas"] = "data-canvas";
    IconName["Datascape"] = "datascape";
    IconName["AdjustLogo"] = "adjust-logo";
    IconName["DeepLink"] = "deep-link";
    IconName["Docs"] = "docs";
    IconName["Download"] = "download";
    IconName["ErrorElephant"] = "error-elephant";
    IconName["FireTv"] = "fire-tv";
    IconName["Graph"] = "graph";
    IconName["InfoRound"] = "info-round";
    IconName["Ios"] = "ios";
    IconName["Lock"] = "lock";
    IconName["LogoBlack"] = "logo-black";
    IconName["LogoWhite"] = "logo-white";
    IconName["LogotypeWhite"] = "logotype-white";
    IconName["LogotypeBlack"] = "logotype-black";
    IconName["NewDashboardAnalytics"] = "new-dashboard-analytics";
    IconName["RokuTv"] = "roku-tv";
    IconName["SamsungTv"] = "samsung-tv";
    IconName["Search"] = "search";
    IconName["Settings"] = "settings";
    IconName["ShieldCheckmark"] = "shield-checkmark";
    IconName["ShieldEllipsis"] = "shield-ellipsis";
    IconName["ShieldError"] = "shield-error";
    IconName["SmartBanners"] = "smart-banners";
    IconName["StarFull"] = "star-full";
    IconName["Times"] = "times";
    IconName["TriangleTop"] = "triangle-top";
    IconName["Upload"] = "upload";
    IconName["Warning"] = "warning";
    IconName["Web"] = "web";
    IconName["WindowsPhone"] = "windows-phone";
    IconName["Windows"] = "windows";
})(IconName || (IconName = {}));

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _ref = /*#__PURE__*/createElement("defs", null, /*#__PURE__*/createElement("path", {
  id: "ad-accounts_svg__a",
  d: "M14.027 6.18a4.42 4.42 0 00.143-1.177c0-1.002-.243-1.754-.73-2.255s-1.232-.751-2.24-.751H8.788v5.167c-.27.187-.525.395-.762.62L5.978 1.998H4.385L2.117 8h1.377l.432-1.296h2.24L6.609 8h1.201c-.552.575-1 1.252-1.31 2H5.003L1 14.013V10H0V0h17v7.81a6.489 6.489 0 00-2.973-1.63zM12.515 6H12.5c-.793 0-1.552.142-2.254.401V3.122h.783c.546 0 .957.152 1.233.455.276.303.414.778.414 1.426 0 .397-.054.729-.161.997zm-6.708-.367H4.286l.756-2.268.765 2.268zm10.146 9.746a.237.237 0 01-.327.07l-.002-.001-.752-.488-.08.072c-.232.211-.49.39-.766.529l-.097.048.182.882a.238.238 0 01-.182.28l-.407.087-.635.137a.234.234 0 01-.278-.181l-.182-.881-.108-.006a3.368 3.368 0 01-.911-.167l-.102-.034-.496.758a.235.235 0 01-.326.07l-.888-.578a.236.236 0 01-.068-.326l.495-.757-.072-.08a3.35 3.35 0 01-.522-.763l-.048-.096-.882.19a.235.235 0 01-.279-.181l-.133-.645-.082-.396a.238.238 0 01.182-.28l.352-.076.53-.114.006-.108c.016-.308.075-.616.175-.912l.035-.103-.754-.49a.234.234 0 01-.067-.325l.583-.894a.237.237 0 01.326-.07l.754.49.08-.073c.232-.211.49-.39.767-.528l.097-.049-.183-.88a.238.238 0 01.183-.281l1.04-.224a.233.233 0 01.28.181l.182.881.108.005c.309.014.615.07.911.168l.102.034.495-.758a.237.237 0 01.326-.07l.889.577c.108.07.139.217.067.326l-.495.758.073.08c.208.23.384.487.522.763l.048.096.882-.19a.23.23 0 01.176.033.23.23 0 01.102.149l.216 1.04a.235.235 0 01-.183.28l-.882.19-.006.107a3.401 3.401 0 01-.175.913l-.034.102.754.49c.108.07.138.217.067.326l-.583.893zM13.6 12.263a1.115 1.115 0 00-1.33-.863c-.293.063-.546.238-.71.49a1.125 1.125 0 00-.049 1.154 1.12 1.12 0 001.847.174c.214-.257.315-.604.242-.955z"
}));

var _ref2 = /*#__PURE__*/createElement("use", {
  fill: "#FFF",
  xlinkHref: "#ad-accounts_svg__a",
  fillRule: "evenodd"
});

function SvgAdAccounts(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    viewBox: "0 0 17 17"
  }, props), _ref, _ref2);
}

function _extends$1() { _extends$1 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1.apply(this, arguments); }

var _ref$1 = /*#__PURE__*/createElement("path", {
  d: "M15.059 0h195.76c8.317 0 15.059 6.742 15.059 15.059v195.76c0 8.317-6.742 15.059-15.059 15.059H15.059C6.742 225.878 0 219.136 0 210.819V15.059C0 6.742 6.742 0 15.059 0zM301.18 0h195.76c8.317 0 15.059 6.742 15.059 15.059v195.76c0 8.317-6.742 15.059-15.059 15.059H301.18c-8.317 0-15.059-6.742-15.059-15.059V15.059C286.121 6.742 292.863 0 301.18 0zM15.059 286.12h195.76c8.317 0 15.059 6.742 15.059 15.059v195.76c0 8.317-6.742 15.059-15.059 15.059H15.059C6.742 511.998 0 505.256 0 496.939v-195.76c0-8.317 6.742-15.059 15.059-15.059zM301.18 286.12h195.76c8.317 0 15.059 6.742 15.059 15.059v195.76c0 8.317-6.742 15.059-15.059 15.059H301.18c-8.317 0-15.059-6.742-15.059-15.059v-195.76c0-8.317 6.742-15.059 15.059-15.059z"
});

function SvgApps(props) {
  return /*#__PURE__*/createElement("svg", _extends$1({
    viewBox: "0 0 512 512"
  }, props), _ref$1);
}

function _extends$2() { _extends$2 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2.apply(this, arguments); }

var _ref$2 = /*#__PURE__*/createElement("path", {
  d: "M22.45 0H2.55C1.42 0 .5.84.5 1.88v18.24c0 1.04.92 1.88 2.05 1.88h19.9c1.13 0 2.05-.84 2.05-1.88V1.88C24.5.84 23.58 0 22.45 0zM2.57 1h19.86c.6 0 1.07.44 1.07.97v18.06c0 .53-.48.97-1.07.97H2.57c-.6 0-1.07-.44-1.07-.97V1.97c0-.53.48-.97 1.07-.97zM8.5 23h10v1h-10z"
});

var _ref2$1 = /*#__PURE__*/createElement("path", {
  d: "M7.16 14.21c-.55 0-1-.5-1-1.11V8.75c0-.61.45-1.11 1-1.11s1 .5 1 1.11v4.35c0 .61-.45 1.11-1 1.11m4.14-8.6c.27 0 .49-.23.49-.53 0-.3-.22-.54-.5-.54-.26 0-.48.24-.48.54 0 .3.22.54.49.54m3.8 0c.27 0 .49-.24.49-.54 0-.3-.22-.54-.5-.54-.26 0-.48.24-.48.54 0 .3.22.54.49.54m-4.03-2.06l-.82-1.3c-.05-.08-.04-.19.03-.23.06-.05.15-.03.2.05l.85 1.36a4.62 4.62 0 013.68 0l.85-1.36c.04-.08.13-.1.2-.05.06.04.07.15.03.22l-.82 1.3a4.23 4.23 0 012.33 3.42H8.74a4.22 4.22 0 012.33-3.41m4.88 12.9v2.43c0 .61-.44 1.11-1 1.11-.54 0-.99-.5-.99-1.11v-2.42h-1.55v2.42c0 .61-.44 1.11-1 1.11-.54 0-.99-.5-.99-1.11v-2.42h-.89c-.43 0-.77-.38-.77-.86V7.67h8.86v7.94c0 .48-.35.86-.78.86h-.89zm3.22-2.25c-.55 0-1-.5-1-1.11V8.75c0-.61.45-1.11 1-1.11s1 .5 1 1.11v4.35c0 .61-.45 1.11-1 1.11"
});

function SvgAndroidTv(props) {
  return /*#__PURE__*/createElement("svg", _extends$2({
    viewBox: "0 0 25 24"
  }, props), _ref$2, _ref2$1);
}

function _extends$3() { _extends$3 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3.apply(this, arguments); }

var _ref$3 = /*#__PURE__*/createElement("path", {
  d: "M396.3 347.4a31 31 0 01-30.3-31.7V192.1a31 31 0 0130.3-31.6 31 31 0 0130.4 31.6v123.6a31 31 0 01-30.4 31.7zm-71 64.2h-27v68.8a31 31 0 01-30.4 31.6 31 31 0 01-30.4-31.6v-68.8h-47.2v68.8A31 31 0 01160 512a31 31 0 01-30.4-31.6v-68.8h-27a24 24 0 01-23.7-24.3V161.4h270v225.9a24 24 0 01-23.6 24.3zm-176-367.2l-25-37.2c-1.4-2.2-1-5.1 1-6.5 1.8-1.3 4.6-.7 6 1.5l26 38.6c17-6.9 36-10.7 56-10.7s39 3.8 56 10.7l26-38.6c1.4-2.2 4.2-2.8 6.1-1.5 2 1.4 2.3 4.3.9 6.5l-25 37.2c39.7 18.9 67.5 54.9 71 96.9h-270c3.6-42 31.4-78 71-97zm122.8 58.5c8.3 0 15-6.8 15-15.3s-6.7-15.3-15-15.3c-8.2 0-14.9 6.8-14.9 15.3s6.7 15.3 15 15.3zm-115.7 0c8.2 0 14.9-6.8 14.9-15.3s-6.7-15.3-15-15.3c-8.2 0-14.9 6.8-14.9 15.3s6.7 15.3 15 15.3zm-126 244.5A31 31 0 010 315.7V192.1a31 31 0 0130.3-31.6A31 31 0 0160.7 192v123.6a31 31 0 01-30.4 31.7z"
});

function SvgAndroid(props) {
  return /*#__PURE__*/createElement("svg", _extends$3({
    viewBox: "0 0 427 512"
  }, props), _ref$3);
}

function _extends$4() { _extends$4 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4.apply(this, arguments); }

var _ref$4 = /*#__PURE__*/createElement("path", {
  d: "M261.74 335.11c-16.075 5.923-29.779 14.916-41.002 26.352l-.017 150.54h181.17v-150.4c-11.296-11.527-25.087-20.565-40.501-26.245 20.569-15.774 34.275-40.659 34.275-68.745 0-46.656-37.822-84.479-84.479-84.479s-84.479 37.822-84.479 84.479c0 28.087 13.707 52.971 34.795 68.332zM482.46 335.11c-16.075 5.923-29.779 14.916-41.002 26.352l-.017 150.54h181.16v-150.4c-11.297-11.527-25.087-20.565-40.501-26.245 20.569-15.774 34.275-40.659 34.275-68.745 0-46.656-37.822-84.479-84.479-84.479s-84.479 37.822-84.479 84.479c0 28.087 13.707 52.971 34.795 68.332zM41.141 335.11c-16.075 5.923-29.779 14.916-41.002 26.352l-.017 150.54h181.17v-150.4c-11.297-11.527-25.087-20.565-40.501-26.245 20.569-15.774 34.275-40.659 34.275-68.745 0-46.656-37.822-84.479-84.479-84.479S6.108 219.955 6.108 266.612c0 28.087 13.706 52.971 34.795 68.332zM399.08 179.82a122.382 122.382 0 0125.692 36.831c17.322-36.953 52.017-64.038 93.535-70.081l.654-27.79a72.462 72.462 0 00-26.723-17.416c13.62-10.439 22.694-26.912 22.694-45.503 0-30.88-25.033-55.913-55.913-55.913s-55.913 25.033-55.913 55.913c0 18.591 9.074 35.064 23.035 45.23-10.518 4.052-19.616 10.047-27.048 17.675zM254.17 161.51c17.215-10.017 37.887-15.93 59.941-15.93s42.726 5.913 60.519 16.24l-.579-43.037a72.462 72.462 0 00-26.723-17.416c13.62-10.439 22.694-26.912 22.694-45.503 0-30.88-25.033-55.913-55.913-55.913s-55.913 25.033-55.913 55.913c0 18.591 9.074 35.064 23.035 45.23-10.518 4.052-19.616 10.047-27.048 17.675zM109.26 147.11c42.28 6.016 77.089 33.131 93.815 70.165 6.833-13.692 15.498-26.031 26.054-36.459l.012-62.029a72.466 72.466 0 00-26.722-17.416c13.62-10.439 22.694-26.912 22.694-45.503 0-30.88-25.033-55.913-55.912-55.913s-55.912 25.033-55.912 55.913c0 18.591 9.074 35.064 23.035 45.23-10.518 4.052-19.616 10.047-27.049 17.675z"
});

function SvgAudience(props) {
  return /*#__PURE__*/createElement("svg", _extends$4({
    viewBox: "0 0 623 512"
  }, props), _ref$4);
}

function _extends$5() { _extends$5 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5.apply(this, arguments); }

var _ref$5 = /*#__PURE__*/createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/createElement("path", {
  d: "M0 0h80v70H0z"
}), /*#__PURE__*/createElement("path", {
  d: "M12.73 14.66c.89 0 1.33-.71 1.33-2.14 0-.68-.11-1.21-.33-1.58a1.1 1.1 0 00-1-.55c-.87 0-1.31.71-1.31 2.13 0 .7.1 1.22.33 1.59.22.36.55.55.98.55zm0-.44c-.27 0-.47-.13-.6-.4s-.19-.7-.19-1.3c0-.6.06-1.02.2-1.29s.32-.4.6-.4c.27 0 .47.14.6.4.13.27.2.7.2 1.3 0 .6-.07 1.02-.2 1.29s-.33.4-.6.4zm4.08.38v-4.14h-.43l-1.08.85.27.35.42-.35c.15-.13.27-.24.34-.32l-.02 1.02v2.59h.5zm3.24.06c.89 0 1.33-.71 1.33-2.14 0-.68-.11-1.21-.33-1.58a1.1 1.1 0 00-1-.55c-.87 0-1.31.71-1.31 2.13 0 .7.1 1.22.33 1.59.22.36.55.55.98.55zm0-.44c-.27 0-.47-.13-.6-.4s-.19-.7-.19-1.3c0-.6.06-1.02.2-1.29s.32-.4.6-.4c.27 0 .48.14.6.4.14.27.2.7.2 1.3 0 .6-.06 1.02-.2 1.29-.12.27-.33.4-.6.4zm4.08.38v-4.14h-.43l-1.08.85.27.35.42-.35c.15-.13.27-.24.34-.32l-.02 1.02v2.59h.5zm3.66 0v-4.14h-.43l-1.08.85.27.35.42-.35c.16-.13.27-.24.34-.32l-.02 1.02v2.59h.5zm3.66 0v-4.14h-.43l-1.08.85.27.35.42-.35c.16-.13.27-.24.34-.32l-.02 1.02v2.59h.5zm3.66 0v-4.14h-.42l-1.09.85.28.35.41-.35c.16-.13.27-.24.34-.32l-.02 1.02v2.59h.5zm3.25.06c.88 0 1.33-.71 1.33-2.14 0-.68-.12-1.21-.34-1.58a1.1 1.1 0 00-1-.55c-.87 0-1.31.71-1.31 2.13 0 .7.11 1.22.33 1.59.23.36.55.55.99.55zm0-.44c-.28 0-.48-.13-.6-.4s-.2-.7-.2-1.3c0-.6.07-1.02.2-1.29s.32-.4.6-.4c.27 0 .48.14.6.4.14.27.2.7.2 1.3 0 .6-.06 1.02-.2 1.29-.12.27-.33.4-.6.4zm4.07.38v-4.14h-.42l-1.09.85.28.35.41-.35c.16-.13.27-.24.35-.32l-.03 1.02v2.59h.5zm3.66 0v-4.14h-.42l-1.09.85.28.35.41-.35c.16-.13.27-.24.35-.32l-.03 1.02v2.59h.5zm3.25.06c.88 0 1.33-.71 1.33-2.14 0-.68-.11-1.21-.34-1.58a1.1 1.1 0 00-1-.55c-.87 0-1.3.71-1.3 2.13 0 .7.1 1.22.33 1.59.22.36.55.55.98.55zm0-.44c-.28 0-.48-.13-.6-.4a3.2 3.2 0 01-.2-1.3c0-.6.07-1.02.2-1.29.12-.26.32-.4.6-.4.28 0 .48.14.61.4.13.27.2.7.2 1.3 0 .6-.07 1.02-.2 1.29s-.33.4-.61.4zm3.66.44c.88 0 1.33-.71 1.33-2.14 0-.68-.11-1.21-.34-1.58a1.1 1.1 0 00-1-.55c-.87 0-1.3.71-1.3 2.13 0 .7.1 1.22.33 1.59.22.36.55.55.98.55zm0-.44c-.27 0-.48-.13-.6-.4a3.2 3.2 0 01-.2-1.3c0-.6.07-1.02.2-1.29.12-.26.33-.4.6-.4.28 0 .48.14.61.4.13.27.2.7.2 1.3 0 .6-.07 1.02-.2 1.29s-.33.4-.61.4zm3.66.44c.89 0 1.33-.71 1.33-2.14 0-.68-.11-1.21-.34-1.58a1.1 1.1 0 00-.99-.55c-.88 0-1.32.71-1.32 2.13 0 .7.11 1.22.34 1.59.22.36.55.55.98.55zm0-.44c-.27 0-.47-.13-.6-.4s-.2-.7-.2-1.3c0-.6.07-1.02.2-1.29s.33-.4.6-.4c.28 0 .48.14.61.4.13.27.2.7.2 1.3 0 .6-.07 1.02-.2 1.29s-.33.4-.61.4zm4.07.38v-4.14h-.42l-1.09.85.28.35.42-.35.34-.32c-.02.45-.02.8-.02 1.02v2.59h.5zm3.25.06c.89 0 1.33-.71 1.33-2.14 0-.68-.11-1.21-.34-1.58a1.1 1.1 0 00-.99-.55c-.88 0-1.32.71-1.32 2.13 0 .7.12 1.22.34 1.59.22.36.55.55.98.55zm0-.44c-.27 0-.47-.13-.6-.4s-.2-.7-.2-1.3c0-.6.07-1.02.2-1.29s.33-.4.6-.4c.28 0 .48.14.61.4.13.27.2.7.2 1.3 0 .6-.07 1.02-.2 1.29s-.33.4-.6.4zm3.66.44c.89 0 1.33-.71 1.33-2.14 0-.68-.11-1.21-.34-1.58a1.1 1.1 0 00-.99-.55c-.88 0-1.32.71-1.32 2.13 0 .7.12 1.22.34 1.59.22.36.55.55.98.55zm0-.44c-.27 0-.47-.13-.6-.4s-.2-.7-.2-1.3c0-.6.07-1.02.2-1.29s.33-.4.6-.4c.28 0 .48.14.61.4.13.27.2.7.2 1.3 0 .6-.07 1.02-.2 1.29s-.33.4-.6.4zm-54.9 6.04c.88 0 1.32-.71 1.32-2.14 0-.68-.11-1.21-.33-1.58a1.1 1.1 0 00-1-.55c-.87 0-1.31.71-1.31 2.13 0 .7.1 1.22.33 1.59.22.36.55.55.98.55zm0-.44c-.28 0-.48-.13-.6-.4s-.2-.7-.2-1.3c0-.6.06-1.02.2-1.29s.32-.4.6-.4c.27 0 .48.14.6.4.14.27.2.7.2 1.3 0 .6-.06 1.02-.2 1.29-.12.27-.33.4-.6.4zm4.07.38v-4.14h-.43l-1.08.85.27.35.42-.35c.15-.13.27-.24.34-.32l-.02 1.02v2.59h.5zm3.66 0v-4.14h-.43l-1.08.85.27.35.42-.35c.15-.13.27-.24.34-.32l-.02 1.02v2.59h.5zm3.25.06c.88 0 1.32-.71 1.32-2.14 0-.68-.1-1.21-.33-1.58a1.1 1.1 0 00-1-.55c-.87 0-1.31.71-1.31 2.13 0 .7.11 1.22.33 1.59.23.36.55.55.99.55zm0-.44c-.28 0-.48-.13-.6-.4s-.2-.7-.2-1.3c0-.6.07-1.02.2-1.29s.32-.4.6-.4c.27 0 .48.14.6.4.14.27.2.7.2 1.3 0 .6-.06 1.02-.2 1.29s-.33.4-.6.4zm3.66.44c.88 0 1.32-.71 1.32-2.14 0-.68-.1-1.21-.33-1.58a1.1 1.1 0 00-1-.55c-.87 0-1.31.71-1.31 2.13 0 .7.11 1.22.33 1.59.23.36.55.55.99.55zm0-.44c-.28 0-.48-.13-.6-.4s-.2-.7-.2-1.3c0-.6.07-1.02.2-1.29s.32-.4.6-.4c.27 0 .48.14.6.4.14.27.2.7.2 1.3 0 .6-.06 1.02-.2 1.29s-.33.4-.6.4zm4.07.38v-4.14h-.42l-1.09.85.28.35.41-.35c.16-.13.27-.24.34-.32l-.02 1.02v2.59h.5zm3.66 0v-4.14h-.42l-1.09.85.28.35.41-.35c.16-.13.27-.24.34-.32l-.02 1.02v2.59h.5zm3.25.06c.88 0 1.33-.71 1.33-2.14 0-.68-.12-1.21-.34-1.58a1.1 1.1 0 00-1-.55c-.87 0-1.3.71-1.3 2.13 0 .7.1 1.22.32 1.59.23.36.56.55.99.55zm0-.44c-.28 0-.48-.13-.6-.4s-.2-.7-.2-1.3c0-.6.07-1.02.2-1.29s.32-.4.6-.4c.28 0 .48.14.6.4.14.27.2.7.2 1.3 0 .6-.06 1.02-.2 1.29-.12.27-.32.4-.6.4zm3.66.44c.88 0 1.33-.71 1.33-2.14 0-.68-.12-1.21-.34-1.58a1.1 1.1 0 00-1-.55c-.87 0-1.3.71-1.3 2.13 0 .7.1 1.22.33 1.59.22.36.55.55.98.55zm0-.44c-.28 0-.48-.13-.6-.4s-.2-.7-.2-1.3c0-.6.07-1.02.2-1.29s.32-.4.6-.4c.28 0 .48.14.61.4.13.27.2.7.2 1.3 0 .6-.07 1.02-.2 1.29s-.33.4-.61.4zm3.66.44c.88 0 1.33-.71 1.33-2.14 0-.68-.11-1.21-.34-1.58a1.1 1.1 0 00-1-.55c-.87 0-1.3.71-1.3 2.13 0 .7.1 1.22.33 1.59.22.36.55.55.98.55zm0-.44c-.27 0-.48-.13-.6-.4s-.2-.7-.2-1.3c0-.6.07-1.02.2-1.29s.33-.4.6-.4c.28 0 .48.14.61.4.13.27.2.7.2 1.3 0 .6-.07 1.02-.2 1.29s-.33.4-.61.4zm4.07.38v-4.14h-.42l-1.09.85.28.35.41-.35c.16-.13.27-.24.35-.32l-.03 1.02v2.59h.5zm3.66 0v-4.14H53l-1.09.85.28.35.41-.35c.16-.13.27-.24.35-.32l-.03 1.02v2.59h.5zm3.25.06c.89 0 1.33-.71 1.33-2.14 0-.68-.11-1.21-.34-1.58a1.1 1.1 0 00-.99-.55c-.88 0-1.32.71-1.32 2.13 0 .7.11 1.22.34 1.59.22.36.55.55.98.55zm0-.44c-.27 0-.47-.13-.6-.4s-.2-.7-.2-1.3c0-.6.07-1.02.2-1.29s.33-.4.6-.4c.28 0 .48.14.61.4.13.27.2.7.2 1.3 0 .6-.07 1.02-.2 1.29s-.33.4-.6.4zm4.07.38v-4.14h-.42l-1.08.85.27.35.42-.35c.15-.13.27-.24.34-.32-.02.45-.02.8-.02 1.02v2.59h.5zm3.25.06c.89 0 1.33-.71 1.33-2.14 0-.68-.11-1.21-.34-1.58a1.1 1.1 0 00-.99-.55c-.88 0-1.32.71-1.32 2.13 0 .7.12 1.22.34 1.59.22.36.55.55.98.55zm0-.44c-.27 0-.47-.13-.6-.4s-.2-.7-.2-1.3c0-.6.07-1.02.2-1.29s.33-.4.6-.4c.28 0 .48.14.61.4.13.27.2.7.2 1.3 0 .6-.07 1.02-.2 1.29s-.33.4-.6.4zm3.66.44c.89 0 1.33-.71 1.33-2.14 0-.68-.11-1.21-.34-1.58a1.1 1.1 0 00-.99-.55c-.88 0-1.31.71-1.31 2.13 0 .7.1 1.22.33 1.59.22.36.55.55.98.55zm0-.44c-.27 0-.47-.13-.6-.4s-.2-.7-.2-1.3c0-.6.07-1.02.2-1.29s.33-.4.6-.4c.28 0 .48.14.61.4.13.27.2.7.2 1.3 0 .6-.07 1.02-.2 1.29s-.33.4-.6.4zm-54.9 6.04c.88 0 1.32-.71 1.32-2.14 0-.68-.1-1.21-.33-1.58a1.1 1.1 0 00-1-.55c-.87 0-1.31.71-1.31 2.13 0 .7.1 1.22.33 1.59.22.36.55.55.98.55zm0-.44c-.28 0-.48-.13-.6-.4s-.2-.7-.2-1.3c0-.6.06-1.02.2-1.29s.32-.4.6-.4c.27 0 .48.14.6.4.14.27.2.7.2 1.3 0 .6-.06 1.02-.2 1.29-.12.27-.33.4-.6.4zm4.07.38v-4.14h-.43l-1.08.85.27.35.42-.35c.15-.13.27-.24.34-.32l-.02 1.02v2.59h.5zm3.66 0v-4.14h-.43l-1.08.85.27.35.42-.35c.16-.13.27-.24.34-.32l-.02 1.02v2.59h.5zm3.25.06c.88 0 1.32-.71 1.32-2.14 0-.68-.1-1.21-.33-1.58a1.1 1.1 0 00-1-.55c-.87 0-1.31.71-1.31 2.13 0 .7.11 1.22.33 1.59.23.36.55.55.99.55zm0-.44c-.28 0-.48-.13-.6-.4s-.2-.7-.2-1.3c0-.6.07-1.02.2-1.29s.32-.4.6-.4c.27 0 .48.14.6.4.14.27.2.7.2 1.3 0 .6-.06 1.02-.2 1.29s-.33.4-.6.4zm4.07.38v-4.14h-.42l-1.09.85.28.35.41-.35c.16-.13.27-.24.34-.32l-.02 1.02v2.59h.5zm3.25.06c.88 0 1.33-.71 1.33-2.14 0-.68-.12-1.21-.34-1.58a1.1 1.1 0 00-1-.55c-.87 0-1.31.71-1.31 2.13 0 .7.11 1.22.33 1.59.23.36.55.55.99.55zm0-.44c-.28 0-.48-.13-.6-.4s-.2-.7-.2-1.3c0-.6.07-1.02.2-1.29s.32-.4.6-.4c.27 0 .48.14.6.4.14.27.2.7.2 1.3 0 .6-.06 1.02-.2 1.29s-.33.4-.6.4zm4.07.38v-4.14h-.42l-1.09.85.28.35.41-.35c.16-.13.27-.24.35-.32l-.03 1.02v2.59h.5zm3.25.06c.88 0 1.33-.71 1.33-2.14 0-.68-.12-1.21-.34-1.58a1.1 1.1 0 00-1-.55c-.87 0-1.3.71-1.3 2.13 0 .7.1 1.22.33 1.59.22.36.55.55.98.55zm0-.44c-.28 0-.48-.13-.6-.4s-.2-.7-.2-1.3c0-.6.07-1.02.2-1.29s.32-.4.6-.4c.28 0 .48.14.61.4.13.27.2.7.2 1.3 0 .6-.07 1.02-.2 1.29s-.33.4-.61.4zm4.07.38v-4.14h-.42l-1.09.85.28.35.41-.35c.16-.13.27-.24.35-.32l-.03 1.02v2.59h.5zm3.25.06c.88 0 1.33-.71 1.33-2.14 0-.68-.11-1.21-.34-1.58a1.1 1.1 0 00-1-.55c-.87 0-1.3.71-1.3 2.13 0 .7.1 1.22.33 1.59.22.36.55.55.98.55zm0-.44c-.27 0-.48-.13-.6-.4s-.2-.7-.2-1.3c0-.6.07-1.02.2-1.29s.33-.4.6-.4c.28 0 .48.14.61.4.13.27.2.7.2 1.3 0 .6-.07 1.02-.2 1.29s-.33.4-.61.4zm3.66.44c.89 0 1.33-.71 1.33-2.14 0-.68-.11-1.21-.34-1.58a1.1 1.1 0 00-.99-.55c-.88 0-1.32.71-1.32 2.13 0 .7.11 1.22.34 1.59.22.36.55.55.98.55zm0-.44c-.27 0-.47-.13-.6-.4a3.2 3.2 0 01-.2-1.3c0-.6.07-1.02.2-1.29.13-.26.33-.4.6-.4.28 0 .48.14.61.4.13.27.2.7.2 1.3 0 .6-.07 1.02-.2 1.29s-.33.4-.61.4zm4.07.38v-4.14H53l-1.09.85.28.35.42-.35.34-.32c-.02.45-.02.8-.02 1.02v2.59h.5zm3.66 0v-4.14h-.42l-1.09.85.28.35.42-.35.34-.32c-.02.45-.02.8-.02 1.02v2.59h.5zm3.25.06c.89 0 1.33-.71 1.33-2.14 0-.68-.11-1.21-.34-1.58a1.1 1.1 0 00-.99-.55c-.88 0-1.32.71-1.32 2.13 0 .7.12 1.22.34 1.59.22.36.55.55.98.55zm0-.44c-.27 0-.47-.13-.6-.4s-.2-.7-.2-1.3c0-.6.07-1.02.2-1.29s.33-.4.6-.4c.28 0 .48.14.61.4.13.27.2.7.2 1.3 0 .6-.07 1.02-.2 1.29s-.33.4-.6.4zm3.66.44c.89 0 1.33-.71 1.33-2.14 0-.68-.11-1.21-.34-1.58a1.1 1.1 0 00-.99-.55c-.88 0-1.31.71-1.31 2.13 0 .7.1 1.22.33 1.59.22.36.55.55.98.55zm0-.44c-.27 0-.47-.13-.6-.4s-.2-.7-.2-1.3c0-.6.07-1.02.2-1.29s.33-.4.6-.4c.28 0 .48.14.61.4.13.27.2.7.2 1.3 0 .6-.07 1.02-.2 1.29s-.33.4-.6.4zm3.66.44c.89 0 1.33-.71 1.33-2.14 0-.68-.11-1.21-.33-1.58a1.1 1.1 0 00-1-.55c-.88 0-1.31.71-1.31 2.13 0 .7.1 1.22.33 1.59.22.36.55.55.98.55zm0-.44c-.27 0-.47-.13-.6-.4s-.19-.7-.19-1.3c0-.6.06-1.02.2-1.29s.32-.4.6-.4c.27 0 .47.14.6.4.13.27.2.7.2 1.3 0 .6-.07 1.02-.2 1.29s-.33.4-.6.4zm-54.5 5.98v-4.14h-.42l-1.08.85.27.35.42-.35c.15-.13.27-.24.34-.32l-.02 1.02v2.59h.5zm3.67 0v-4.14h-.43l-1.08.85.27.35.42-.35c.15-.13.27-.24.34-.32l-.02 1.02v2.59h.5zm3.66 0v-4.14h-.43l-1.08.85.27.35.42-.35c.16-.13.27-.24.34-.32l-.02 1.02v2.59h.5zm3.25.06c.88 0 1.32-.71 1.32-2.14 0-.68-.1-1.21-.33-1.58a1.1 1.1 0 00-1-.55c-.87 0-1.31.71-1.31 2.13 0 .7.11 1.22.33 1.59.23.36.55.55.99.55zm0-.44c-.28 0-.48-.13-.6-.4s-.2-.7-.2-1.3c0-.6.07-1.02.2-1.29s.32-.4.6-.4c.27 0 .48.14.6.4.14.27.2.7.2 1.3 0 .6-.06 1.02-.2 1.29s-.33.4-.6.4zm4.07.38v-4.14h-.42l-1.09.85.28.35.41-.35c.16-.13.27-.24.34-.32l-.02 1.02v2.59h.5zm3.25.06c.88 0 1.33-.71 1.33-2.14 0-.68-.12-1.21-.34-1.58a1.1 1.1 0 00-1-.55c-.87 0-1.31.71-1.31 2.13 0 .7.11 1.22.33 1.59.23.36.55.55.99.55zm0-.44c-.28 0-.48-.13-.6-.4s-.2-.7-.2-1.3c0-.6.07-1.02.2-1.29s.32-.4.6-.4c.27 0 .48.14.6.4.14.27.2.7.2 1.3 0 .6-.06 1.02-.2 1.29s-.33.4-.6.4zm3.66.44c.88 0 1.33-.71 1.33-2.14 0-.68-.12-1.21-.34-1.58a1.1 1.1 0 00-1-.55c-.87 0-1.3.71-1.3 2.13 0 .7.1 1.22.32 1.59.23.36.56.55.99.55zm0-.44c-.28 0-.48-.13-.6-.4s-.2-.7-.2-1.3c0-.6.07-1.02.2-1.29s.32-.4.6-.4c.28 0 .48.14.6.4.14.27.2.7.2 1.3 0 .6-.06 1.02-.2 1.29s-.32.4-.6.4zm4.07.38v-4.14h-.42l-1.09.85.28.35.41-.35c.16-.13.27-.24.35-.32l-.03 1.02v2.59h.5zm3.66 0v-4.14h-.42l-1.09.85.28.35.41-.35c.16-.13.27-.24.35-.32l-.03 1.02v2.59h.5zm3.25.06c.88 0 1.33-.71 1.33-2.14 0-.68-.11-1.21-.34-1.58a1.1 1.1 0 00-1-.55c-.87 0-1.3.71-1.3 2.13 0 .7.1 1.22.33 1.59.22.36.55.55.98.55zm0-.44c-.27 0-.47-.13-.6-.4s-.2-.7-.2-1.3c0-.6.07-1.02.2-1.29s.33-.4.6-.4c.28 0 .48.14.61.4.13.27.2.7.2 1.3 0 .6-.07 1.02-.2 1.29s-.33.4-.61.4zm3.66.44c.89 0 1.33-.71 1.33-2.14 0-.68-.11-1.21-.34-1.58a1.1 1.1 0 00-.99-.55c-.88 0-1.32.71-1.32 2.13 0 .7.11 1.22.34 1.59.22.36.55.55.98.55zm0-.44c-.27 0-.47-.13-.6-.4a3.2 3.2 0 01-.2-1.3c0-.6.07-1.02.2-1.29.13-.26.33-.4.6-.4.28 0 .48.14.61.4.13.27.2.7.2 1.3 0 .6-.07 1.02-.2 1.29s-.33.4-.61.4zm4.07.38v-4.14H53l-1.09.85.28.35.42-.35.34-.32c-.02.45-.02.8-.02 1.02v2.59h.5zm3.66 0v-4.14h-.42l-1.08.85.27.35.42-.35c.15-.13.27-.24.34-.32-.02.45-.02.8-.02 1.02v2.59h.5zm3.67 0v-4.14h-.43l-1.08.85.27.35.42-.35c.15-.13.27-.24.34-.32-.02.45-.02.8-.02 1.02v2.59h.5zm3.66 0v-4.14h-.43l-1.08.85.27.35.42-.35c.15-.13.27-.24.34-.32-.02.45-.02.8-.02 1.02v2.59h.5zm3.24.06c.89 0 1.33-.71 1.33-2.14 0-.68-.11-1.21-.33-1.58a1.1 1.1 0 00-1-.55c-.88 0-1.31.71-1.31 2.13 0 .7.1 1.22.33 1.59.22.36.55.55.98.55zm0-.44c-.27 0-.47-.13-.6-.4s-.19-.7-.19-1.3c0-.6.06-1.02.2-1.29s.32-.4.6-.4c.27 0 .47.14.6.4.13.27.2.7.2 1.3 0 .6-.07 1.02-.2 1.29s-.33.4-.6.4zM13.14 37v-4.14h-.42l-1.08.85.27.35.42-.35c.15-.13.27-.24.34-.32l-.02 1.02V37h.5zm3.26.06c.88 0 1.32-.71 1.32-2.14 0-.68-.1-1.21-.33-1.58a1.1 1.1 0 00-1-.55c-.87 0-1.31.71-1.31 2.13 0 .7.1 1.22.33 1.59.23.36.55.55.98.55zm0-.44c-.28 0-.48-.13-.6-.4s-.2-.7-.2-1.3c0-.6.07-1.02.2-1.29s.32-.4.6-.4c.27 0 .48.14.6.4.14.27.2.7.2 1.3 0 .6-.06 1.02-.2 1.29-.12.27-.33.4-.6.4zm4.07.38v-4.14h-.43l-1.08.85.27.35.42-.35c.16-.13.27-.24.34-.32l-.02 1.02V37h.5zm3.25.06c.88 0 1.32-.71 1.32-2.14 0-.68-.1-1.21-.33-1.58a1.1 1.1 0 00-1-.55c-.87 0-1.31.71-1.31 2.13 0 .7.11 1.22.33 1.59.23.36.55.55.99.55zm0-.44c-.28 0-.48-.13-.6-.4s-.2-.7-.2-1.3c0-.6.07-1.02.2-1.29s.32-.4.6-.4c.27 0 .48.14.6.4.14.27.2.7.2 1.3 0 .6-.06 1.02-.2 1.29s-.33.4-.6.4zm4.07.38v-4.14h-.42l-1.09.85.28.35.41-.35c.16-.13.27-.24.34-.32l-.02 1.02V37h.5zm3.25.06c.88 0 1.33-.71 1.33-2.14 0-.68-.12-1.21-.34-1.58a1.1 1.1 0 00-1-.55c-.87 0-1.31.71-1.31 2.13 0 .7.11 1.22.33 1.59.23.36.55.55.99.55zm0-.44c-.28 0-.48-.13-.6-.4s-.2-.7-.2-1.3c0-.6.07-1.02.2-1.29s.32-.4.6-.4c.27 0 .48.14.6.4.14.27.2.7.2 1.3 0 .6-.06 1.02-.2 1.29s-.33.4-.6.4zm4.07.38v-4.14h-.42l-1.09.85.28.35.41-.35c.16-.13.27-.24.35-.32l-.03 1.02V37h.5zm3.25.06c.88 0 1.33-.71 1.33-2.14 0-.68-.12-1.21-.34-1.58a1.1 1.1 0 00-1-.55c-.87 0-1.3.71-1.3 2.13 0 .7.1 1.22.33 1.59.22.36.55.55.98.55zm0-.44c-.28 0-.48-.13-.6-.4s-.2-.7-.2-1.3c0-.6.07-1.02.2-1.29s.32-.4.6-.4c.28 0 .48.14.61.4.13.27.2.7.2 1.3 0 .6-.07 1.02-.2 1.29s-.33.4-.61.4zm3.66.44c.88 0 1.33-.71 1.33-2.14 0-.68-.11-1.21-.34-1.58a1.1 1.1 0 00-1-.55c-.87 0-1.3.71-1.3 2.13 0 .7.1 1.22.33 1.59.22.36.55.55.98.55zm0-.44c-.27 0-.48-.13-.6-.4s-.2-.7-.2-1.3c0-.6.07-1.02.2-1.29s.33-.4.6-.4c.28 0 .48.14.61.4.13.27.2.7.2 1.3 0 .6-.07 1.02-.2 1.29s-.33.4-.61.4zm3.66.44c.88 0 1.33-.71 1.33-2.14 0-.68-.11-1.21-.34-1.58a1.1 1.1 0 00-1-.55c-.87 0-1.3.71-1.3 2.13 0 .7.1 1.22.33 1.59.22.36.55.55.98.55zm0-.44c-.27 0-.47-.13-.6-.4s-.2-.7-.2-1.3c0-.6.07-1.02.2-1.29s.33-.4.6-.4c.28 0 .48.14.61.4.13.27.2.7.2 1.3 0 .6-.07 1.02-.2 1.29s-.33.4-.61.4zm4.07.38v-4.14h-.42l-1.09.85.28.35.42-.35.34-.32c-.02.45-.02.8-.02 1.02V37h.5zm3.25.06c.89 0 1.33-.71 1.33-2.14 0-.68-.11-1.21-.34-1.58a1.1 1.1 0 00-.99-.55c-.88 0-1.32.71-1.32 2.13 0 .7.12 1.22.34 1.59.22.36.55.55.98.55zm0-.44c-.27 0-.47-.13-.6-.4a3.2 3.2 0 01-.2-1.3c0-.6.07-1.02.2-1.29.13-.26.33-.4.6-.4.28 0 .48.14.61.4.13.27.2.7.2 1.3 0 .6-.07 1.02-.2 1.29s-.33.4-.6.4zm4.07.38v-4.14h-.42l-1.08.85.27.35.42-.35c.15-.13.27-.24.34-.32-.02.45-.02.8-.02 1.02V37h.5zm3.25.06c.89 0 1.33-.71 1.33-2.14 0-.68-.11-1.21-.34-1.58a1.1 1.1 0 00-.99-.55c-.88 0-1.32.71-1.32 2.13 0 .7.12 1.22.34 1.59.22.36.55.55.98.55zm0-.44c-.27 0-.47-.13-.6-.4s-.2-.7-.2-1.3c0-.6.07-1.02.2-1.29s.33-.4.6-.4c.28 0 .48.14.61.4.13.27.2.7.2 1.3 0 .6-.07 1.02-.2 1.29s-.33.4-.6.4zm4.08.38v-4.14h-.43l-1.08.85.27.35.42-.35c.15-.13.27-.24.34-.32-.02.45-.02.8-.02 1.02V37h.5zm3.24.06c.89 0 1.33-.71 1.33-2.14 0-.68-.11-1.21-.33-1.58a1.1 1.1 0 00-1-.55c-.88 0-1.31.71-1.31 2.13 0 .7.1 1.22.33 1.59.22.36.55.55.98.55zm0-.44c-.27 0-.47-.13-.6-.4s-.19-.7-.19-1.3c0-.6.06-1.02.2-1.29s.32-.4.6-.4c.27 0 .47.14.6.4.13.27.2.7.2 1.3 0 .6-.07 1.02-.2 1.29s-.33.4-.6.4zm-54.9 6.04c.88 0 1.32-.71 1.32-2.14 0-.68-.1-1.21-.33-1.58a1.1 1.1 0 00-1-.55c-.87 0-1.31.71-1.31 2.13 0 .7.1 1.22.33 1.59.22.36.55.55.98.55zm0-.44c-.28 0-.48-.13-.6-.4s-.2-.7-.2-1.3c0-.6.07-1.02.2-1.29s.32-.4.6-.4c.27 0 .48.14.6.4.14.27.2.7.2 1.3 0 .6-.06 1.02-.2 1.29-.12.27-.33.4-.6.4zm3.66.44c.88 0 1.32-.71 1.32-2.14 0-.68-.1-1.21-.33-1.58a1.1 1.1 0 00-1-.55c-.87 0-1.31.71-1.31 2.13 0 .7.11 1.22.33 1.59.23.36.55.55.99.55zm0-.44c-.28 0-.48-.13-.6-.4s-.2-.7-.2-1.3c0-.6.07-1.02.2-1.29s.32-.4.6-.4c.27 0 .48.14.6.4.14.27.2.7.2 1.3 0 .6-.06 1.02-.2 1.29-.12.27-.33.4-.6.4zm3.66.44c.88 0 1.32-.71 1.32-2.14 0-.68-.1-1.21-.33-1.58a1.1 1.1 0 00-1-.55c-.87 0-1.31.71-1.31 2.13 0 .7.11 1.22.33 1.59.23.36.55.55.99.55zm0-.44c-.28 0-.48-.13-.6-.4s-.2-.7-.2-1.3c0-.6.07-1.02.2-1.29s.32-.4.6-.4c.27 0 .48.14.6.4.14.27.2.7.2 1.3 0 .6-.06 1.02-.2 1.29-.12.27-.33.4-.6.4zm4.07.38v-4.14h-.42l-1.09.85.28.35.41-.35c.16-.13.27-.24.34-.32l-.02 1.02v2.59h.5zm3.25.06c.88 0 1.33-.71 1.33-2.14 0-.68-.12-1.21-.34-1.58a1.1 1.1 0 00-1-.55c-.87 0-1.31.71-1.31 2.13 0 .7.11 1.22.33 1.59.23.36.55.55.99.55zm0-.44c-.28 0-.48-.13-.6-.4s-.2-.7-.2-1.3c0-.6.07-1.02.2-1.29s.32-.4.6-.4c.27 0 .48.14.6.4.14.27.2.7.2 1.3 0 .6-.06 1.02-.2 1.29s-.33.4-.6.4zm3.66.44c.88 0 1.33-.71 1.33-2.14 0-.68-.12-1.21-.34-1.58a1.1 1.1 0 00-1-.55c-.87 0-1.3.71-1.3 2.13 0 .7.1 1.22.32 1.59.23.36.56.55.99.55zm0-.44c-.28 0-.48-.13-.6-.4s-.2-.7-.2-1.3c0-.6.07-1.02.2-1.29s.32-.4.6-.4c.28 0 .48.14.6.4.14.27.2.7.2 1.3 0 .6-.06 1.02-.2 1.29s-.32.4-.6.4zm4.07.38v-4.14h-.42l-1.09.85.28.35.41-.35c.16-.13.27-.24.35-.32l-.03 1.02v2.59h.5zm3.25.06c.88 0 1.33-.71 1.33-2.14 0-.68-.11-1.21-.34-1.58a1.1 1.1 0 00-1-.55c-.87 0-1.3.71-1.3 2.13 0 .7.1 1.22.33 1.59.22.36.55.55.98.55zm0-.44c-.27 0-.48-.13-.6-.4s-.2-.7-.2-1.3c0-.6.07-1.02.2-1.29s.33-.4.6-.4c.28 0 .48.14.61.4.13.27.2.7.2 1.3 0 .6-.07 1.02-.2 1.29s-.33.4-.61.4zm4.07.38v-4.14h-.42l-1.09.85.28.35.41-.35c.16-.13.27-.24.35-.32l-.03 1.02v2.59h.5zm3.25.06c.89 0 1.33-.71 1.33-2.14 0-.68-.11-1.21-.34-1.58a1.1 1.1 0 00-.99-.55c-.88 0-1.32.71-1.32 2.13 0 .7.11 1.22.34 1.59.22.36.55.55.98.55zm0-.44c-.27 0-.47-.13-.6-.4s-.2-.7-.2-1.3c0-.6.07-1.02.2-1.29s.33-.4.6-.4c.28 0 .48.14.61.4.13.27.2.7.2 1.3 0 .6-.07 1.02-.2 1.29s-.33.4-.61.4zm3.66.44c.89 0 1.33-.71 1.33-2.14 0-.68-.11-1.21-.34-1.58a1.1 1.1 0 00-.99-.55c-.88 0-1.32.71-1.32 2.13 0 .7.11 1.22.34 1.59.22.36.55.55.98.55zm0-.44c-.27 0-.47-.13-.6-.4a3.2 3.2 0 01-.2-1.3c0-.6.07-1.02.2-1.29.13-.26.33-.4.6-.4.28 0 .48.14.61.4.13.27.2.7.2 1.3 0 .6-.07 1.02-.2 1.29s-.33.4-.6.4zm4.07.38v-4.14H53l-1.08.85.27.35.42-.35c.15-.13.27-.24.34-.32-.02.45-.02.8-.02 1.02v2.59h.5zm3.67 0v-4.14h-.43l-1.08.85.27.35.42-.35c.15-.13.27-.24.34-.32-.02.45-.02.8-.02 1.02v2.59h.5zm3.66 0v-4.14h-.43l-1.08.85.27.35.42-.35c.15-.13.27-.24.34-.32-.02.45-.02.8-.02 1.02v2.59h.5zm3.66 0v-4.14h-.43l-1.08.85.27.35.42-.35c.15-.13.27-.24.34-.32l-.02 1.02v2.59h.5zm3.24.06c.89 0 1.33-.71 1.33-2.14 0-.68-.11-1.21-.33-1.58a1.1 1.1 0 00-1-.55c-.87 0-1.31.71-1.31 2.13 0 .7.1 1.22.33 1.59.22.36.55.55.98.55zm0-.44c-.27 0-.47-.13-.6-.4s-.19-.7-.19-1.3c0-.6.06-1.02.2-1.29s.32-.4.6-.4c.27 0 .47.14.6.4.14.27.2.7.2 1.3 0 .6-.06 1.02-.2 1.29-.13.27-.33.4-.6.4zm-54.5 5.98v-4.14h-.42l-1.08.85.27.35.42-.35c.15-.13.27-.24.34-.32l-.02 1.02v2.59h.5zm3.26.06c.88 0 1.32-.71 1.32-2.14 0-.68-.1-1.21-.33-1.58a1.1 1.1 0 00-1-.55c-.87 0-1.31.71-1.31 2.13 0 .7.11 1.22.33 1.59.23.36.55.55.99.55zm0-.44c-.28 0-.48-.13-.6-.4s-.2-.7-.2-1.3c0-.6.07-1.02.2-1.29s.32-.4.6-.4c.27 0 .48.14.6.4.14.27.2.7.2 1.3 0 .6-.06 1.02-.2 1.29-.12.27-.33.4-.6.4zm3.66.44c.88 0 1.32-.71 1.32-2.14 0-.68-.1-1.21-.33-1.58a1.1 1.1 0 00-1-.55c-.87 0-1.31.71-1.31 2.13 0 .7.11 1.22.33 1.59.23.36.55.55.99.55zm0-.44c-.28 0-.48-.13-.6-.4s-.2-.7-.2-1.3c0-.6.07-1.02.2-1.29s.32-.4.6-.4c.27 0 .48.14.6.4.14.27.2.7.2 1.3 0 .6-.06 1.02-.2 1.29-.12.27-.33.4-.6.4zm4.07.38v-4.14h-.42l-1.09.85.28.35.41-.35c.16-.13.27-.24.34-.32l-.02 1.02v2.59h.5zm3.66 0v-4.14h-.42l-1.09.85.28.35.41-.35c.16-.13.27-.24.34-.32l-.02 1.02v2.59h.5zm3.25.06c.88 0 1.33-.71 1.33-2.14 0-.68-.12-1.21-.34-1.58a1.1 1.1 0 00-1-.55c-.87 0-1.3.71-1.3 2.13 0 .7.1 1.22.33 1.59.22.36.55.55.98.55zm0-.44c-.28 0-.48-.13-.6-.4s-.2-.7-.2-1.3c0-.6.07-1.02.2-1.29s.32-.4.6-.4c.28 0 .48.14.61.4.13.27.2.7.2 1.3 0 .6-.07 1.02-.2 1.29s-.33.4-.61.4zm3.66.44c.88 0 1.33-.71 1.33-2.14 0-.68-.12-1.21-.34-1.58a1.1 1.1 0 00-1-.55c-.87 0-1.3.71-1.3 2.13 0 .7.1 1.22.33 1.59.22.36.55.55.98.55zm0-.44c-.28 0-.48-.13-.6-.4s-.2-.7-.2-1.3c0-.6.07-1.02.2-1.29s.32-.4.6-.4c.28 0 .48.14.61.4.13.27.2.7.2 1.3 0 .6-.07 1.02-.2 1.29s-.33.4-.61.4zm3.66.44c.88 0 1.33-.71 1.33-2.14 0-.68-.11-1.21-.34-1.58a1.1 1.1 0 00-1-.55c-.87 0-1.3.71-1.3 2.13 0 .7.1 1.22.33 1.59.22.36.55.55.98.55zm0-.44c-.27 0-.48-.13-.6-.4s-.2-.7-.2-1.3c0-.6.07-1.02.2-1.29s.33-.4.6-.4c.28 0 .48.14.61.4.13.27.2.7.2 1.3 0 .6-.07 1.02-.2 1.29s-.33.4-.61.4zm4.07.38v-4.14h-.42l-1.09.85.28.35.41-.35c.16-.13.27-.24.35-.32l-.03 1.02v2.59h.5zm3.66 0v-4.14h-.42l-1.09.85.28.35.42-.35.34-.32c-.02.45-.02.8-.02 1.02v2.59h.5zm3.66 0v-4.14h-.42l-1.09.85.28.35.42-.35.34-.32c-.02.45-.02.8-.02 1.02v2.59h.5zm3.66 0v-4.14H53l-1.08.85.27.35.42-.35c.15-.13.27-.24.34-.32-.02.45-.02.8-.02 1.02v2.59h.5zm3.25.06c.89 0 1.33-.71 1.33-2.14 0-.68-.11-1.21-.34-1.58a1.1 1.1 0 00-.99-.55c-.88 0-1.32.71-1.32 2.13 0 .7.12 1.22.34 1.59.22.36.55.55.98.55zm0-.44c-.27 0-.47-.13-.6-.4s-.2-.7-.2-1.3c0-.6.07-1.02.2-1.29s.33-.4.6-.4c.28 0 .48.14.61.4.13.27.2.7.2 1.3 0 .6-.07 1.02-.2 1.29s-.33.4-.6.4zm4.08.38v-4.14h-.43l-1.08.85.27.35.42-.35c.15-.13.27-.24.34-.32-.02.45-.02.8-.02 1.02v2.59h.5zm3.24.06c.89 0 1.33-.71 1.33-2.14 0-.68-.11-1.21-.33-1.58a1.1 1.1 0 00-1-.55c-.87 0-1.31.71-1.31 2.13 0 .7.1 1.22.33 1.59.22.36.55.55.98.55zm0-.44c-.27 0-.47-.13-.6-.4s-.19-.7-.19-1.3c0-.6.06-1.02.2-1.29s.32-.4.6-.4c.27 0 .47.14.6.4.13.27.2.7.2 1.3 0 .6-.07 1.02-.2 1.29s-.33.4-.6.4zm4.08.38v-4.14h-.43l-1.08.85.27.35.42-.35c.15-.13.27-.24.34-.32l-.02 1.02v2.59h.5zm-55.32 5.66c.88 0 1.32-.71 1.32-2.14 0-.68-.1-1.21-.33-1.58a1.1 1.1 0 00-1-.55c-.87 0-1.31.71-1.31 2.13 0 .7.1 1.22.33 1.59.23.36.55.55.98.55zm0-.44c-.28 0-.48-.13-.6-.4s-.2-.7-.2-1.3c0-.6.07-1.02.2-1.29s.32-.4.6-.4c.27 0 .48.14.6.4.14.27.2.7.2 1.3 0 .6-.06 1.02-.2 1.29-.12.27-.33.4-.6.4zm3.66.44c.88 0 1.32-.71 1.32-2.14 0-.68-.1-1.21-.33-1.58a1.1 1.1 0 00-1-.55c-.87 0-1.31.71-1.31 2.13 0 .7.11 1.22.33 1.59.23.36.55.55.99.55zm0-.44c-.28 0-.48-.13-.6-.4s-.2-.7-.2-1.3c0-.6.07-1.02.2-1.29s.32-.4.6-.4c.27 0 .48.14.6.4.14.27.2.7.2 1.3 0 .6-.06 1.02-.2 1.29-.12.27-.33.4-.6.4zm3.66.44c.88 0 1.32-.71 1.32-2.14 0-.68-.1-1.21-.33-1.58a1.1 1.1 0 00-1-.55c-.87 0-1.31.71-1.31 2.13 0 .7.11 1.22.33 1.59.23.36.55.55.99.55zm0-.44c-.28 0-.48-.13-.6-.4s-.2-.7-.2-1.3c0-.6.07-1.02.2-1.29s.32-.4.6-.4c.27 0 .48.14.6.4.14.27.2.7.2 1.3 0 .6-.06 1.02-.2 1.29-.12.27-.33.4-.6.4zm3.66.44c.88 0 1.33-.71 1.33-2.14 0-.68-.12-1.21-.34-1.58a1.1 1.1 0 00-1-.55c-.87 0-1.31.71-1.31 2.13 0 .7.11 1.22.33 1.59.23.36.55.55.99.55zm0-.44c-.28 0-.48-.13-.6-.4s-.2-.7-.2-1.3c0-.6.07-1.02.2-1.29s.32-.4.6-.4c.27 0 .48.14.6.4.14.27.2.7.2 1.3 0 .6-.06 1.02-.2 1.29s-.33.4-.6.4zm4.07.38v-4.14h-.42l-1.09.85.28.35.41-.35c.16-.13.27-.24.35-.32l-.03 1.02v2.59h.5zm3.66 0v-4.14h-.42l-1.09.85.28.35.41-.35c.16-.13.27-.24.35-.32l-.03 1.02v2.59h.5zm3.66 0v-4.14h-.42l-1.09.85.28.35.41-.35c.16-.13.27-.24.35-.32l-.03 1.02v2.59h.5zm3.66 0v-4.14h-.42l-1.09.85.28.35.41-.35c.16-.13.27-.24.35-.32l-.03 1.02v2.59h.5zm3.25.06c.89 0 1.33-.71 1.33-2.14 0-.68-.11-1.21-.34-1.58a1.1 1.1 0 00-.99-.55c-.88 0-1.32.71-1.32 2.13 0 .7.11 1.22.34 1.59.22.36.55.55.98.55zm0-.44c-.27 0-.47-.13-.6-.4s-.2-.7-.2-1.3c0-.6.07-1.02.2-1.29s.33-.4.6-.4c.28 0 .48.14.61.4.13.27.2.7.2 1.3 0 .6-.07 1.02-.2 1.29s-.33.4-.61.4zm4.07.38v-4.14h-.42l-1.09.85.28.35.42-.35.34-.32c-.02.45-.02.8-.02 1.02v2.59h.5zm3.25.06c.89 0 1.33-.71 1.33-2.14 0-.68-.11-1.21-.34-1.58a1.1 1.1 0 00-.99-.55c-.88 0-1.32.71-1.32 2.13 0 .7.12 1.22.34 1.59.22.36.55.55.98.55zm0-.44c-.27 0-.47-.13-.6-.4a3.2 3.2 0 01-.2-1.3c0-.6.07-1.02.2-1.29.13-.26.33-.4.6-.4.28 0 .48.14.61.4.13.27.2.7.2 1.3 0 .6-.07 1.02-.2 1.29s-.33.4-.6.4zm4.07.38v-4.14H53l-1.08.85.27.35.42-.35c.15-.13.27-.24.34-.32-.02.45-.02.8-.02 1.02v2.59h.5zm3.67 0v-4.14h-.43l-1.08.85.27.35.42-.35c.15-.13.27-.24.34-.32-.02.45-.02.8-.02 1.02v2.59h.5zm3.24.06c.89 0 1.33-.71 1.33-2.14 0-.68-.11-1.21-.33-1.58a1.1 1.1 0 00-1-.55c-.88 0-1.31.71-1.31 2.13 0 .7.1 1.22.33 1.59.22.36.55.55.98.55zm0-.44c-.27 0-.47-.13-.6-.4s-.19-.7-.19-1.3c0-.6.06-1.02.2-1.29s.32-.4.6-.4c.27 0 .47.14.6.4.13.27.2.7.2 1.3 0 .6-.07 1.02-.2 1.29s-.33.4-.6.4zm4.08.38v-4.14h-.43l-1.08.85.27.35.42-.35c.15-.13.27-.24.34-.32l-.02 1.02v2.59h.5zm3.24.06c.89 0 1.33-.71 1.33-2.14 0-.68-.11-1.21-.33-1.58a1.1 1.1 0 00-1-.55c-.87 0-1.31.71-1.31 2.13 0 .7.1 1.22.33 1.59.22.36.55.55.98.55zm0-.44c-.27 0-.47-.13-.6-.4s-.19-.7-.19-1.3c0-.6.06-1.02.2-1.29s.32-.4.6-.4c.27 0 .48.14.6.4.14.27.2.7.2 1.3 0 .6-.06 1.02-.2 1.29-.12.27-.33.4-.6.4z",
  fill: "#8A95B3",
  fillRule: "nonzero",
  opacity: 0.6
}), /*#__PURE__*/createElement("path", {
  fill: "#8A95B3",
  fillRule: "nonzero",
  d: "M48 10h21v16H48zM23 61h33v4H23z"
}), /*#__PURE__*/createElement("path", {
  d: "M75.5 3.5h-71v56h71v-56zm-1 1v54h-69v-54h69z",
  fill: "#8A95B3",
  fillRule: "nonzero"
}), /*#__PURE__*/createElement("path", {
  d: "M72.5 6.5h-65v50h65v-50zm-1 1v48h-63v-48h63z",
  fill: "#8A95B3",
  fillRule: "nonzero"
}));

function SvgBannerComputer(props) {
  return /*#__PURE__*/createElement("svg", _extends$5({
    viewBox: "0 0 80 80"
  }, props), _ref$5);
}

function _extends$6() { _extends$6 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6.apply(this, arguments); }

var _ref$6 = /*#__PURE__*/createElement("defs", null, /*#__PURE__*/createElement("circle", {
  id: "banner-search_svg__a",
  cx: 40,
  cy: 40,
  r: 40
}), /*#__PURE__*/createElement("path", {
  d: "M16.99 0a16.99 16.99 0 0114.14 26.41L48 43.28 43.28 48 26.41 31.13A16.99 16.99 0 1117 0zm0 3.09a13.9 13.9 0 100 27.8 13.9 13.9 0 000-27.8z",
  id: "banner-search_svg__c"
}));

var _ref2$2 = /*#__PURE__*/createElement("mask", {
  id: "banner-search_svg__b",
  fill: "#fff"
}, /*#__PURE__*/createElement("use", {
  href: "#banner-search_svg__a"
}));

var _ref3 = /*#__PURE__*/createElement("circle", {
  fillOpacity: 0.4,
  fill: "#454F76",
  mask: "url(#banner-search_svg__b)",
  cx: 40,
  cy: 40,
  r: 40
});

var _ref4 = /*#__PURE__*/createElement("g", {
  transform: "translate(16 16)"
}, /*#__PURE__*/createElement("mask", {
  id: "banner-search_svg__d",
  fill: "#fff"
}, /*#__PURE__*/createElement("use", {
  href: "#banner-search_svg__c"
})), /*#__PURE__*/createElement("use", {
  fill: "#8A95B3",
  href: "#banner-search_svg__c"
}), /*#__PURE__*/createElement("g", {
  mask: "url(#banner-search_svg__d)",
  fill: "#8A95B3"
}, /*#__PURE__*/createElement("path", {
  d: "M0 0h48v48H0z"
})));

function SvgBannerSearch(props) {
  return /*#__PURE__*/createElement("svg", _extends$6({
    viewBox: "0 0 80 80"
  }, props), _ref$6, /*#__PURE__*/createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, _ref2$2, /*#__PURE__*/createElement("use", {
    fill: "#454F76",
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4,
    href: "#banner-search_svg__a"
  }), _ref3, _ref4));
}

function _extends$7() { _extends$7 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7.apply(this, arguments); }

var _ref$7 = /*#__PURE__*/createElement("path", {
  d: "M207.799 512L0 310.627l59.983-62.125 147.816 143.531L614.828-.001l59.984 62.126z"
});

function SvgCheckmark(props) {
  return /*#__PURE__*/createElement("svg", _extends$7({
    viewBox: "0 0 675 512"
  }, props), _ref$7);
}

function _extends$8() { _extends$8 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8.apply(this, arguments); }

var _ref$8 = /*#__PURE__*/createElement("path", {
  d: "M10 4V2h2v3H6v9H1V2h2v2h7zM9 1.864c0 .517-.38.924-.829.924H4.83c-.464 0-.829-.423-.829-.924V0h5v1.864zM7 6h7v9H7V6zm1 3h5V8H8v1zm0 2h5v-1H8v1zm0 2h5v-1H8v1z"
});

function SvgClipboard(props) {
  return /*#__PURE__*/createElement("svg", _extends$8({
    viewBox: "0 0 15 15"
  }, props), _ref$8);
}

function _extends$9() { _extends$9 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9.apply(this, arguments); }

var _ref$9 = /*#__PURE__*/createElement("path", {
  d: "M509.147 333.831c2.192-7.163-3.553-15.742-10.431-18.728-22.262-9.657-36.36-31.295-35.868-55.106.51-24.379 16.441-46.167 39.629-54.18 7.295-2.513 11.396-10.224 9.43-17.689-5.122-19.408-12.397-38.079-21.638-55.541-3.61-6.86-12-9.751-19.106-6.52-21.43 9.752-50.022 4.441-66.483-12.662-17.103-17.877-21.109-44.788-9.94-66.974a14.707 14.707 0 00-5.764-19.37A265.267 265.267 0 00334.38 3.212c-7.389-2.268-15.231 1.53-18.067 8.693-8.976 22.866-31.351 37.89-55.73 37.399-23.376-.51-46.64-17.613-54.199-39.78-2.513-7.295-10.224-11.415-17.669-9.486-19.522 5.103-38.419 12.435-56.145 21.808-6.916 3.628-9.751 12-6.558 19.087 10.262 22.639 5.159 49.361-12.719 66.501-17.046 16.328-43.352 20.202-67.088 9.921-7.597-3.591-15.326-.813-19.2 5.84-10.053 17.311-18.142 35.906-24.076 55.182-2.211 7.2 3.799 15.837 10.753 18.86 21.393 8.637 36.019 30.539 35.547 54.974-.492 24.378-16.422 46.149-39.629 54.18-7.276 2.514-11.396 10.205-9.43 17.651a263.506 263.506 0 0021.581 55.56c3.61 6.897 11.981 9.77 19.125 6.558 21.506-9.77 50.08-4.441 66.464 12.642 17.159 17.858 21.165 44.769 9.997 66.974-3.515 6.974-.964 15.459 5.764 19.351a261.258 261.258 0 0027.288 13.776 263.538 263.538 0 0027.308 10.091c7.37 2.267 15.232-1.531 18.066-8.712 8.939-22.866 31.352-37.89 55.692-37.38 23.547.51 46.659 17.632 54.237 39.78 2.533 7.313 10.186 11.376 17.669 9.486a264.341 264.341 0 0056.145-21.808c6.897-3.628 9.77-12 6.558-19.087-10.262-22.659-5.197-49.399 12.68-66.501 16.8-16.12 42.502-20.693 63.969-11.377l2.967 1.38c6.728 3.572 15.459 1.002 19.389-5.745 10.053-17.348 18.142-35.906 24.076-55.2zm-288.099 3.987c-44.674-19.389-65.255-71.49-45.884-116.184 19.389-44.674 71.49-65.254 116.184-45.884 44.675 19.389 65.255 71.49 45.884 116.184-19.389 44.675-71.49 65.255-116.184 45.884z"
});

function SvgCog(props) {
  return /*#__PURE__*/createElement("svg", _extends$9({
    viewBox: "0 0 512 512"
  }, props), _ref$9);
}

function _extends$a() { _extends$a = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$a.apply(this, arguments); }

var _ref$a = /*#__PURE__*/createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/createElement("path", {
  d: "M13.633 28.571a10.843 10.843 0 01-3.573-14.799c.029-.048.063-.091.093-.139.03-.048.053-.098.084-.145a10.842 10.842 0 0114.867-3.275c.208.13.7-.01 1.039-.553 1.057-1.692 2.655-4.282 3.607-5.806.286-.457.166-.89-.037-1.017a17.033 17.033 0 00-1.834-1.013c-.502-.24-1.198.102-1.497.575-.866 1.465-2.627 2.289-4.404 1.983A4.345 4.345 0 0118.466.889a1.085 1.085 0 00-1.183-.883 19.474 19.474 0 00-4.293.957 1.086 1.086 0 00-.69 1.322c.473 1.678-.233 3.703-1.66 4.709a4.335 4.335 0 01-4.997-.015 1.085 1.085 0 00-1.476.206A19.22 19.22 0 002.86 9.022l-.022.04-.026.037c-.399.64-.758 1.3-1.078 1.98-.246.52-.045 1.14.462 1.417a4.33 4.33 0 012.202 4.485C4.12 18.705 2.61 20.227.895 20.536a1.09 1.09 0 00-.887 1.201 19.566 19.566 0 001.022 4.278c.193.535.766.828 1.313.675a4.346 4.346 0 014.679 1.626c1.054 1.464 1.085 3.407.148 4.83-.294.474-.296 1.25.14 1.595.55.433.954.73 1.715 1.205.202.127.643.046.93-.413.952-1.523 2.58-4.095 3.637-5.787.339-.543.25-1.045.041-1.175",
  fill: "#FFF"
}), /*#__PURE__*/createElement("path", {
  d: "M28 17a4 4 0 11-7.999.001A4 4 0 0128 17m7 9a4 4 0 11-8 0 4 4 0 118 0",
  fill: "#FFF"
}), /*#__PURE__*/createElement("path", {
  stroke: "#FFF",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M17 26h18M17 17h18"
}));

function SvgControlCenter(props) {
  return /*#__PURE__*/createElement("svg", _extends$a({
    viewBox: "0 0 36 36"
  }, props), _ref$a);
}

function _extends$b() { _extends$b = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$b.apply(this, arguments); }

var _ref$b = /*#__PURE__*/createElement("g", {
  fill: "#fff"
}, /*#__PURE__*/createElement("path", {
  d: "M14.361 0L16 1.238l-4.166 6.077L6.701 4.84 3.217 9H0V6.88h2.304l3.874-4.625 4.988 2.405z"
}), /*#__PURE__*/createElement("path", {
  d: "M15.085 8L16 9.875l-3.998 2.202-4.146-1.37L5.236 16H1v-2.112h3.035l2.833-5.72 4.944 1.634z"
}));

function SvgDataCanvas(props) {
  return /*#__PURE__*/createElement("svg", _extends$b({
    viewBox: "0 0 16 16"
  }, props), _ref$b);
}

function _extends$c() { _extends$c = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$c.apply(this, arguments); }

var _ref$c = /*#__PURE__*/createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.355 0l7.354 3.96v8.08L14.355 16l-6.646-3.579a1.348 1.348 0 011.278-2.373l5.368 2.89 4.659-2.508V5.57l-4.66-2.509-3.184 1.715 3.968 2.177a1.348 1.348 0 11-1.297 2.363L7.7 5.947a1.348 1.348 0 01.009-2.368L14.355 0z",
  fill: "#fff"
});

function SvgDatascape(props) {
  return /*#__PURE__*/createElement("svg", _extends$c({
    width: 16,
    height: 16,
    viewBox: "0 0 28 16",
    fill: "none"
  }, props), _ref$c);
}

function _extends$d() { _extends$d = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$d.apply(this, arguments); }

var _ref$d = /*#__PURE__*/createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M23.4 4.4c-.7-1.5-3.3-2.2-4.5 0l-6 11.8c-15-4.9-17.1 8.8-5.3 15.7 1.7 1 3.2-.2 3.6-1l4.2-8.3c6.9 2.8 16.6 9.3 16.6 9.3 2.7 1.6 4.7-1.3 3.7-3.3L23.4 4.4zM8 25.9c-2-1.1-7.1-7.9 2.6-5l-2.6 5zm9.7-7.9l3.4-6.8L27 22.8c-1.7-1.1-6.9-3.9-9.3-4.8z"
});

function SvgAdjustLogo(props) {
  return /*#__PURE__*/createElement("svg", _extends$d({
    viewBox: "0 0 36 36"
  }, props), _ref$d);
}

function _extends$e() { _extends$e = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$e.apply(this, arguments); }

var _ref$e = /*#__PURE__*/createElement("path", {
  d: "M20.1 8.9c2 0 3.6 1.6 3.6 3.5 0 2-1.6 3.6-3.6 3.6-1.3 0-2.6-.8-3.1-2h-2.3c-1.1 0-1.8-.1-2.3-.7-.4-.6-.5-.9-.5-1.9v-1.3l2.3-.4c.1.6.1 1 .1 1.7v.2c.1.1.3.1.4.1h2c.3-1.6 1.8-2.8 3.4-2.8zm0 2.4c-.6 0-1.1.5-1.1 1.1 0 .7.5 1.2 1.1 1.2.7 0 1.2-.5 1.2-1.2 0-.6-.5-1.1-1.2-1.1zm0-11.3c2 0 3.6 1.6 3.6 3.6 0 1.9-1.6 3.5-3.6 3.5-1.5 0-2.8-1-3.3-2.4h-2.4c-.1.3-.2.6-.2 1.3v.1c-.1 1-.2 1.4-.4 1.9-.3.9-1 1.5-2 1.5H6.9c-.5 1.4-1.8 2.4-3.3 2.4-2 0-3.6-1.6-3.6-3.6s1.6-3.6 3.6-3.6c1.5 0 2.8 1 3.3 2.4h4.7c.1-.2.1-.5.2-1.2v-.1c.1-.9.2-1.4.4-1.9.3-1 1.1-1.5 2.1-1.5h2.5C17.3 1 18.6 0 20.1 0zM3.6 7.1c-.7 0-1.2.5-1.2 1.2s.5 1.2 1.2 1.2c.6 0 1.1-.5 1.1-1.2s-.5-1.2-1.1-1.2zm16.5-4.7c-.6 0-1.1.5-1.1 1.2 0 .6.5 1.1 1.1 1.1.7 0 1.2-.5 1.2-1.1 0-.7-.5-1.2-1.2-1.2z"
});

function SvgDeeplink(props) {
  return /*#__PURE__*/createElement("svg", _extends$e({
    viewBox: "0 0 24 16"
  }, props), _ref$e);
}

function _extends$f() { _extends$f = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$f.apply(this, arguments); }

var _ref$f = /*#__PURE__*/createElement("path", {
  d: "M15 17H2V0h9c.09 0 4 3.865 4 3.956V17zM10 4.997h4.003L10 1v3.997zM4 8h4V7H4v1zm0 2h4V9H4v1zm0 2h4v-1H4v1zm0 2h4v-1H4v1zm5-6h4V7H9v1zm0 2h4V9H9v1zm0 2h4v-1H9v1zm0 2h4v-1H9v1z",
  fill: "#FFF",
  fillRule: "evenodd"
});

function SvgDocs(props) {
  return /*#__PURE__*/createElement("svg", _extends$f({
    viewBox: "0 0 17 17"
  }, props), _ref$f);
}

function _extends$g() { _extends$g = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$g.apply(this, arguments); }

var _ref$g = /*#__PURE__*/createElement("path", {
  d: "M14.47 12.997V15h-14v-2.003h14zM10.514 1v3.608h3.989L7.488 11.28.473 4.608H4.5V1h6.014z"
});

function SvgDownload(props) {
  return /*#__PURE__*/createElement("svg", _extends$g({
    viewBox: "0 0 15 15"
  }, props), _ref$g);
}

function _extends$h() { _extends$h = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$h.apply(this, arguments); }

var _ref$h = /*#__PURE__*/createElement("path", {
  d: "M633.1 251.6c-20-8-28-29-30.6-37.6-5.2-17.7-7.9-34.7-7.7-47.8v-.5-.3c0-11.6-1.8-40-15.7-66.9-18.1-34.8-49.5-53.3-93.3-54.9h-10.5c-18.1.7-34.4 4.4-48.4 11-4.3-9.1-11.7-16.9-21.8-23.3-12.4-7.7-29.2-9.4-47.1-4.7-22.7 6-44.2 21.4-53.4 38.5-10.7 20-13.2 48.6-15.3 73.7-.8 9-1.5 17.5-2.5 25.3-5.5 40.3-5.1 153.5 44.8 161.5 1.1.2 2.3.3 3.3.3 5.3 0 11.2-1.9 13.7-6 1.7-2.6 2.5-7.1-2.4-14-4-5.6-9.1-6.8-14-7.9-5.8-1.4-10.7-2.5-14.2-10.5-2.7-6.3-4.1-19.8-3.7-34.4.5-16.5 3.4-32 7.8-42.5 3.2-7.6 7.2-12.7 11.8-15 1.9 2.8 6.9 9.2 12.5 7.1 1.6-.6 3.5-3.2 6.6-7.5 1.9-2.5 3.7-5.3 4.9-6.2 3.7-2.9 7.7-5.5 12-7.5 4.2 11 11.8 26.2 22.5 45.3 13.6 24.2 28.2 47.4 32.2 53.6 3.8 5.9 6.5 20.1 8.6 33l.8 4.5c.9 5.1 1.7 10 2.4 13.9-37.6 16.5-63.8 54.1-63.8 97.6 0 58.9 47.7 106.6 106.6 106.5s106.5-47.8 106.5-106.6c0-42.4-24.7-78.9-60.5-96.2.1-1 .1-2.1.2-3.2.2-5.6.8-11.2 1.6-16.6 2.2-12.9 4.8-27.2 8.6-33 4-6.2 18.7-29.4 32.2-53.6 12.3-21.9 20.4-38.6 24.1-49.7 1 11.3 3.5 24.3 7.4 37.7 2.6 9 11.1 31 32.2 39.5.2.1.4.1.5.1.6 0 1.1-.4 1.3-.9.8-.7.4-1.5-.2-1.8zm-277-64.7c-1.5 1.2-3.3 3.9-5.4 6.8-1.8 2.4-4.4 6.1-5.3 6.5-4.2 1.6-8.9-5.5-9.5-6.7 0-.1 0-.1-.1-.2-.3-.8-1.1-1.1-1.9-.8-5.9 2.3-10.8 7.9-14.6 17-10.3 24.4-9.9 65.9-4.1 79.1 4 9.3 10.2 10.7 16.2 12.1 4.6 1.1 8.9 2.1 12.3 6.8 2.3 3 4.4 7.4 2.3 10.9-2.3 3.7-9.1 5.2-14.1 4.4-47.1-7.6-47.5-120.3-42.3-158.3 1.1-7.8 1.8-16.4 2.5-25.5 2.2-25 4.5-53.2 15.1-72.7 8.9-16.3 29.6-31.2 51.4-37 6.1-1.6 12.3-2.3 18.7-2.4 9.9 0 18.8 2.3 26.1 6.9 10.2 6.4 17.4 14.2 21.3 23.3 2.4 5.6 3.7 11.5 3.9 17.5 1.3 26.2-15.4 56.2-29.3 81.2-2.8 5.1-5.5 9.9-7.8 14.3l-2.8 1c-6.2 2.2-12.5 4.4-18.6 7.2-4.9 2.2-9.6 5.1-14 8.6zm227.1 242.7c0 57.3-46.4 103.7-103.7 103.7s-103.7-46.5-103.7-103.7c0-45.4 29.2-84 69.9-98.1.2-.1.4-.2.7-.2.6-.2 1.1-.4 1.7-.5l.9-.3c.6-.2 1.1-.3 1.7-.5.3-.1.6-.2.9-.2.6-.2 1.2-.3 1.8-.5.2-.1.5-.1.7-.2.7-.2 1.3-.3 2-.5.2 0 .3-.1.5-.1.8-.2 1.5-.3 2.3-.5h.2c6.8-1.4 13.7-2.1 20.9-2.1 56.7.1 103.1 46.5 103.2 103.7zM462.9 232.9c4.1 3.1 8.8 5.2 13.9 6.1 2.4.4 4.8.4 7.2 0 5.1-.9 9.9-2.9 13.9-6.1l-17.5 84.3zm102.8-7.4c-13.5 24.2-28.1 47.2-32.1 53.5-4.1 6.3-6.9 20.9-9 34.1-.9 5.6-1.4 11.3-1.7 16.9-.1.7-.1 1.4-.1 2.1-12.8-5.7-26.6-8.8-40.6-9.1l19.5-93.6c.1-.5-.1-1-.4-1.4-.6-.5-1.5-.5-2.1.1-.1.1-6.4 6.7-15.6 8.1-2.2.3-4.2.3-6.4 0-9.3-1.5-15.6-8-15.6-8.1-.4-.5-1.2-.6-1.7-.3-.6.3-.9 1-.8 1.6l19.5 93.6c-11.4.1-22.6 2-33.3 5.6-.1 0-.1 0-.2.1-.7.2-1.4.5-2.2.8-.2.1-.3.1-.5.2-.6.2-1.2.4-1.8.7-.3.1-.6.2-.8.3s-.4.2-.6.2c-.8-3.7-1.6-8.3-2.4-13.2l-.8-4.5c-2.3-13.2-5-27.8-9-34.1-4-6.2-18.6-29.3-32.1-53.5-10.8-19.1-18.2-34.3-22.4-45.1.8-.4 1.6-.7 2.4-1 .5-.2.9-.4 1.4-.6 1.1-.5 2.3-.9 3.3-1.4.4-.1.7-.3 1.1-.4 1.5-.6 2.8-1.1 4.3-1.6h.1c1.6-.6 3-1.1 4.6-1.7l3.4-1.2c.3-.1.6-.4.8-.7 2.4-4.6 5.1-9.5 8-14.8 9.1-16.5 20.1-36.2 25.8-55.8v-.1c.3-1 .6-2.1.8-3 0-.1 0-.2.1-.3.3-1 .5-2 .7-2.9 0-.1.1-.3.1-.4.2-1 .4-1.9.6-2.8 0-.2.1-.3.1-.5.2-.9.3-1.9.5-2.7 0-.2.1-.4.1-.6.1-.9.2-1.8.4-2.6 0-.2.1-.4.1-.6.1-.9.2-1.7.2-2.5 0-.2 0-.5.1-.7.1-.8.1-1.7.1-2.4v-.8V76v-.8c0-.8-.1-1.6-.1-2.3 0-.3 0-.6-.1-.8-.1-.8-.2-1.5-.2-2.3 0-.3-.1-.6-.1-.9-.1-.7-.2-1.5-.4-2.2-.1-.3-.1-.6-.2-.9-.1-.7-.3-1.4-.5-2.2-.1-.3-.2-.6-.2-.9l-.6-2.1-.3-.9c-.2-.7-.5-1.4-.7-2-.1-.2-.1-.4-.2-.6 13.6-6.5 29.6-10 47.4-10.7h10.2c42.8 1.7 73.3 19.6 91 53.4 13.9 26.6 15.4 55 15.4 66.1-.2 8.6-9.2 29.1-26.3 59.6z"
});

var _ref2$3 = /*#__PURE__*/createElement("path", {
  d: "M324.6 106.2c-4.7 0-8.6 3.8-8.6 8.6 0 4.7 3.8 8.6 8.6 8.6 4.7 0 8.6-3.8 8.6-8.6 0-4.7-3.8-8.6-8.6-8.6zm5.8 8.6c0 3.1-2.5 5.8-5.8 5.8-3.1 0-5.8-2.5-5.8-5.8s2.5-5.8 5.8-5.8c3.3.1 5.8 2.6 5.8 5.8z"
});

function SvgErrorElephant(props) {
  return /*#__PURE__*/createElement("svg", _extends$h({
    viewBox: "224 24 512 512"
  }, props), _ref$h, _ref2$3);
}

function _extends$i() { _extends$i = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$i.apply(this, arguments); }

var _ref$i = /*#__PURE__*/createElement("path", {
  d: "M22.45 0c1.13 0 2.05.84 2.05 1.88v18.24c0 1.04-.92 1.88-2.05 1.88H2.55C1.42 22 .5 21.16.5 20.12V1.88C.5.84 1.42 0 2.55 0zM4.6 13.3c-.2-.12-.35.08-.18.23 2.1 1.9 4.89 3.04 7.98 3.04 2.2 0 4.76-.69 6.53-2 .3-.2.04-.53-.26-.4a15.88 15.88 0 01-14.07-.88zm15.82-.14c-.2-.24-1.85-.44-2.86.27-.16.1-.13.26.04.24.57-.07 1.84-.22 2.06.07.23.29-.25 1.48-.46 2.01-.07.16.07.23.22.1.95-.79 1.2-2.45 1-2.69zm-7.93-5.7c-.6 0-1.15.21-1.5.63-.31.38-.5.93-.5 1.65 0 .72.16 1.26.47 1.63.33.39.81.65 1.66.65.32 0 .94-.07 1.34-.26.14-.05.14-.12.14-.25v-.29c-.02-.09-.07-.12-.2-.08a4 4 0 01-1.17.2c-.47 0-.88-.13-1.1-.4a1.7 1.7 0 01-.32-1h2.74l.04-.02c.1-.08.1-.43.11-.58.05-1.27-.62-1.88-1.7-1.88zm4.33-1.08h-.4c-.09.02-.14.07-.15.18l-.1 1.04-.63.08-.06.01c-.09.03-.12.09-.12.2v.26c.03.07.1.1.17.1h.62v2.7c.07.86.72 1 1.19 1 .27 0 .48-.02.7-.07.23-.07.25-.11.26-.2v-.4c-.02-.08-.08-.1-.17-.08-.2.04-.34.06-.54.07-.55-.04-.6-.22-.6-.76V8.25h1.15c.08-.01.12-.06.12-.16v-.4c-.03-.08-.08-.1-.17-.1h-1.11V6.5c-.02-.07-.07-.12-.17-.12zm-11.8-.82c-1.05-.2-1.97.02-1.97 1.35v.7l-.61.07-.06.01c-.09.02-.12.07-.12.17v.29c.02.07.07.1.17.1h.62v3.53c.02.08.07.1.17.1h.56c.08 0 .11-.06.11-.16V8.25h1.19c.08-.01.12-.06.12-.16v-.33l-.01-.07c-.02-.07-.07-.1-.16-.1H3.89v-.84l.01-.12c.07-.54.69-.46 1.09-.41.2.04.26 0 .26-.14v-.33c-.02-.1-.08-.14-.24-.19zM6.6 7.6h-.56c-.08.02-.12.07-.12.17v4.02c.02.08.07.1.17.1h.56c.08 0 .11-.06.11-.16V7.71a.154.154 0 00-.16-.12zm12.82 0h-.58c-.12 0-.15.08-.1.2l1.55 3.93c.05.12.12.17.24.17h.53c.12 0 .17-.07.21-.17l1.56-3.93c.05-.12.02-.2-.12-.2h-.52c-.12 0-.17.05-.22.17l-1.17 3.35-1.18-3.35c-.04-.1-.09-.17-.2-.17zm-9.36-.04c-.53 0-.88.13-1.39.66l-.06-.48-.02-.06c-.03-.07-.1-.08-.17-.08h-.43c-.08.02-.12.07-.12.17v4.02c.02.08.07.1.17.1h.56c.08 0 .11-.06.11-.16v-3l.1-.07c.29-.2.57-.33 1.15-.33.16 0 .38.06.38-.1v-.54c-.02-.09-.1-.13-.28-.13zm2.39.56c1 0 .98.87.96 1.24h-2.1v-.12c.08-.6.4-1.12 1.14-1.12zm-6.1-2.3c-.3 0-.53.2-.53.5 0 .33.2.52.53.52.32 0 .53-.2.53-.51 0-.35-.22-.52-.54-.52zM16.5 23v1h-8v-1z"
});

function SvgFireTv(props) {
  return /*#__PURE__*/createElement("svg", _extends$i({
    viewBox: "0 0 25 24"
  }, props), _ref$i);
}

function _extends$j() { _extends$j = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$j.apply(this, arguments); }

var _ref$j = /*#__PURE__*/createElement("path", {
  d: "M342.86 0h114.29v512H342.86V0zM171.43 298.66h114.28V512H171.42V298.66zM0 156.56h114.28V512H0V156.56z"
});

function SvgGraph(props) {
  return /*#__PURE__*/createElement("svg", _extends$j({
    viewBox: "0 0 457 512"
  }, props), _ref$j);
}

function _extends$k() { _extends$k = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$k.apply(this, arguments); }

var _ref$k = /*#__PURE__*/createElement("path", {
  d: "M256 0C114.615 0 0 114.615 0 256s114.615 256 256 256 256-114.615 256-256S397.385 0 256 0zm32.16 112.224v57.6h-64.32v-57.6h64.32zm0 287.664h-64.32V227.296h64.32v172.592z"
});

function SvgInfoRound(props) {
  return /*#__PURE__*/createElement("svg", _extends$k({
    viewBox: "0 0 512 512"
  }, props), _ref$k);
}

function _extends$l() { _extends$l = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$l.apply(this, arguments); }

var _ref$l = /*#__PURE__*/createElement("path", {
  d: "M422.6 281.9h-41.9c-.4-2.4-1.2-4.9-2.5-7.2l-7.7-14.5a5770 5770 0 00-22-41.5h74.1a8 8 0 018 8V274a8 8 0 01-8 7.9zM356 300.3c-5.5 2.3-8.7 4.5-17 .4-8.2-4-49.4-98.8-60-123.5-10.6-24.7-42.5-90.4-32.2-95.5 7.4-3.7 33.8 48 53.5 79.2 19.8 31 61 111.2 66.1 120.3 5 9.2-4.8 16.8-10.3 19zM254 184.7l-95.7 166a8 8 0 01-10.8 2.8l-20.7-11.8A7.8 7.8 0 01124 331l95.7-166a8 8 0 0110.9-2.9l20.7 11.8a8 8 0 012.9 10.8zM89.5 281.9a8 8 0 01-8-7.9v-47.4a8 8 0 018-7.9H173L136.6 282H89.4zm30.7 68.9l20.6 11.8c3.8 2.2 4 6 .4 8.4l-26.8 18c-3.6 2.4-6.2.9-5.7-3.4l3.6-31c.5-4.3 4-6 7.8-4zm157.7-132l29.6 63.1h-87l36.4-63.2h21zm78.8 94.6l11.9-6a8.8 8.8 0 0111.6 3.8L390 330c2.2 4.3.7 9.7-3.3 12.1l-8.5 5a9 9 0 01-12-2.8l-12.5-19.6a7.7 7.7 0 013-11.3zm55.4 82.2c-2.6-8.3-22.5-8.8-31.4-21.3-9-12.5-1.5-18.9 1.6-21.8 36-20.3 29.8 43.1 29.8 43.1z"
});

var _ref2$4 = /*#__PURE__*/createElement("path", {
  d: "M256 512a256 256 0 110-512 256 256 0 010 512zm0-488.7a232.7 232.7 0 100 465.4 232.7 232.7 0 000-465.4z"
});

function SvgIos(props) {
  return /*#__PURE__*/createElement("svg", _extends$l({
    viewBox: "0 0 512 512"
  }, props), _ref$l, _ref2$4);
}

function _extends$m() { _extends$m = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$m.apply(this, arguments); }

var _ref$m = /*#__PURE__*/createElement("path", {
  d: "M28 12h-2.5V9c0-4.14-3.36-7.5-7.5-7.5-4.14 0-7.5 3.36-7.5 7.5v3H8c-1.65 0-2 .35-2 2v17c0 1.65.35 2 2 2h20c1.65 0 2-.35 2-2V14c0-1.65-.35-2-2-2zm-10 4c1.65 0 3 1.35 3 3 0 1.3-.838 2.413-2 2.828V26h-2v-4.172A3.012 3.012 0 0115 19c0-1.65 1.35-3 3-3zm4.65-4h-9.3V9A4.654 4.654 0 0118 4.35 4.654 4.654 0 0122.65 9v3z"
});

function SvgLock(props) {
  return /*#__PURE__*/createElement("svg", _extends$m({
    viewBox: "0 0 36 36"
  }, props), _ref$m);
}

function _extends$n() { _extends$n = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$n.apply(this, arguments); }

var _ref$n = /*#__PURE__*/createElement("path", {
  d: "M97.5 192.5a95 95 0 10-95-95 95 95 0 0095 95z"
});

var _ref2$5 = /*#__PURE__*/createElement("path", {
  d: "M58.07 145.76a9.17 9.17 0 01-5-1.52c-2.38-1.58-23.41-15.92-26.53-33.28a23.43 23.43 0 014.24-18.38c7.61-10.42 22-12.26 43.71-5.47l23.4-43.33a9.15 9.15 0 0116.27.32l43.55 88.46a9.16 9.16 0 01-13.38 11.61 470.06 470.06 0 00-47.93-28.09c-4.88-2.44-9.35-4.5-13.43-6.25L66.13 141a9.16 9.16 0 01-5.83 4.52 8.91 8.91 0 01-2.23.24zm-5.73-44.39c-3.88 0-6 .9-6.83 2a5.14 5.14 0 00-1 4.33c.85 4.76 5.78 10.46 10.7 15l10.34-19.1a51.25 51.25 0 00-13.21-2.23zm39.38-7.7q6.19 2.7 13 6.09c7.9 3.95 15.56 8.16 22.4 12.13l-21.56-43.8z",
  fill: "#fff"
});

function SvgLogoBlack(props) {
  return /*#__PURE__*/createElement("svg", _extends$n({
    "data-name": "Layer 1",
    viewBox: "0 0 195 195"
  }, props), _ref$n, _ref2$5);
}

function _extends$o() { _extends$o = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$o.apply(this, arguments); }

var _ref$o = /*#__PURE__*/createElement("path", {
  d: "M97.5 192.5a95 95 0 10-95-95 95 95 0 0095 95z",
  fill: "#fff"
});

var _ref2$6 = /*#__PURE__*/createElement("path", {
  d: "M58.07 145.76a9.17 9.17 0 01-5-1.52c-2.38-1.58-23.41-15.92-26.53-33.28a23.43 23.43 0 014.24-18.38c7.61-10.42 22-12.26 43.71-5.47l23.4-43.33a9.15 9.15 0 0116.27.32l43.55 88.46a9.16 9.16 0 01-13.38 11.61 470.06 470.06 0 00-47.93-28.09c-4.88-2.44-9.35-4.5-13.43-6.25L66.13 141a9.16 9.16 0 01-5.83 4.52 8.91 8.91 0 01-2.23.24zm-5.73-44.39c-3.88 0-6 .9-6.83 2a5.14 5.14 0 00-1 4.33c.85 4.76 5.78 10.46 10.7 15l10.34-19.1a51.25 51.25 0 00-13.21-2.23zm39.38-7.7q6.19 2.7 13 6.09c7.9 3.95 15.56 8.16 22.4 12.13l-21.56-43.8z"
});

function SvgLogoWhite(props) {
  return /*#__PURE__*/createElement("svg", _extends$o({
    "data-name": "Layer 1",
    viewBox: "0 0 195 195"
  }, props), _ref$o, _ref2$6);
}

function _extends$p() { _extends$p = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$p.apply(this, arguments); }

var _ref$p = /*#__PURE__*/createElement("path", {
  d: "M229.65 8.1a7.12 7.12 0 00-7.12 7.12v51.1c0 20.72-13.6 28.7-25 31.74a7.13 7.13 0 003.67 13.77c10.93-3 35.6-13 35.6-45.51v-51.1a7.13 7.13 0 00-7.15-7.12zM75.53 7a7.44 7.44 0 00-13.29 0L44.63 41.38C.12 27.34-6.09 67.16 28.79 87.44a7.56 7.56 0 0010.58-3l12.48-24.28c20.23 8.21 48.85 27 49.05 27.15 7.84 4.58 14-3.94 10.79-9.74zM30.09 69.75c-6-3.2-21-23.1 7.55-14.74zm28.64-23l10.15-19.8 17.3 33.73c-5.34-3.06-20.7-11.31-27.45-13.95zM159 8h-23.78a7.54 7.54 0 00-7.54 7.54v65.18a7.54 7.54 0 007.54 7.55H159A40.16 40.16 0 00159 8zm0 65.22h-16.24V23.05H159a25.07 25.07 0 110 50.13zM315.49 15.5V53c0 12-8.11 20.15-20.15 20.15S275.18 65.06 275.18 53V15.5c0-10-15.08-10-15.08 0V53c0 20.35 14.88 35.24 35.24 35.24S330.58 73.38 330.58 53V15.5c0-10.03-15.09-10.03-15.09 0zM476.09 8h-55.41c-10.05 0-10.05 15.09 0 15.09h20.17v57.63c0 10 15.08 10 15.08 0V23.05h20.16c10.06 0 10.06-15.05 0-15.05zM360.9 27.89c.67-7.09 14.07-10.57 25.5-1.05 7.23 6 17.59-2.8 10.46-11.07-12.53-14.54-51.21-13.58-51.21 13.67 0 28.3 44.21 22.43 39.79 38.91-2.05 7.66-19.52 10.18-27.75-1.09-6.95-9.52-18.62 0-12.65 8.47 17.32 24.64 56.07 14.08 56.07-9.72 0-28.35-41.63-23.07-40.21-38.12z"
});

function SvgLogotype(props) {
  return /*#__PURE__*/createElement("svg", _extends$p({
    viewBox: "0 0 490 115"
  }, props), _ref$p);
}

function _extends$q() { _extends$q = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$q.apply(this, arguments); }

var _ref$q = /*#__PURE__*/createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5 0a1 1 0 00-1 1v14a1 1 0 001 1h18a1 1 0 001-1V1a1 1 0 00-1-1H5zm16 3h-6v2h2.586L13.5 9.086l-2-2L6.086 12.5 7.5 13.914l4-4 2 2 5.5-5.5V9h2V3z",
  fill: "#fff"
});

function SvgNewDashboardAnalytics(props) {
  return /*#__PURE__*/createElement("svg", _extends$q({
    width: 28,
    height: 16,
    fill: "none"
  }, props), _ref$q);
}

function _extends$r() { _extends$r = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$r.apply(this, arguments); }

var _ref$r = /*#__PURE__*/createElement("path", {
  d: "M5.49 9.05c0-.57-.47-1.03-1.04-1.03h-.51v2.04h.51c.57 0 1.04-.45 1.04-1.01m2.33 4.07H5.94l-1.5-2.04h-.5v2.04H2.28V7h2.38c1.37 0 2.49.92 2.49 2.05 0 .68-.43 1.3-1.08 1.67l1.75 2.4"
});

var _ref2$7 = /*#__PURE__*/createElement("path", {
  d: "M9.75 9.44c-.44 0-.82.58-.82 1.3 0 .72.38 1.3.82 1.3.45 0 .83-.58.83-1.3 0-.72-.38-1.3-.83-1.3m2.58 1.3a2.53 2.53 0 01-2.58 2.48 2.52 2.52 0 01-2.57-2.48 2.52 2.52 0 012.57-2.48c1.42 0 2.58 1.1 2.58 2.48m3.84-2.42l-1.92 1.88V8.31h-1.68v4.81h1.68v-1.95l2 1.95h2.11l-2.55-2.5 2.11-2.07v2.85c0 .95.58 1.82 2.05 1.82.7 0 1.33-.38 1.64-.73l.76.63h.35v-4.8h-1.67v3.1c-.19.33-.45.53-.86.53-.4 0-.6-.24-.6-1V8.32h-3.42zM16.5 24v-1h-8v1z"
});

var _ref3$1 = /*#__PURE__*/createElement("path", {
  d: "M22.45 0H2.55C1.42 0 .5.84.5 1.88v18.24c0 1.04.92 1.88 2.05 1.88h19.9c1.13 0 2.05-.84 2.05-1.88V1.88C24.5.84 23.58 0 22.45 0zM2.57 1h19.86c.6 0 1.07.44 1.07.97v18.06c0 .53-.48.97-1.07.97H2.57c-.6 0-1.07-.44-1.07-.97V1.97c0-.53.48-.97 1.07-.97z"
});

function SvgRokuTv(props) {
  return /*#__PURE__*/createElement("svg", _extends$r({
    viewBox: "0 0 25 24"
  }, props), _ref$r, _ref2$7, _ref3$1);
}

function _extends$s() { _extends$s = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$s.apply(this, arguments); }

var _ref$s = /*#__PURE__*/createElement("path", {
  d: "M16.5 24v-1h-8v1zm5.95-24H2.55C1.42 0 .5.84.5 1.88v18.24c0 1.04.92 1.88 2.05 1.88h19.9c1.13 0 2.05-.84 2.05-1.88V1.88C24.5.84 23.58 0 22.45 0zM2.57 1h19.86c.6 0 1.07.44 1.07.97v18.06c0 .53-.48.97-1.07.97H2.57c-.6 0-1.07-.44-1.07-.97V1.97c0-.53.48-.97 1.07-.97z"
});

var _ref2$8 = /*#__PURE__*/createElement("path", {
  d: "M13 12.7c.1.25.06.57.02.76-.08.35-.3.7-.95.7-.6 0-.97-.38-.97-.94v-1H8.5v.8c0 2.14 1.48 2.88 3.15 2.97-3.96 2.33-8.44 4.16-9 2.38-.71-2.21 2.7-5.8 6.37-8.84 1.02 1.44 3.55 2.05 3.98 3.17zm1.6-7.15c3.44-1.98 6.8-3.07 7.8-2.12 1.5 1.47-2.02 5.92-5.87 9.2-.31.27-.67.55-1.07.85l-.02.17c.12-.89.03-1.46 0-1.68-.42-2.15-4.1-2.8-4.36-4l-.02-.06.15-.11c.41-.31.84-.62 1.27-.91.24.15.37.43.37.78v.64h2.42v-.72c0-.95-.34-1.56-.83-1.94z"
});

var _ref3$2 = /*#__PURE__*/createElement("path", {
  d: "M13.01 10.08l-1.15-.66-.22-.13c-.6-.4-.95-.75-1.05-1.2a1.88 1.88 0 01-.01-.76c.13-.65.6-1.09 1.37-1.09.8 0 1.33.52 1.4 1.29v.28h1.42v-.22c0-1.47-.92-2.05-2.57-2.09H12c-1.7 0-2.7.6-2.89 1.85-.07.45-.06.79.02 1.22.14.67.65 1.2 1.73 1.86l1.18.7c.72.44 1.15.8 1.36 1.26l.06.14.05.16c.06.22.06.47.03.7l-.04.18c-.15.66-.62 1.08-1.43 1.08-.81 0-1.4-.52-1.46-1.28v-.15l-.01-.5H9v.3c0 1.65 1.01 2.42 2.82 2.48h.2c1.73 0 2.75-.63 2.92-1.91.1-.66.07-1.17 0-1.53-.14-.71-.73-1.28-1.93-1.98z"
});

function SvgSamsungTv(props) {
  return /*#__PURE__*/createElement("svg", _extends$s({
    viewBox: "0 0 25 24"
  }, props), _ref$s, _ref2$8, _ref3$2);
}

function _extends$t() { _extends$t = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$t.apply(this, arguments); }

var _ref$t = /*#__PURE__*/createElement("path", {
  d: "M275.47 329.78l48.62-48.62L506.45 463.5l-48.637 48.636-182.34-182.36z"
});

var _ref2$9 = /*#__PURE__*/createElement("path", {
  d: "M189.11 378.23C84.67 378.23 0 293.559 0 189.12S84.671.01 189.11.01s189.11 84.671 189.11 189.11-84.671 189.11-189.11 189.11zm0-343.84c-85.463 0-154.73 69.267-154.73 154.73s69.267 154.73 154.73 154.73 154.73-69.267 154.73-154.73S274.573 34.39 189.11 34.39z"
});

function SvgSearch(props) {
  return /*#__PURE__*/createElement("svg", _extends$t({
    viewBox: "0 0 507 512"
  }, props), _ref$t, _ref2$9);
}

function _extends$u() { _extends$u = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$u.apply(this, arguments); }

var _ref$u = /*#__PURE__*/createElement("path", {
  d: "M7.022 16H0l.517-3.395C.517 10.622 2.84 9 5.682 9h1.34C6.375 10.01 6 11.211 6 12.5s.375 2.49 1.022 3.5zM6.5 8a3.5 3.5 0 110-7 3.5 3.5 0 010 7zm9.453 7.38a.237.237 0 01-.327.07l-.002-.002-.752-.488-.08.072c-.231.211-.49.39-.766.529l-.097.048.182.882a.238.238 0 01-.182.28l-.407.087-.635.137a.234.234 0 01-.278-.181l-.182-.881-.108-.006a3.368 3.368 0 01-.911-.167l-.102-.034-.496.758a.235.235 0 01-.326.07l-.888-.578a.236.236 0 01-.068-.326l.495-.757-.072-.08a3.35 3.35 0 01-.522-.763l-.048-.096-.882.19a.235.235 0 01-.279-.181l-.133-.645-.082-.396a.238.238 0 01.182-.28l.352-.076.53-.114.007-.108c.015-.308.075-.616.174-.912l.035-.103-.754-.49a.234.234 0 01-.067-.325l.583-.894a.237.237 0 01.326-.07l.754.49.08-.073c.233-.211.49-.39.767-.528l.097-.049-.183-.88a.238.238 0 01.183-.281l1.04-.224a.233.233 0 01.28.181l.182.881.108.005c.309.014.615.07.911.168l.102.034.495-.758a.237.237 0 01.327-.07l.888.577c.108.07.139.217.068.326l-.496.758.073.08c.208.23.384.487.522.763l.048.096.882-.19a.23.23 0 01.176.033.23.23 0 01.102.149l.216 1.04a.235.235 0 01-.183.28l-.882.19-.006.107a3.401 3.401 0 01-.175.913l-.034.102.754.49c.108.07.139.217.067.326l-.583.893zm-2.352-3.117a1.115 1.115 0 00-1.33-.863c-.293.063-.546.238-.71.49a1.125 1.125 0 00-.049 1.154 1.12 1.12 0 001.847.174c.214-.257.315-.604.242-.955z",
  fill: "#FFF",
  fillRule: "evenodd"
});

function SvgSettings(props) {
  return /*#__PURE__*/createElement("svg", _extends$u({
    viewBox: "0 0 17 17"
  }, props), _ref$u);
}

function _extends$v() { _extends$v = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$v.apply(this, arguments); }

var _ref$v = /*#__PURE__*/createElement("defs", null, /*#__PURE__*/createElement("path", {
  d: "M13.5 0L0 6v9c0 8.32 5.76 16.11 13.5 18C21.24 31.11 27 23.33 27 15V6L13.5 0zm-3 24l-6-6 2.12-2.12 3.89 3.87 9.89-9.88L22.5 12l-12 12z",
  id: "shield-checkmark_svg__a"
}));

var _ref2$a = /*#__PURE__*/createElement("g", {
  transform: "translate(4 2)"
}, /*#__PURE__*/createElement("mask", {
  id: "shield-checkmark_svg__b",
  fill: "#fff"
}, /*#__PURE__*/createElement("use", {
  xlinkHref: "#shield-checkmark_svg__a"
})), /*#__PURE__*/createElement("use", {
  xlinkHref: "#shield-checkmark_svg__a"
}), /*#__PURE__*/createElement("path", {
  mask: "url(#shield-checkmark_svg__b)",
  d: "M-4-2h36v36H-4z"
}));

function SvgShieldCheckmark(props) {
  return /*#__PURE__*/createElement("svg", _extends$v({
    viewBox: "0 0 36 36"
  }, props), _ref$v, _ref2$a);
}

function _extends$w() { _extends$w = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$w.apply(this, arguments); }

var _ref$w = /*#__PURE__*/createElement("defs", null, /*#__PURE__*/createElement("path", {
  d: "M14 0L0 6v9a18.8 18.8 0 0014 18 18.8 18.8 0 0014-18V6L14 0zM6 18a2 2 0 110-4 2 2 0 110 4zm8 0a2 2 0 110-4 2 2 0 110 4zm8 0a2 2 0 110-4 2 2 0 110 4z",
  id: "shield-ellipsis_svg__a"
}));

var _ref2$b = /*#__PURE__*/createElement("g", {
  transform: "translate(4 2)"
}, /*#__PURE__*/createElement("mask", {
  id: "shield-ellipsis_svg__b",
  fill: "#fff"
}, /*#__PURE__*/createElement("use", {
  xlinkHref: "#shield-ellipsis_svg__a"
})), /*#__PURE__*/createElement("use", {
  xlinkHref: "#shield-ellipsis_svg__a"
}), /*#__PURE__*/createElement("path", {
  mask: "url(#shield-ellipsis_svg__b)",
  d: "M-4-2h36v36H-4z"
}));

function SvgShieldEllipsis(props) {
  return /*#__PURE__*/createElement("svg", _extends$w({
    viewBox: "0 0 36 36"
  }, props), _ref$w, _ref2$b);
}

function _extends$x() { _extends$x = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$x.apply(this, arguments); }

var _ref$x = /*#__PURE__*/createElement("defs", null, /*#__PURE__*/createElement("path", {
  d: "M13.5 0L27 6v9c0 8.32-5.76 16.11-13.5 18C5.76 31.11 0 23.33 0 15V6l13.5-6zm4.4 9.73l-4.4 4.45-4.4-4.45-2.29 2.33 4.4 4.45-4.4 4.45 2.29 2.33 4.4-4.43 4.4 4.43 2.29-2.33-4.38-4.45 4.38-4.45-2.29-2.33z",
  id: "shield-error_svg__a"
}));

var _ref2$c = /*#__PURE__*/createElement("g", {
  transform: "translate(4 2)"
}, /*#__PURE__*/createElement("mask", {
  id: "shield-error_svg__b",
  fill: "#fff"
}, /*#__PURE__*/createElement("use", {
  xlinkHref: "#shield-error_svg__a"
})), /*#__PURE__*/createElement("use", {
  xlinkHref: "#shield-error_svg__a"
}), /*#__PURE__*/createElement("path", {
  mask: "url(#shield-error_svg__b)",
  d: "M-1234-2h36v36H-4z"
}));

function SvgShieldError(props) {
  return /*#__PURE__*/createElement("svg", _extends$x({
    viewBox: "0 0 36 36"
  }, props), _ref$x, _ref2$c);
}

function _extends$y() { _extends$y = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$y.apply(this, arguments); }

var _ref$y = /*#__PURE__*/createElement("path", {
  d: "M12 18H2V4h10m0-4H2a2 2 0 00-2 2v18c0 1.1.9 2 2 2h10a2 2 0 002-2V2a2 2 0 00-2-2z",
  fill: "#FFF"
});

var _ref2$d = /*#__PURE__*/createElement("path", {
  stroke: "#FFF",
  fill: "#FFF",
  d: "M3.5 15.5h7v1h-7z"
});

function SvgSmartBanners(props) {
  return /*#__PURE__*/createElement("svg", _extends$y({
    viewBox: "0 0 14 22"
  }, props), _ref$y, _ref2$d);
}

function _extends$z() { _extends$z = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$z.apply(this, arguments); }

var _ref$z = /*#__PURE__*/createElement("path", {
  d: "M264.827.018l87.287 160.892 177.505 34.657-123.568 134.108 22.422 182.308-163.646-78.018-163.663 78.018 22.439-182.308L.034 195.567l177.505-34.657L264.826.018z"
});

function SvgStarFull(props) {
  return /*#__PURE__*/createElement("svg", _extends$z({
    viewBox: "0 0 530 512"
  }, props), _ref$z);
}

function _extends$A() { _extends$A = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$A.apply(this, arguments); }

var _ref$A = /*#__PURE__*/createElement("path", {
  d: "M512.32 443.968l-68.352 68.352L256 324.352 68.032 512.32-.32 443.968 187.648 256-.32 68.032 68.032-.32 256 187.648 443.968-.32l68.352 68.352L324.352 256 512.32 443.968z"
});

function SvgTimes(props) {
  return /*#__PURE__*/createElement("svg", _extends$A({
    viewBox: "0 0 512 512"
  }, props), _ref$A);
}

function _extends$B() { _extends$B = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$B.apply(this, arguments); }

var _ref$B = /*#__PURE__*/createElement("path", {
  d: "M398 0l398 512H0z"
});

function SvgTriangleTop(props) {
  return /*#__PURE__*/createElement("svg", _extends$B({
    viewBox: "0 0 797 512"
  }, props), _ref$B);
}

function _extends$C() { _extends$C = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$C.apply(this, arguments); }

var _ref$C = /*#__PURE__*/createElement("path", {
  d: "M.198 511.901L305.548-.181l305.35 512.082H.197zm334.915-354.353h-59.127v177.218h59.127V157.548zm-59.128 236.296v59.078h59.127v-59.078h-59.127z"
});

function SvgWarning(props) {
  return /*#__PURE__*/createElement("svg", _extends$C({
    viewBox: "0 0 611 512"
  }, props), _ref$C);
}

function _extends$D() { _extends$D = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$D.apply(this, arguments); }

var _ref$D = /*#__PURE__*/createElement("path", {
  d: "M0 455.111h398.222V512H0v-56.889zM199.111 0L0 189.63h113.778v189.63h170.666V189.63h113.778z"
});

function SvgUpload(props) {
  return /*#__PURE__*/createElement("svg", _extends$D({
    viewBox: "0 0 398 512"
  }, props), _ref$D);
}

function _extends$E() { _extends$E = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$E.apply(this, arguments); }

var _ref$E = /*#__PURE__*/createElement("path", {
  d: "M10 14.6H7.2c-.5-1.3-.7-2.8-.7-4.3H10v4.3zm0 4.5c-1-1-2-2.3-2.6-3.7h2.7l-.1 3.7zm-6.1-2.7l-1-1h3.7C7 16.7 7.9 18 8.9 19a9.2 9.2 0 01-5-2.6zm-2.6-6.1h4.3c0 1.5.3 3 .7 4.3H2.5a9.1 9.1 0 01-1.2-4.3zm1.3-5h3.8C6 6.6 5.7 8 5.6 9.5H1.3c0-1.6.5-3 1.3-4.3zM9.2.8c-1 1-1.9 2.2-2.5 3.6H3.1a9.3 9.3 0 016-3.6zm1 0v3.7H7.5C8.2 3 9.1 1.7 10.3.7zm.8 0c1.1 1 2 2.3 2.6 3.7H11V.8zm6.2 2.6l.9 1.2h-3.6C13.9 3.1 13 2 12 .8c2 .3 3.7 1.2 5 2.6zm2.6 6.2h-4.4c0-1.5-.2-3-.7-4.3h3.9a9.1 9.1 0 011.2 4.3zm-6.6 9l-1.3.4 1-1.3-.3-.9c-.5.8-1.1 1.6-1.8 2.2v-3.7h1.3l-.3-.7h-1v-2.9l-.7-2.2H6.4c0-1.5.3-3 .8-4.3h3v3.9l.7.3v-4h3c.5 1.3.8 2.8.8 4.3h-3.5l1 .4.8.3h1.7v.7l.6.3.1-1 4.3.1a9 9 0 01-.5 2.6l.6.3A9.8 9.8 0 0010.7 0h-.2a10 10 0 00-10 9.7 10 10 0 009.9 10h.1c1 0 2 0 3-.4l-.3-.7z"
});

var _ref2$e = /*#__PURE__*/createElement("path", {
  d: "M20.5 14.6l-3.3 1 2.8 2.7-1 1.1-3-2.7-1.5 3.2-3.2-9.3.6.2 8.6 3.8"
});

function SvgWeb(props) {
  return /*#__PURE__*/createElement("svg", _extends$E({
    viewBox: "0 0 21 20"
  }, props), _ref$E, _ref2$e);
}

function _extends$F() { _extends$F = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$F.apply(this, arguments); }

var _ref$F = /*#__PURE__*/createElement("path", {
  d: "M358.8 512L0 439.2V174.4l358.8-72.8 71.7 26.5v357.4L358.8 512zm-202-289.3L77 234.1v61.7h79.7v-73zm0 83.3H77v67l79.7 11.4V306zM267 207.2l-100.3 15v73.6H267v-88.6zm0 98.8H166.8v79L267 400v-94zm13.6-215.5c0-29.8.6-44-33.5-39a122 122 0 00-2-13.4c41.2-6.2 48.4 6.2 48.4 52.4v8.3l-13 2.7v-11zm-111 33.5v-20.3c0-42.1 15.8-48.8 37.6-56.5a71 71 0 011.4 13.7c-19 8.3-26.4 14.3-26 43v17.5l-13 2.6zm52.1-62c0-22.2-3.4-57-56.7-44.4-35.4 8.4-54.6 20-54.2 57.6V136l-13 2.6V73.9c0-55 32.6-63.3 64.6-70.7C221.8-10.4 234.7 21 234.9 63v47.8l-13.1 2.6V62z"
});

function SvgWindowsPhone(props) {
  return /*#__PURE__*/createElement("svg", _extends$F({
    viewBox: "0 0 431 512"
  }, props), _ref$F);
}

function _extends$G() { _extends$G = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$G.apply(this, arguments); }

var _ref$G = /*#__PURE__*/createElement("path", {
  d: "M241.4 472.4v-210H512v249.5l-270.6-39.5zm0-432.8L512 0v235.3H241.4V39.6zM0 262.3h214.6v208.4L-.1 440.4v-178zM0 71.5l214.6-30.3v194.1H-.1V71.5z"
});

function SvgWindows(props) {
  return /*#__PURE__*/createElement("svg", _extends$G({
    viewBox: "0 0 512 512"
  }, props), _ref$G);
}

const SvgIcon = props => {
    const { name, fill = 'white' } = props, rest = __rest(props, ["name", "fill"]);
    switch (name) {
        case IconName.AdAccounts:
            return React__default.createElement(SvgAdAccounts, Object.assign({ fill: fill }, rest));
        case IconName.AndroidTv:
            return React__default.createElement(SvgAndroidTv, Object.assign({ fill: fill }, rest));
        case IconName.Android:
            return React__default.createElement(SvgAndroid, Object.assign({ fill: fill }, rest));
        case IconName.Apps:
            return React__default.createElement(SvgApps, Object.assign({ fill: fill }, rest));
        case IconName.Audience:
            return React__default.createElement(SvgAudience, Object.assign({ fill: fill }, rest));
        case IconName.BannerComputer:
            return React__default.createElement(SvgBannerComputer, Object.assign({}, rest));
        case IconName.BannerSearch:
            return React__default.createElement(SvgBannerSearch, Object.assign({}, rest));
        case IconName.Checkmark:
            return React__default.createElement(SvgCheckmark, Object.assign({ fill: fill }, rest));
        case IconName.Clipboard:
            return React__default.createElement(SvgClipboard, Object.assign({ fill: fill }, rest));
        case IconName.Cog:
            return React__default.createElement(SvgCog, Object.assign({ fill: fill }, rest));
        case IconName.ControlCenter:
            return React__default.createElement(SvgControlCenter, Object.assign({ fill: fill }, rest));
        case IconName.DataCanvas:
            return React__default.createElement(SvgDataCanvas, Object.assign({ fill: fill }, rest));
        case IconName.Datascape:
            return React__default.createElement(SvgDatascape, Object.assign({ fill: fill }, rest));
        case IconName.AdjustLogo:
            return React__default.createElement(SvgAdjustLogo, Object.assign({ fill: fill }, rest));
        case IconName.DeepLink:
            return React__default.createElement(SvgDeeplink, Object.assign({ fill: fill }, rest));
        case IconName.Docs:
            return React__default.createElement(SvgDocs, Object.assign({ fill: fill }, rest));
        case IconName.Download:
            return React__default.createElement(SvgDownload, Object.assign({ fill: fill }, rest));
        case IconName.ErrorElephant:
            return React__default.createElement(SvgErrorElephant, Object.assign({ fill: fill }, rest));
        case IconName.FireTv:
            return React__default.createElement(SvgFireTv, Object.assign({ fill: fill }, rest));
        case IconName.Graph:
            return React__default.createElement(SvgGraph, Object.assign({ fill: fill }, rest));
        case IconName.Lock:
            return React__default.createElement(SvgLock, Object.assign({ fill: fill }, rest));
        case IconName.LogoBlack:
            return React__default.createElement(SvgLogoBlack, Object.assign({}, rest));
        case IconName.LogoWhite:
            return React__default.createElement(SvgLogoWhite, Object.assign({}, rest));
        case IconName.LogotypeBlack:
            return React__default.createElement(SvgLogotype, Object.assign({ fill: "black" }, rest));
        case IconName.LogotypeWhite:
            return React__default.createElement(SvgLogotype, Object.assign({ fill: "white" }, rest));
        case IconName.InfoRound:
            return React__default.createElement(SvgInfoRound, Object.assign({ fill: fill }, rest));
        case IconName.Ios:
            return React__default.createElement(SvgIos, Object.assign({ fill: fill }, rest));
        case IconName.NewDashboardAnalytics:
            return React__default.createElement(SvgNewDashboardAnalytics, Object.assign({ fill: fill }, rest));
        case IconName.RokuTv:
            return React__default.createElement(SvgRokuTv, Object.assign({ fill: fill }, rest));
        case IconName.SamsungTv:
            return React__default.createElement(SvgSamsungTv, Object.assign({ fill: fill }, rest));
        case IconName.Search:
            return React__default.createElement(SvgSearch, Object.assign({ fill: fill }, rest));
        case IconName.Settings:
            return React__default.createElement(SvgSettings, Object.assign({ fill: fill }, rest));
        case IconName.ShieldCheckmark:
            return React__default.createElement(SvgShieldCheckmark, Object.assign({ fill: fill }, rest));
        case IconName.ShieldEllipsis:
            return React__default.createElement(SvgShieldEllipsis, Object.assign({ fill: fill }, rest));
        case IconName.ShieldError:
            return React__default.createElement(SvgShieldError, Object.assign({ fill: fill }, rest));
        case IconName.SmartBanners:
            return React__default.createElement(SvgSmartBanners, Object.assign({ fill: fill }, rest));
        case IconName.StarFull:
            return React__default.createElement(SvgStarFull, Object.assign({ fill: fill }, rest));
        case IconName.Times:
            return React__default.createElement(SvgTimes, Object.assign({ fill: fill }, rest));
        case IconName.TriangleTop:
            return React__default.createElement(SvgTriangleTop, Object.assign({ fill: fill }, rest));
        case IconName.Upload:
            return React__default.createElement(SvgUpload, Object.assign({ fill: fill }, rest));
        case IconName.Warning:
            return React__default.createElement(SvgWarning, Object.assign({ fill: fill }, rest));
        case IconName.Web:
            return React__default.createElement(SvgWeb, Object.assign({ fill: fill }, rest));
        case IconName.WindowsPhone:
            return React__default.createElement(SvgWindowsPhone, Object.assign({ fill: fill }, rest));
        case IconName.Windows:
            return React__default.createElement(SvgWindows, Object.assign({ fill: fill }, rest));
        default: {
            const unknownIconName = name;
            throw new Error(`Unknown name of SVG icon: ${unknownIconName}`);
        }
    }
};

function toInteger(dirtyNumber) {
  if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) {
    return NaN;
  }

  var number = Number(dirtyNumber);

  if (isNaN(number)) {
    return number;
  }

  return number < 0 ? Math.ceil(number) : Math.floor(number);
}

function requiredArgs(required, args) {
  if (args.length < required) {
    throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
  }
}

/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @param {Date|Number} argument - the value to convert
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */

function toDate(argument) {
  requiredArgs(1, arguments);
  var argStr = Object.prototype.toString.call(argument); // Clone the date

  if (argument instanceof Date || typeof argument === 'object' && argStr === '[object Date]') {
    // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
  } else if (typeof argument === 'number' || argStr === '[object Number]') {
    return new Date(argument);
  } else {
    if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
      // eslint-disable-next-line no-console
      console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as arguments. Please use `parseISO` to parse strings. See: https://git.io/fjule"); // eslint-disable-next-line no-console

      console.warn(new Error().stack);
    }

    return new Date(NaN);
  }
}

/**
 * @name isAfter
 * @category Common Helpers
 * @summary Is the first date after the second one?
 *
 * @description
 * Is the first date after the second one?
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date that should be after the other one to return true
 * @param {Date|Number} dateToCompare - the date to compare with
 * @returns {Boolean} the first date is after the second date
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Is 10 July 1989 after 11 February 1987?
 * var result = isAfter(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> true
 */

function isAfter(dirtyDate, dirtyDateToCompare) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var dateToCompare = toDate(dirtyDateToCompare);
  return date.getTime() > dateToCompare.getTime();
}

var MILLISECONDS_IN_HOUR = 3600000;
var MILLISECONDS_IN_MINUTE = 60000;
var DEFAULT_ADDITIONAL_DIGITS = 2;
var patterns = {
  dateTimeDelimiter: /[T ]/,
  timeZoneDelimiter: /[Z ]/i,
  timezone: /([Z+-].*)$/
};
var dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
var timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
var timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
/**
 * @name parseISO
 * @category Common Helpers
 * @summary Parse ISO string
 *
 * @description
 * Parse the given string in ISO 8601 format and return an instance of Date.
 *
 * Function accepts complete ISO 8601 formats as well as partial implementations.
 * ISO 8601: http://en.wikipedia.org/wiki/ISO_8601
 *
 * If the argument isn't a string, the function cannot parse the string or
 * the values are invalid, it returns Invalid Date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - The previous `parse` implementation was renamed to `parseISO`.
 *
 *   ```javascript
 *   // Before v2.0.0
 *   parse('2016-01-01')
 *
 *   // v2.0.0 onward
 *   parseISO('2016-01-01')
 *   ```
 *
 * - `parseISO` now validates separate date and time values in ISO-8601 strings
 *   and returns `Invalid Date` if the date is invalid.
 *
 *   ```javascript
 *   parseISO('2018-13-32')
 *   //=> Invalid Date
 *   ```
 *
 * - `parseISO` now doesn't fall back to `new Date` constructor
 *   if it fails to parse a string argument. Instead, it returns `Invalid Date`.
 *
 * @param {String} argument - the value to convert
 * @param {Object} [options] - an object with options.
 * @param {0|1|2} [options.additionalDigits=2] - the additional number of digits in the extended year format
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Convert string '2014-02-11T11:30:30' to date:
 * var result = parseISO('2014-02-11T11:30:30')
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert string '+02014101' to date,
 * // if the additional number of digits in the extended year format is 1:
 * var result = parseISO('+02014101', { additionalDigits: 1 })
 * //=> Fri Apr 11 2014 00:00:00
 */

function parseISO(argument, dirtyOptions) {
  requiredArgs(1, arguments);
  var options = dirtyOptions || {};
  var additionalDigits = options.additionalDigits == null ? DEFAULT_ADDITIONAL_DIGITS : toInteger(options.additionalDigits);

  if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) {
    throw new RangeError('additionalDigits must be 0, 1 or 2');
  }

  if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) {
    return new Date(NaN);
  }

  var dateStrings = splitDateString(argument);
  var date;

  if (dateStrings.date) {
    var parseYearResult = parseYear(dateStrings.date, additionalDigits);
    date = parseDate(parseYearResult.restDateString, parseYearResult.year);
  }

  if (isNaN(date) || !date) {
    return new Date(NaN);
  }

  var timestamp = date.getTime();
  var time = 0;
  var offset;

  if (dateStrings.time) {
    time = parseTime(dateStrings.time);

    if (isNaN(time) || time === null) {
      return new Date(NaN);
    }
  }

  if (dateStrings.timezone) {
    offset = parseTimezone(dateStrings.timezone);

    if (isNaN(offset)) {
      return new Date(NaN);
    }
  } else {
    var dirtyDate = new Date(timestamp + time); // js parsed string assuming it's in UTC timezone
    // but we need it to be parsed in our timezone
    // so we use utc values to build date in our timezone.
    // Year values from 0 to 99 map to the years 1900 to 1999
    // so set year explicitly with setFullYear.

    var result = new Date(dirtyDate.getUTCFullYear(), dirtyDate.getUTCMonth(), dirtyDate.getUTCDate(), dirtyDate.getUTCHours(), dirtyDate.getUTCMinutes(), dirtyDate.getUTCSeconds(), dirtyDate.getUTCMilliseconds());
    result.setFullYear(dirtyDate.getUTCFullYear());
    return result;
  }

  return new Date(timestamp + time + offset);
}

function splitDateString(dateString) {
  var dateStrings = {};
  var array = dateString.split(patterns.dateTimeDelimiter);
  var timeString;

  if (/:/.test(array[0])) {
    dateStrings.date = null;
    timeString = array[0];
  } else {
    dateStrings.date = array[0];
    timeString = array[1];

    if (patterns.timeZoneDelimiter.test(dateStrings.date)) {
      dateStrings.date = dateString.split(patterns.timeZoneDelimiter)[0];
      timeString = dateString.substr(dateStrings.date.length, dateString.length);
    }
  }

  if (timeString) {
    var token = patterns.timezone.exec(timeString);

    if (token) {
      dateStrings.time = timeString.replace(token[1], '');
      dateStrings.timezone = token[1];
    } else {
      dateStrings.time = timeString;
    }
  }

  return dateStrings;
}

function parseYear(dateString, additionalDigits) {
  var regex = new RegExp('^(?:(\\d{4}|[+-]\\d{' + (4 + additionalDigits) + '})|(\\d{2}|[+-]\\d{' + (2 + additionalDigits) + '})$)');
  var captures = dateString.match(regex); // Invalid ISO-formatted year

  if (!captures) return {
    year: null
  };
  var year = captures[1] && parseInt(captures[1]);
  var century = captures[2] && parseInt(captures[2]);
  return {
    year: century == null ? year : century * 100,
    restDateString: dateString.slice((captures[1] || captures[2]).length)
  };
}

function parseDate(dateString, year) {
  // Invalid ISO-formatted year
  if (year === null) return null;
  var captures = dateString.match(dateRegex); // Invalid ISO-formatted string

  if (!captures) return null;
  var isWeekDate = !!captures[4];
  var dayOfYear = parseDateUnit(captures[1]);
  var month = parseDateUnit(captures[2]) - 1;
  var day = parseDateUnit(captures[3]);
  var week = parseDateUnit(captures[4]);
  var dayOfWeek = parseDateUnit(captures[5]) - 1;

  if (isWeekDate) {
    if (!validateWeekDate(year, week, dayOfWeek)) {
      return new Date(NaN);
    }

    return dayOfISOWeekYear(year, week, dayOfWeek);
  } else {
    var date = new Date(0);

    if (!validateDate(year, month, day) || !validateDayOfYearDate(year, dayOfYear)) {
      return new Date(NaN);
    }

    date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
    return date;
  }
}

function parseDateUnit(value) {
  return value ? parseInt(value) : 1;
}

function parseTime(timeString) {
  var captures = timeString.match(timeRegex);
  if (!captures) return null; // Invalid ISO-formatted time

  var hours = parseTimeUnit(captures[1]);
  var minutes = parseTimeUnit(captures[2]);
  var seconds = parseTimeUnit(captures[3]);

  if (!validateTime(hours, minutes, seconds)) {
    return NaN;
  }

  return hours * MILLISECONDS_IN_HOUR + minutes * MILLISECONDS_IN_MINUTE + seconds * 1000;
}

function parseTimeUnit(value) {
  return value && parseFloat(value.replace(',', '.')) || 0;
}

function parseTimezone(timezoneString) {
  if (timezoneString === 'Z') return 0;
  var captures = timezoneString.match(timezoneRegex);
  if (!captures) return 0;
  var sign = captures[1] === '+' ? -1 : 1;
  var hours = parseInt(captures[2]);
  var minutes = captures[3] && parseInt(captures[3]) || 0;

  if (!validateTimezone(hours, minutes)) {
    return NaN;
  }

  return sign * (hours * MILLISECONDS_IN_HOUR + minutes * MILLISECONDS_IN_MINUTE);
}

function dayOfISOWeekYear(isoWeekYear, week, day) {
  var date = new Date(0);
  date.setUTCFullYear(isoWeekYear, 0, 4);
  var fourthOfJanuaryDay = date.getUTCDay() || 7;
  var diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
  date.setUTCDate(date.getUTCDate() + diff);
  return date;
} // Validation functions
// February is null to handle the leap year (using ||)


var daysInMonths = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

function isLeapYearIndex(year) {
  return year % 400 === 0 || year % 4 === 0 && year % 100;
}

function validateDate(year, month, date) {
  return month >= 0 && month <= 11 && date >= 1 && date <= (daysInMonths[month] || (isLeapYearIndex(year) ? 29 : 28));
}

function validateDayOfYearDate(year, dayOfYear) {
  return dayOfYear >= 1 && dayOfYear <= (isLeapYearIndex(year) ? 366 : 365);
}

function validateWeekDate(_year, week, day) {
  return week >= 1 && week <= 53 && day >= 0 && day <= 6;
}

function validateTime(hours, minutes, seconds) {
  if (hours === 24) {
    return minutes === 0 && seconds === 0;
  }

  return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
}

function validateTimezone(_hours, minutes) {
  return minutes >= 0 && minutes <= 59;
}

var Language;
(function (Language) {
    Language["English"] = "en";
    Language["Spanish"] = "es";
    Language["Portuguese"] = "pt";
    Language["Chinese"] = "zh";
    Language["Japanese"] = "ja";
    Language["Korean"] = "ko";
    Language["Vietnamese"] = "vi";
    Language["Russian"] = "ru";
    Language["Turkish"] = "tr";
    Language["French"] = "fr";
})(Language || (Language = {}));
var UserRole;
(function (UserRole) {
    UserRole["Admin"] = "admin";
    UserRole["Editor"] = "editor";
    UserRole["Reader"] = "reader";
    UserRole["Custom"] = "custom";
})(UserRole || (UserRole = {}));
var AccountState;
(function (AccountState) {
    AccountState["Active"] = "active";
    AccountState["WaitingForData"] = "waiting_for_data";
    AccountState["SetupApp"] = "setup_app";
    AccountState["Paused"] = "paused";
})(AccountState || (AccountState = {}));
var FeatureKey;
(function (FeatureKey) {
    FeatureKey["Segmentation"] = "segmentation";
    FeatureKey["AudienceBuilder"] = "audience_builder";
    FeatureKey["ControlCenter"] = "control_center";
    FeatureKey["DataStudio"] = "datastudio";
    FeatureKey["SKAdNetwork"] = "skadnetwork";
    FeatureKey["SmartBanners"] = "smart_banners";
    FeatureKey["IosAppVerification"] = "ios_app_verification";
    FeatureKey["allowNewDashboardFeature"] = "allow_new_dashboard_by_default";
    FeatureKey["defaultSuiteAccess"] = "default_suite_access";
    FeatureKey["optionalSuiteAccess"] = "optional_suite_access";
    FeatureKey["displayClassicDashboardFeature"] = "display_classic_dashboards";
})(FeatureKey || (FeatureKey = {}));

function isPackageActive(account, packageName) {
    const currentPackage = account.packages.find(accountPackage => accountPackage.name === packageName);
    if (!currentPackage) {
        return false;
    }
    return isAfter(new Date(), parseISO(currentPackage.active_since + 'Z'));
}
function hasFeature(account, feature) {
    var _a;
    return !!((_a = account.features[feature]) === null || _a === void 0 ? void 0 : _a.enabled);
}
function hasCustomRole(user, role) {
    var _a, _b;
    const appLocalRoles = (_b = (_a = user.local_roles) === null || _a === void 0 ? void 0 : _a.mobile_apps) !== null && _b !== void 0 ? _b : [];
    return appLocalRoles.some(app => app.role === role);
}
function hasSegmentationPackageUtil(account) {
    var _a, _b;
    if (account.new_feature_scope) {
        return hasFeature(account, FeatureKey.Segmentation);
    }
    const isFeatureEnabled = !!((_b = (_a = account.features) === null || _a === void 0 ? void 0 : _a[FeatureKey.AudienceBuilder]) === null || _b === void 0 ? void 0 : _b.enabled);
    return isFeatureEnabled || isPackageActive(account, FeatureKey.AudienceBuilder);
}
function hasControlCenterPackageUtil(account) {
    var _a, _b;
    if (account.new_feature_scope) {
        return hasFeature(account, FeatureKey.ControlCenter);
    }
    const isFeatureEnabled = !!((_b = (_a = account.features) === null || _a === void 0 ? void 0 : _a[FeatureKey.ControlCenter]) === null || _b === void 0 ? void 0 : _b.enabled);
    return isFeatureEnabled || isPackageActive(account, FeatureKey.ControlCenter);
}
function getSortedLinks(links) {
    const initialList = {
        logo: [],
        top: [],
        bottom: [],
    };
    return links.reduce((sortedList, item) => {
        sortedList[item.position].push(item);
        return sortedList;
    }, initialList);
}
function generateUrl(link, baseUrl, props) {
    var _a;
    const url = link.url || ((_a = link.getUrl) === null || _a === void 0 ? void 0 : _a.call(link, props));
    if (!url) {
        return;
    }
    else if (link.name === 'suite-dashboard' || link.name === 'new-statistics' || link.name === 'sanSettings') {
        return url;
    }
    return `${baseUrl}${url}`;
}
function getVisibleProps(currentUser, currentAccount) {
    var _a;
    const isAdmin = currentUser.role === UserRole.Admin;
    const isEditor = currentUser.role === UserRole.Editor || hasCustomRole(currentUser, UserRole.Editor);
    const isCustom = currentUser.role === UserRole.Custom;
    const isAdvanced = currentUser.advanced_permissions === true;
    const onBoardingStates = [AccountState.WaitingForData, AccountState.SetupApp];
    const isOnBoarding = onBoardingStates.includes(currentAccount.state) && currentAccount.in_demo_period;
    const isWaitingForData = currentAccount.state === AccountState.WaitingForData;
    const isActive = currentAccount.state === AccountState.Active;
    const isSuperAdmin = currentUser.super_admin;
    const isMultipleAccount = currentUser.multiple_accounts_view;
    const hasCostData = !!((_a = currentUser.features.cost_data) === null || _a === void 0 ? void 0 : _a.enabled);
    const hasControlCenterPackage = hasControlCenterPackageUtil(currentAccount);
    const hasSegmentationPackage = hasSegmentationPackageUtil(currentAccount);
    const hasDataStudioAccess = hasFeature(currentAccount, FeatureKey.DataStudio);
    const hasSKAdNetworkFeature = hasFeature(currentAccount, FeatureKey.SKAdNetwork);
    const hasSmartBannersFeature = hasFeature(currentAccount, FeatureKey.SmartBanners);
    const hasAllowNewDashboardFeature = hasFeature(currentAccount, FeatureKey.allowNewDashboardFeature);
    const hasDefaultSuiteAccess = hasFeature(currentAccount, FeatureKey.defaultSuiteAccess);
    const hasOptionalSuiteAccess = hasFeature(currentAccount, FeatureKey.optionalSuiteAccess);
    const hasDisplayClassicDashboardFeature = hasFeature(currentAccount, FeatureKey.displayClassicDashboardFeature);
    return {
        isAdmin,
        isEditor,
        isCustom,
        isAdvanced,
        isOnBoarding,
        isWaitingForData,
        isActive,
        isSuperAdmin,
        isMultipleAccount,
        hasCostData,
        hasControlCenterPackage,
        hasSegmentationPackage,
        hasDataStudioAccess,
        hasSKAdNetworkFeature,
        hasSmartBannersFeature,
        hasAllowNewDashboardFeature,
        hasDefaultSuiteAccess,
        hasOptionalSuiteAccess,
        hasDisplayClassicDashboardFeature,
    };
}

const oldEnvRegex = {
    staging: /dash-qa(-\d)?\.adjust/,
    demo: /dash-demo(-\d)?\.adjust/,
    prod: /dash\.adjust/,
};
const getSuiteHost = () => {
    var _a, _b, _c;
    const { host } = window.location;
    if (oldEnvRegex.staging.test(host)) {
        const qaNumber = ((_a = host.match(oldEnvRegex.staging)) === null || _a === void 0 ? void 0 : _a[1]) || '-1';
        return `https://staging${qaNumber}.suite.adjust.com`;
    }
    else if (oldEnvRegex.demo.test(host)) {
        const demoNumber = ((_b = host.match(oldEnvRegex.demo)) === null || _b === void 0 ? void 0 : _b[1]) || '-1';
        return `https://demo${demoNumber}.suite.adjust.com`;
    }
    else if (oldEnvRegex.prod.test(host)) {
        return 'https://suite.adjust.com';
    }
    // For local development
    if (host.includes('local.adjust.com')) {
        const qaNumber = ((_c = (process.env.NODE_ENV || 'qa-1').match(/\d+/)) === null || _c === void 0 ? void 0 : _c[0]) || '1';
        return `https://staging-${qaNumber}.suite.adjust.com`;
    }
    return `https://${host}`;
};
const classicRedirectToSuite = (to) => {
    const suiteDomain = getSuiteHost();
    const toEncoded = encodeURIComponent(to);
    return `${suiteDomain}/classic-redirect?from=generic_dash&to=${toEncoded}`;
};

var Position;
(function (Position) {
    Position["Top"] = "top";
    Position["Bottom"] = "bottom";
    Position["Logo"] = "logo";
})(Position || (Position = {}));

const getNavbarConfig = (t, toggleSidebar) => [
    {
        name: 'apps',
        label: t('menu.apps'),
        icon: IconName.Apps,
        url: '/#/',
        position: Position.Top,
        checkVisibility: (props) => !props.isOnBoarding && (props.isSuperAdmin || props.isActive),
    },
    {
        name: 'on-boarding',
        label: t('menu.apps'),
        icon: IconName.Apps,
        url: '/#/on-boarding',
        position: Position.Top,
        checkVisibility: (props) => props.isOnBoarding && (props.isSuperAdmin || !props.isActive),
    },
    {
        name: 'suite-dashboard',
        label: t('menu.suite-dashboard'),
        icon: IconName.AdjustLogo,
        url: classicRedirectToSuite('/'),
        position: Position.Top,
        checkVisibility: ({ isSuperAdmin, isActive, hasDefaultSuiteAccess, hasOptionalSuiteAccess, }) => isSuperAdmin || (isActive && (hasDefaultSuiteAccess || hasOptionalSuiteAccess)),
    },
    {
        name: 'new-statistics',
        label: t('menu.new-dashboard'),
        icon: IconName.Datascape,
        url: classicRedirectToSuite('/datascape/overview'),
        position: Position.Top,
        checkVisibility: ({ isSuperAdmin, isActive, hasAllowNewDashboardFeature, hasDefaultSuiteAccess, }) => isSuperAdmin || (isActive && hasAllowNewDashboardFeature && !hasDefaultSuiteAccess),
    },
    {
        name: 'statistics',
        label: t('menu.statistics'),
        icon: IconName.Graph,
        url: '/#/statistics-apps',
        position: Position.Top,
        checkVisibility: ({ isSuperAdmin, isActive, hasAllowNewDashboardFeature, hasDisplayClassicDashboardFeature, }) => isSuperAdmin ||
            (isActive && !hasAllowNewDashboardFeature) ||
            (isActive && hasAllowNewDashboardFeature && hasDisplayClassicDashboardFeature),
    },
    {
        name: 'statisticsAppsMultiple',
        label: t('menu.multi-account-apps'),
        icon: IconName.Graph,
        url: '/#/statistics-apps/multiple',
        position: Position.Logo,
        checkVisibility: (props) => props.isActive && props.isMultipleAccount,
    },
    {
        name: 'segmentation',
        label: t('menu.audience-builder'),
        icon: IconName.Audience,
        url: '/#/audience-builder',
        position: Position.Top,
        checkVisibility: (props) => (props.isSuperAdmin || props.isActive) && (props.isAdmin || props.isEditor),
    },
    {
        name: 'deeplink',
        label: t('menu.deeplink-generator'),
        icon: IconName.DeepLink,
        url: '/deeplink-generator',
        position: Position.Top,
        checkVisibility: (props) => (props.isSuperAdmin || props.isActive || props.isWaitingForData) && (props.isAdmin || props.isEditor),
    },
    {
        name: 'control-center',
        label: t('menu.control-center'),
        icon: IconName.ControlCenter,
        url: '/control-center',
        position: Position.Top,
        checkVisibility: ({ isSuperAdmin, isActive, isWaitingForData, hasControlCenterPackage, hasSKAdNetworkFeature, hasAllowNewDashboardFeature, hasDisplayClassicDashboardFeature, }) => (hasControlCenterPackage || hasSKAdNetworkFeature) &&
            (isSuperAdmin ||
                isWaitingForData ||
                (isActive && !hasAllowNewDashboardFeature) ||
                (isActive && hasAllowNewDashboardFeature && hasDisplayClassicDashboardFeature)),
    },
    {
        name: 'accountSettings',
        label: t('menu.settings.account'),
        icon: IconName.Settings,
        url: '/account/data',
        position: Position.Bottom,
        checkVisibility: (props) => props.isAdmin,
    },
    {
        name: 'accountSettings.profile',
        label: t('menu.settings.profile'),
        icon: IconName.Settings,
        onClick: () => toggleSidebar('userSettings'),
        position: Position.Bottom,
        checkVisibility: (props) => !props.isAdmin,
    },
    {
        name: 'sanSettings',
        label: t('menu.settings.san'),
        icon: IconName.AdAccounts,
        getUrl: (props) => props.hasDefaultSuiteAccess || props.hasOptionalSuiteAccess
            ? classicRedirectToSuite('/connections')
            : '/#/settings/san',
        position: Position.Bottom,
        checkVisibility: (props) => props.isAdmin || props.isEditor,
    },
    {
        name: 'data-canvas',
        label: t('menu.data-studio'),
        icon: IconName.DataCanvas,
        url: '/data-canvas',
        position: Position.Top,
        extraClasses: ['hide-for-mobile'],
        checkVisibility: ({ isSuperAdmin, isAdvanced, hasDataStudioAccess, hasAllowNewDashboardFeature, hasDisplayClassicDashboardFeature, }) => isSuperAdmin ||
            (hasDataStudioAccess && !isAdvanced && !hasAllowNewDashboardFeature) ||
            (hasDataStudioAccess && !isAdvanced && hasAllowNewDashboardFeature && hasDisplayClassicDashboardFeature),
    },
    {
        name: 'smart-banners',
        label: t('menu.smart-banners'),
        icon: IconName.SmartBanners,
        url: '/smart-banners',
        position: Position.Top,
        checkVisibility: ({ isSuperAdmin, hasSmartBannersFeature }) => isSuperAdmin || hasSmartBannersFeature,
    },
];

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function unwrapExports (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, basedir, module) {
	return module = {
	  path: basedir,
	  exports: {},
	  require: function (path, base) {
      return commonjsRequire(path, (base === undefined || base === null) ? module.path : base);
    }
	}, fn(module, module.exports), module.exports;
}

function commonjsRequire () {
	throw new Error('Dynamic requires are not currently supported by @rollup/plugin-commonjs');
}

var classnames = createCommonjsModule(function (module) {
/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg) && arg.length) {
				var inner = classNames.apply(null, arg);
				if (inner) {
					classes.push(inner);
				}
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if ( module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else {
		window.classNames = classNames;
	}
}());
});

const LinkList = ({ linkConfigList, activeLink }) => (React__default.createElement(React__default.Fragment, null, linkConfigList.map(link => (React__default.createElement("li", { key: link.name, className: classnames(link.extraClasses, {
        active: activeLink === link.name,
    }) },
    React__default.createElement("a", { href: link.url, onClick: link.onClick },
        React__default.createElement(SvgIcon, { name: link.icon, className: "main-menu__list-icon" }),
        React__default.createElement("span", null, link.label)))))));

const MenuHeader = ({ activeLink, toggleSidebar, linkConfigList }) => (React__default.createElement("div", { className: classnames('main-menu__header', {
        'main-menu__header--with-items': !!linkConfigList.length,
    }) },
    React__default.createElement("button", { className: "main-menu__logo-button", onClick: () => toggleSidebar() },
        React__default.createElement(SvgIcon, { name: IconName.LogotypeWhite, className: "main-menu__logo" })),
    !!linkConfigList.length && (React__default.createElement("ul", { className: "main-menu__list" },
        React__default.createElement(LinkList, { linkConfigList: linkConfigList, activeLink: activeLink })))));

const docsUrl = 'help.adjust.com';
const gettext = (value) => value;
function getHelpCenterUrl(language = Language.English) {
    if (language === Language.English) {
        return `https://${docsUrl}`;
    }
    return `https://${docsUrl}/${language}`;
}

const MenuContent = ({ activeLink, language, linkConfigListTop, linkConfigListBottom, t, }) => (React__default.createElement("div", { className: "main-menu__content" },
    React__default.createElement("ul", { className: "main-menu__list" },
        React__default.createElement(LinkList, { linkConfigList: linkConfigListTop, activeLink: activeLink })),
    React__default.createElement("ul", { className: "main-menu__list" },
        React__default.createElement(LinkList, { linkConfigList: linkConfigListBottom, activeLink: activeLink }),
        React__default.createElement("li", null,
            React__default.createElement("a", { href: getHelpCenterUrl(language), target: "_blank", rel: "noopener noreferrer" },
                React__default.createElement(SvgIcon, { name: IconName.Docs, className: "main-menu__list-icon" }),
                React__default.createElement("span", null, t('menu.docs')))))));

function areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) {
        return false;
    }
    for (var i = 0; i < newInputs.length; i++) {
        if (newInputs[i] !== lastInputs[i]) {
            return false;
        }
    }
    return true;
}

function memoizeOne(resultFn, isEqual) {
    if (isEqual === void 0) { isEqual = areInputsEqual; }
    var lastThis;
    var lastArgs = [];
    var lastResult;
    var calledOnce = false;
    function memoized() {
        var newArgs = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            newArgs[_i] = arguments[_i];
        }
        if (calledOnce && lastThis === this && isEqual(newArgs, lastArgs)) {
            return lastResult;
        }
        lastResult = resultFn.apply(this, newArgs);
        calledOnce = true;
        lastThis = this;
        lastArgs = newArgs;
        return lastResult;
    }
    return memoized;
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

var inheritsLoose = _inheritsLoose;

/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/
// $FlowFixMe
function sheetForTag(tag) {
  if (tag.sheet) {
    // $FlowFixMe
    return tag.sheet;
  } // this weirdness brought to you by firefox

  /* istanbul ignore next */


  for (var i = 0; i < document.styleSheets.length; i++) {
    if (document.styleSheets[i].ownerNode === tag) {
      // $FlowFixMe
      return document.styleSheets[i];
    }
  }
}

function createStyleElement(options) {
  var tag = document.createElement('style');
  tag.setAttribute('data-emotion', options.key);

  if (options.nonce !== undefined) {
    tag.setAttribute('nonce', options.nonce);
  }

  tag.appendChild(document.createTextNode(''));
  return tag;
}

var StyleSheet =
/*#__PURE__*/
function () {
  function StyleSheet(options) {
    this.isSpeedy = options.speedy === undefined ? process.env.NODE_ENV === 'production' : options.speedy;
    this.tags = [];
    this.ctr = 0;
    this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets

    this.key = options.key;
    this.container = options.container;
    this.before = null;
  }

  var _proto = StyleSheet.prototype;

  _proto.insert = function insert(rule) {
    // the max length is how many rules we have per style tag, it's 65000 in speedy mode
    // it's 1 in dev because we insert source maps that map a single rule to a location
    // and you can only have one source map per style tag
    if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) {
      var _tag = createStyleElement(this);

      var before;

      if (this.tags.length === 0) {
        before = this.before;
      } else {
        before = this.tags[this.tags.length - 1].nextSibling;
      }

      this.container.insertBefore(_tag, before);
      this.tags.push(_tag);
    }

    var tag = this.tags[this.tags.length - 1];

    if (this.isSpeedy) {
      var sheet = sheetForTag(tag);

      try {
        // this is a really hot path
        // we check the second character first because having "i"
        // as the second character will happen less often than
        // having "@" as the first character
        var isImportRule = rule.charCodeAt(1) === 105 && rule.charCodeAt(0) === 64; // this is the ultrafast version, works across browsers
        // the big drawback is that the css won't be editable in devtools

        sheet.insertRule(rule, // we need to insert @import rules before anything else
        // otherwise there will be an error
        // technically this means that the @import rules will
        // _usually_(not always since there could be multiple style tags)
        // be the first ones in prod and generally later in dev
        // this shouldn't really matter in the real world though
        // @import is generally only used for font faces from google fonts and etc.
        // so while this could be technically correct then it would be slower and larger
        // for a tiny bit of correctness that won't matter in the real world
        isImportRule ? 0 : sheet.cssRules.length);
      } catch (e) {
        if (process.env.NODE_ENV !== 'production') {
          console.warn("There was a problem inserting the following rule: \"" + rule + "\"", e);
        }
      }
    } else {
      tag.appendChild(document.createTextNode(rule));
    }

    this.ctr++;
  };

  _proto.flush = function flush() {
    // $FlowFixMe
    this.tags.forEach(function (tag) {
      return tag.parentNode.removeChild(tag);
    });
    this.tags = [];
    this.ctr = 0;
  };

  return StyleSheet;
}();

function stylis_min (W) {
  function M(d, c, e, h, a) {
    for (var m = 0, b = 0, v = 0, n = 0, q, g, x = 0, K = 0, k, u = k = q = 0, l = 0, r = 0, I = 0, t = 0, B = e.length, J = B - 1, y, f = '', p = '', F = '', G = '', C; l < B;) {
      g = e.charCodeAt(l);
      l === J && 0 !== b + n + v + m && (0 !== b && (g = 47 === b ? 10 : 47), n = v = m = 0, B++, J++);

      if (0 === b + n + v + m) {
        if (l === J && (0 < r && (f = f.replace(N, '')), 0 < f.trim().length)) {
          switch (g) {
            case 32:
            case 9:
            case 59:
            case 13:
            case 10:
              break;

            default:
              f += e.charAt(l);
          }

          g = 59;
        }

        switch (g) {
          case 123:
            f = f.trim();
            q = f.charCodeAt(0);
            k = 1;

            for (t = ++l; l < B;) {
              switch (g = e.charCodeAt(l)) {
                case 123:
                  k++;
                  break;

                case 125:
                  k--;
                  break;

                case 47:
                  switch (g = e.charCodeAt(l + 1)) {
                    case 42:
                    case 47:
                      a: {
                        for (u = l + 1; u < J; ++u) {
                          switch (e.charCodeAt(u)) {
                            case 47:
                              if (42 === g && 42 === e.charCodeAt(u - 1) && l + 2 !== u) {
                                l = u + 1;
                                break a;
                              }

                              break;

                            case 10:
                              if (47 === g) {
                                l = u + 1;
                                break a;
                              }

                          }
                        }

                        l = u;
                      }

                  }

                  break;

                case 91:
                  g++;

                case 40:
                  g++;

                case 34:
                case 39:
                  for (; l++ < J && e.charCodeAt(l) !== g;) {
                  }

              }

              if (0 === k) break;
              l++;
            }

            k = e.substring(t, l);
            0 === q && (q = (f = f.replace(ca, '').trim()).charCodeAt(0));

            switch (q) {
              case 64:
                0 < r && (f = f.replace(N, ''));
                g = f.charCodeAt(1);

                switch (g) {
                  case 100:
                  case 109:
                  case 115:
                  case 45:
                    r = c;
                    break;

                  default:
                    r = O;
                }

                k = M(c, r, k, g, a + 1);
                t = k.length;
                0 < A && (r = X(O, f, I), C = H(3, k, r, c, D, z, t, g, a, h), f = r.join(''), void 0 !== C && 0 === (t = (k = C.trim()).length) && (g = 0, k = ''));
                if (0 < t) switch (g) {
                  case 115:
                    f = f.replace(da, ea);

                  case 100:
                  case 109:
                  case 45:
                    k = f + '{' + k + '}';
                    break;

                  case 107:
                    f = f.replace(fa, '$1 $2');
                    k = f + '{' + k + '}';
                    k = 1 === w || 2 === w && L('@' + k, 3) ? '@-webkit-' + k + '@' + k : '@' + k;
                    break;

                  default:
                    k = f + k, 112 === h && (k = (p += k, ''));
                } else k = '';
                break;

              default:
                k = M(c, X(c, f, I), k, h, a + 1);
            }

            F += k;
            k = I = r = u = q = 0;
            f = '';
            g = e.charCodeAt(++l);
            break;

          case 125:
          case 59:
            f = (0 < r ? f.replace(N, '') : f).trim();
            if (1 < (t = f.length)) switch (0 === u && (q = f.charCodeAt(0), 45 === q || 96 < q && 123 > q) && (t = (f = f.replace(' ', ':')).length), 0 < A && void 0 !== (C = H(1, f, c, d, D, z, p.length, h, a, h)) && 0 === (t = (f = C.trim()).length) && (f = '\x00\x00'), q = f.charCodeAt(0), g = f.charCodeAt(1), q) {
              case 0:
                break;

              case 64:
                if (105 === g || 99 === g) {
                  G += f + e.charAt(l);
                  break;
                }

              default:
                58 !== f.charCodeAt(t - 1) && (p += P(f, q, g, f.charCodeAt(2)));
            }
            I = r = u = q = 0;
            f = '';
            g = e.charCodeAt(++l);
        }
      }

      switch (g) {
        case 13:
        case 10:
          47 === b ? b = 0 : 0 === 1 + q && 107 !== h && 0 < f.length && (r = 1, f += '\x00');
          0 < A * Y && H(0, f, c, d, D, z, p.length, h, a, h);
          z = 1;
          D++;
          break;

        case 59:
        case 125:
          if (0 === b + n + v + m) {
            z++;
            break;
          }

        default:
          z++;
          y = e.charAt(l);

          switch (g) {
            case 9:
            case 32:
              if (0 === n + m + b) switch (x) {
                case 44:
                case 58:
                case 9:
                case 32:
                  y = '';
                  break;

                default:
                  32 !== g && (y = ' ');
              }
              break;

            case 0:
              y = '\\0';
              break;

            case 12:
              y = '\\f';
              break;

            case 11:
              y = '\\v';
              break;

            case 38:
              0 === n + b + m && (r = I = 1, y = '\f' + y);
              break;

            case 108:
              if (0 === n + b + m + E && 0 < u) switch (l - u) {
                case 2:
                  112 === x && 58 === e.charCodeAt(l - 3) && (E = x);

                case 8:
                  111 === K && (E = K);
              }
              break;

            case 58:
              0 === n + b + m && (u = l);
              break;

            case 44:
              0 === b + v + n + m && (r = 1, y += '\r');
              break;

            case 34:
            case 39:
              0 === b && (n = n === g ? 0 : 0 === n ? g : n);
              break;

            case 91:
              0 === n + b + v && m++;
              break;

            case 93:
              0 === n + b + v && m--;
              break;

            case 41:
              0 === n + b + m && v--;
              break;

            case 40:
              if (0 === n + b + m) {
                if (0 === q) switch (2 * x + 3 * K) {
                  case 533:
                    break;

                  default:
                    q = 1;
                }
                v++;
              }

              break;

            case 64:
              0 === b + v + n + m + u + k && (k = 1);
              break;

            case 42:
            case 47:
              if (!(0 < n + m + v)) switch (b) {
                case 0:
                  switch (2 * g + 3 * e.charCodeAt(l + 1)) {
                    case 235:
                      b = 47;
                      break;

                    case 220:
                      t = l, b = 42;
                  }

                  break;

                case 42:
                  47 === g && 42 === x && t + 2 !== l && (33 === e.charCodeAt(t + 2) && (p += e.substring(t, l + 1)), y = '', b = 0);
              }
          }

          0 === b && (f += y);
      }

      K = x;
      x = g;
      l++;
    }

    t = p.length;

    if (0 < t) {
      r = c;
      if (0 < A && (C = H(2, p, r, d, D, z, t, h, a, h), void 0 !== C && 0 === (p = C).length)) return G + p + F;
      p = r.join(',') + '{' + p + '}';

      if (0 !== w * E) {
        2 !== w || L(p, 2) || (E = 0);

        switch (E) {
          case 111:
            p = p.replace(ha, ':-moz-$1') + p;
            break;

          case 112:
            p = p.replace(Q, '::-webkit-input-$1') + p.replace(Q, '::-moz-$1') + p.replace(Q, ':-ms-input-$1') + p;
        }

        E = 0;
      }
    }

    return G + p + F;
  }

  function X(d, c, e) {
    var h = c.trim().split(ia);
    c = h;
    var a = h.length,
        m = d.length;

    switch (m) {
      case 0:
      case 1:
        var b = 0;

        for (d = 0 === m ? '' : d[0] + ' '; b < a; ++b) {
          c[b] = Z(d, c[b], e).trim();
        }

        break;

      default:
        var v = b = 0;

        for (c = []; b < a; ++b) {
          for (var n = 0; n < m; ++n) {
            c[v++] = Z(d[n] + ' ', h[b], e).trim();
          }
        }

    }

    return c;
  }

  function Z(d, c, e) {
    var h = c.charCodeAt(0);
    33 > h && (h = (c = c.trim()).charCodeAt(0));

    switch (h) {
      case 38:
        return c.replace(F, '$1' + d.trim());

      case 58:
        return d.trim() + c.replace(F, '$1' + d.trim());

      default:
        if (0 < 1 * e && 0 < c.indexOf('\f')) return c.replace(F, (58 === d.charCodeAt(0) ? '' : '$1') + d.trim());
    }

    return d + c;
  }

  function P(d, c, e, h) {
    var a = d + ';',
        m = 2 * c + 3 * e + 4 * h;

    if (944 === m) {
      d = a.indexOf(':', 9) + 1;
      var b = a.substring(d, a.length - 1).trim();
      b = a.substring(0, d).trim() + b + ';';
      return 1 === w || 2 === w && L(b, 1) ? '-webkit-' + b + b : b;
    }

    if (0 === w || 2 === w && !L(a, 1)) return a;

    switch (m) {
      case 1015:
        return 97 === a.charCodeAt(10) ? '-webkit-' + a + a : a;

      case 951:
        return 116 === a.charCodeAt(3) ? '-webkit-' + a + a : a;

      case 963:
        return 110 === a.charCodeAt(5) ? '-webkit-' + a + a : a;

      case 1009:
        if (100 !== a.charCodeAt(4)) break;

      case 969:
      case 942:
        return '-webkit-' + a + a;

      case 978:
        return '-webkit-' + a + '-moz-' + a + a;

      case 1019:
      case 983:
        return '-webkit-' + a + '-moz-' + a + '-ms-' + a + a;

      case 883:
        if (45 === a.charCodeAt(8)) return '-webkit-' + a + a;
        if (0 < a.indexOf('image-set(', 11)) return a.replace(ja, '$1-webkit-$2') + a;
        break;

      case 932:
        if (45 === a.charCodeAt(4)) switch (a.charCodeAt(5)) {
          case 103:
            return '-webkit-box-' + a.replace('-grow', '') + '-webkit-' + a + '-ms-' + a.replace('grow', 'positive') + a;

          case 115:
            return '-webkit-' + a + '-ms-' + a.replace('shrink', 'negative') + a;

          case 98:
            return '-webkit-' + a + '-ms-' + a.replace('basis', 'preferred-size') + a;
        }
        return '-webkit-' + a + '-ms-' + a + a;

      case 964:
        return '-webkit-' + a + '-ms-flex-' + a + a;

      case 1023:
        if (99 !== a.charCodeAt(8)) break;
        b = a.substring(a.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify');
        return '-webkit-box-pack' + b + '-webkit-' + a + '-ms-flex-pack' + b + a;

      case 1005:
        return ka.test(a) ? a.replace(aa, ':-webkit-') + a.replace(aa, ':-moz-') + a : a;

      case 1e3:
        b = a.substring(13).trim();
        c = b.indexOf('-') + 1;

        switch (b.charCodeAt(0) + b.charCodeAt(c)) {
          case 226:
            b = a.replace(G, 'tb');
            break;

          case 232:
            b = a.replace(G, 'tb-rl');
            break;

          case 220:
            b = a.replace(G, 'lr');
            break;

          default:
            return a;
        }

        return '-webkit-' + a + '-ms-' + b + a;

      case 1017:
        if (-1 === a.indexOf('sticky', 9)) break;

      case 975:
        c = (a = d).length - 10;
        b = (33 === a.charCodeAt(c) ? a.substring(0, c) : a).substring(d.indexOf(':', 7) + 1).trim();

        switch (m = b.charCodeAt(0) + (b.charCodeAt(7) | 0)) {
          case 203:
            if (111 > b.charCodeAt(8)) break;

          case 115:
            a = a.replace(b, '-webkit-' + b) + ';' + a;
            break;

          case 207:
          case 102:
            a = a.replace(b, '-webkit-' + (102 < m ? 'inline-' : '') + 'box') + ';' + a.replace(b, '-webkit-' + b) + ';' + a.replace(b, '-ms-' + b + 'box') + ';' + a;
        }

        return a + ';';

      case 938:
        if (45 === a.charCodeAt(5)) switch (a.charCodeAt(6)) {
          case 105:
            return b = a.replace('-items', ''), '-webkit-' + a + '-webkit-box-' + b + '-ms-flex-' + b + a;

          case 115:
            return '-webkit-' + a + '-ms-flex-item-' + a.replace(ba, '') + a;

          default:
            return '-webkit-' + a + '-ms-flex-line-pack' + a.replace('align-content', '').replace(ba, '') + a;
        }
        break;

      case 973:
      case 989:
        if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4)) break;

      case 931:
      case 953:
        if (!0 === la.test(d)) return 115 === (b = d.substring(d.indexOf(':') + 1)).charCodeAt(0) ? P(d.replace('stretch', 'fill-available'), c, e, h).replace(':fill-available', ':stretch') : a.replace(b, '-webkit-' + b) + a.replace(b, '-moz-' + b.replace('fill-', '')) + a;
        break;

      case 962:
        if (a = '-webkit-' + a + (102 === a.charCodeAt(5) ? '-ms-' + a : '') + a, 211 === e + h && 105 === a.charCodeAt(13) && 0 < a.indexOf('transform', 10)) return a.substring(0, a.indexOf(';', 27) + 1).replace(ma, '$1-webkit-$2') + a;
    }

    return a;
  }

  function L(d, c) {
    var e = d.indexOf(1 === c ? ':' : '{'),
        h = d.substring(0, 3 !== c ? e : 10);
    e = d.substring(e + 1, d.length - 1);
    return R(2 !== c ? h : h.replace(na, '$1'), e, c);
  }

  function ea(d, c) {
    var e = P(c, c.charCodeAt(0), c.charCodeAt(1), c.charCodeAt(2));
    return e !== c + ';' ? e.replace(oa, ' or ($1)').substring(4) : '(' + c + ')';
  }

  function H(d, c, e, h, a, m, b, v, n, q) {
    for (var g = 0, x = c, w; g < A; ++g) {
      switch (w = S[g].call(B, d, x, e, h, a, m, b, v, n, q)) {
        case void 0:
        case !1:
        case !0:
        case null:
          break;

        default:
          x = w;
      }
    }

    if (x !== c) return x;
  }

  function T(d) {
    switch (d) {
      case void 0:
      case null:
        A = S.length = 0;
        break;

      default:
        if ('function' === typeof d) S[A++] = d;else if ('object' === typeof d) for (var c = 0, e = d.length; c < e; ++c) {
          T(d[c]);
        } else Y = !!d | 0;
    }

    return T;
  }

  function U(d) {
    d = d.prefix;
    void 0 !== d && (R = null, d ? 'function' !== typeof d ? w = 1 : (w = 2, R = d) : w = 0);
    return U;
  }

  function B(d, c) {
    var e = d;
    33 > e.charCodeAt(0) && (e = e.trim());
    V = e;
    e = [V];

    if (0 < A) {
      var h = H(-1, c, e, e, D, z, 0, 0, 0, 0);
      void 0 !== h && 'string' === typeof h && (c = h);
    }

    var a = M(O, e, c, 0, 0);
    0 < A && (h = H(-2, a, e, e, D, z, a.length, 0, 0, 0), void 0 !== h && (a = h));
    V = '';
    E = 0;
    z = D = 1;
    return a;
  }

  var ca = /^\0+/g,
      N = /[\0\r\f]/g,
      aa = /: */g,
      ka = /zoo|gra/,
      ma = /([,: ])(transform)/g,
      ia = /,\r+?/g,
      F = /([\t\r\n ])*\f?&/g,
      fa = /@(k\w+)\s*(\S*)\s*/,
      Q = /::(place)/g,
      ha = /:(read-only)/g,
      G = /[svh]\w+-[tblr]{2}/,
      da = /\(\s*(.*)\s*\)/g,
      oa = /([\s\S]*?);/g,
      ba = /-self|flex-/g,
      na = /[^]*?(:[rp][el]a[\w-]+)[^]*/,
      la = /stretch|:\s*\w+\-(?:conte|avail)/,
      ja = /([^-])(image-set\()/,
      z = 1,
      D = 1,
      E = 0,
      w = 1,
      O = [],
      S = [],
      A = 0,
      R = null,
      Y = 0,
      V = '';
  B.use = T;
  B.set = U;
  void 0 !== W && U(W);
  return B;
}

var weakMemoize = function weakMemoize(func) {
  // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
  var cache = new WeakMap();
  return function (arg) {
    if (cache.has(arg)) {
      // $FlowFixMe
      return cache.get(arg);
    }

    var ret = func(arg);
    cache.set(arg, ret);
    return ret;
  };
};

// https://github.com/thysultan/stylis.js/tree/master/plugins/rule-sheet
// inlined to avoid umd wrapper and peerDep warnings/installing stylis
// since we use stylis after closure compiler
var delimiter = '/*|*/';
var needle = delimiter + '}';

function toSheet(block) {
  if (block) {
    Sheet.current.insert(block + '}');
  }
}

var Sheet = {
  current: null
};
var ruleSheet = function ruleSheet(context, content, selectors, parents, line, column, length, ns, depth, at) {
  switch (context) {
    // property
    case 1:
      {
        switch (content.charCodeAt(0)) {
          case 64:
            {
              // @import
              Sheet.current.insert(content + ';');
              return '';
            }
          // charcode for l

          case 108:
            {
              // charcode for b
              // this ignores label
              if (content.charCodeAt(2) === 98) {
                return '';
              }
            }
        }

        break;
      }
    // selector

    case 2:
      {
        if (ns === 0) return content + delimiter;
        break;
      }
    // at-rule

    case 3:
      {
        switch (ns) {
          // @font-face, @page
          case 102:
          case 112:
            {
              Sheet.current.insert(selectors[0] + content);
              return '';
            }

          default:
            {
              return content + (at === 0 ? delimiter : '');
            }
        }
      }

    case -2:
      {
        content.split(needle).forEach(toSheet);
      }
  }
};
var removeLabel = function removeLabel(context, content) {
  if (context === 1 && // charcode for l
  content.charCodeAt(0) === 108 && // charcode for b
  content.charCodeAt(2) === 98 // this ignores label
  ) {
      return '';
    }
};

var isBrowser = typeof document !== 'undefined';
var rootServerStylisCache = {};
var getServerStylisCache = isBrowser ? undefined : weakMemoize(function () {
  var getCache = weakMemoize(function () {
    return {};
  });
  var prefixTrueCache = {};
  var prefixFalseCache = {};
  return function (prefix) {
    if (prefix === undefined || prefix === true) {
      return prefixTrueCache;
    }

    if (prefix === false) {
      return prefixFalseCache;
    }

    return getCache(prefix);
  };
});

var createCache = function createCache(options) {
  if (options === undefined) options = {};
  var key = options.key || 'css';
  var stylisOptions;

  if (options.prefix !== undefined) {
    stylisOptions = {
      prefix: options.prefix
    };
  }

  var stylis = new stylis_min(stylisOptions);

  if (process.env.NODE_ENV !== 'production') {
    // $FlowFixMe
    if (/[^a-z-]/.test(key)) {
      throw new Error("Emotion key must only contain lower case alphabetical characters and - but \"" + key + "\" was passed");
    }
  }

  var inserted = {}; // $FlowFixMe

  var container;

  if (isBrowser) {
    container = options.container || document.head;
    var nodes = document.querySelectorAll("style[data-emotion-" + key + "]");
    Array.prototype.forEach.call(nodes, function (node) {
      var attrib = node.getAttribute("data-emotion-" + key); // $FlowFixMe

      attrib.split(' ').forEach(function (id) {
        inserted[id] = true;
      });

      if (node.parentNode !== container) {
        container.appendChild(node);
      }
    });
  }

  var _insert;

  if (isBrowser) {
    stylis.use(options.stylisPlugins)(ruleSheet);

    _insert = function insert(selector, serialized, sheet, shouldCache) {
      var name = serialized.name;
      Sheet.current = sheet;

      if (process.env.NODE_ENV !== 'production' && serialized.map !== undefined) {
        var map = serialized.map;
        Sheet.current = {
          insert: function insert(rule) {
            sheet.insert(rule + map);
          }
        };
      }

      stylis(selector, serialized.styles);

      if (shouldCache) {
        cache.inserted[name] = true;
      }
    };
  } else {
    stylis.use(removeLabel);
    var serverStylisCache = rootServerStylisCache;

    if (options.stylisPlugins || options.prefix !== undefined) {
      stylis.use(options.stylisPlugins); // $FlowFixMe

      serverStylisCache = getServerStylisCache(options.stylisPlugins || rootServerStylisCache)(options.prefix);
    }

    var getRules = function getRules(selector, serialized) {
      var name = serialized.name;

      if (serverStylisCache[name] === undefined) {
        serverStylisCache[name] = stylis(selector, serialized.styles);
      }

      return serverStylisCache[name];
    };

    _insert = function _insert(selector, serialized, sheet, shouldCache) {
      var name = serialized.name;
      var rules = getRules(selector, serialized);

      if (cache.compat === undefined) {
        // in regular mode, we don't set the styles on the inserted cache
        // since we don't need to and that would be wasting memory
        // we return them so that they are rendered in a style tag
        if (shouldCache) {
          cache.inserted[name] = true;
        }

        if ( // using === development instead of !== production
        // because if people do ssr in tests, the source maps showing up would be annoying
        process.env.NODE_ENV === 'development' && serialized.map !== undefined) {
          return rules + serialized.map;
        }

        return rules;
      } else {
        // in compat mode, we put the styles on the inserted cache so
        // that emotion-server can pull out the styles
        // except when we don't want to cache it which was in Global but now
        // is nowhere but we don't want to do a major right now
        // and just in case we're going to leave the case here
        // it's also not affecting client side bundle size
        // so it's really not a big deal
        if (shouldCache) {
          cache.inserted[name] = rules;
        } else {
          return rules;
        }
      }
    };
  }

  if (process.env.NODE_ENV !== 'production') {
    // https://esbench.com/bench/5bf7371a4cd7e6009ef61d0a
    var commentStart = /\/\*/g;
    var commentEnd = /\*\//g;
    stylis.use(function (context, content) {
      switch (context) {
        case -1:
          {
            while (commentStart.test(content)) {
              commentEnd.lastIndex = commentStart.lastIndex;

              if (commentEnd.test(content)) {
                commentStart.lastIndex = commentEnd.lastIndex;
                continue;
              }

              throw new Error('Your styles have an unterminated comment ("/*" without corresponding "*/").');
            }

            commentStart.lastIndex = 0;
            break;
          }
      }
    });
    stylis.use(function (context, content, selectors) {
      switch (context) {
        case -1:
          {
            var flag = 'emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason';
            var unsafePseudoClasses = content.match(/(:first|:nth|:nth-last)-child/g);

            if (unsafePseudoClasses && cache.compat !== true) {
              unsafePseudoClasses.forEach(function (unsafePseudoClass) {
                var ignoreRegExp = new RegExp(unsafePseudoClass + ".*\\/\\* " + flag + " \\*\\/");
                var ignore = ignoreRegExp.test(content);

                if (unsafePseudoClass && !ignore) {
                  console.error("The pseudo class \"" + unsafePseudoClass + "\" is potentially unsafe when doing server-side rendering. Try changing it to \"" + unsafePseudoClass.split('-child')[0] + "-of-type\".");
                }
              });
            }

            break;
          }
      }
    });
  }

  var cache = {
    key: key,
    sheet: new StyleSheet({
      key: key,
      container: container,
      nonce: options.nonce,
      speedy: options.speedy
    }),
    nonce: options.nonce,
    inserted: inserted,
    registered: {},
    insert: _insert
  };
  return cache;
};

var isBrowser$1 = typeof document !== 'undefined';
function getRegisteredStyles(registered, registeredStyles, classNames) {
  var rawClassName = '';
  classNames.split(' ').forEach(function (className) {
    if (registered[className] !== undefined) {
      registeredStyles.push(registered[className]);
    } else {
      rawClassName += className + " ";
    }
  });
  return rawClassName;
}
var insertStyles = function insertStyles(cache, serialized, isStringTag) {
  var className = cache.key + "-" + serialized.name;

  if ( // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (isStringTag === false || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  isBrowser$1 === false && cache.compat !== undefined) && cache.registered[className] === undefined) {
    cache.registered[className] = serialized.styles;
  }

  if (cache.inserted[serialized.name] === undefined) {
    var stylesForSSR = '';
    var current = serialized;

    do {
      var maybeStyles = cache.insert("." + className, current, cache.sheet, true);

      if (!isBrowser$1 && maybeStyles !== undefined) {
        stylesForSSR += maybeStyles;
      }

      current = current.next;
    } while (current !== undefined);

    if (!isBrowser$1 && stylesForSSR.length !== 0) {
      return stylesForSSR;
    }
  }
};

/* eslint-disable */
// Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function murmur2(str) {
  // 'm' and 'r' are mixing constants generated offline.
  // They're not really 'magic', they just happen to work well.
  // const m = 0x5bd1e995;
  // const r = 24;
  // Initialize the hash
  var h = 0; // Mix 4 bytes at a time into the hash

  var k,
      i = 0,
      len = str.length;

  for (; len >= 4; ++i, len -= 4) {
    k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
    k =
    /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
    k ^=
    /* k >>> r: */
    k >>> 24;
    h =
    /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^
    /* Math.imul(h, m): */
    (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Handle the last few bytes of the input array


  switch (len) {
    case 3:
      h ^= (str.charCodeAt(i + 2) & 0xff) << 16;

    case 2:
      h ^= (str.charCodeAt(i + 1) & 0xff) << 8;

    case 1:
      h ^= str.charCodeAt(i) & 0xff;
      h =
      /* Math.imul(h, m): */
      (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Do a few final mixes of the hash to ensure the last few
  // bytes are well-incorporated.


  h ^= h >>> 13;
  h =
  /* Math.imul(h, m): */
  (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  return ((h ^ h >>> 15) >>> 0).toString(36);
}

var unitlessKeys = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};

function memoize(fn) {
  var cache = {};
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

var ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var hyphenateRegex = /[A-Z]|^ms/g;
var animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;

var isCustomProperty = function isCustomProperty(property) {
  return property.charCodeAt(1) === 45;
};

var isProcessableValue = function isProcessableValue(value) {
  return value != null && typeof value !== 'boolean';
};

var processStyleName = memoize(function (styleName) {
  return isCustomProperty(styleName) ? styleName : styleName.replace(hyphenateRegex, '-$&').toLowerCase();
});

var processStyleValue = function processStyleValue(key, value) {
  switch (key) {
    case 'animation':
    case 'animationName':
      {
        if (typeof value === 'string') {
          return value.replace(animationRegex, function (match, p1, p2) {
            cursor = {
              name: p1,
              styles: p2,
              next: cursor
            };
            return p1;
          });
        }
      }
  }

  if (unitlessKeys[key] !== 1 && !isCustomProperty(key) && typeof value === 'number' && value !== 0) {
    return value + 'px';
  }

  return value;
};

if (process.env.NODE_ENV !== 'production') {
  var contentValuePattern = /(attr|calc|counters?|url)\(/;
  var contentValues = ['normal', 'none', 'counter', 'open-quote', 'close-quote', 'no-open-quote', 'no-close-quote', 'initial', 'inherit', 'unset'];
  var oldProcessStyleValue = processStyleValue;
  var msPattern = /^-ms-/;
  var hyphenPattern = /-(.)/g;
  var hyphenatedCache = {};

  processStyleValue = function processStyleValue(key, value) {
    if (key === 'content') {
      if (typeof value !== 'string' || contentValues.indexOf(value) === -1 && !contentValuePattern.test(value) && (value.charAt(0) !== value.charAt(value.length - 1) || value.charAt(0) !== '"' && value.charAt(0) !== "'")) {
        console.error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + value + "\"'`");
      }
    }

    var processed = oldProcessStyleValue(key, value);

    if (processed !== '' && !isCustomProperty(key) && key.indexOf('-') !== -1 && hyphenatedCache[key] === undefined) {
      hyphenatedCache[key] = true;
      console.error("Using kebab-case for css properties in objects is not supported. Did you mean " + key.replace(msPattern, 'ms-').replace(hyphenPattern, function (str, _char) {
        return _char.toUpperCase();
      }) + "?");
    }

    return processed;
  };
}

var shouldWarnAboutInterpolatingClassNameFromCss = true;

function handleInterpolation(mergedProps, registered, interpolation, couldBeSelectorInterpolation) {
  if (interpolation == null) {
    return '';
  }

  if (interpolation.__emotion_styles !== undefined) {
    if (process.env.NODE_ENV !== 'production' && interpolation.toString() === 'NO_COMPONENT_SELECTOR') {
      throw new Error('Component selectors can only be used in conjunction with babel-plugin-emotion.');
    }

    return interpolation;
  }

  switch (typeof interpolation) {
    case 'boolean':
      {
        return '';
      }

    case 'object':
      {
        if (interpolation.anim === 1) {
          cursor = {
            name: interpolation.name,
            styles: interpolation.styles,
            next: cursor
          };
          return interpolation.name;
        }

        if (interpolation.styles !== undefined) {
          var next = interpolation.next;

          if (next !== undefined) {
            // not the most efficient thing ever but this is a pretty rare case
            // and there will be very few iterations of this generally
            while (next !== undefined) {
              cursor = {
                name: next.name,
                styles: next.styles,
                next: cursor
              };
              next = next.next;
            }
          }

          var styles = interpolation.styles + ";";

          if (process.env.NODE_ENV !== 'production' && interpolation.map !== undefined) {
            styles += interpolation.map;
          }

          return styles;
        }

        return createStringFromObject(mergedProps, registered, interpolation);
      }

    case 'function':
      {
        if (mergedProps !== undefined) {
          var previousCursor = cursor;
          var result = interpolation(mergedProps);
          cursor = previousCursor;
          return handleInterpolation(mergedProps, registered, result, couldBeSelectorInterpolation);
        } else if (process.env.NODE_ENV !== 'production') {
          console.error('Functions that are interpolated in css calls will be stringified.\n' + 'If you want to have a css call based on props, create a function that returns a css call like this\n' + 'let dynamicStyle = (props) => css`color: ${props.color}`\n' + 'It can be called directly with props or interpolated in a styled call like this\n' + "let SomeComponent = styled('div')`${dynamicStyle}`");
        }

        break;
      }

    case 'string':
      if (process.env.NODE_ENV !== 'production') {
        var matched = [];
        var replaced = interpolation.replace(animationRegex, function (match, p1, p2) {
          var fakeVarName = "animation" + matched.length;
          matched.push("const " + fakeVarName + " = keyframes`" + p2.replace(/^@keyframes animation-\w+/, '') + "`");
          return "${" + fakeVarName + "}";
        });

        if (matched.length) {
          console.error('`keyframes` output got interpolated into plain string, please wrap it with `css`.\n\n' + 'Instead of doing this:\n\n' + [].concat(matched, ["`" + replaced + "`"]).join('\n') + '\n\nYou should wrap it with `css` like this:\n\n' + ("css`" + replaced + "`"));
        }
      }

      break;
  } // finalize string values (regular strings and functions interpolated into css calls)


  if (registered == null) {
    return interpolation;
  }

  var cached = registered[interpolation];

  if (process.env.NODE_ENV !== 'production' && couldBeSelectorInterpolation && shouldWarnAboutInterpolatingClassNameFromCss && cached !== undefined) {
    console.error('Interpolating a className from css`` is not recommended and will cause problems with composition.\n' + 'Interpolating a className from css`` will be completely unsupported in a future major version of Emotion');
    shouldWarnAboutInterpolatingClassNameFromCss = false;
  }

  return cached !== undefined && !couldBeSelectorInterpolation ? cached : interpolation;
}

function createStringFromObject(mergedProps, registered, obj) {
  var string = '';

  if (Array.isArray(obj)) {
    for (var i = 0; i < obj.length; i++) {
      string += handleInterpolation(mergedProps, registered, obj[i], false);
    }
  } else {
    for (var _key in obj) {
      var value = obj[_key];

      if (typeof value !== 'object') {
        if (registered != null && registered[value] !== undefined) {
          string += _key + "{" + registered[value] + "}";
        } else if (isProcessableValue(value)) {
          string += processStyleName(_key) + ":" + processStyleValue(_key, value) + ";";
        }
      } else {
        if (_key === 'NO_COMPONENT_SELECTOR' && process.env.NODE_ENV !== 'production') {
          throw new Error('Component selectors can only be used in conjunction with babel-plugin-emotion.');
        }

        if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
          for (var _i = 0; _i < value.length; _i++) {
            if (isProcessableValue(value[_i])) {
              string += processStyleName(_key) + ":" + processStyleValue(_key, value[_i]) + ";";
            }
          }
        } else {
          var interpolated = handleInterpolation(mergedProps, registered, value, false);

          switch (_key) {
            case 'animation':
            case 'animationName':
              {
                string += processStyleName(_key) + ":" + interpolated + ";";
                break;
              }

            default:
              {
                if (process.env.NODE_ENV !== 'production' && _key === 'undefined') {
                  console.error(UNDEFINED_AS_OBJECT_KEY_ERROR);
                }

                string += _key + "{" + interpolated + "}";
              }
          }
        }
      }
    }
  }

  return string;
}

var labelPattern = /label:\s*([^\s;\n{]+)\s*;/g;
var sourceMapPattern;

if (process.env.NODE_ENV !== 'production') {
  sourceMapPattern = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//;
} // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list


var cursor;
var serializeStyles = function serializeStyles(args, registered, mergedProps) {
  if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) {
    return args[0];
  }

  var stringMode = true;
  var styles = '';
  cursor = undefined;
  var strings = args[0];

  if (strings == null || strings.raw === undefined) {
    stringMode = false;
    styles += handleInterpolation(mergedProps, registered, strings, false);
  } else {
    if (process.env.NODE_ENV !== 'production' && strings[0] === undefined) {
      console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR);
    }

    styles += strings[0];
  } // we start at 1 since we've already handled the first arg


  for (var i = 1; i < args.length; i++) {
    styles += handleInterpolation(mergedProps, registered, args[i], styles.charCodeAt(styles.length - 1) === 46);

    if (stringMode) {
      if (process.env.NODE_ENV !== 'production' && strings[i] === undefined) {
        console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR);
      }

      styles += strings[i];
    }
  }

  var sourceMap;

  if (process.env.NODE_ENV !== 'production') {
    styles = styles.replace(sourceMapPattern, function (match) {
      sourceMap = match;
      return '';
    });
  } // using a global regex with .exec is stateful so lastIndex has to be reset each time


  labelPattern.lastIndex = 0;
  var identifierName = '';
  var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5

  while ((match = labelPattern.exec(styles)) !== null) {
    identifierName += '-' + // $FlowFixMe we know it's not null
    match[1];
  }

  var name = murmur2(styles) + identifierName;

  if (process.env.NODE_ENV !== 'production') {
    // $FlowFixMe SerializedStyles type doesn't have toString property (and we don't want to add it)
    return {
      name: name,
      styles: styles,
      map: sourceMap,
      next: cursor,
      toString: function toString() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
      }
    };
  }

  return {
    name: name,
    styles: styles,
    next: cursor
  };
};

function css() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return serializeStyles(args);
}

var isBrowser$2 = typeof document !== 'undefined';

var EmotionCacheContext = createContext( // we're doing this to avoid preconstruct's dead code elimination in this one case
// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? createCache() : null);
var ThemeContext = createContext({});
var CacheProvider = EmotionCacheContext.Provider;

var withEmotionCache = function withEmotionCache(func) {
  var render = function render(props, ref) {
    return createElement(EmotionCacheContext.Consumer, null, function (cache) {
      return func(props, cache, ref);
    });
  }; // $FlowFixMe


  return forwardRef(render);
};

if (!isBrowser$2) {
  var BasicProvider =
  /*#__PURE__*/
  function (_React$Component) {
    inheritsLoose(BasicProvider, _React$Component);

    function BasicProvider(props, context, updater) {
      var _this;

      _this = _React$Component.call(this, props, context, updater) || this;
      _this.state = {
        value: createCache()
      };
      return _this;
    }

    var _proto = BasicProvider.prototype;

    _proto.render = function render() {
      return createElement(EmotionCacheContext.Provider, this.state, this.props.children(this.state.value));
    };

    return BasicProvider;
  }(Component);

  withEmotionCache = function withEmotionCache(func) {
    return function (props) {
      return createElement(EmotionCacheContext.Consumer, null, function (context) {
        if (context === null) {
          return createElement(BasicProvider, null, function (newContext) {
            return func(props, newContext);
          });
        } else {
          return func(props, context);
        }
      });
    };
  };
}

// thus we only need to replace what is a valid character for JS, but not for CSS

var sanitizeIdentifier = function sanitizeIdentifier(identifier) {
  return identifier.replace(/\$/g, '-');
};

var typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var labelPropName = '__EMOTION_LABEL_PLEASE_DO_NOT_USE__';
var hasOwnProperty = Object.prototype.hasOwnProperty;

var render = function render(cache, props, theme, ref) {
  var cssProp = theme === null ? props.css : props.css(theme); // so that using `css` from `emotion` and passing the result to the css prop works
  // not passing the registered cache to serializeStyles because it would
  // make certain babel optimisations not possible

  if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) {
    cssProp = cache.registered[cssProp];
  }

  var type = props[typePropName];
  var registeredStyles = [cssProp];
  var className = '';

  if (typeof props.className === 'string') {
    className = getRegisteredStyles(cache.registered, registeredStyles, props.className);
  } else if (props.className != null) {
    className = props.className + " ";
  }

  var serialized = serializeStyles(registeredStyles);

  if (process.env.NODE_ENV !== 'production' && serialized.name.indexOf('-') === -1) {
    var labelFromStack = props[labelPropName];

    if (labelFromStack) {
      serialized = serializeStyles([serialized, 'label:' + labelFromStack + ';']);
    }
  }

  var rules = insertStyles(cache, serialized, typeof type === 'string');
  className += cache.key + "-" + serialized.name;
  var newProps = {};

  for (var key in props) {
    if (hasOwnProperty.call(props, key) && key !== 'css' && key !== typePropName && (process.env.NODE_ENV === 'production' || key !== labelPropName)) {
      newProps[key] = props[key];
    }
  }

  newProps.ref = ref;
  newProps.className = className;
  var ele = createElement(type, newProps);

  if (!isBrowser$2 && rules !== undefined) {
    var _ref;

    var serializedNames = serialized.name;
    var next = serialized.next;

    while (next !== undefined) {
      serializedNames += ' ' + next.name;
      next = next.next;
    }

    return createElement(Fragment$1, null, createElement("style", (_ref = {}, _ref["data-emotion-" + cache.key] = serializedNames, _ref.dangerouslySetInnerHTML = {
      __html: rules
    }, _ref.nonce = cache.sheet.nonce, _ref)), ele);
  }

  return ele;
};

var Emotion =
/* #__PURE__ */
withEmotionCache(function (props, cache, ref) {
  // use Context.read for the theme when it's stable
  if (typeof props.css === 'function') {
    return createElement(ThemeContext.Consumer, null, function (theme) {
      return render(cache, props, theme, ref);
    });
  }

  return render(cache, props, null, ref);
});

if (process.env.NODE_ENV !== 'production') {
  Emotion.displayName = 'EmotionCssPropInternal';
} // $FlowFixMe


var jsx = function jsx(type, props) {
  var args = arguments;

  if (props == null || !hasOwnProperty.call(props, 'css')) {
    // $FlowFixMe
    return createElement.apply(undefined, args);
  }

  if (process.env.NODE_ENV !== 'production' && typeof props.css === 'string' && // check if there is a css declaration
  props.css.indexOf(':') !== -1) {
    throw new Error("Strings are not allowed as css prop values, please wrap it in a css template literal from '@emotion/css' like this: css`" + props.css + "`");
  }

  var argsLength = args.length;
  var createElementArgArray = new Array(argsLength);
  createElementArgArray[0] = Emotion;
  var newProps = {};

  for (var key in props) {
    if (hasOwnProperty.call(props, key)) {
      newProps[key] = props[key];
    }
  }

  newProps[typePropName] = type;

  if (process.env.NODE_ENV !== 'production') {
    var error = new Error();

    if (error.stack) {
      // chrome
      var match = error.stack.match(/at (?:Object\.|)jsx.*\n\s+at ([A-Z][A-Za-z$]+) /);

      if (!match) {
        // safari and firefox
        match = error.stack.match(/.*\n([A-Z][A-Za-z$]+)@/);
      }

      if (match) {
        newProps[labelPropName] = sanitizeIdentifier(match[1]);
      }
    }
  }

  createElementArgArray[1] = newProps;

  for (var i = 2; i < argsLength; i++) {
    createElementArgArray[i] = args[i];
  } // $FlowFixMe


  return createElement.apply(null, createElementArgArray);
};

var keyframes = function keyframes() {
  var insertable = css.apply(void 0, arguments);
  var name = "animation-" + insertable.name; // $FlowFixMe

  return {
    name: name,
    styles: "@keyframes " + name + "{" + insertable.styles + "}",
    anim: 1,
    toString: function toString() {
      return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
    }
  };
};

var classnames$1 = function classnames(args) {
  var len = args.length;
  var i = 0;
  var cls = '';

  for (; i < len; i++) {
    var arg = args[i];
    if (arg == null) continue;
    var toAdd = void 0;

    switch (typeof arg) {
      case 'boolean':
        break;

      case 'object':
        {
          if (Array.isArray(arg)) {
            toAdd = classnames(arg);
          } else {
            toAdd = '';

            for (var k in arg) {
              if (arg[k] && k) {
                toAdd && (toAdd += ' ');
                toAdd += k;
              }
            }
          }

          break;
        }

      default:
        {
          toAdd = arg;
        }
    }

    if (toAdd) {
      cls && (cls += ' ');
      cls += toAdd;
    }
  }

  return cls;
};

function merge(registered, css, className) {
  var registeredStyles = [];
  var rawClassName = getRegisteredStyles(registered, registeredStyles, className);

  if (registeredStyles.length < 2) {
    return className;
  }

  return rawClassName + css(registeredStyles);
}

var ClassNames = withEmotionCache(function (props, context) {
  return createElement(ThemeContext.Consumer, null, function (theme) {
    var rules = '';
    var serializedHashes = '';
    var hasRendered = false;

    var css = function css() {
      if (hasRendered && process.env.NODE_ENV !== 'production') {
        throw new Error('css can only be used during render');
      }

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      var serialized = serializeStyles(args, context.registered);

      if (isBrowser$2) {
        insertStyles(context, serialized, false);
      } else {
        var res = insertStyles(context, serialized, false);

        if (res !== undefined) {
          rules += res;
        }
      }

      if (!isBrowser$2) {
        serializedHashes += " " + serialized.name;
      }

      return context.key + "-" + serialized.name;
    };

    var cx = function cx() {
      if (hasRendered && process.env.NODE_ENV !== 'production') {
        throw new Error('cx can only be used during render');
      }

      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return merge(context.registered, css, classnames$1(args));
    };

    var content = {
      css: css,
      cx: cx,
      theme: theme
    };
    var ele = props.children(content);
    hasRendered = true;

    if (!isBrowser$2 && rules.length !== 0) {
      var _ref;

      return createElement(Fragment$1, null, createElement("style", (_ref = {}, _ref["data-emotion-" + context.key] = serializedHashes.substring(1), _ref.dangerouslySetInnerHTML = {
        __html: rules
      }, _ref.nonce = context.sheet.nonce, _ref)), ele);
    }

    return ele;
  });
});

/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t$1=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t$1:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}var AsyncMode=l;var ConcurrentMode=m;var ContextConsumer=k;var ContextProvider=h;var Element$1=c;var ForwardRef=n;var Fragment=e;var Lazy=t$1;var Memo=r;var Portal=d;
var Profiler=g;var StrictMode=f;var Suspense=p;var isAsyncMode=function(a){return A(a)||z(a)===l};var isConcurrentMode=A;var isContextConsumer=function(a){return z(a)===k};var isContextProvider=function(a){return z(a)===h};var isElement=function(a){return "object"===typeof a&&null!==a&&a.$$typeof===c};var isForwardRef=function(a){return z(a)===n};var isFragment=function(a){return z(a)===e};var isLazy=function(a){return z(a)===t$1};
var isMemo=function(a){return z(a)===r};var isPortal=function(a){return z(a)===d};var isProfiler=function(a){return z(a)===g};var isStrictMode=function(a){return z(a)===f};var isSuspense=function(a){return z(a)===p};
var isValidElementType=function(a){return "string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t$1||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};var typeOf=z;

var reactIs_production_min = {
	AsyncMode: AsyncMode,
	ConcurrentMode: ConcurrentMode,
	ContextConsumer: ContextConsumer,
	ContextProvider: ContextProvider,
	Element: Element$1,
	ForwardRef: ForwardRef,
	Fragment: Fragment,
	Lazy: Lazy,
	Memo: Memo,
	Portal: Portal,
	Profiler: Profiler,
	StrictMode: StrictMode,
	Suspense: Suspense,
	isAsyncMode: isAsyncMode,
	isConcurrentMode: isConcurrentMode,
	isContextConsumer: isContextConsumer,
	isContextProvider: isContextProvider,
	isElement: isElement,
	isForwardRef: isForwardRef,
	isFragment: isFragment,
	isLazy: isLazy,
	isMemo: isMemo,
	isPortal: isPortal,
	isProfiler: isProfiler,
	isStrictMode: isStrictMode,
	isSuspense: isSuspense,
	isValidElementType: isValidElementType,
	typeOf: typeOf
};

var reactIs_development = createCommonjsModule(function (module, exports) {



if (process.env.NODE_ENV !== "production") {
  (function() {

// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.
var hasSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
// (unstable) APIs that have been removed. Can we remove the symbols?

var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;

function isValidElementType(type) {
  return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
  type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
}

function typeOf(object) {
  if (typeof object === 'object' && object !== null) {
    var $$typeof = object.$$typeof;

    switch ($$typeof) {
      case REACT_ELEMENT_TYPE:
        var type = object.type;

        switch (type) {
          case REACT_ASYNC_MODE_TYPE:
          case REACT_CONCURRENT_MODE_TYPE:
          case REACT_FRAGMENT_TYPE:
          case REACT_PROFILER_TYPE:
          case REACT_STRICT_MODE_TYPE:
          case REACT_SUSPENSE_TYPE:
            return type;

          default:
            var $$typeofType = type && type.$$typeof;

            switch ($$typeofType) {
              case REACT_CONTEXT_TYPE:
              case REACT_FORWARD_REF_TYPE:
              case REACT_LAZY_TYPE:
              case REACT_MEMO_TYPE:
              case REACT_PROVIDER_TYPE:
                return $$typeofType;

              default:
                return $$typeof;
            }

        }

      case REACT_PORTAL_TYPE:
        return $$typeof;
    }
  }

  return undefined;
} // AsyncMode is deprecated along with isAsyncMode

var AsyncMode = REACT_ASYNC_MODE_TYPE;
var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
var ContextConsumer = REACT_CONTEXT_TYPE;
var ContextProvider = REACT_PROVIDER_TYPE;
var Element = REACT_ELEMENT_TYPE;
var ForwardRef = REACT_FORWARD_REF_TYPE;
var Fragment = REACT_FRAGMENT_TYPE;
var Lazy = REACT_LAZY_TYPE;
var Memo = REACT_MEMO_TYPE;
var Portal = REACT_PORTAL_TYPE;
var Profiler = REACT_PROFILER_TYPE;
var StrictMode = REACT_STRICT_MODE_TYPE;
var Suspense = REACT_SUSPENSE_TYPE;
var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

function isAsyncMode(object) {
  {
    if (!hasWarnedAboutDeprecatedIsAsyncMode) {
      hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

      console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
    }
  }

  return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
}
function isConcurrentMode(object) {
  return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
}
function isContextConsumer(object) {
  return typeOf(object) === REACT_CONTEXT_TYPE;
}
function isContextProvider(object) {
  return typeOf(object) === REACT_PROVIDER_TYPE;
}
function isElement(object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
}
function isForwardRef(object) {
  return typeOf(object) === REACT_FORWARD_REF_TYPE;
}
function isFragment(object) {
  return typeOf(object) === REACT_FRAGMENT_TYPE;
}
function isLazy(object) {
  return typeOf(object) === REACT_LAZY_TYPE;
}
function isMemo(object) {
  return typeOf(object) === REACT_MEMO_TYPE;
}
function isPortal(object) {
  return typeOf(object) === REACT_PORTAL_TYPE;
}
function isProfiler(object) {
  return typeOf(object) === REACT_PROFILER_TYPE;
}
function isStrictMode(object) {
  return typeOf(object) === REACT_STRICT_MODE_TYPE;
}
function isSuspense(object) {
  return typeOf(object) === REACT_SUSPENSE_TYPE;
}

exports.AsyncMode = AsyncMode;
exports.ConcurrentMode = ConcurrentMode;
exports.ContextConsumer = ContextConsumer;
exports.ContextProvider = ContextProvider;
exports.Element = Element;
exports.ForwardRef = ForwardRef;
exports.Fragment = Fragment;
exports.Lazy = Lazy;
exports.Memo = Memo;
exports.Portal = Portal;
exports.Profiler = Profiler;
exports.StrictMode = StrictMode;
exports.Suspense = Suspense;
exports.isAsyncMode = isAsyncMode;
exports.isConcurrentMode = isConcurrentMode;
exports.isContextConsumer = isContextConsumer;
exports.isContextProvider = isContextProvider;
exports.isElement = isElement;
exports.isForwardRef = isForwardRef;
exports.isFragment = isFragment;
exports.isLazy = isLazy;
exports.isMemo = isMemo;
exports.isPortal = isPortal;
exports.isProfiler = isProfiler;
exports.isStrictMode = isStrictMode;
exports.isSuspense = isSuspense;
exports.isValidElementType = isValidElementType;
exports.typeOf = typeOf;
  })();
}
});

var reactIs = createCommonjsModule(function (module) {

if (process.env.NODE_ENV === 'production') {
  module.exports = reactIs_production_min;
} else {
  module.exports = reactIs_development;
}
});

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty$1 = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

var objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty$1.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

var ReactPropTypesSecret_1 = ReactPropTypesSecret;

var printWarning = function() {};

if (process.env.NODE_ENV !== 'production') {
  var ReactPropTypesSecret$1 = ReactPropTypesSecret_1;
  var loggedTypeFailures = {};
  var has = Function.call.bind(Object.prototype.hasOwnProperty);

  printWarning = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
  if (process.env.NODE_ENV !== 'production') {
    for (var typeSpecName in typeSpecs) {
      if (has(typeSpecs, typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error(
              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.'
            );
            err.name = 'Invariant Violation';
            throw err;
          }
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret$1);
        } catch (ex) {
          error = ex;
        }
        if (error && !(error instanceof Error)) {
          printWarning(
            (componentName || 'React class') + ': type specification of ' +
            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
            'You may have forgotten to pass an argument to the type checker ' +
            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
            'shape all require an argument).'
          );
        }
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;

          var stack = getStack ? getStack() : '';

          printWarning(
            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
          );
        }
      }
    }
  }
}

/**
 * Resets warning cache when testing.
 *
 * @private
 */
checkPropTypes.resetWarningCache = function() {
  if (process.env.NODE_ENV !== 'production') {
    loggedTypeFailures = {};
  }
};

var checkPropTypes_1 = checkPropTypes;

var has$1 = Function.call.bind(Object.prototype.hasOwnProperty);
var printWarning$1 = function() {};

if (process.env.NODE_ENV !== 'production') {
  printWarning$1 = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

function emptyFunctionThatReturnsNull() {
  return null;
}

var factoryWithTypeCheckers = function(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */

  var ANONYMOUS = '<<anonymous>>';

  // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),

    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    elementType: createElementTypeTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker,
  };

  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */
  /*eslint-disable no-self-compare*/
  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */
  function PropTypeError(message) {
    this.message = message;
    this.stack = '';
  }
  // Make `instanceof Error` still work for returned errors.
  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (process.env.NODE_ENV !== 'production') {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret_1) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          var err = new Error(
            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
            'Use `PropTypes.checkPropTypes()` to call them. ' +
            'Read more at http://fb.me/use-check-prop-types'
          );
          err.name = 'Invariant Violation';
          throw err;
        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;
          if (
            !manualPropTypeCallCache[cacheKey] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3
          ) {
            printWarning$1(
              'You are manually calling a React.PropTypes validation ' +
              'function for the `' + propFullName + '` prop on `' + componentName  + '`. This is deprecated ' +
              'and will throw in the standalone `prop-types` package. ' +
              'You may be seeing this warning due to a third-party PropTypes ' +
              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
            );
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);

    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);

        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret_1);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!reactIs.isValidElementType(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
      if (process.env.NODE_ENV !== 'production') {
        if (arguments.length > 1) {
          printWarning$1(
            'Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' +
            'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).'
          );
        } else {
          printWarning$1('Invalid argument supplied to oneOf, expected an array.');
        }
      }
      return emptyFunctionThatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
        var type = getPreciseType(value);
        if (type === 'symbol') {
          return String(value);
        }
        return value;
      });
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (has$1(propValue, key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
      process.env.NODE_ENV !== 'production' ? printWarning$1('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunctionThatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        printWarning$1(
          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
        );
        return emptyFunctionThatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret_1) == null) {
          return null;
        }
      }

      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (!checker) {
          continue;
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      // We need to check all keys in case some are required but missing from
      // props.
      var allKeys = objectAssign({}, props[propName], shapeTypes);
      for (var key in allKeys) {
        var checker = shapeTypes[key];
        if (!checker) {
          return new PropTypeError(
            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
            '\nValid keys: ' +  JSON.stringify(Object.keys(shapeTypes), null, '  ')
          );
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
        if (error) {
          return error;
        }
      }
      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;
      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    }

    // falsy value can't be a Symbol
    if (!propValue) {
      return false;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  }

  // Equivalent of `typeof` but with special handling for array and regexp.
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }

  // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }

  // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }

  // Returns class name of the object, if any.
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes_1;
  ReactPropTypes.resetWarningCache = checkPropTypes_1.resetWarningCache;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

var factoryWithThrowingShims = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret_1) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  }  shim.isRequired = shim;
  function getShim() {
    return shim;
  }  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

var propTypes = createCommonjsModule(function (module) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (process.env.NODE_ENV !== 'production') {
  var ReactIs = reactIs;

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = factoryWithTypeCheckers(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = factoryWithThrowingShims();
}
});

// ==============================
// NO OP
// ==============================
var noop = function noop() {};
// Class Name Prefixer
// ==============================

/**
 String representation of component state for styling with class names.

 Expects an array of strings OR a string/object pair:
 - className(['comp', 'comp-arg', 'comp-arg-2'])
   @returns 'react-select__comp react-select__comp-arg react-select__comp-arg-2'
 - className('comp', { some: true, state: false })
   @returns 'react-select__comp react-select__comp--some'
*/

function applyPrefixToName(prefix, name) {
  if (!name) {
    return prefix;
  } else if (name[0] === '-') {
    return prefix + name;
  } else {
    return prefix + '__' + name;
  }
}

function classNames(prefix, state, className) {
  var arr = [className];

  if (state && prefix) {
    for (var key in state) {
      if (state.hasOwnProperty(key) && state[key]) {
        arr.push("" + applyPrefixToName(prefix, key));
      }
    }
  }

  return arr.filter(function (i) {
    return i;
  }).map(function (i) {
    return String(i).trim();
  }).join(' ');
} // ==============================
// Clean Value
// ==============================

var cleanValue = function cleanValue(value) {
  if (Array.isArray(value)) return value.filter(Boolean);
  if (typeof value === 'object' && value !== null) return [value];
  return [];
}; // ==============================
// Handle Input Change
// ==============================

function handleInputChange(inputValue, actionMeta, onInputChange) {
  if (onInputChange) {
    var newValue = onInputChange(inputValue, actionMeta);
    if (typeof newValue === 'string') return newValue;
  }

  return inputValue;
} // ==============================
// Scroll Helpers
// ==============================

function isDocumentElement(el) {
  return [document.documentElement, document.body, window].indexOf(el) > -1;
} // Normalized Scroll Top
// ------------------------------

function getScrollTop(el) {
  if (isDocumentElement(el)) {
    return window.pageYOffset;
  }

  return el.scrollTop;
}
function scrollTo(el, top) {
  // with a scroll distance, we perform scroll on the element
  if (isDocumentElement(el)) {
    window.scrollTo(0, top);
    return;
  }

  el.scrollTop = top;
} // Get Scroll Parent
// ------------------------------

function getScrollParent(element) {
  var style = getComputedStyle(element);
  var excludeStaticParent = style.position === 'absolute';
  var overflowRx = /(auto|scroll)/;
  var docEl = document.documentElement; // suck it, flow...

  if (style.position === 'fixed') return docEl;

  for (var parent = element; parent = parent.parentElement;) {
    style = getComputedStyle(parent);

    if (excludeStaticParent && style.position === 'static') {
      continue;
    }

    if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) {
      return parent;
    }
  }

  return docEl;
} // Animated Scroll To
// ------------------------------

/**
  @param t: time (elapsed)
  @param b: initial value
  @param c: amount of change
  @param d: duration
*/

function easeOutCubic(t, b, c, d) {
  return c * ((t = t / d - 1) * t * t + 1) + b;
}

function animatedScrollTo(element, to, duration, callback) {
  if (duration === void 0) {
    duration = 200;
  }

  if (callback === void 0) {
    callback = noop;
  }

  var start = getScrollTop(element);
  var change = to - start;
  var increment = 10;
  var currentTime = 0;

  function animateScroll() {
    currentTime += increment;
    var val = easeOutCubic(currentTime, start, change, duration);
    scrollTo(element, val);

    if (currentTime < duration) {
      window.requestAnimationFrame(animateScroll);
    } else {
      callback(element);
    }
  }

  animateScroll();
} // Scroll Into View
// ------------------------------

function scrollIntoView(menuEl, focusedEl) {
  var menuRect = menuEl.getBoundingClientRect();
  var focusedRect = focusedEl.getBoundingClientRect();
  var overScroll = focusedEl.offsetHeight / 3;

  if (focusedRect.bottom + overScroll > menuRect.bottom) {
    scrollTo(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
  } else if (focusedRect.top - overScroll < menuRect.top) {
    scrollTo(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
  }
} // ==============================
// Get bounding client object
// ==============================
// cannot get keys using array notation with DOMRect

function getBoundingClientObj(element) {
  var rect = element.getBoundingClientRect();
  return {
    bottom: rect.bottom,
    height: rect.height,
    left: rect.left,
    right: rect.right,
    top: rect.top,
    width: rect.width
  };
}
// Touch Capability Detector
// ==============================

function isTouchCapable() {
  try {
    document.createEvent('TouchEvent');
    return true;
  } catch (e) {
    return false;
  }
} // ==============================
// Mobile Device Detector
// ==============================

function isMobileDevice() {
  try {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  } catch (e) {
    return false;
  }
}

var AutosizeInput_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



var _react2 = _interopRequireDefault(React__default);



var _propTypes2 = _interopRequireDefault(propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var sizerStyle = {
	position: 'absolute',
	top: 0,
	left: 0,
	visibility: 'hidden',
	height: 0,
	overflow: 'scroll',
	whiteSpace: 'pre'
};

var INPUT_PROPS_BLACKLIST = ['extraWidth', 'injectStyles', 'inputClassName', 'inputRef', 'inputStyle', 'minWidth', 'onAutosize', 'placeholderIsMinWidth'];

var cleanInputProps = function cleanInputProps(inputProps) {
	INPUT_PROPS_BLACKLIST.forEach(function (field) {
		return delete inputProps[field];
	});
	return inputProps;
};

var copyStyles = function copyStyles(styles, node) {
	node.style.fontSize = styles.fontSize;
	node.style.fontFamily = styles.fontFamily;
	node.style.fontWeight = styles.fontWeight;
	node.style.fontStyle = styles.fontStyle;
	node.style.letterSpacing = styles.letterSpacing;
	node.style.textTransform = styles.textTransform;
};

var isIE = typeof window !== 'undefined' && window.navigator ? /MSIE |Trident\/|Edge\//.test(window.navigator.userAgent) : false;

var generateId = function generateId() {
	// we only need an auto-generated ID for stylesheet injection, which is only
	// used for IE. so if the browser is not IE, this should return undefined.
	return isIE ? '_' + Math.random().toString(36).substr(2, 12) : undefined;
};

var AutosizeInput = function (_Component) {
	_inherits(AutosizeInput, _Component);

	function AutosizeInput(props) {
		_classCallCheck(this, AutosizeInput);

		var _this = _possibleConstructorReturn(this, (AutosizeInput.__proto__ || Object.getPrototypeOf(AutosizeInput)).call(this, props));

		_this.inputRef = function (el) {
			_this.input = el;
			if (typeof _this.props.inputRef === 'function') {
				_this.props.inputRef(el);
			}
		};

		_this.placeHolderSizerRef = function (el) {
			_this.placeHolderSizer = el;
		};

		_this.sizerRef = function (el) {
			_this.sizer = el;
		};

		_this.state = {
			inputWidth: props.minWidth,
			inputId: props.id || generateId()
		};
		return _this;
	}

	_createClass(AutosizeInput, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			this.mounted = true;
			this.copyInputStyles();
			this.updateInputWidth();
		}
	}, {
		key: 'UNSAFE_componentWillReceiveProps',
		value: function UNSAFE_componentWillReceiveProps(nextProps) {
			var id = nextProps.id;

			if (id !== this.props.id) {
				this.setState({ inputId: id || generateId() });
			}
		}
	}, {
		key: 'componentDidUpdate',
		value: function componentDidUpdate(prevProps, prevState) {
			if (prevState.inputWidth !== this.state.inputWidth) {
				if (typeof this.props.onAutosize === 'function') {
					this.props.onAutosize(this.state.inputWidth);
				}
			}
			this.updateInputWidth();
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			this.mounted = false;
		}
	}, {
		key: 'copyInputStyles',
		value: function copyInputStyles() {
			if (!this.mounted || !window.getComputedStyle) {
				return;
			}
			var inputStyles = this.input && window.getComputedStyle(this.input);
			if (!inputStyles) {
				return;
			}
			copyStyles(inputStyles, this.sizer);
			if (this.placeHolderSizer) {
				copyStyles(inputStyles, this.placeHolderSizer);
			}
		}
	}, {
		key: 'updateInputWidth',
		value: function updateInputWidth() {
			if (!this.mounted || !this.sizer || typeof this.sizer.scrollWidth === 'undefined') {
				return;
			}
			var newInputWidth = void 0;
			if (this.props.placeholder && (!this.props.value || this.props.value && this.props.placeholderIsMinWidth)) {
				newInputWidth = Math.max(this.sizer.scrollWidth, this.placeHolderSizer.scrollWidth) + 2;
			} else {
				newInputWidth = this.sizer.scrollWidth + 2;
			}
			// add extraWidth to the detected width. for number types, this defaults to 16 to allow for the stepper UI
			var extraWidth = this.props.type === 'number' && this.props.extraWidth === undefined ? 16 : parseInt(this.props.extraWidth) || 0;
			newInputWidth += extraWidth;
			if (newInputWidth < this.props.minWidth) {
				newInputWidth = this.props.minWidth;
			}
			if (newInputWidth !== this.state.inputWidth) {
				this.setState({
					inputWidth: newInputWidth
				});
			}
		}
	}, {
		key: 'getInput',
		value: function getInput() {
			return this.input;
		}
	}, {
		key: 'focus',
		value: function focus() {
			this.input.focus();
		}
	}, {
		key: 'blur',
		value: function blur() {
			this.input.blur();
		}
	}, {
		key: 'select',
		value: function select() {
			this.input.select();
		}
	}, {
		key: 'renderStyles',
		value: function renderStyles() {
			// this method injects styles to hide IE's clear indicator, which messes
			// with input size detection. the stylesheet is only injected when the
			// browser is IE, and can also be disabled by the `injectStyles` prop.
			var injectStyles = this.props.injectStyles;

			return isIE && injectStyles ? _react2.default.createElement('style', { dangerouslySetInnerHTML: {
					__html: 'input#' + this.state.inputId + '::-ms-clear {display: none;}'
				} }) : null;
		}
	}, {
		key: 'render',
		value: function render() {
			var sizerValue = [this.props.defaultValue, this.props.value, ''].reduce(function (previousValue, currentValue) {
				if (previousValue !== null && previousValue !== undefined) {
					return previousValue;
				}
				return currentValue;
			});

			var wrapperStyle = _extends({}, this.props.style);
			if (!wrapperStyle.display) wrapperStyle.display = 'inline-block';

			var inputStyle = _extends({
				boxSizing: 'content-box',
				width: this.state.inputWidth + 'px'
			}, this.props.inputStyle);

			var inputProps = _objectWithoutProperties(this.props, []);

			cleanInputProps(inputProps);
			inputProps.className = this.props.inputClassName;
			inputProps.id = this.state.inputId;
			inputProps.style = inputStyle;

			return _react2.default.createElement(
				'div',
				{ className: this.props.className, style: wrapperStyle },
				this.renderStyles(),
				_react2.default.createElement('input', _extends({}, inputProps, { ref: this.inputRef })),
				_react2.default.createElement(
					'div',
					{ ref: this.sizerRef, style: sizerStyle },
					sizerValue
				),
				this.props.placeholder ? _react2.default.createElement(
					'div',
					{ ref: this.placeHolderSizerRef, style: sizerStyle },
					this.props.placeholder
				) : null
			);
		}
	}]);

	return AutosizeInput;
}(React__default.Component);

AutosizeInput.propTypes = {
	className: _propTypes2.default.string, // className for the outer element
	defaultValue: _propTypes2.default.any, // default field value
	extraWidth: _propTypes2.default.oneOfType([// additional width for input element
	_propTypes2.default.number, _propTypes2.default.string]),
	id: _propTypes2.default.string, // id to use for the input, can be set for consistent snapshots
	injectStyles: _propTypes2.default.bool, // inject the custom stylesheet to hide clear UI, defaults to true
	inputClassName: _propTypes2.default.string, // className for the input element
	inputRef: _propTypes2.default.func, // ref callback for the input element
	inputStyle: _propTypes2.default.object, // css styles for the input element
	minWidth: _propTypes2.default.oneOfType([// minimum width for input element
	_propTypes2.default.number, _propTypes2.default.string]),
	onAutosize: _propTypes2.default.func, // onAutosize handler: function(newWidth) {}
	onChange: _propTypes2.default.func, // onChange handler: function(event) {}
	placeholder: _propTypes2.default.string, // placeholder text
	placeholderIsMinWidth: _propTypes2.default.bool, // don't collapse size to less than the placeholder
	style: _propTypes2.default.object, // css styles for the outer element
	value: _propTypes2.default.any // field value
};
AutosizeInput.defaultProps = {
	minWidth: 1,
	injectStyles: true
};

exports.default = AutosizeInput;
});

var AutosizeInput = /*@__PURE__*/unwrapExports(AutosizeInput_1);

function _extends$H() { _extends$H = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$H.apply(this, arguments); }

function _inheritsLoose$1(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
function getMenuPlacement(_ref) {
  var maxHeight = _ref.maxHeight,
      menuEl = _ref.menuEl,
      minHeight = _ref.minHeight,
      placement = _ref.placement,
      shouldScroll = _ref.shouldScroll,
      isFixedPosition = _ref.isFixedPosition,
      theme = _ref.theme;
  var spacing = theme.spacing;
  var scrollParent = getScrollParent(menuEl);
  var defaultState = {
    placement: 'bottom',
    maxHeight: maxHeight
  }; // something went wrong, return default state

  if (!menuEl || !menuEl.offsetParent) return defaultState; // we can't trust `scrollParent.scrollHeight` --> it may increase when
  // the menu is rendered

  var _scrollParent$getBoun = scrollParent.getBoundingClientRect(),
      scrollHeight = _scrollParent$getBoun.height;

  var _menuEl$getBoundingCl = menuEl.getBoundingClientRect(),
      menuBottom = _menuEl$getBoundingCl.bottom,
      menuHeight = _menuEl$getBoundingCl.height,
      menuTop = _menuEl$getBoundingCl.top;

  var _menuEl$offsetParent$ = menuEl.offsetParent.getBoundingClientRect(),
      containerTop = _menuEl$offsetParent$.top;

  var viewHeight = window.innerHeight;
  var scrollTop = getScrollTop(scrollParent);
  var marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
  var marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
  var viewSpaceAbove = containerTop - marginTop;
  var viewSpaceBelow = viewHeight - menuTop;
  var scrollSpaceAbove = viewSpaceAbove + scrollTop;
  var scrollSpaceBelow = scrollHeight - scrollTop - menuTop;
  var scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
  var scrollUp = scrollTop + menuTop - marginTop;
  var scrollDuration = 160;

  switch (placement) {
    case 'auto':
    case 'bottom':
      // 1: the menu will fit, do nothing
      if (viewSpaceBelow >= menuHeight) {
        return {
          placement: 'bottom',
          maxHeight: maxHeight
        };
      } // 2: the menu will fit, if scrolled


      if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
        if (shouldScroll) {
          animatedScrollTo(scrollParent, scrollDown, scrollDuration);
        }

        return {
          placement: 'bottom',
          maxHeight: maxHeight
        };
      } // 3: the menu will fit, if constrained


      if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
        if (shouldScroll) {
          animatedScrollTo(scrollParent, scrollDown, scrollDuration);
        } // we want to provide as much of the menu as possible to the user,
        // so give them whatever is available below rather than the minHeight.


        var constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
        return {
          placement: 'bottom',
          maxHeight: constrainedHeight
        };
      } // 4. Forked beviour when there isn't enough space below
      // AUTO: flip the menu, render above


      if (placement === 'auto' || isFixedPosition) {
        // may need to be constrained after flipping
        var _constrainedHeight = maxHeight;
        var spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;

        if (spaceAbove >= minHeight) {
          _constrainedHeight = Math.min(spaceAbove - marginBottom - spacing.controlHeight, maxHeight);
        }

        return {
          placement: 'top',
          maxHeight: _constrainedHeight
        };
      } // BOTTOM: allow browser to increase scrollable area and immediately set scroll


      if (placement === 'bottom') {
        scrollTo(scrollParent, scrollDown);
        return {
          placement: 'bottom',
          maxHeight: maxHeight
        };
      }

      break;

    case 'top':
      // 1: the menu will fit, do nothing
      if (viewSpaceAbove >= menuHeight) {
        return {
          placement: 'top',
          maxHeight: maxHeight
        };
      } // 2: the menu will fit, if scrolled


      if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
        if (shouldScroll) {
          animatedScrollTo(scrollParent, scrollUp, scrollDuration);
        }

        return {
          placement: 'top',
          maxHeight: maxHeight
        };
      } // 3: the menu will fit, if constrained


      if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
        var _constrainedHeight2 = maxHeight; // we want to provide as much of the menu as possible to the user,
        // so give them whatever is available below rather than the minHeight.

        if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
          _constrainedHeight2 = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
        }

        if (shouldScroll) {
          animatedScrollTo(scrollParent, scrollUp, scrollDuration);
        }

        return {
          placement: 'top',
          maxHeight: _constrainedHeight2
        };
      } // 4. not enough space, the browser WILL NOT increase scrollable area when
      // absolutely positioned element rendered above the viewport (only below).
      // Flip the menu, render below


      return {
        placement: 'bottom',
        maxHeight: maxHeight
      };

    default:
      throw new Error("Invalid placement provided \"" + placement + "\".");
  } // fulfil contract with flow: implicit return value of undefined


  return defaultState;
} // Menu Component
// ------------------------------

function alignToControl(placement) {
  var placementToCSSProp = {
    bottom: 'top',
    top: 'bottom'
  };
  return placement ? placementToCSSProp[placement] : 'bottom';
}

var coercePlacement = function coercePlacement(p) {
  return p === 'auto' ? 'bottom' : p;
};

var menuCSS = function menuCSS(_ref2) {
  var _ref3;

  var placement = _ref2.placement,
      _ref2$theme = _ref2.theme,
      borderRadius = _ref2$theme.borderRadius,
      spacing = _ref2$theme.spacing,
      colors = _ref2$theme.colors;
  return _ref3 = {
    label: 'menu'
  }, _ref3[alignToControl(placement)] = '100%', _ref3.backgroundColor = colors.neutral0, _ref3.borderRadius = borderRadius, _ref3.boxShadow = '0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)', _ref3.marginBottom = spacing.menuGutter, _ref3.marginTop = spacing.menuGutter, _ref3.position = 'absolute', _ref3.width = '100%', _ref3.zIndex = 1, _ref3;
}; // NOTE: internal only

var MenuPlacer =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose$1(MenuPlacer, _Component);

  function MenuPlacer() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.state = {
      maxHeight: _this.props.maxMenuHeight,
      placement: null
    };

    _this.getPlacement = function (ref) {
      var _this$props = _this.props,
          minMenuHeight = _this$props.minMenuHeight,
          maxMenuHeight = _this$props.maxMenuHeight,
          menuPlacement = _this$props.menuPlacement,
          menuPosition = _this$props.menuPosition,
          menuShouldScrollIntoView = _this$props.menuShouldScrollIntoView,
          theme = _this$props.theme;
      var getPortalPlacement = _this.context.getPortalPlacement;
      if (!ref) return; // DO NOT scroll if position is fixed

      var isFixedPosition = menuPosition === 'fixed';
      var shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
      var state = getMenuPlacement({
        maxHeight: maxMenuHeight,
        menuEl: ref,
        minHeight: minMenuHeight,
        placement: menuPlacement,
        shouldScroll: shouldScroll,
        isFixedPosition: isFixedPosition,
        theme: theme
      });
      if (getPortalPlacement) getPortalPlacement(state);

      _this.setState(state);
    };

    _this.getUpdatedProps = function () {
      var menuPlacement = _this.props.menuPlacement;
      var placement = _this.state.placement || coercePlacement(menuPlacement);
      return _extends$H({}, _this.props, {
        placement: placement,
        maxHeight: _this.state.maxHeight
      });
    };

    return _this;
  }

  var _proto = MenuPlacer.prototype;

  _proto.render = function render() {
    var children = this.props.children;
    return children({
      ref: this.getPlacement,
      placerProps: this.getUpdatedProps()
    });
  };

  return MenuPlacer;
}(Component);
MenuPlacer.contextTypes = {
  getPortalPlacement: propTypes.func
};

var Menu = function Menu(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerRef = props.innerRef,
      innerProps = props.innerProps;
  return jsx("div", _extends$H({
    css: getStyles('menu', props),
    className: cx({
      menu: true
    }, className)
  }, innerProps, {
    ref: innerRef
  }), children);
};
// Menu List
// ==============================

var menuListCSS = function menuListCSS(_ref4) {
  var maxHeight = _ref4.maxHeight,
      baseUnit = _ref4.theme.spacing.baseUnit;
  return {
    maxHeight: maxHeight,
    overflowY: 'auto',
    paddingBottom: baseUnit,
    paddingTop: baseUnit,
    position: 'relative',
    // required for offset[Height, Top] > keyboard scroll
    WebkitOverflowScrolling: 'touch'
  };
};
var MenuList = function MenuList(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      isMulti = props.isMulti,
      innerRef = props.innerRef;
  return jsx("div", {
    css: getStyles('menuList', props),
    className: cx({
      'menu-list': true,
      'menu-list--is-multi': isMulti
    }, className),
    ref: innerRef
  }, children);
}; // ==============================
// Menu Notices
// ==============================

var noticeCSS = function noticeCSS(_ref5) {
  var _ref5$theme = _ref5.theme,
      baseUnit = _ref5$theme.spacing.baseUnit,
      colors = _ref5$theme.colors;
  return {
    color: colors.neutral40,
    padding: baseUnit * 2 + "px " + baseUnit * 3 + "px",
    textAlign: 'center'
  };
};

var noOptionsMessageCSS = noticeCSS;
var loadingMessageCSS = noticeCSS;
var NoOptionsMessage = function NoOptionsMessage(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps;
  return jsx("div", _extends$H({
    css: getStyles('noOptionsMessage', props),
    className: cx({
      'menu-notice': true,
      'menu-notice--no-options': true
    }, className)
  }, innerProps), children);
};
NoOptionsMessage.defaultProps = {
  children: 'No options'
};
var LoadingMessage = function LoadingMessage(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps;
  return jsx("div", _extends$H({
    css: getStyles('loadingMessage', props),
    className: cx({
      'menu-notice': true,
      'menu-notice--loading': true
    }, className)
  }, innerProps), children);
};
LoadingMessage.defaultProps = {
  children: 'Loading...'
}; // ==============================
// Menu Portal
// ==============================

var menuPortalCSS = function menuPortalCSS(_ref6) {
  var rect = _ref6.rect,
      offset = _ref6.offset,
      position = _ref6.position;
  return {
    left: rect.left,
    position: position,
    top: offset,
    width: rect.width,
    zIndex: 1
  };
};
var MenuPortal =
/*#__PURE__*/
function (_Component2) {
  _inheritsLoose$1(MenuPortal, _Component2);

  function MenuPortal() {
    var _this2;

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    _this2 = _Component2.call.apply(_Component2, [this].concat(args)) || this;
    _this2.state = {
      placement: null
    };

    _this2.getPortalPlacement = function (_ref7) {
      var placement = _ref7.placement;
      var initialPlacement = coercePlacement(_this2.props.menuPlacement); // avoid re-renders if the placement has not changed

      if (placement !== initialPlacement) {
        _this2.setState({
          placement: placement
        });
      }
    };

    return _this2;
  }

  var _proto2 = MenuPortal.prototype;

  _proto2.getChildContext = function getChildContext() {
    return {
      getPortalPlacement: this.getPortalPlacement
    };
  } // callback for occassions where the menu must "flip"
  ;

  _proto2.render = function render() {
    var _this$props2 = this.props,
        appendTo = _this$props2.appendTo,
        children = _this$props2.children,
        controlElement = _this$props2.controlElement,
        menuPlacement = _this$props2.menuPlacement,
        position = _this$props2.menuPosition,
        getStyles = _this$props2.getStyles;
    var isFixed = position === 'fixed'; // bail early if required elements aren't present

    if (!appendTo && !isFixed || !controlElement) {
      return null;
    }

    var placement = this.state.placement || coercePlacement(menuPlacement);
    var rect = getBoundingClientObj(controlElement);
    var scrollDistance = isFixed ? 0 : window.pageYOffset;
    var offset = rect[placement] + scrollDistance;
    var state = {
      offset: offset,
      position: position,
      rect: rect
    }; // same wrapper element whether fixed or portalled

    var menuWrapper = jsx("div", {
      css: getStyles('menuPortal', state)
    }, children);
    return appendTo ? createPortal(menuWrapper, appendTo) : menuWrapper;
  };

  return MenuPortal;
}(Component);
MenuPortal.childContextTypes = {
  getPortalPlacement: propTypes.func
};

var isArray = Array.isArray;
var keyList = Object.keys;
var hasProp = Object.prototype.hasOwnProperty;

function equal(a, b) {
  // fast-deep-equal index.js 2.0.1
  if (a === b) return true;

  if (a && b && typeof a == 'object' && typeof b == 'object') {
    var arrA = isArray(a),
        arrB = isArray(b),
        i,
        length,
        key;

    if (arrA && arrB) {
      length = a.length;
      if (length != b.length) return false;

      for (i = length; i-- !== 0;) {
        if (!equal(a[i], b[i])) return false;
      }

      return true;
    }

    if (arrA != arrB) return false;
    var dateA = a instanceof Date,
        dateB = b instanceof Date;
    if (dateA != dateB) return false;
    if (dateA && dateB) return a.getTime() == b.getTime();
    var regexpA = a instanceof RegExp,
        regexpB = b instanceof RegExp;
    if (regexpA != regexpB) return false;
    if (regexpA && regexpB) return a.toString() == b.toString();
    var keys = keyList(a);
    length = keys.length;

    if (length !== keyList(b).length) {
      return false;
    }

    for (i = length; i-- !== 0;) {
      if (!hasProp.call(b, keys[i])) return false;
    } // end fast-deep-equal
    // Custom handling for React


    for (i = length; i-- !== 0;) {
      key = keys[i];

      if (key === '_owner' && a.$$typeof) {
        // React-specific: avoid traversing React elements' _owner.
        //  _owner contains circular references
        // and is not needed when comparing the actual elements (and not their owners)
        // .$$typeof and ._store on just reasonable markers of a react element
        continue;
      } else {
        // all other properties should be traversed as usual
        if (!equal(a[key], b[key])) return false;
      }
    } // fast-deep-equal index.js 2.0.1


    return true;
  }

  return a !== a && b !== b;
} // end fast-deep-equal


function exportedEqual(a, b) {
  try {
    return equal(a, b);
  } catch (error) {
    if (error.message && error.message.match(/stack|recursion/i)) {
      // warn on circular references, don't crash
      // browsers give this different errors name and messages:
      // chrome/safari: "RangeError", "Maximum call stack size exceeded"
      // firefox: "InternalError", too much recursion"
      // edge: "Error", "Out of stack space"
      console.warn('Warning: react-fast-compare does not handle circular references.', error.name, error.message);
      return false;
    } // some other error. we should definitely know about these


    throw error;
  }
}

function _extends$1$1() { _extends$1$1 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1$1.apply(this, arguments); }
var containerCSS = function containerCSS(_ref) {
  var isDisabled = _ref.isDisabled,
      isRtl = _ref.isRtl;
  return {
    label: 'container',
    direction: isRtl ? 'rtl' : null,
    pointerEvents: isDisabled ? 'none' : null,
    // cancel mouse events when disabled
    position: 'relative'
  };
};
var SelectContainer = function SelectContainer(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps,
      isDisabled = props.isDisabled,
      isRtl = props.isRtl;
  return jsx("div", _extends$1$1({
    css: getStyles('container', props),
    className: cx({
      '--is-disabled': isDisabled,
      '--is-rtl': isRtl
    }, className)
  }, innerProps), children);
}; // ==============================
// Value Container
// ==============================

var valueContainerCSS = function valueContainerCSS(_ref2) {
  var spacing = _ref2.theme.spacing;
  return {
    alignItems: 'center',
    display: 'flex',
    flex: 1,
    flexWrap: 'wrap',
    padding: spacing.baseUnit / 2 + "px " + spacing.baseUnit * 2 + "px",
    WebkitOverflowScrolling: 'touch',
    position: 'relative',
    overflow: 'hidden'
  };
};
var ValueContainer = function ValueContainer(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      isMulti = props.isMulti,
      getStyles = props.getStyles,
      hasValue = props.hasValue;
  return jsx("div", {
    css: getStyles('valueContainer', props),
    className: cx({
      'value-container': true,
      'value-container--is-multi': isMulti,
      'value-container--has-value': hasValue
    }, className)
  }, children);
}; // ==============================
// Indicator Container
// ==============================

var indicatorsContainerCSS = function indicatorsContainerCSS() {
  return {
    alignItems: 'center',
    alignSelf: 'stretch',
    display: 'flex',
    flexShrink: 0
  };
};
var IndicatorsContainer = function IndicatorsContainer(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles;
  return jsx("div", {
    css: getStyles('indicatorsContainer', props),
    className: cx({
      indicators: true
    }, className)
  }, children);
};

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  0%, 80%, 100% { opacity: 0; }\n  40% { opacity: 1; }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

function _extends$2$1() { _extends$2$1 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2$1.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var _ref2$f = process.env.NODE_ENV === "production" ? {
  name: "19bqh2r",
  styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0;"
} : {
  name: "19bqh2r",
  styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"
};

// ==============================
// Dropdown & Clear Icons
// ==============================
var Svg = function Svg(_ref) {
  var size = _ref.size,
      props = _objectWithoutPropertiesLoose(_ref, ["size"]);

  return jsx("svg", _extends$2$1({
    height: size,
    width: size,
    viewBox: "0 0 20 20",
    "aria-hidden": "true",
    focusable: "false",
    css: _ref2$f
  }, props));
};

var CrossIcon = function CrossIcon(props) {
  return jsx(Svg, _extends$2$1({
    size: 20
  }, props), jsx("path", {
    d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
  }));
};
var DownChevron = function DownChevron(props) {
  return jsx(Svg, _extends$2$1({
    size: 20
  }, props), jsx("path", {
    d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
  }));
}; // ==============================
// Dropdown & Clear Buttons
// ==============================

var baseCSS = function baseCSS(_ref3) {
  var isFocused = _ref3.isFocused,
      _ref3$theme = _ref3.theme,
      baseUnit = _ref3$theme.spacing.baseUnit,
      colors = _ref3$theme.colors;
  return {
    label: 'indicatorContainer',
    color: isFocused ? colors.neutral60 : colors.neutral20,
    display: 'flex',
    padding: baseUnit * 2,
    transition: 'color 150ms',
    ':hover': {
      color: isFocused ? colors.neutral80 : colors.neutral40
    }
  };
};

var dropdownIndicatorCSS = baseCSS;
var DropdownIndicator = function DropdownIndicator(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps;
  return jsx("div", _extends$2$1({}, innerProps, {
    css: getStyles('dropdownIndicator', props),
    className: cx({
      indicator: true,
      'dropdown-indicator': true
    }, className)
  }), children || jsx(DownChevron, null));
};
var clearIndicatorCSS = baseCSS;
var ClearIndicator = function ClearIndicator(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps;
  return jsx("div", _extends$2$1({}, innerProps, {
    css: getStyles('clearIndicator', props),
    className: cx({
      indicator: true,
      'clear-indicator': true
    }, className)
  }), children || jsx(CrossIcon, null));
}; // ==============================
// Separator
// ==============================

var indicatorSeparatorCSS = function indicatorSeparatorCSS(_ref4) {
  var isDisabled = _ref4.isDisabled,
      _ref4$theme = _ref4.theme,
      baseUnit = _ref4$theme.spacing.baseUnit,
      colors = _ref4$theme.colors;
  return {
    label: 'indicatorSeparator',
    alignSelf: 'stretch',
    backgroundColor: isDisabled ? colors.neutral10 : colors.neutral20,
    marginBottom: baseUnit * 2,
    marginTop: baseUnit * 2,
    width: 1
  };
};
var IndicatorSeparator = function IndicatorSeparator(props) {
  var className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps;
  return jsx("span", _extends$2$1({}, innerProps, {
    css: getStyles('indicatorSeparator', props),
    className: cx({
      'indicator-separator': true
    }, className)
  }));
}; // ==============================
// Loading
// ==============================

var loadingDotAnimations = keyframes(_templateObject());
var loadingIndicatorCSS = function loadingIndicatorCSS(_ref5) {
  var isFocused = _ref5.isFocused,
      size = _ref5.size,
      _ref5$theme = _ref5.theme,
      colors = _ref5$theme.colors,
      baseUnit = _ref5$theme.spacing.baseUnit;
  return {
    label: 'loadingIndicator',
    color: isFocused ? colors.neutral60 : colors.neutral20,
    display: 'flex',
    padding: baseUnit * 2,
    transition: 'color 150ms',
    alignSelf: 'center',
    fontSize: size,
    lineHeight: 1,
    marginRight: size,
    textAlign: 'center',
    verticalAlign: 'middle'
  };
};

var LoadingDot = function LoadingDot(_ref6) {
  var delay = _ref6.delay,
      offset = _ref6.offset;
  return jsx("span", {
    css:
    /*#__PURE__*/
    css({
      animation: loadingDotAnimations + " 1s ease-in-out " + delay + "ms infinite;",
      backgroundColor: 'currentColor',
      borderRadius: '1em',
      display: 'inline-block',
      marginLeft: offset ? '1em' : null,
      height: '1em',
      verticalAlign: 'top',
      width: '1em'
    }, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")
  });
};

var LoadingIndicator = function LoadingIndicator(props) {
  var className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps,
      isRtl = props.isRtl;
  return jsx("div", _extends$2$1({}, innerProps, {
    css: getStyles('loadingIndicator', props),
    className: cx({
      indicator: true,
      'loading-indicator': true
    }, className)
  }), jsx(LoadingDot, {
    delay: 0,
    offset: isRtl
  }), jsx(LoadingDot, {
    delay: 160,
    offset: true
  }), jsx(LoadingDot, {
    delay: 320,
    offset: !isRtl
  }));
};
LoadingIndicator.defaultProps = {
  size: 4
};

function _extends$3$1() { _extends$3$1 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3$1.apply(this, arguments); }
var css$1 = function css(_ref) {
  var isDisabled = _ref.isDisabled,
      isFocused = _ref.isFocused,
      _ref$theme = _ref.theme,
      colors = _ref$theme.colors,
      borderRadius = _ref$theme.borderRadius,
      spacing = _ref$theme.spacing;
  return {
    label: 'control',
    alignItems: 'center',
    backgroundColor: isDisabled ? colors.neutral5 : colors.neutral0,
    borderColor: isDisabled ? colors.neutral10 : isFocused ? colors.primary : colors.neutral20,
    borderRadius: borderRadius,
    borderStyle: 'solid',
    borderWidth: 1,
    boxShadow: isFocused ? "0 0 0 1px " + colors.primary : null,
    cursor: 'default',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    minHeight: spacing.controlHeight,
    outline: '0 !important',
    position: 'relative',
    transition: 'all 100ms',
    '&:hover': {
      borderColor: isFocused ? colors.primary : colors.neutral30
    }
  };
};

var Control = function Control(props) {
  var children = props.children,
      cx = props.cx,
      getStyles = props.getStyles,
      className = props.className,
      isDisabled = props.isDisabled,
      isFocused = props.isFocused,
      innerRef = props.innerRef,
      innerProps = props.innerProps,
      menuIsOpen = props.menuIsOpen;
  return jsx("div", _extends$3$1({
    ref: innerRef,
    css: getStyles('control', props),
    className: cx({
      control: true,
      'control--is-disabled': isDisabled,
      'control--is-focused': isFocused,
      'control--menu-is-open': menuIsOpen
    }, className)
  }, innerProps), children);
};

function _objectWithoutPropertiesLoose$1(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends$4$1() { _extends$4$1 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4$1.apply(this, arguments); }
var groupCSS = function groupCSS(_ref) {
  var spacing = _ref.theme.spacing;
  return {
    paddingBottom: spacing.baseUnit * 2,
    paddingTop: spacing.baseUnit * 2
  };
};

var Group = function Group(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      Heading = props.Heading,
      headingProps = props.headingProps,
      label = props.label,
      theme = props.theme,
      selectProps = props.selectProps;
  return jsx("div", {
    css: getStyles('group', props),
    className: cx({
      group: true
    }, className)
  }, jsx(Heading, _extends$4$1({}, headingProps, {
    selectProps: selectProps,
    theme: theme,
    getStyles: getStyles,
    cx: cx
  }), label), jsx("div", null, children));
};

var groupHeadingCSS = function groupHeadingCSS(_ref2) {
  var spacing = _ref2.theme.spacing;
  return {
    label: 'group',
    color: '#999',
    cursor: 'default',
    display: 'block',
    fontSize: '75%',
    fontWeight: '500',
    marginBottom: '0.25em',
    paddingLeft: spacing.baseUnit * 3,
    paddingRight: spacing.baseUnit * 3,
    textTransform: 'uppercase'
  };
};
var GroupHeading = function GroupHeading(props) {
  var className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      theme = props.theme,
      selectProps = props.selectProps,
      cleanProps = _objectWithoutPropertiesLoose$1(props, ["className", "cx", "getStyles", "theme", "selectProps"]);

  return jsx("div", _extends$4$1({
    css: getStyles('groupHeading', _extends$4$1({
      theme: theme
    }, cleanProps)),
    className: cx({
      'group-heading': true
    }, className)
  }, cleanProps));
};

function _extends$5$1() { _extends$5$1 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5$1.apply(this, arguments); }

function _objectWithoutPropertiesLoose$2(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var inputCSS = function inputCSS(_ref) {
  var isDisabled = _ref.isDisabled,
      _ref$theme = _ref.theme,
      spacing = _ref$theme.spacing,
      colors = _ref$theme.colors;
  return {
    margin: spacing.baseUnit / 2,
    paddingBottom: spacing.baseUnit / 2,
    paddingTop: spacing.baseUnit / 2,
    visibility: isDisabled ? 'hidden' : 'visible',
    color: colors.neutral80
  };
};

var inputStyle = function inputStyle(isHidden) {
  return {
    label: 'input',
    background: 0,
    border: 0,
    fontSize: 'inherit',
    opacity: isHidden ? 0 : 1,
    outline: 0,
    padding: 0,
    color: 'inherit'
  };
};

var Input = function Input(_ref2) {
  var className = _ref2.className,
      cx = _ref2.cx,
      getStyles = _ref2.getStyles,
      innerRef = _ref2.innerRef,
      isHidden = _ref2.isHidden,
      isDisabled = _ref2.isDisabled,
      theme = _ref2.theme,
      selectProps = _ref2.selectProps,
      props = _objectWithoutPropertiesLoose$2(_ref2, ["className", "cx", "getStyles", "innerRef", "isHidden", "isDisabled", "theme", "selectProps"]);

  return jsx("div", {
    css: getStyles('input', _extends$5$1({
      theme: theme
    }, props))
  }, jsx(AutosizeInput, _extends$5$1({
    className: cx({
      input: true
    }, className),
    inputRef: innerRef,
    inputStyle: inputStyle(isHidden),
    disabled: isDisabled
  }, props)));
};

function _extends$6$1() { _extends$6$1 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6$1.apply(this, arguments); }
var multiValueCSS = function multiValueCSS(_ref) {
  var _ref$theme = _ref.theme,
      spacing = _ref$theme.spacing,
      borderRadius = _ref$theme.borderRadius,
      colors = _ref$theme.colors;
  return {
    label: 'multiValue',
    backgroundColor: colors.neutral10,
    borderRadius: borderRadius / 2,
    display: 'flex',
    margin: spacing.baseUnit / 2,
    minWidth: 0 // resolves flex/text-overflow bug

  };
};
var multiValueLabelCSS = function multiValueLabelCSS(_ref2) {
  var _ref2$theme = _ref2.theme,
      borderRadius = _ref2$theme.borderRadius,
      colors = _ref2$theme.colors,
      cropWithEllipsis = _ref2.cropWithEllipsis;
  return {
    borderRadius: borderRadius / 2,
    color: colors.neutral80,
    fontSize: '85%',
    overflow: 'hidden',
    padding: 3,
    paddingLeft: 6,
    textOverflow: cropWithEllipsis ? 'ellipsis' : null,
    whiteSpace: 'nowrap'
  };
};
var multiValueRemoveCSS = function multiValueRemoveCSS(_ref3) {
  var _ref3$theme = _ref3.theme,
      spacing = _ref3$theme.spacing,
      borderRadius = _ref3$theme.borderRadius,
      colors = _ref3$theme.colors,
      isFocused = _ref3.isFocused;
  return {
    alignItems: 'center',
    borderRadius: borderRadius / 2,
    backgroundColor: isFocused && colors.dangerLight,
    display: 'flex',
    paddingLeft: spacing.baseUnit,
    paddingRight: spacing.baseUnit,
    ':hover': {
      backgroundColor: colors.dangerLight,
      color: colors.danger
    }
  };
};
var MultiValueGeneric = function MultiValueGeneric(_ref4) {
  var children = _ref4.children,
      innerProps = _ref4.innerProps;
  return jsx("div", innerProps, children);
};
var MultiValueContainer = MultiValueGeneric;
var MultiValueLabel = MultiValueGeneric;
function MultiValueRemove(_ref5) {
  var children = _ref5.children,
      innerProps = _ref5.innerProps;
  return jsx("div", innerProps, children || jsx(CrossIcon, {
    size: 14
  }));
}

var MultiValue = function MultiValue(props) {
  var children = props.children,
      className = props.className,
      components = props.components,
      cx = props.cx,
      data = props.data,
      getStyles = props.getStyles,
      innerProps = props.innerProps,
      isDisabled = props.isDisabled,
      removeProps = props.removeProps,
      selectProps = props.selectProps;
  var Container = components.Container,
      Label = components.Label,
      Remove = components.Remove;
  return jsx(ClassNames, null, function (_ref6) {
    var css = _ref6.css,
        emotionCx = _ref6.cx;
    return jsx(Container, {
      data: data,
      innerProps: _extends$6$1({}, innerProps, {
        className: emotionCx(css(getStyles('multiValue', props)), cx({
          'multi-value': true,
          'multi-value--is-disabled': isDisabled
        }, className))
      }),
      selectProps: selectProps
    }, jsx(Label, {
      data: data,
      innerProps: {
        className: emotionCx(css(getStyles('multiValueLabel', props)), cx({
          'multi-value__label': true
        }, className))
      },
      selectProps: selectProps
    }, children), jsx(Remove, {
      data: data,
      innerProps: _extends$6$1({
        className: emotionCx(css(getStyles('multiValueRemove', props)), cx({
          'multi-value__remove': true
        }, className))
      }, removeProps),
      selectProps: selectProps
    }));
  });
};

MultiValue.defaultProps = {
  cropWithEllipsis: true
};

function _extends$7$1() { _extends$7$1 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7$1.apply(this, arguments); }
var optionCSS = function optionCSS(_ref) {
  var isDisabled = _ref.isDisabled,
      isFocused = _ref.isFocused,
      isSelected = _ref.isSelected,
      _ref$theme = _ref.theme,
      spacing = _ref$theme.spacing,
      colors = _ref$theme.colors;
  return {
    label: 'option',
    backgroundColor: isSelected ? colors.primary : isFocused ? colors.primary25 : 'transparent',
    color: isDisabled ? colors.neutral20 : isSelected ? colors.neutral0 : 'inherit',
    cursor: 'default',
    display: 'block',
    fontSize: 'inherit',
    padding: spacing.baseUnit * 2 + "px " + spacing.baseUnit * 3 + "px",
    width: '100%',
    userSelect: 'none',
    WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)',
    // provide some affordance on touch devices
    ':active': {
      backgroundColor: !isDisabled && (isSelected ? colors.primary : colors.primary50)
    }
  };
};

var Option = function Option(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      isDisabled = props.isDisabled,
      isFocused = props.isFocused,
      isSelected = props.isSelected,
      innerRef = props.innerRef,
      innerProps = props.innerProps;
  return jsx("div", _extends$7$1({
    css: getStyles('option', props),
    className: cx({
      option: true,
      'option--is-disabled': isDisabled,
      'option--is-focused': isFocused,
      'option--is-selected': isSelected
    }, className),
    ref: innerRef
  }, innerProps), children);
};

function _extends$8$1() { _extends$8$1 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8$1.apply(this, arguments); }
var placeholderCSS = function placeholderCSS(_ref) {
  var _ref$theme = _ref.theme,
      spacing = _ref$theme.spacing,
      colors = _ref$theme.colors;
  return {
    label: 'placeholder',
    color: colors.neutral50,
    marginLeft: spacing.baseUnit / 2,
    marginRight: spacing.baseUnit / 2,
    position: 'absolute',
    top: '50%',
    transform: 'translateY(-50%)'
  };
};

var Placeholder = function Placeholder(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps;
  return jsx("div", _extends$8$1({
    css: getStyles('placeholder', props),
    className: cx({
      placeholder: true
    }, className)
  }, innerProps), children);
};

function _extends$9$1() { _extends$9$1 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9$1.apply(this, arguments); }
var css$1$1 = function css(_ref) {
  var isDisabled = _ref.isDisabled,
      _ref$theme = _ref.theme,
      spacing = _ref$theme.spacing,
      colors = _ref$theme.colors;
  return {
    label: 'singleValue',
    color: isDisabled ? colors.neutral40 : colors.neutral80,
    marginLeft: spacing.baseUnit / 2,
    marginRight: spacing.baseUnit / 2,
    maxWidth: "calc(100% - " + spacing.baseUnit * 2 + "px)",
    overflow: 'hidden',
    position: 'absolute',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    top: '50%',
    transform: 'translateY(-50%)'
  };
};

var SingleValue = function SingleValue(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      isDisabled = props.isDisabled,
      innerProps = props.innerProps;
  return jsx("div", _extends$9$1({
    css: getStyles('singleValue', props),
    className: cx({
      'single-value': true,
      'single-value--is-disabled': isDisabled
    }, className)
  }, innerProps), children);
};

function _extends$a$1() { _extends$a$1 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$a$1.apply(this, arguments); }
var components = {
  ClearIndicator: ClearIndicator,
  Control: Control,
  DropdownIndicator: DropdownIndicator,
  DownChevron: DownChevron,
  CrossIcon: CrossIcon,
  Group: Group,
  GroupHeading: GroupHeading,
  IndicatorsContainer: IndicatorsContainer,
  IndicatorSeparator: IndicatorSeparator,
  Input: Input,
  LoadingIndicator: LoadingIndicator,
  Menu: Menu,
  MenuList: MenuList,
  MenuPortal: MenuPortal,
  LoadingMessage: LoadingMessage,
  NoOptionsMessage: NoOptionsMessage,
  MultiValue: MultiValue,
  MultiValueContainer: MultiValueContainer,
  MultiValueLabel: MultiValueLabel,
  MultiValueRemove: MultiValueRemove,
  Option: Option,
  Placeholder: Placeholder,
  SelectContainer: SelectContainer,
  SingleValue: SingleValue,
  ValueContainer: ValueContainer
};
var defaultComponents = function defaultComponents(props) {
  return _extends$a$1({}, components, props.components);
};

var diacritics = [{
  base: 'A',
  letters: /[\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F]/g
}, {
  base: 'AA',
  letters: /[\uA732]/g
}, {
  base: 'AE',
  letters: /[\u00C6\u01FC\u01E2]/g
}, {
  base: 'AO',
  letters: /[\uA734]/g
}, {
  base: 'AU',
  letters: /[\uA736]/g
}, {
  base: 'AV',
  letters: /[\uA738\uA73A]/g
}, {
  base: 'AY',
  letters: /[\uA73C]/g
}, {
  base: 'B',
  letters: /[\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181]/g
}, {
  base: 'C',
  letters: /[\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E]/g
}, {
  base: 'D',
  letters: /[\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779]/g
}, {
  base: 'DZ',
  letters: /[\u01F1\u01C4]/g
}, {
  base: 'Dz',
  letters: /[\u01F2\u01C5]/g
}, {
  base: 'E',
  letters: /[\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E]/g
}, {
  base: 'F',
  letters: /[\u0046\u24BB\uFF26\u1E1E\u0191\uA77B]/g
}, {
  base: 'G',
  letters: /[\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E]/g
}, {
  base: 'H',
  letters: /[\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D]/g
}, {
  base: 'I',
  letters: /[\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197]/g
}, {
  base: 'J',
  letters: /[\u004A\u24BF\uFF2A\u0134\u0248]/g
}, {
  base: 'K',
  letters: /[\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2]/g
}, {
  base: 'L',
  letters: /[\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780]/g
}, {
  base: 'LJ',
  letters: /[\u01C7]/g
}, {
  base: 'Lj',
  letters: /[\u01C8]/g
}, {
  base: 'M',
  letters: /[\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C]/g
}, {
  base: 'N',
  letters: /[\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4]/g
}, {
  base: 'NJ',
  letters: /[\u01CA]/g
}, {
  base: 'Nj',
  letters: /[\u01CB]/g
}, {
  base: 'O',
  letters: /[\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C]/g
}, {
  base: 'OI',
  letters: /[\u01A2]/g
}, {
  base: 'OO',
  letters: /[\uA74E]/g
}, {
  base: 'OU',
  letters: /[\u0222]/g
}, {
  base: 'P',
  letters: /[\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754]/g
}, {
  base: 'Q',
  letters: /[\u0051\u24C6\uFF31\uA756\uA758\u024A]/g
}, {
  base: 'R',
  letters: /[\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782]/g
}, {
  base: 'S',
  letters: /[\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784]/g
}, {
  base: 'T',
  letters: /[\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786]/g
}, {
  base: 'TZ',
  letters: /[\uA728]/g
}, {
  base: 'U',
  letters: /[\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244]/g
}, {
  base: 'V',
  letters: /[\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245]/g
}, {
  base: 'VY',
  letters: /[\uA760]/g
}, {
  base: 'W',
  letters: /[\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72]/g
}, {
  base: 'X',
  letters: /[\u0058\u24CD\uFF38\u1E8A\u1E8C]/g
}, {
  base: 'Y',
  letters: /[\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE]/g
}, {
  base: 'Z',
  letters: /[\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762]/g
}, {
  base: 'a',
  letters: /[\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250]/g
}, {
  base: 'aa',
  letters: /[\uA733]/g
}, {
  base: 'ae',
  letters: /[\u00E6\u01FD\u01E3]/g
}, {
  base: 'ao',
  letters: /[\uA735]/g
}, {
  base: 'au',
  letters: /[\uA737]/g
}, {
  base: 'av',
  letters: /[\uA739\uA73B]/g
}, {
  base: 'ay',
  letters: /[\uA73D]/g
}, {
  base: 'b',
  letters: /[\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253]/g
}, {
  base: 'c',
  letters: /[\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184]/g
}, {
  base: 'd',
  letters: /[\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A]/g
}, {
  base: 'dz',
  letters: /[\u01F3\u01C6]/g
}, {
  base: 'e',
  letters: /[\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD]/g
}, {
  base: 'f',
  letters: /[\u0066\u24D5\uFF46\u1E1F\u0192\uA77C]/g
}, {
  base: 'g',
  letters: /[\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F]/g
}, {
  base: 'h',
  letters: /[\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265]/g
}, {
  base: 'hv',
  letters: /[\u0195]/g
}, {
  base: 'i',
  letters: /[\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131]/g
}, {
  base: 'j',
  letters: /[\u006A\u24D9\uFF4A\u0135\u01F0\u0249]/g
}, {
  base: 'k',
  letters: /[\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3]/g
}, {
  base: 'l',
  letters: /[\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747]/g
}, {
  base: 'lj',
  letters: /[\u01C9]/g
}, {
  base: 'm',
  letters: /[\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F]/g
}, {
  base: 'n',
  letters: /[\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5]/g
}, {
  base: 'nj',
  letters: /[\u01CC]/g
}, {
  base: 'o',
  letters: /[\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275]/g
}, {
  base: 'oi',
  letters: /[\u01A3]/g
}, {
  base: 'ou',
  letters: /[\u0223]/g
}, {
  base: 'oo',
  letters: /[\uA74F]/g
}, {
  base: 'p',
  letters: /[\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755]/g
}, {
  base: 'q',
  letters: /[\u0071\u24E0\uFF51\u024B\uA757\uA759]/g
}, {
  base: 'r',
  letters: /[\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783]/g
}, {
  base: 's',
  letters: /[\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B]/g
}, {
  base: 't',
  letters: /[\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787]/g
}, {
  base: 'tz',
  letters: /[\uA729]/g
}, {
  base: 'u',
  letters: /[\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289]/g
}, {
  base: 'v',
  letters: /[\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C]/g
}, {
  base: 'vy',
  letters: /[\uA761]/g
}, {
  base: 'w',
  letters: /[\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73]/g
}, {
  base: 'x',
  letters: /[\u0078\u24E7\uFF58\u1E8B\u1E8D]/g
}, {
  base: 'y',
  letters: /[\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF]/g
}, {
  base: 'z',
  letters: /[\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763]/g
}];
var stripDiacritics = function stripDiacritics(str) {
  for (var i = 0; i < diacritics.length; i++) {
    str = str.replace(diacritics[i].letters, diacritics[i].base);
  }

  return str;
};

function _extends$I() { _extends$I = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$I.apply(this, arguments); }

var trimString = function trimString(str) {
  return str.replace(/^\s+|\s+$/g, '');
};

var defaultStringify = function defaultStringify(option) {
  return option.label + " " + option.value;
};

var createFilter = function createFilter(config) {
  return function (option, rawInput) {
    var _ignoreCase$ignoreAcc = _extends$I({
      ignoreCase: true,
      ignoreAccents: true,
      stringify: defaultStringify,
      trim: true,
      matchFrom: 'any'
    }, config),
        ignoreCase = _ignoreCase$ignoreAcc.ignoreCase,
        ignoreAccents = _ignoreCase$ignoreAcc.ignoreAccents,
        stringify = _ignoreCase$ignoreAcc.stringify,
        trim = _ignoreCase$ignoreAcc.trim,
        matchFrom = _ignoreCase$ignoreAcc.matchFrom;

    var input = trim ? trimString(rawInput) : rawInput;
    var candidate = trim ? trimString(stringify(option)) : stringify(option);

    if (ignoreCase) {
      input = input.toLowerCase();
      candidate = candidate.toLowerCase();
    }

    if (ignoreAccents) {
      input = stripDiacritics(input);
      candidate = stripDiacritics(candidate);
    }

    return matchFrom === 'start' ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
  };
};

function _extends$1$2() { _extends$1$2 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1$2.apply(this, arguments); }

var _ref$H = process.env.NODE_ENV === "production" ? {
  name: "1laao21-a11yText",
  styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap;"
} : {
  name: "1laao21-a11yText",
  styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkExMXlUZXh0LmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQVFNIiwiZmlsZSI6IkExMXlUZXh0LmpzIiwic291cmNlc0NvbnRlbnQiOlsiLy8gQGZsb3dcbi8qKiBAanN4IGpzeCAqL1xuaW1wb3J0IHsgdHlwZSBFbGVtZW50Q29uZmlnIH0gZnJvbSAncmVhY3QnO1xuaW1wb3J0IHsganN4IH0gZnJvbSAnQGVtb3Rpb24vY29yZSc7XG5cbi8vIEFzc2lzdGl2ZSB0ZXh0IHRvIGRlc2NyaWJlIHZpc3VhbCBlbGVtZW50cy4gSGlkZGVuIGZvciBzaWdodGVkIHVzZXJzLlxuY29uc3QgQTExeVRleHQgPSAocHJvcHM6IEVsZW1lbnRDb25maWc8J3NwYW4nPikgPT4gKFxuICAgIDxzcGFuXG4gICAgICBjc3M9e3tcbiAgICAgICAgbGFiZWw6ICdhMTF5VGV4dCcsXG4gICAgICAgIHpJbmRleDogOTk5OSxcbiAgICAgICAgYm9yZGVyOiAwLFxuICAgICAgICBjbGlwOiAncmVjdCgxcHgsIDFweCwgMXB4LCAxcHgpJyxcbiAgICAgICAgaGVpZ2h0OiAxLFxuICAgICAgICB3aWR0aDogMSxcbiAgICAgICAgcG9zaXRpb246ICdhYnNvbHV0ZScsXG4gICAgICAgIG92ZXJmbG93OiAnaGlkZGVuJyxcbiAgICAgICAgcGFkZGluZzogMCxcbiAgICAgICAgd2hpdGVTcGFjZTogJ25vd3JhcCcsXG4gICAgICB9fVxuICAgICAgey4uLnByb3BzfVxuICAgIC8+XG4pO1xuXG5leHBvcnQgZGVmYXVsdCBBMTF5VGV4dDtcbiJdfQ== */"
};

var A11yText = function A11yText(props) {
  return jsx("span", _extends$1$2({
    css: _ref$H
  }, props));
};

function _extends$2$2() { _extends$2$2 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2$2.apply(this, arguments); }

function _objectWithoutPropertiesLoose$3(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function DummyInput(_ref) {
  var inProp = _ref.in,
      out = _ref.out,
      onExited = _ref.onExited,
      appear = _ref.appear,
      enter = _ref.enter,
      exit = _ref.exit,
      innerRef = _ref.innerRef,
      emotion = _ref.emotion,
      props = _objectWithoutPropertiesLoose$3(_ref, ["in", "out", "onExited", "appear", "enter", "exit", "innerRef", "emotion"]);

  return jsx("input", _extends$2$2({
    ref: innerRef
  }, props, {
    css:
    /*#__PURE__*/
    css({
      label: 'dummyInput',
      // get rid of any default styles
      background: 0,
      border: 0,
      fontSize: 'inherit',
      outline: 0,
      padding: 0,
      // important! without `width` browsers won't allow focus
      width: 1,
      // remove cursor on desktop
      color: 'transparent',
      // remove cursor on mobile whilst maintaining "scroll into view" behaviour
      left: -100,
      opacity: 0,
      position: 'relative',
      transform: 'scale(0)'
    }, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkR1bW15SW5wdXQuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBbUJNIiwiZmlsZSI6IkR1bW15SW5wdXQuanMiLCJzb3VyY2VzQ29udGVudCI6WyIvLyBAZmxvd1xuLyoqIEBqc3gganN4ICovXG5pbXBvcnQgeyBqc3ggfSBmcm9tICdAZW1vdGlvbi9jb3JlJztcblxuZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24gRHVtbXlJbnB1dCh7XG4gIGluOiBpblByb3AsXG4gIG91dCxcbiAgb25FeGl0ZWQsXG4gIGFwcGVhcixcbiAgZW50ZXIsXG4gIGV4aXQsXG4gIGlubmVyUmVmLFxuICBlbW90aW9uLFxuICAuLi5wcm9wc1xufTogYW55KSB7XG4gIHJldHVybiAoXG4gICAgPGlucHV0XG4gICAgICByZWY9e2lubmVyUmVmfVxuICAgICAgey4uLnByb3BzfVxuICAgICAgY3NzPXt7XG4gICAgICAgIGxhYmVsOiAnZHVtbXlJbnB1dCcsXG4gICAgICAgIC8vIGdldCByaWQgb2YgYW55IGRlZmF1bHQgc3R5bGVzXG4gICAgICAgIGJhY2tncm91bmQ6IDAsXG4gICAgICAgIGJvcmRlcjogMCxcbiAgICAgICAgZm9udFNpemU6ICdpbmhlcml0JyxcbiAgICAgICAgb3V0bGluZTogMCxcbiAgICAgICAgcGFkZGluZzogMCxcbiAgICAgICAgLy8gaW1wb3J0YW50ISB3aXRob3V0IGB3aWR0aGAgYnJvd3NlcnMgd29uJ3QgYWxsb3cgZm9jdXNcbiAgICAgICAgd2lkdGg6IDEsXG5cbiAgICAgICAgLy8gcmVtb3ZlIGN1cnNvciBvbiBkZXNrdG9wXG4gICAgICAgIGNvbG9yOiAndHJhbnNwYXJlbnQnLFxuXG4gICAgICAgIC8vIHJlbW92ZSBjdXJzb3Igb24gbW9iaWxlIHdoaWxzdCBtYWludGFpbmluZyBcInNjcm9sbCBpbnRvIHZpZXdcIiBiZWhhdmlvdXJcbiAgICAgICAgbGVmdDogLTEwMCxcbiAgICAgICAgb3BhY2l0eTogMCxcbiAgICAgICAgcG9zaXRpb246ICdyZWxhdGl2ZScsXG4gICAgICAgIHRyYW5zZm9ybTogJ3NjYWxlKDApJyxcbiAgICAgIH19XG4gICAgLz5cbiAgKTtcbn1cbiJdfQ== */")
  }));
}

function _inheritsLoose$2(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var NodeResolver =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose$2(NodeResolver, _Component);

  function NodeResolver() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = NodeResolver.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.props.innerRef(findDOMNode(this));
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.props.innerRef(null);
  };

  _proto.render = function render() {
    return this.props.children;
  };

  return NodeResolver;
}(Component);

var STYLE_KEYS = ['boxSizing', 'height', 'overflow', 'paddingRight', 'position'];
var LOCK_STYLES = {
  boxSizing: 'border-box',
  // account for possible declaration `width: 100%;` on body
  overflow: 'hidden',
  position: 'relative',
  height: '100%'
};

function preventTouchMove(e) {
  e.preventDefault();
}
function allowTouchMove(e) {
  e.stopPropagation();
}
function preventInertiaScroll() {
  var top = this.scrollTop;
  var totalScroll = this.scrollHeight;
  var currentScroll = top + this.offsetHeight;

  if (top === 0) {
    this.scrollTop = 1;
  } else if (currentScroll === totalScroll) {
    this.scrollTop = top - 1;
  }
} // `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface

function isTouchDevice() {
  return 'ontouchstart' in window || navigator.maxTouchPoints;
}

function _inheritsLoose$1$1(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
var activeScrollLocks = 0;

var ScrollLock =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose$1$1(ScrollLock, _Component);

  function ScrollLock() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.originalStyles = {};
    _this.listenerOptions = {
      capture: false,
      passive: false
    };
    return _this;
  }

  var _proto = ScrollLock.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var _this2 = this;

    if (!canUseDOM) return;
    var _this$props = this.props,
        accountForScrollbars = _this$props.accountForScrollbars,
        touchScrollTarget = _this$props.touchScrollTarget;
    var target = document.body;
    var targetStyle = target && target.style;

    if (accountForScrollbars) {
      // store any styles already applied to the body
      STYLE_KEYS.forEach(function (key) {
        var val = targetStyle && targetStyle[key];
        _this2.originalStyles[key] = val;
      });
    } // apply the lock styles and padding if this is the first scroll lock


    if (accountForScrollbars && activeScrollLocks < 1) {
      var currentPadding = parseInt(this.originalStyles.paddingRight, 10) || 0;
      var clientWidth = document.body ? document.body.clientWidth : 0;
      var adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
      Object.keys(LOCK_STYLES).forEach(function (key) {
        var val = LOCK_STYLES[key];

        if (targetStyle) {
          targetStyle[key] = val;
        }
      });

      if (targetStyle) {
        targetStyle.paddingRight = adjustedPadding + "px";
      }
    } // account for touch devices


    if (target && isTouchDevice()) {
      // Mobile Safari ignores { overflow: hidden } declaration on the body.
      target.addEventListener('touchmove', preventTouchMove, this.listenerOptions); // Allow scroll on provided target

      if (touchScrollTarget) {
        touchScrollTarget.addEventListener('touchstart', preventInertiaScroll, this.listenerOptions);
        touchScrollTarget.addEventListener('touchmove', allowTouchMove, this.listenerOptions);
      }
    } // increment active scroll locks


    activeScrollLocks += 1;
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    var _this3 = this;

    if (!canUseDOM) return;
    var _this$props2 = this.props,
        accountForScrollbars = _this$props2.accountForScrollbars,
        touchScrollTarget = _this$props2.touchScrollTarget;
    var target = document.body;
    var targetStyle = target && target.style; // safely decrement active scroll locks

    activeScrollLocks = Math.max(activeScrollLocks - 1, 0); // reapply original body styles, if any

    if (accountForScrollbars && activeScrollLocks < 1) {
      STYLE_KEYS.forEach(function (key) {
        var val = _this3.originalStyles[key];

        if (targetStyle) {
          targetStyle[key] = val;
        }
      });
    } // remove touch listeners


    if (target && isTouchDevice()) {
      target.removeEventListener('touchmove', preventTouchMove, this.listenerOptions);

      if (touchScrollTarget) {
        touchScrollTarget.removeEventListener('touchstart', preventInertiaScroll, this.listenerOptions);
        touchScrollTarget.removeEventListener('touchmove', allowTouchMove, this.listenerOptions);
      }
    }
  };

  _proto.render = function render() {
    return null;
  };

  return ScrollLock;
}(Component);

ScrollLock.defaultProps = {
  accountForScrollbars: true
};

function _inheritsLoose$2$1(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var _ref$1$1 = process.env.NODE_ENV === "production" ? {
  name: "1dsbpcp",
  styles: "position:fixed;left:0;bottom:0;right:0;top:0;"
} : {
  name: "1dsbpcp",
  styles: "position:fixed;left:0;bottom:0;right:0;top:0;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"
};

// NOTE:
// We shouldn't need this after updating to React v16.3.0, which introduces:
// - createRef() https://reactjs.org/docs/react-api.html#reactcreateref
// - forwardRef() https://reactjs.org/docs/react-api.html#reactforwardref
var ScrollBlock =
/*#__PURE__*/
function (_PureComponent) {
  _inheritsLoose$2$1(ScrollBlock, _PureComponent);

  function ScrollBlock() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _PureComponent.call.apply(_PureComponent, [this].concat(args)) || this;
    _this.state = {
      touchScrollTarget: null
    };

    _this.getScrollTarget = function (ref) {
      if (ref === _this.state.touchScrollTarget) return;

      _this.setState({
        touchScrollTarget: ref
      });
    };

    _this.blurSelectInput = function () {
      if (document.activeElement) {
        document.activeElement.blur();
      }
    };

    return _this;
  }

  var _proto = ScrollBlock.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        isEnabled = _this$props.isEnabled;
    var touchScrollTarget = this.state.touchScrollTarget; // bail early if not enabled

    if (!isEnabled) return children;
    /*
     * Div
     * ------------------------------
     * blocks scrolling on non-body elements behind the menu
      * NodeResolver
     * ------------------------------
     * we need a reference to the scrollable element to "unlock" scroll on
     * mobile devices
      * ScrollLock
     * ------------------------------
     * actually does the scroll locking
     */

    return jsx("div", null, jsx("div", {
      onClick: this.blurSelectInput,
      css: _ref$1$1
    }), jsx(NodeResolver, {
      innerRef: this.getScrollTarget
    }, children), touchScrollTarget ? jsx(ScrollLock, {
      touchScrollTarget: touchScrollTarget
    }) : null);
  };

  return ScrollBlock;
}(PureComponent);

function _objectWithoutPropertiesLoose$1$1(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose$3(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var ScrollCaptor =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose$3(ScrollCaptor, _Component);

  function ScrollCaptor() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.isBottom = false;
    _this.isTop = false;
    _this.scrollTarget = void 0;
    _this.touchStart = void 0;

    _this.cancelScroll = function (event) {
      event.preventDefault();
      event.stopPropagation();
    };

    _this.handleEventDelta = function (event, delta) {
      var _this$props = _this.props,
          onBottomArrive = _this$props.onBottomArrive,
          onBottomLeave = _this$props.onBottomLeave,
          onTopArrive = _this$props.onTopArrive,
          onTopLeave = _this$props.onTopLeave;
      var _this$scrollTarget = _this.scrollTarget,
          scrollTop = _this$scrollTarget.scrollTop,
          scrollHeight = _this$scrollTarget.scrollHeight,
          clientHeight = _this$scrollTarget.clientHeight;
      var target = _this.scrollTarget;
      var isDeltaPositive = delta > 0;
      var availableScroll = scrollHeight - clientHeight - scrollTop;
      var shouldCancelScroll = false; // reset bottom/top flags

      if (availableScroll > delta && _this.isBottom) {
        if (onBottomLeave) onBottomLeave(event);
        _this.isBottom = false;
      }

      if (isDeltaPositive && _this.isTop) {
        if (onTopLeave) onTopLeave(event);
        _this.isTop = false;
      } // bottom limit


      if (isDeltaPositive && delta > availableScroll) {
        if (onBottomArrive && !_this.isBottom) {
          onBottomArrive(event);
        }

        target.scrollTop = scrollHeight;
        shouldCancelScroll = true;
        _this.isBottom = true; // top limit
      } else if (!isDeltaPositive && -delta > scrollTop) {
        if (onTopArrive && !_this.isTop) {
          onTopArrive(event);
        }

        target.scrollTop = 0;
        shouldCancelScroll = true;
        _this.isTop = true;
      } // cancel scroll


      if (shouldCancelScroll) {
        _this.cancelScroll(event);
      }
    };

    _this.onWheel = function (event) {
      _this.handleEventDelta(event, event.deltaY);
    };

    _this.onTouchStart = function (event) {
      // set touch start so we can calculate touchmove delta
      _this.touchStart = event.changedTouches[0].clientY;
    };

    _this.onTouchMove = function (event) {
      var deltaY = _this.touchStart - event.changedTouches[0].clientY;

      _this.handleEventDelta(event, deltaY);
    };

    _this.getScrollTarget = function (ref) {
      _this.scrollTarget = ref;
    };

    return _this;
  }

  var _proto = ScrollCaptor.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.startListening(this.scrollTarget);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.stopListening(this.scrollTarget);
  };

  _proto.startListening = function startListening(el) {
    // bail early if no element is available to attach to
    if (!el) return; // all the if statements are to appease Flow 😢

    if (typeof el.addEventListener === 'function') {
      el.addEventListener('wheel', this.onWheel, false);
    }

    if (typeof el.addEventListener === 'function') {
      el.addEventListener('touchstart', this.onTouchStart, false);
    }

    if (typeof el.addEventListener === 'function') {
      el.addEventListener('touchmove', this.onTouchMove, false);
    }
  };

  _proto.stopListening = function stopListening(el) {
    // all the if statements are to appease Flow 😢
    if (typeof el.removeEventListener === 'function') {
      el.removeEventListener('wheel', this.onWheel, false);
    }

    if (typeof el.removeEventListener === 'function') {
      el.removeEventListener('touchstart', this.onTouchStart, false);
    }

    if (typeof el.removeEventListener === 'function') {
      el.removeEventListener('touchmove', this.onTouchMove, false);
    }
  };

  _proto.render = function render() {
    return React__default.createElement(NodeResolver, {
      innerRef: this.getScrollTarget
    }, this.props.children);
  };

  return ScrollCaptor;
}(Component);

function ScrollCaptorSwitch(_ref) {
  var _ref$isEnabled = _ref.isEnabled,
      isEnabled = _ref$isEnabled === void 0 ? true : _ref$isEnabled,
      props = _objectWithoutPropertiesLoose$1$1(_ref, ["isEnabled"]);

  return isEnabled ? React__default.createElement(ScrollCaptor, props) : props.children;
}

var instructionsAriaMessage = function instructionsAriaMessage(event, context) {
  if (context === void 0) {
    context = {};
  }

  var _context = context,
      isSearchable = _context.isSearchable,
      isMulti = _context.isMulti,
      label = _context.label,
      isDisabled = _context.isDisabled;

  switch (event) {
    case 'menu':
      return "Use Up and Down to choose options" + (isDisabled ? '' : ', press Enter to select the currently focused option') + ", press Escape to exit the menu, press Tab to select the option and exit the menu.";

    case 'input':
      return (label ? label : 'Select') + " is focused " + (isSearchable ? ',type to refine list' : '') + ", press Down to open the menu, " + (isMulti ? ' press left to focus selected values' : '');

    case 'value':
      return 'Use left and right to toggle between focused values, press Backspace to remove the currently focused value';
  }
};
var valueEventAriaMessage = function valueEventAriaMessage(event, context) {
  var value = context.value,
      isDisabled = context.isDisabled;
  if (!value) return;

  switch (event) {
    case 'deselect-option':
    case 'pop-value':
    case 'remove-value':
      return "option " + value + ", deselected.";

    case 'select-option':
      return isDisabled ? "option " + value + " is disabled. Select another option." : "option " + value + ", selected.";
  }
};
var valueFocusAriaMessage = function valueFocusAriaMessage(_ref) {
  var focusedValue = _ref.focusedValue,
      getOptionLabel = _ref.getOptionLabel,
      selectValue = _ref.selectValue;
  return "value " + getOptionLabel(focusedValue) + " focused, " + (selectValue.indexOf(focusedValue) + 1) + " of " + selectValue.length + ".";
};
var optionFocusAriaMessage = function optionFocusAriaMessage(_ref2) {
  var focusedOption = _ref2.focusedOption,
      getOptionLabel = _ref2.getOptionLabel,
      options = _ref2.options;
  return "option " + getOptionLabel(focusedOption) + " focused" + (focusedOption.isDisabled ? ' disabled' : '') + ", " + (options.indexOf(focusedOption) + 1) + " of " + options.length + ".";
};
var resultsAriaMessage = function resultsAriaMessage(_ref3) {
  var inputValue = _ref3.inputValue,
      screenReaderMessage = _ref3.screenReaderMessage;
  return "" + screenReaderMessage + (inputValue ? ' for search term ' + inputValue : '') + ".";
};

var formatGroupLabel = function formatGroupLabel(group) {
  return group.label;
};
var getOptionLabel = function getOptionLabel(option) {
  return option.label;
};
var getOptionValue = function getOptionValue(option) {
  return option.value;
};
var isOptionDisabled = function isOptionDisabled(option) {
  return !!option.isDisabled;
};
var defaultStyles = {
  clearIndicator: clearIndicatorCSS,
  container: containerCSS,
  control: css$1,
  dropdownIndicator: dropdownIndicatorCSS,
  group: groupCSS,
  groupHeading: groupHeadingCSS,
  indicatorsContainer: indicatorsContainerCSS,
  indicatorSeparator: indicatorSeparatorCSS,
  input: inputCSS,
  loadingIndicator: loadingIndicatorCSS,
  loadingMessage: loadingMessageCSS,
  menu: menuCSS,
  menuList: menuListCSS,
  menuPortal: menuPortalCSS,
  multiValue: multiValueCSS,
  multiValueLabel: multiValueLabelCSS,
  multiValueRemove: multiValueRemoveCSS,
  noOptionsMessage: noOptionsMessageCSS,
  option: optionCSS,
  placeholder: placeholderCSS,
  singleValue: css$1$1,
  valueContainer: valueContainerCSS
}; // Merge Utility

var colors = {
  primary: '#2684FF',
  primary75: '#4C9AFF',
  primary50: '#B2D4FF',
  primary25: '#DEEBFF',
  danger: '#DE350B',
  dangerLight: '#FFBDAD',
  neutral0: 'hsl(0, 0%, 100%)',
  neutral5: 'hsl(0, 0%, 95%)',
  neutral10: 'hsl(0, 0%, 90%)',
  neutral20: 'hsl(0, 0%, 80%)',
  neutral30: 'hsl(0, 0%, 70%)',
  neutral40: 'hsl(0, 0%, 60%)',
  neutral50: 'hsl(0, 0%, 50%)',
  neutral60: 'hsl(0, 0%, 40%)',
  neutral70: 'hsl(0, 0%, 30%)',
  neutral80: 'hsl(0, 0%, 20%)',
  neutral90: 'hsl(0, 0%, 10%)'
};
var borderRadius = 4; // Used to calculate consistent margin/padding on elements

var baseUnit = 4; // The minimum height of the control

var controlHeight = 38; // The amount of space between the control and menu */

var menuGutter = baseUnit * 2;
var spacing = {
  baseUnit: baseUnit,
  controlHeight: controlHeight,
  menuGutter: menuGutter
};
var defaultTheme = {
  borderRadius: borderRadius,
  colors: colors,
  spacing: spacing
};

function _objectWithoutPropertiesLoose$2$1(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends$4$2() { _extends$4$2 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4$2.apply(this, arguments); }

function _inheritsLoose$4(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
var defaultProps = {
  backspaceRemovesValue: true,
  blurInputOnSelect: isTouchCapable(),
  captureMenuScroll: !isTouchCapable(),
  closeMenuOnSelect: true,
  closeMenuOnScroll: false,
  components: {},
  controlShouldRenderValue: true,
  escapeClearsValue: false,
  filterOption: createFilter(),
  formatGroupLabel: formatGroupLabel,
  getOptionLabel: getOptionLabel,
  getOptionValue: getOptionValue,
  isDisabled: false,
  isLoading: false,
  isMulti: false,
  isRtl: false,
  isSearchable: true,
  isOptionDisabled: isOptionDisabled,
  loadingMessage: function loadingMessage() {
    return 'Loading...';
  },
  maxMenuHeight: 300,
  minMenuHeight: 140,
  menuIsOpen: false,
  menuPlacement: 'bottom',
  menuPosition: 'absolute',
  menuShouldBlockScroll: false,
  menuShouldScrollIntoView: !isMobileDevice(),
  noOptionsMessage: function noOptionsMessage() {
    return 'No options';
  },
  openMenuOnFocus: false,
  openMenuOnClick: true,
  options: [],
  pageSize: 5,
  placeholder: 'Select...',
  screenReaderStatus: function screenReaderStatus(_ref) {
    var count = _ref.count;
    return count + " result" + (count !== 1 ? 's' : '') + " available";
  },
  styles: {},
  tabIndex: '0',
  tabSelectsValue: true
};
var instanceId = 1;

var Select =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose$4(Select, _Component);

  // Misc. Instance Properties
  // ------------------------------
  // TODO
  // Refs
  // ------------------------------
  // Lifecycle
  // ------------------------------
  function Select(_props) {
    var _this;

    _this = _Component.call(this, _props) || this;
    _this.state = {
      ariaLiveSelection: '',
      ariaLiveContext: '',
      focusedOption: null,
      focusedValue: null,
      inputIsHidden: false,
      isFocused: false,
      menuOptions: {
        render: [],
        focusable: []
      },
      selectValue: []
    };
    _this.blockOptionHover = false;
    _this.isComposing = false;
    _this.clearFocusValueOnUpdate = false;
    _this.commonProps = void 0;
    _this.components = void 0;
    _this.hasGroups = false;
    _this.initialTouchX = 0;
    _this.initialTouchY = 0;
    _this.inputIsHiddenAfterUpdate = void 0;
    _this.instancePrefix = '';
    _this.openAfterFocus = false;
    _this.scrollToFocusedOptionOnUpdate = false;
    _this.userIsDragging = void 0;
    _this.controlRef = null;

    _this.getControlRef = function (ref) {
      _this.controlRef = ref;
    };

    _this.focusedOptionRef = null;

    _this.getFocusedOptionRef = function (ref) {
      _this.focusedOptionRef = ref;
    };

    _this.menuListRef = null;

    _this.getMenuListRef = function (ref) {
      _this.menuListRef = ref;
    };

    _this.inputRef = null;

    _this.getInputRef = function (ref) {
      _this.inputRef = ref;
    };

    _this.cacheComponents = function (components) {
      _this.components = defaultComponents({
        components: components
      });
    };

    _this.focus = _this.focusInput;
    _this.blur = _this.blurInput;

    _this.onChange = function (newValue, actionMeta) {
      var _this$props = _this.props,
          onChange = _this$props.onChange,
          name = _this$props.name;
      onChange(newValue, _extends$4$2({}, actionMeta, {
        name: name
      }));
    };

    _this.setValue = function (newValue, action, option) {
      if (action === void 0) {
        action = 'set-value';
      }

      var _this$props2 = _this.props,
          closeMenuOnSelect = _this$props2.closeMenuOnSelect,
          isMulti = _this$props2.isMulti;

      _this.onInputChange('', {
        action: 'set-value'
      });

      if (closeMenuOnSelect) {
        _this.inputIsHiddenAfterUpdate = !isMulti;

        _this.onMenuClose();
      } // when the select value should change, we should reset focusedValue


      _this.clearFocusValueOnUpdate = true;

      _this.onChange(newValue, {
        action: action,
        option: option
      });
    };

    _this.selectOption = function (newValue) {
      var _this$props3 = _this.props,
          blurInputOnSelect = _this$props3.blurInputOnSelect,
          isMulti = _this$props3.isMulti;
      var selectValue = _this.state.selectValue;

      if (isMulti) {
        if (_this.isOptionSelected(newValue, selectValue)) {
          var candidate = _this.getOptionValue(newValue);

          _this.setValue(selectValue.filter(function (i) {
            return _this.getOptionValue(i) !== candidate;
          }), 'deselect-option', newValue);

          _this.announceAriaLiveSelection({
            event: 'deselect-option',
            context: {
              value: _this.getOptionLabel(newValue)
            }
          });
        } else {
          if (!_this.isOptionDisabled(newValue, selectValue)) {
            _this.setValue([].concat(selectValue, [newValue]), 'select-option', newValue);

            _this.announceAriaLiveSelection({
              event: 'select-option',
              context: {
                value: _this.getOptionLabel(newValue)
              }
            });
          } else {
            // announce that option is disabled
            _this.announceAriaLiveSelection({
              event: 'select-option',
              context: {
                value: _this.getOptionLabel(newValue),
                isDisabled: true
              }
            });
          }
        }
      } else {
        if (!_this.isOptionDisabled(newValue, selectValue)) {
          _this.setValue(newValue, 'select-option');

          _this.announceAriaLiveSelection({
            event: 'select-option',
            context: {
              value: _this.getOptionLabel(newValue)
            }
          });
        } else {
          // announce that option is disabled
          _this.announceAriaLiveSelection({
            event: 'select-option',
            context: {
              value: _this.getOptionLabel(newValue),
              isDisabled: true
            }
          });
        }
      }

      if (blurInputOnSelect) {
        _this.blurInput();
      }
    };

    _this.removeValue = function (removedValue) {
      var selectValue = _this.state.selectValue;

      var candidate = _this.getOptionValue(removedValue);

      var newValue = selectValue.filter(function (i) {
        return _this.getOptionValue(i) !== candidate;
      });

      _this.onChange(newValue.length ? newValue : null, {
        action: 'remove-value',
        removedValue: removedValue
      });

      _this.announceAriaLiveSelection({
        event: 'remove-value',
        context: {
          value: removedValue ? _this.getOptionLabel(removedValue) : ''
        }
      });

      _this.focusInput();
    };

    _this.clearValue = function () {
      var isMulti = _this.props.isMulti;

      _this.onChange(isMulti ? [] : null, {
        action: 'clear'
      });
    };

    _this.popValue = function () {
      var selectValue = _this.state.selectValue;
      var lastSelectedValue = selectValue[selectValue.length - 1];
      var newValue = selectValue.slice(0, selectValue.length - 1);

      _this.announceAriaLiveSelection({
        event: 'pop-value',
        context: {
          value: lastSelectedValue ? _this.getOptionLabel(lastSelectedValue) : ''
        }
      });

      _this.onChange(newValue.length ? newValue : null, {
        action: 'pop-value',
        removedValue: lastSelectedValue
      });
    };

    _this.getOptionLabel = function (data) {
      return _this.props.getOptionLabel(data);
    };

    _this.getOptionValue = function (data) {
      return _this.props.getOptionValue(data);
    };

    _this.getStyles = function (key, props) {
      var base = defaultStyles[key](props);
      base.boxSizing = 'border-box';
      var custom = _this.props.styles[key];
      return custom ? custom(base, props) : base;
    };

    _this.getElementId = function (element) {
      return _this.instancePrefix + "-" + element;
    };

    _this.getActiveDescendentId = function () {
      var menuIsOpen = _this.props.menuIsOpen;
      var _this$state = _this.state,
          menuOptions = _this$state.menuOptions,
          focusedOption = _this$state.focusedOption;
      if (!focusedOption || !menuIsOpen) return undefined;
      var index = menuOptions.focusable.indexOf(focusedOption);
      var option = menuOptions.render[index];
      return option && option.key;
    };

    _this.announceAriaLiveSelection = function (_ref2) {
      var event = _ref2.event,
          context = _ref2.context;

      _this.setState({
        ariaLiveSelection: valueEventAriaMessage(event, context)
      });
    };

    _this.announceAriaLiveContext = function (_ref3) {
      var event = _ref3.event,
          context = _ref3.context;

      _this.setState({
        ariaLiveContext: instructionsAriaMessage(event, _extends$4$2({}, context, {
          label: _this.props['aria-label']
        }))
      });
    };

    _this.onMenuMouseDown = function (event) {
      if (event.button !== 0) {
        return;
      }

      event.stopPropagation();
      event.preventDefault();

      _this.focusInput();
    };

    _this.onMenuMouseMove = function (event) {
      _this.blockOptionHover = false;
    };

    _this.onControlMouseDown = function (event) {
      var openMenuOnClick = _this.props.openMenuOnClick;

      if (!_this.state.isFocused) {
        if (openMenuOnClick) {
          _this.openAfterFocus = true;
        }

        _this.focusInput();
      } else if (!_this.props.menuIsOpen) {
        if (openMenuOnClick) {
          _this.openMenu('first');
        }
      } else {
        if ( // $FlowFixMe
        event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') {
          _this.onMenuClose();
        }
      }

      if ( // $FlowFixMe
      event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') {
        event.preventDefault();
      }
    };

    _this.onDropdownIndicatorMouseDown = function (event) {
      // ignore mouse events that weren't triggered by the primary button
      if (event && event.type === 'mousedown' && event.button !== 0) {
        return;
      }

      if (_this.props.isDisabled) return;
      var _this$props4 = _this.props,
          isMulti = _this$props4.isMulti,
          menuIsOpen = _this$props4.menuIsOpen;

      _this.focusInput();

      if (menuIsOpen) {
        _this.inputIsHiddenAfterUpdate = !isMulti;

        _this.onMenuClose();
      } else {
        _this.openMenu('first');
      }

      event.preventDefault();
      event.stopPropagation();
    };

    _this.onClearIndicatorMouseDown = function (event) {
      // ignore mouse events that weren't triggered by the primary button
      if (event && event.type === 'mousedown' && event.button !== 0) {
        return;
      }

      _this.clearValue();

      event.stopPropagation();
      _this.openAfterFocus = false;

      if (event.type === 'touchend') {
        _this.focusInput();
      } else {
        setTimeout(function () {
          return _this.focusInput();
        });
      }
    };

    _this.onScroll = function (event) {
      if (typeof _this.props.closeMenuOnScroll === 'boolean') {
        if (event.target instanceof HTMLElement && isDocumentElement(event.target)) {
          _this.props.onMenuClose();
        }
      } else if (typeof _this.props.closeMenuOnScroll === 'function') {
        if (_this.props.closeMenuOnScroll(event)) {
          _this.props.onMenuClose();
        }
      }
    };

    _this.onCompositionStart = function () {
      _this.isComposing = true;
    };

    _this.onCompositionEnd = function () {
      _this.isComposing = false;
    };

    _this.onTouchStart = function (_ref4) {
      var touches = _ref4.touches;
      var touch = touches.item(0);

      if (!touch) {
        return;
      }

      _this.initialTouchX = touch.clientX;
      _this.initialTouchY = touch.clientY;
      _this.userIsDragging = false;
    };

    _this.onTouchMove = function (_ref5) {
      var touches = _ref5.touches;
      var touch = touches.item(0);

      if (!touch) {
        return;
      }

      var deltaX = Math.abs(touch.clientX - _this.initialTouchX);
      var deltaY = Math.abs(touch.clientY - _this.initialTouchY);
      var moveThreshold = 5;
      _this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
    };

    _this.onTouchEnd = function (event) {
      if (_this.userIsDragging) return; // close the menu if the user taps outside
      // we're checking on event.target here instead of event.currentTarget, because we want to assert information
      // on events on child elements, not the document (which we've attached this handler to).

      if (_this.controlRef && !_this.controlRef.contains(event.target) && _this.menuListRef && !_this.menuListRef.contains(event.target)) {
        _this.blurInput();
      } // reset move vars


      _this.initialTouchX = 0;
      _this.initialTouchY = 0;
    };

    _this.onControlTouchEnd = function (event) {
      if (_this.userIsDragging) return;

      _this.onControlMouseDown(event);
    };

    _this.onClearIndicatorTouchEnd = function (event) {
      if (_this.userIsDragging) return;

      _this.onClearIndicatorMouseDown(event);
    };

    _this.onDropdownIndicatorTouchEnd = function (event) {
      if (_this.userIsDragging) return;

      _this.onDropdownIndicatorMouseDown(event);
    };

    _this.handleInputChange = function (event) {
      var inputValue = event.currentTarget.value;
      _this.inputIsHiddenAfterUpdate = false;

      _this.onInputChange(inputValue, {
        action: 'input-change'
      });

      _this.onMenuOpen();
    };

    _this.onInputFocus = function (event) {
      var _this$props5 = _this.props,
          isSearchable = _this$props5.isSearchable,
          isMulti = _this$props5.isMulti;

      if (_this.props.onFocus) {
        _this.props.onFocus(event);
      }

      _this.inputIsHiddenAfterUpdate = false;

      _this.announceAriaLiveContext({
        event: 'input',
        context: {
          isSearchable: isSearchable,
          isMulti: isMulti
        }
      });

      _this.setState({
        isFocused: true
      });

      if (_this.openAfterFocus || _this.props.openMenuOnFocus) {
        _this.openMenu('first');
      }

      _this.openAfterFocus = false;
    };

    _this.onInputBlur = function (event) {
      if (_this.menuListRef && _this.menuListRef.contains(document.activeElement)) {
        _this.inputRef.focus();

        return;
      }

      if (_this.props.onBlur) {
        _this.props.onBlur(event);
      }

      _this.onInputChange('', {
        action: 'input-blur'
      });

      _this.onMenuClose();

      _this.setState({
        focusedValue: null,
        isFocused: false
      });
    };

    _this.onOptionHover = function (focusedOption) {
      if (_this.blockOptionHover || _this.state.focusedOption === focusedOption) {
        return;
      }

      _this.setState({
        focusedOption: focusedOption
      });
    };

    _this.shouldHideSelectedOptions = function () {
      var _this$props6 = _this.props,
          hideSelectedOptions = _this$props6.hideSelectedOptions,
          isMulti = _this$props6.isMulti;
      if (hideSelectedOptions === undefined) return isMulti;
      return hideSelectedOptions;
    };

    _this.onKeyDown = function (event) {
      var _this$props7 = _this.props,
          isMulti = _this$props7.isMulti,
          backspaceRemovesValue = _this$props7.backspaceRemovesValue,
          escapeClearsValue = _this$props7.escapeClearsValue,
          inputValue = _this$props7.inputValue,
          isClearable = _this$props7.isClearable,
          isDisabled = _this$props7.isDisabled,
          menuIsOpen = _this$props7.menuIsOpen,
          onKeyDown = _this$props7.onKeyDown,
          tabSelectsValue = _this$props7.tabSelectsValue,
          openMenuOnFocus = _this$props7.openMenuOnFocus;
      var _this$state2 = _this.state,
          focusedOption = _this$state2.focusedOption,
          focusedValue = _this$state2.focusedValue,
          selectValue = _this$state2.selectValue;
      if (isDisabled) return;

      if (typeof onKeyDown === 'function') {
        onKeyDown(event);

        if (event.defaultPrevented) {
          return;
        }
      } // Block option hover events when the user has just pressed a key


      _this.blockOptionHover = true;

      switch (event.key) {
        case 'ArrowLeft':
          if (!isMulti || inputValue) return;

          _this.focusValue('previous');

          break;

        case 'ArrowRight':
          if (!isMulti || inputValue) return;

          _this.focusValue('next');

          break;

        case 'Delete':
        case 'Backspace':
          if (inputValue) return;

          if (focusedValue) {
            _this.removeValue(focusedValue);
          } else {
            if (!backspaceRemovesValue) return;

            if (isMulti) {
              _this.popValue();
            } else if (isClearable) {
              _this.clearValue();
            }
          }

          break;

        case 'Tab':
          if (_this.isComposing) return;

          if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || // don't capture the event if the menu opens on focus and the focused
          // option is already selected; it breaks the flow of navigation
          openMenuOnFocus && _this.isOptionSelected(focusedOption, selectValue)) {
            return;
          }

          _this.selectOption(focusedOption);

          break;

        case 'Enter':
          if (event.keyCode === 229) {
            // ignore the keydown event from an Input Method Editor(IME)
            // ref. https://www.w3.org/TR/uievents/#determine-keydown-keyup-keyCode
            break;
          }

          if (menuIsOpen) {
            if (!focusedOption) return;
            if (_this.isComposing) return;

            _this.selectOption(focusedOption);

            break;
          }

          return;

        case 'Escape':
          if (menuIsOpen) {
            _this.inputIsHiddenAfterUpdate = false;

            _this.onInputChange('', {
              action: 'menu-close'
            });

            _this.onMenuClose();
          } else if (isClearable && escapeClearsValue) {
            _this.clearValue();
          }

          break;

        case ' ':
          // space
          if (inputValue) {
            return;
          }

          if (!menuIsOpen) {
            _this.openMenu('first');

            break;
          }

          if (!focusedOption) return;

          _this.selectOption(focusedOption);

          break;

        case 'ArrowUp':
          if (menuIsOpen) {
            _this.focusOption('up');
          } else {
            _this.openMenu('last');
          }

          break;

        case 'ArrowDown':
          if (menuIsOpen) {
            _this.focusOption('down');
          } else {
            _this.openMenu('first');
          }

          break;

        case 'PageUp':
          if (!menuIsOpen) return;

          _this.focusOption('pageup');

          break;

        case 'PageDown':
          if (!menuIsOpen) return;

          _this.focusOption('pagedown');

          break;

        case 'Home':
          if (!menuIsOpen) return;

          _this.focusOption('first');

          break;

        case 'End':
          if (!menuIsOpen) return;

          _this.focusOption('last');

          break;

        default:
          return;
      }

      event.preventDefault();
    };

    _this.buildMenuOptions = function (props, selectValue) {
      var _props$inputValue = props.inputValue,
          inputValue = _props$inputValue === void 0 ? '' : _props$inputValue,
          options = props.options;

      var toOption = function toOption(option, id) {
        var isDisabled = _this.isOptionDisabled(option, selectValue);

        var isSelected = _this.isOptionSelected(option, selectValue);

        var label = _this.getOptionLabel(option);

        var value = _this.getOptionValue(option);

        if (_this.shouldHideSelectedOptions() && isSelected || !_this.filterOption({
          label: label,
          value: value,
          data: option
        }, inputValue)) {
          return;
        }

        var onHover = isDisabled ? undefined : function () {
          return _this.onOptionHover(option);
        };
        var onSelect = isDisabled ? undefined : function () {
          return _this.selectOption(option);
        };
        var optionId = _this.getElementId('option') + "-" + id;
        return {
          innerProps: {
            id: optionId,
            onClick: onSelect,
            onMouseMove: onHover,
            onMouseOver: onHover,
            tabIndex: -1
          },
          data: option,
          isDisabled: isDisabled,
          isSelected: isSelected,
          key: optionId,
          label: label,
          type: 'option',
          value: value
        };
      };

      return options.reduce(function (acc, item, itemIndex) {
        if (item.options) {
          // TODO needs a tidier implementation
          if (!_this.hasGroups) _this.hasGroups = true;
          var items = item.options;
          var children = items.map(function (child, i) {
            var option = toOption(child, itemIndex + "-" + i);
            if (option) acc.focusable.push(child);
            return option;
          }).filter(Boolean);

          if (children.length) {
            var groupId = _this.getElementId('group') + "-" + itemIndex;
            acc.render.push({
              type: 'group',
              key: groupId,
              data: item,
              options: children
            });
          }
        } else {
          var option = toOption(item, "" + itemIndex);

          if (option) {
            acc.render.push(option);
            acc.focusable.push(item);
          }
        }

        return acc;
      }, {
        render: [],
        focusable: []
      });
    };

    var _value = _props.value;
    _this.cacheComponents = memoizeOne(_this.cacheComponents, exportedEqual).bind(_assertThisInitialized(_assertThisInitialized(_this)));

    _this.cacheComponents(_props.components);

    _this.instancePrefix = 'react-select-' + (_this.props.instanceId || ++instanceId);

    var _selectValue = cleanValue(_value);

    _this.buildMenuOptions = memoizeOne(_this.buildMenuOptions, function (newArgs, lastArgs) {
      var _ref6 = newArgs,
          newProps = _ref6[0],
          newSelectValue = _ref6[1];
      var _ref7 = lastArgs,
          lastProps = _ref7[0],
          lastSelectValue = _ref7[1];
      return exportedEqual(newSelectValue, lastSelectValue) && exportedEqual(newProps.inputValue, lastProps.inputValue) && exportedEqual(newProps.options, lastProps.options);
    }).bind(_assertThisInitialized(_assertThisInitialized(_this)));

    var _menuOptions = _props.menuIsOpen ? _this.buildMenuOptions(_props, _selectValue) : {
      render: [],
      focusable: []
    };

    _this.state.menuOptions = _menuOptions;
    _this.state.selectValue = _selectValue;
    return _this;
  }

  var _proto = Select.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.startListeningComposition();
    this.startListeningToTouch();

    if (this.props.closeMenuOnScroll && document && document.addEventListener) {
      // Listen to all scroll events, and filter them out inside of 'onScroll'
      document.addEventListener('scroll', this.onScroll, true);
    }

    if (this.props.autoFocus) {
      this.focusInput();
    }
  };

  _proto.UNSAFE_componentWillReceiveProps = function UNSAFE_componentWillReceiveProps(nextProps) {
    var _this$props8 = this.props,
        options = _this$props8.options,
        value = _this$props8.value,
        menuIsOpen = _this$props8.menuIsOpen,
        inputValue = _this$props8.inputValue; // re-cache custom components

    this.cacheComponents(nextProps.components); // rebuild the menu options

    if (nextProps.value !== value || nextProps.options !== options || nextProps.menuIsOpen !== menuIsOpen || nextProps.inputValue !== inputValue) {
      var selectValue = cleanValue(nextProps.value);
      var menuOptions = nextProps.menuIsOpen ? this.buildMenuOptions(nextProps, selectValue) : {
        render: [],
        focusable: []
      };
      var focusedValue = this.getNextFocusedValue(selectValue);
      var focusedOption = this.getNextFocusedOption(menuOptions.focusable);
      this.setState({
        menuOptions: menuOptions,
        selectValue: selectValue,
        focusedOption: focusedOption,
        focusedValue: focusedValue
      });
    } // some updates should toggle the state of the input visibility


    if (this.inputIsHiddenAfterUpdate != null) {
      this.setState({
        inputIsHidden: this.inputIsHiddenAfterUpdate
      });
      delete this.inputIsHiddenAfterUpdate;
    }
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var _this$props9 = this.props,
        isDisabled = _this$props9.isDisabled,
        menuIsOpen = _this$props9.menuIsOpen;
    var isFocused = this.state.isFocused;

    if ( // ensure focus is restored correctly when the control becomes enabled
    isFocused && !isDisabled && prevProps.isDisabled || // ensure focus is on the Input when the menu opens
    isFocused && menuIsOpen && !prevProps.menuIsOpen) {
      this.focusInput();
    } // scroll the focused option into view if necessary


    if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
      scrollIntoView(this.menuListRef, this.focusedOptionRef);
      this.scrollToFocusedOptionOnUpdate = false;
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.stopListeningComposition();
    this.stopListeningToTouch();
    document.removeEventListener('scroll', this.onScroll, true);
  };

  // ==============================
  // Consumer Handlers
  // ==============================
  _proto.onMenuOpen = function onMenuOpen() {
    this.props.onMenuOpen();
  };

  _proto.onMenuClose = function onMenuClose() {
    var _this$props10 = this.props,
        isSearchable = _this$props10.isSearchable,
        isMulti = _this$props10.isMulti;
    this.announceAriaLiveContext({
      event: 'input',
      context: {
        isSearchable: isSearchable,
        isMulti: isMulti
      }
    });
    this.onInputChange('', {
      action: 'menu-close'
    });
    this.props.onMenuClose();
  };

  _proto.onInputChange = function onInputChange(newValue, actionMeta) {
    this.props.onInputChange(newValue, actionMeta);
  } // ==============================
  // Methods
  // ==============================
  ;

  _proto.focusInput = function focusInput() {
    if (!this.inputRef) return;
    this.inputRef.focus();
  };

  _proto.blurInput = function blurInput() {
    if (!this.inputRef) return;
    this.inputRef.blur();
  } // aliased for consumers
  ;

  _proto.openMenu = function openMenu(focusOption) {
    var _this2 = this;

    var _this$state3 = this.state,
        selectValue = _this$state3.selectValue,
        isFocused = _this$state3.isFocused;
    var menuOptions = this.buildMenuOptions(this.props, selectValue);
    var isMulti = this.props.isMulti;
    var openAtIndex = focusOption === 'first' ? 0 : menuOptions.focusable.length - 1;

    if (!isMulti) {
      var selectedIndex = menuOptions.focusable.indexOf(selectValue[0]);

      if (selectedIndex > -1) {
        openAtIndex = selectedIndex;
      }
    } // only scroll if the menu isn't already open


    this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
    this.inputIsHiddenAfterUpdate = false;
    this.setState({
      menuOptions: menuOptions,
      focusedValue: null,
      focusedOption: menuOptions.focusable[openAtIndex]
    }, function () {
      _this2.onMenuOpen();

      _this2.announceAriaLiveContext({
        event: 'menu'
      });
    });
  };

  _proto.focusValue = function focusValue(direction) {
    var _this$props11 = this.props,
        isMulti = _this$props11.isMulti,
        isSearchable = _this$props11.isSearchable;
    var _this$state4 = this.state,
        selectValue = _this$state4.selectValue,
        focusedValue = _this$state4.focusedValue; // Only multiselects support value focusing

    if (!isMulti) return;
    this.setState({
      focusedOption: null
    });
    var focusedIndex = selectValue.indexOf(focusedValue);

    if (!focusedValue) {
      focusedIndex = -1;
      this.announceAriaLiveContext({
        event: 'value'
      });
    }

    var lastIndex = selectValue.length - 1;
    var nextFocus = -1;
    if (!selectValue.length) return;

    switch (direction) {
      case 'previous':
        if (focusedIndex === 0) {
          // don't cycle from the start to the end
          nextFocus = 0;
        } else if (focusedIndex === -1) {
          // if nothing is focused, focus the last value first
          nextFocus = lastIndex;
        } else {
          nextFocus = focusedIndex - 1;
        }

        break;

      case 'next':
        if (focusedIndex > -1 && focusedIndex < lastIndex) {
          nextFocus = focusedIndex + 1;
        }

        break;
    }

    if (nextFocus === -1) {
      this.announceAriaLiveContext({
        event: 'input',
        context: {
          isSearchable: isSearchable,
          isMulti: isMulti
        }
      });
    }

    this.setState({
      inputIsHidden: nextFocus !== -1,
      focusedValue: selectValue[nextFocus]
    });
  };

  _proto.focusOption = function focusOption(direction) {
    if (direction === void 0) {
      direction = 'first';
    }

    var pageSize = this.props.pageSize;
    var _this$state5 = this.state,
        focusedOption = _this$state5.focusedOption,
        menuOptions = _this$state5.menuOptions;
    var options = menuOptions.focusable;
    if (!options.length) return;
    var nextFocus = 0; // handles 'first'

    var focusedIndex = options.indexOf(focusedOption);

    if (!focusedOption) {
      focusedIndex = -1;
      this.announceAriaLiveContext({
        event: 'menu'
      });
    }

    if (direction === 'up') {
      nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
    } else if (direction === 'down') {
      nextFocus = (focusedIndex + 1) % options.length;
    } else if (direction === 'pageup') {
      nextFocus = focusedIndex - pageSize;
      if (nextFocus < 0) nextFocus = 0;
    } else if (direction === 'pagedown') {
      nextFocus = focusedIndex + pageSize;
      if (nextFocus > options.length - 1) nextFocus = options.length - 1;
    } else if (direction === 'last') {
      nextFocus = options.length - 1;
    }

    this.scrollToFocusedOptionOnUpdate = true;
    this.setState({
      focusedOption: options[nextFocus],
      focusedValue: null
    });
    this.announceAriaLiveContext({
      event: 'menu',
      context: {
        isDisabled: isOptionDisabled(options[nextFocus])
      }
    });
  };

  // ==============================
  // Getters
  // ==============================
  _proto.getTheme = function getTheme() {
    // Use the default theme if there are no customizations.
    if (!this.props.theme) {
      return defaultTheme;
    } // If the theme prop is a function, assume the function
    // knows how to merge the passed-in default theme with
    // its own modifications.


    if (typeof this.props.theme === 'function') {
      return this.props.theme(defaultTheme);
    } // Otherwise, if a plain theme object was passed in,
    // overlay it with the default theme.


    return _extends$4$2({}, defaultTheme, this.props.theme);
  };

  _proto.getCommonProps = function getCommonProps() {
    var clearValue = this.clearValue,
        getStyles = this.getStyles,
        setValue = this.setValue,
        selectOption = this.selectOption,
        props = this.props;
    var classNamePrefix = props.classNamePrefix,
        isMulti = props.isMulti,
        isRtl = props.isRtl,
        options = props.options;
    var selectValue = this.state.selectValue;
    var hasValue = this.hasValue();

    var getValue = function getValue() {
      return selectValue;
    };

    var cx = classNames.bind(null, classNamePrefix);
    return {
      cx: cx,
      clearValue: clearValue,
      getStyles: getStyles,
      getValue: getValue,
      hasValue: hasValue,
      isMulti: isMulti,
      isRtl: isRtl,
      options: options,
      selectOption: selectOption,
      setValue: setValue,
      selectProps: props,
      theme: this.getTheme()
    };
  };

  _proto.getNextFocusedValue = function getNextFocusedValue(nextSelectValue) {
    if (this.clearFocusValueOnUpdate) {
      this.clearFocusValueOnUpdate = false;
      return null;
    }

    var _this$state6 = this.state,
        focusedValue = _this$state6.focusedValue,
        lastSelectValue = _this$state6.selectValue;
    var lastFocusedIndex = lastSelectValue.indexOf(focusedValue);

    if (lastFocusedIndex > -1) {
      var nextFocusedIndex = nextSelectValue.indexOf(focusedValue);

      if (nextFocusedIndex > -1) {
        // the focused value is still in the selectValue, return it
        return focusedValue;
      } else if (lastFocusedIndex < nextSelectValue.length) {
        // the focusedValue is not present in the next selectValue array by
        // reference, so return the new value at the same index
        return nextSelectValue[lastFocusedIndex];
      }
    }

    return null;
  };

  _proto.getNextFocusedOption = function getNextFocusedOption(options) {
    var lastFocusedOption = this.state.focusedOption;
    return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
  };

  _proto.hasValue = function hasValue() {
    var selectValue = this.state.selectValue;
    return selectValue.length > 0;
  };

  _proto.hasOptions = function hasOptions() {
    return !!this.state.menuOptions.render.length;
  };

  _proto.countOptions = function countOptions() {
    return this.state.menuOptions.focusable.length;
  };

  _proto.isClearable = function isClearable() {
    var _this$props12 = this.props,
        isClearable = _this$props12.isClearable,
        isMulti = _this$props12.isMulti; // single select, by default, IS NOT clearable
    // multi select, by default, IS clearable

    if (isClearable === undefined) return isMulti;
    return isClearable;
  };

  _proto.isOptionDisabled = function isOptionDisabled(option, selectValue) {
    return typeof this.props.isOptionDisabled === 'function' ? this.props.isOptionDisabled(option, selectValue) : false;
  };

  _proto.isOptionSelected = function isOptionSelected(option, selectValue) {
    var _this3 = this;

    if (selectValue.indexOf(option) > -1) return true;

    if (typeof this.props.isOptionSelected === 'function') {
      return this.props.isOptionSelected(option, selectValue);
    }

    var candidate = this.getOptionValue(option);
    return selectValue.some(function (i) {
      return _this3.getOptionValue(i) === candidate;
    });
  };

  _proto.filterOption = function filterOption(option, inputValue) {
    return this.props.filterOption ? this.props.filterOption(option, inputValue) : true;
  };

  _proto.formatOptionLabel = function formatOptionLabel(data, context) {
    if (typeof this.props.formatOptionLabel === 'function') {
      var inputValue = this.props.inputValue;
      var selectValue = this.state.selectValue;
      return this.props.formatOptionLabel(data, {
        context: context,
        inputValue: inputValue,
        selectValue: selectValue
      });
    } else {
      return this.getOptionLabel(data);
    }
  };

  _proto.formatGroupLabel = function formatGroupLabel(data) {
    return this.props.formatGroupLabel(data);
  } // ==============================
  // Mouse Handlers
  // ==============================
  ;

  // ==============================
  // Composition Handlers
  // ==============================
  _proto.startListeningComposition = function startListeningComposition() {
    if (document && document.addEventListener) {
      document.addEventListener('compositionstart', this.onCompositionStart, false);
      document.addEventListener('compositionend', this.onCompositionEnd, false);
    }
  };

  _proto.stopListeningComposition = function stopListeningComposition() {
    if (document && document.removeEventListener) {
      document.removeEventListener('compositionstart', this.onCompositionStart);
      document.removeEventListener('compositionend', this.onCompositionEnd);
    }
  };

  // ==============================
  // Touch Handlers
  // ==============================
  _proto.startListeningToTouch = function startListeningToTouch() {
    if (document && document.addEventListener) {
      document.addEventListener('touchstart', this.onTouchStart, false);
      document.addEventListener('touchmove', this.onTouchMove, false);
      document.addEventListener('touchend', this.onTouchEnd, false);
    }
  };

  _proto.stopListeningToTouch = function stopListeningToTouch() {
    if (document && document.removeEventListener) {
      document.removeEventListener('touchstart', this.onTouchStart);
      document.removeEventListener('touchmove', this.onTouchMove);
      document.removeEventListener('touchend', this.onTouchEnd);
    }
  };

  // ==============================
  // Renderers
  // ==============================
  _proto.constructAriaLiveMessage = function constructAriaLiveMessage() {
    var _this$state7 = this.state,
        ariaLiveContext = _this$state7.ariaLiveContext,
        selectValue = _this$state7.selectValue,
        focusedValue = _this$state7.focusedValue,
        focusedOption = _this$state7.focusedOption;
    var _this$props13 = this.props,
        options = _this$props13.options,
        menuIsOpen = _this$props13.menuIsOpen,
        inputValue = _this$props13.inputValue,
        screenReaderStatus = _this$props13.screenReaderStatus; // An aria live message representing the currently focused value in the select.

    var focusedValueMsg = focusedValue ? valueFocusAriaMessage({
      focusedValue: focusedValue,
      getOptionLabel: this.getOptionLabel,
      selectValue: selectValue
    }) : ''; // An aria live message representing the currently focused option in the select.

    var focusedOptionMsg = focusedOption && menuIsOpen ? optionFocusAriaMessage({
      focusedOption: focusedOption,
      getOptionLabel: this.getOptionLabel,
      options: options
    }) : ''; // An aria live message representing the set of focusable results and current searchterm/inputvalue.

    var resultsMsg = resultsAriaMessage({
      inputValue: inputValue,
      screenReaderMessage: screenReaderStatus({
        count: this.countOptions()
      })
    });
    return focusedValueMsg + " " + focusedOptionMsg + " " + resultsMsg + " " + ariaLiveContext;
  };

  _proto.renderInput = function renderInput() {
    var _this$props14 = this.props,
        isDisabled = _this$props14.isDisabled,
        isSearchable = _this$props14.isSearchable,
        inputId = _this$props14.inputId,
        inputValue = _this$props14.inputValue,
        tabIndex = _this$props14.tabIndex;
    var Input = this.components.Input;
    var inputIsHidden = this.state.inputIsHidden;
    var id = inputId || this.getElementId('input'); // aria attributes makes the JSX "noisy", separated for clarity

    var ariaAttributes = {
      'aria-autocomplete': 'list',
      'aria-label': this.props['aria-label'],
      'aria-labelledby': this.props['aria-labelledby']
    };

    if (!isSearchable) {
      // use a dummy input to maintain focus/blur functionality
      return React__default.createElement(DummyInput, _extends$4$2({
        id: id,
        innerRef: this.getInputRef,
        onBlur: this.onInputBlur,
        onChange: noop,
        onFocus: this.onInputFocus,
        readOnly: true,
        disabled: isDisabled,
        tabIndex: tabIndex,
        value: ""
      }, ariaAttributes));
    }

    var _this$commonProps = this.commonProps,
        cx = _this$commonProps.cx,
        theme = _this$commonProps.theme,
        selectProps = _this$commonProps.selectProps;
    return React__default.createElement(Input, _extends$4$2({
      autoCapitalize: "none",
      autoComplete: "off",
      autoCorrect: "off",
      cx: cx,
      getStyles: this.getStyles,
      id: id,
      innerRef: this.getInputRef,
      isDisabled: isDisabled,
      isHidden: inputIsHidden,
      onBlur: this.onInputBlur,
      onChange: this.handleInputChange,
      onFocus: this.onInputFocus,
      selectProps: selectProps,
      spellCheck: "false",
      tabIndex: tabIndex,
      theme: theme,
      type: "text",
      value: inputValue
    }, ariaAttributes));
  };

  _proto.renderPlaceholderOrValue = function renderPlaceholderOrValue() {
    var _this4 = this;

    var _this$components = this.components,
        MultiValue = _this$components.MultiValue,
        MultiValueContainer = _this$components.MultiValueContainer,
        MultiValueLabel = _this$components.MultiValueLabel,
        MultiValueRemove = _this$components.MultiValueRemove,
        SingleValue = _this$components.SingleValue,
        Placeholder = _this$components.Placeholder;
    var commonProps = this.commonProps;
    var _this$props15 = this.props,
        controlShouldRenderValue = _this$props15.controlShouldRenderValue,
        isDisabled = _this$props15.isDisabled,
        isMulti = _this$props15.isMulti,
        inputValue = _this$props15.inputValue,
        placeholder = _this$props15.placeholder;
    var _this$state8 = this.state,
        selectValue = _this$state8.selectValue,
        focusedValue = _this$state8.focusedValue,
        isFocused = _this$state8.isFocused;

    if (!this.hasValue() || !controlShouldRenderValue) {
      return inputValue ? null : React__default.createElement(Placeholder, _extends$4$2({}, commonProps, {
        key: "placeholder",
        isDisabled: isDisabled,
        isFocused: isFocused
      }), placeholder);
    }

    if (isMulti) {
      var selectValues = selectValue.map(function (opt, index) {
        var isOptionFocused = opt === focusedValue;
        return React__default.createElement(MultiValue, _extends$4$2({}, commonProps, {
          components: {
            Container: MultiValueContainer,
            Label: MultiValueLabel,
            Remove: MultiValueRemove
          },
          isFocused: isOptionFocused,
          isDisabled: isDisabled,
          key: _this4.getOptionValue(opt),
          index: index,
          removeProps: {
            onClick: function onClick() {
              return _this4.removeValue(opt);
            },
            onTouchEnd: function onTouchEnd() {
              return _this4.removeValue(opt);
            },
            onMouseDown: function onMouseDown(e) {
              e.preventDefault();
              e.stopPropagation();
            }
          },
          data: opt
        }), _this4.formatOptionLabel(opt, 'value'));
      });
      return selectValues;
    }

    if (inputValue) {
      return null;
    }

    var singleValue = selectValue[0];
    return React__default.createElement(SingleValue, _extends$4$2({}, commonProps, {
      data: singleValue,
      isDisabled: isDisabled
    }), this.formatOptionLabel(singleValue, 'value'));
  };

  _proto.renderClearIndicator = function renderClearIndicator() {
    var ClearIndicator = this.components.ClearIndicator;
    var commonProps = this.commonProps;
    var _this$props16 = this.props,
        isDisabled = _this$props16.isDisabled,
        isLoading = _this$props16.isLoading;
    var isFocused = this.state.isFocused;

    if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) {
      return null;
    }

    var innerProps = {
      onMouseDown: this.onClearIndicatorMouseDown,
      onTouchEnd: this.onClearIndicatorTouchEnd,
      'aria-hidden': 'true'
    };
    return React__default.createElement(ClearIndicator, _extends$4$2({}, commonProps, {
      innerProps: innerProps,
      isFocused: isFocused
    }));
  };

  _proto.renderLoadingIndicator = function renderLoadingIndicator() {
    var LoadingIndicator = this.components.LoadingIndicator;
    var commonProps = this.commonProps;
    var _this$props17 = this.props,
        isDisabled = _this$props17.isDisabled,
        isLoading = _this$props17.isLoading;
    var isFocused = this.state.isFocused;
    if (!LoadingIndicator || !isLoading) return null;
    var innerProps = {
      'aria-hidden': 'true'
    };
    return React__default.createElement(LoadingIndicator, _extends$4$2({}, commonProps, {
      innerProps: innerProps,
      isDisabled: isDisabled,
      isFocused: isFocused
    }));
  };

  _proto.renderIndicatorSeparator = function renderIndicatorSeparator() {
    var _this$components2 = this.components,
        DropdownIndicator = _this$components2.DropdownIndicator,
        IndicatorSeparator = _this$components2.IndicatorSeparator; // separator doesn't make sense without the dropdown indicator

    if (!DropdownIndicator || !IndicatorSeparator) return null;
    var commonProps = this.commonProps;
    var isDisabled = this.props.isDisabled;
    var isFocused = this.state.isFocused;
    return React__default.createElement(IndicatorSeparator, _extends$4$2({}, commonProps, {
      isDisabled: isDisabled,
      isFocused: isFocused
    }));
  };

  _proto.renderDropdownIndicator = function renderDropdownIndicator() {
    var DropdownIndicator = this.components.DropdownIndicator;
    if (!DropdownIndicator) return null;
    var commonProps = this.commonProps;
    var isDisabled = this.props.isDisabled;
    var isFocused = this.state.isFocused;
    var innerProps = {
      onMouseDown: this.onDropdownIndicatorMouseDown,
      onTouchEnd: this.onDropdownIndicatorTouchEnd,
      'aria-hidden': 'true'
    };
    return React__default.createElement(DropdownIndicator, _extends$4$2({}, commonProps, {
      innerProps: innerProps,
      isDisabled: isDisabled,
      isFocused: isFocused
    }));
  };

  _proto.renderMenu = function renderMenu() {
    var _this5 = this;

    var _this$components3 = this.components,
        Group = _this$components3.Group,
        GroupHeading = _this$components3.GroupHeading,
        Menu = _this$components3.Menu,
        MenuList = _this$components3.MenuList,
        MenuPortal = _this$components3.MenuPortal,
        LoadingMessage = _this$components3.LoadingMessage,
        NoOptionsMessage = _this$components3.NoOptionsMessage,
        Option = _this$components3.Option;
    var commonProps = this.commonProps;
    var _this$state9 = this.state,
        focusedOption = _this$state9.focusedOption,
        menuOptions = _this$state9.menuOptions;
    var _this$props18 = this.props,
        captureMenuScroll = _this$props18.captureMenuScroll,
        inputValue = _this$props18.inputValue,
        isLoading = _this$props18.isLoading,
        loadingMessage = _this$props18.loadingMessage,
        minMenuHeight = _this$props18.minMenuHeight,
        maxMenuHeight = _this$props18.maxMenuHeight,
        menuIsOpen = _this$props18.menuIsOpen,
        menuPlacement = _this$props18.menuPlacement,
        menuPosition = _this$props18.menuPosition,
        menuPortalTarget = _this$props18.menuPortalTarget,
        menuShouldBlockScroll = _this$props18.menuShouldBlockScroll,
        menuShouldScrollIntoView = _this$props18.menuShouldScrollIntoView,
        noOptionsMessage = _this$props18.noOptionsMessage,
        onMenuScrollToTop = _this$props18.onMenuScrollToTop,
        onMenuScrollToBottom = _this$props18.onMenuScrollToBottom;
    if (!menuIsOpen) return null; // TODO: Internal Option Type here

    var render = function render(props) {
      // for performance, the menu options in state aren't changed when the
      // focused option changes so we calculate additional props based on that
      var isFocused = focusedOption === props.data;
      props.innerRef = isFocused ? _this5.getFocusedOptionRef : undefined;
      return React__default.createElement(Option, _extends$4$2({}, commonProps, props, {
        isFocused: isFocused
      }), _this5.formatOptionLabel(props.data, 'menu'));
    };

    var menuUI;

    if (this.hasOptions()) {
      menuUI = menuOptions.render.map(function (item) {
        if (item.type === 'group') {
          var type = item.type,
              group = _objectWithoutPropertiesLoose$2$1(item, ["type"]);

          var headingId = item.key + "-heading";
          return React__default.createElement(Group, _extends$4$2({}, commonProps, group, {
            Heading: GroupHeading,
            headingProps: {
              id: headingId
            },
            label: _this5.formatGroupLabel(item.data)
          }), item.options.map(function (option) {
            return render(option);
          }));
        } else if (item.type === 'option') {
          return render(item);
        }
      });
    } else if (isLoading) {
      var message = loadingMessage({
        inputValue: inputValue
      });
      if (message === null) return null;
      menuUI = React__default.createElement(LoadingMessage, commonProps, message);
    } else {
      var _message = noOptionsMessage({
        inputValue: inputValue
      });

      if (_message === null) return null;
      menuUI = React__default.createElement(NoOptionsMessage, commonProps, _message);
    }

    var menuPlacementProps = {
      minMenuHeight: minMenuHeight,
      maxMenuHeight: maxMenuHeight,
      menuPlacement: menuPlacement,
      menuPosition: menuPosition,
      menuShouldScrollIntoView: menuShouldScrollIntoView
    };
    var menuElement = React__default.createElement(MenuPlacer, _extends$4$2({}, commonProps, menuPlacementProps), function (_ref8) {
      var ref = _ref8.ref,
          _ref8$placerProps = _ref8.placerProps,
          placement = _ref8$placerProps.placement,
          maxHeight = _ref8$placerProps.maxHeight;
      return React__default.createElement(Menu, _extends$4$2({}, commonProps, menuPlacementProps, {
        innerRef: ref,
        innerProps: {
          onMouseDown: _this5.onMenuMouseDown,
          onMouseMove: _this5.onMenuMouseMove
        },
        isLoading: isLoading,
        placement: placement
      }), React__default.createElement(ScrollCaptorSwitch, {
        isEnabled: captureMenuScroll,
        onTopArrive: onMenuScrollToTop,
        onBottomArrive: onMenuScrollToBottom
      }, React__default.createElement(ScrollBlock, {
        isEnabled: menuShouldBlockScroll
      }, React__default.createElement(MenuList, _extends$4$2({}, commonProps, {
        innerRef: _this5.getMenuListRef,
        isLoading: isLoading,
        maxHeight: maxHeight
      }), menuUI))));
    }); // positioning behaviour is almost identical for portalled and fixed,
    // so we use the same component. the actual portalling logic is forked
    // within the component based on `menuPosition`

    return menuPortalTarget || menuPosition === 'fixed' ? React__default.createElement(MenuPortal, _extends$4$2({}, commonProps, {
      appendTo: menuPortalTarget,
      controlElement: this.controlRef,
      menuPlacement: menuPlacement,
      menuPosition: menuPosition
    }), menuElement) : menuElement;
  };

  _proto.renderFormField = function renderFormField() {
    var _this6 = this;

    var _this$props19 = this.props,
        delimiter = _this$props19.delimiter,
        isDisabled = _this$props19.isDisabled,
        isMulti = _this$props19.isMulti,
        name = _this$props19.name;
    var selectValue = this.state.selectValue;
    if (!name || isDisabled) return;

    if (isMulti) {
      if (delimiter) {
        var value = selectValue.map(function (opt) {
          return _this6.getOptionValue(opt);
        }).join(delimiter);
        return React__default.createElement("input", {
          name: name,
          type: "hidden",
          value: value
        });
      } else {
        var input = selectValue.length > 0 ? selectValue.map(function (opt, i) {
          return React__default.createElement("input", {
            key: "i-" + i,
            name: name,
            type: "hidden",
            value: _this6.getOptionValue(opt)
          });
        }) : React__default.createElement("input", {
          name: name,
          type: "hidden"
        });
        return React__default.createElement("div", null, input);
      }
    } else {
      var _value2 = selectValue[0] ? this.getOptionValue(selectValue[0]) : '';

      return React__default.createElement("input", {
        name: name,
        type: "hidden",
        value: _value2
      });
    }
  };

  _proto.renderLiveRegion = function renderLiveRegion() {
    if (!this.state.isFocused) return null;
    return React__default.createElement(A11yText, {
      "aria-live": "polite"
    }, React__default.createElement("p", {
      id: "aria-selection-event"
    }, "\xA0", this.state.ariaLiveSelection), React__default.createElement("p", {
      id: "aria-context"
    }, "\xA0", this.constructAriaLiveMessage()));
  };

  _proto.render = function render() {
    var _this$components4 = this.components,
        Control = _this$components4.Control,
        IndicatorsContainer = _this$components4.IndicatorsContainer,
        SelectContainer = _this$components4.SelectContainer,
        ValueContainer = _this$components4.ValueContainer;
    var _this$props20 = this.props,
        className = _this$props20.className,
        id = _this$props20.id,
        isDisabled = _this$props20.isDisabled,
        menuIsOpen = _this$props20.menuIsOpen;
    var isFocused = this.state.isFocused;
    var commonProps = this.commonProps = this.getCommonProps();
    return React__default.createElement(SelectContainer, _extends$4$2({}, commonProps, {
      className: className,
      innerProps: {
        id: id,
        onKeyDown: this.onKeyDown
      },
      isDisabled: isDisabled,
      isFocused: isFocused
    }), this.renderLiveRegion(), React__default.createElement(Control, _extends$4$2({}, commonProps, {
      innerRef: this.getControlRef,
      innerProps: {
        onMouseDown: this.onControlMouseDown,
        onTouchEnd: this.onControlTouchEnd
      },
      isDisabled: isDisabled,
      isFocused: isFocused,
      menuIsOpen: menuIsOpen
    }), React__default.createElement(ValueContainer, _extends$4$2({}, commonProps, {
      isDisabled: isDisabled
    }), this.renderPlaceholderOrValue(), this.renderInput()), React__default.createElement(IndicatorsContainer, _extends$4$2({}, commonProps, {
      isDisabled: isDisabled
    }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
  };

  return Select;
}(Component);

Select.defaultProps = defaultProps;

function _extends$J() { _extends$J = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$J.apply(this, arguments); }

function _objectWithoutPropertiesLoose$4(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose$5(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
var defaultProps$1 = {
  defaultInputValue: '',
  defaultMenuIsOpen: false,
  defaultValue: null
};

var manageState = function manageState(SelectComponent) {
  var _class, _temp;

  return _temp = _class =
  /*#__PURE__*/
  function (_Component) {
    _inheritsLoose$5(StateManager, _Component);

    function StateManager() {
      var _this;

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _Component.call.apply(_Component, [this].concat(args)) || this;
      _this.select = void 0;
      _this.state = {
        inputValue: _this.props.inputValue !== undefined ? _this.props.inputValue : _this.props.defaultInputValue,
        menuIsOpen: _this.props.menuIsOpen !== undefined ? _this.props.menuIsOpen : _this.props.defaultMenuIsOpen,
        value: _this.props.value !== undefined ? _this.props.value : _this.props.defaultValue
      };

      _this.onChange = function (value, actionMeta) {
        _this.callProp('onChange', value, actionMeta);

        _this.setState({
          value: value
        });
      };

      _this.onInputChange = function (value, actionMeta) {
        // TODO: for backwards compatibility, we allow the prop to return a new
        // value, but now inputValue is a controllable prop we probably shouldn't
        var newValue = _this.callProp('onInputChange', value, actionMeta);

        _this.setState({
          inputValue: newValue !== undefined ? newValue : value
        });
      };

      _this.onMenuOpen = function () {
        _this.callProp('onMenuOpen');

        _this.setState({
          menuIsOpen: true
        });
      };

      _this.onMenuClose = function () {
        _this.callProp('onMenuClose');

        _this.setState({
          menuIsOpen: false
        });
      };

      return _this;
    }

    var _proto = StateManager.prototype;

    _proto.focus = function focus() {
      this.select.focus();
    };

    _proto.blur = function blur() {
      this.select.blur();
    } // FIXME: untyped flow code, return any
    ;

    _proto.getProp = function getProp(key) {
      return this.props[key] !== undefined ? this.props[key] : this.state[key];
    } // FIXME: untyped flow code, return any
    ;

    _proto.callProp = function callProp(name) {
      if (typeof this.props[name] === 'function') {
        var _this$props;

        for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
          args[_key2 - 1] = arguments[_key2];
        }

        return (_this$props = this.props)[name].apply(_this$props, args);
      }
    };

    _proto.render = function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          defaultInputValue = _this$props2.defaultInputValue,
          defaultMenuIsOpen = _this$props2.defaultMenuIsOpen,
          defaultValue = _this$props2.defaultValue,
          props = _objectWithoutPropertiesLoose$4(_this$props2, ["defaultInputValue", "defaultMenuIsOpen", "defaultValue"]);

      return React__default.createElement(SelectComponent, _extends$J({}, props, {
        ref: function ref(_ref) {
          _this2.select = _ref;
        },
        inputValue: this.getProp('inputValue'),
        menuIsOpen: this.getProp('menuIsOpen'),
        onChange: this.onChange,
        onInputChange: this.onInputChange,
        onMenuClose: this.onMenuClose,
        onMenuOpen: this.onMenuOpen,
        value: this.getProp('value')
      }));
    };

    return StateManager;
  }(Component), _class.defaultProps = defaultProps$1, _temp;
};

var index = manageState(Select);

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = ".select-field .select__control {\n  min-height: 32px;\n  border: 0;\n  border-bottom: 2px solid #b5bdd1;\n  background-color: transparent;\n  border-radius: 0;\n  outline: none;\n  box-shadow: none;\n  padding-left: 0;\n  transition: all 300ms ease-in-out; }\n  .select-field .select__control:hover {\n    border-color: #fff; }\n  .select-field .select__control--is-focused {\n    background-color: #96a1bd;\n    padding-left: 10px; }\n    .select-field .select__control--is-focused:hover {\n      border-color: #b5bdd1; }\n    .select-field .select__control--is-focused .select__multi-value {\n      border-color: var(--value-border, #fff); }\n  .select-field .select__control--is-disabled {\n    pointer-events: all;\n    cursor: not-allowed; }\n    .select-field .select__control--is-disabled .select__value-container {\n      pointer-events: none; }\n  .error .select-field .select__control {\n    border-color: #eac029; }\n\n.select-field .select__value-container {\n  padding: 0;\n  color: #fff;\n  font-size: 14px;\n  cursor: text; }\n\n.select-field .select__placeholder {\n  color: #b5bdd1; }\n\n.select-field .select__input {\n  color: #fff; }\n  .select-field .select__input input {\n    height: 22px;\n    transition: none; }\n\n.select-field .select__single-value {\n  color: #fff; }\n\n.select-field .select__multi-value {\n  color: #fff;\n  border: 1px solid var(--value-border, #96a1bd);\n  border-radius: 2px;\n  background-color: var(--value-bg, transparent);\n  transition: background-color 300ms ease-in-out; }\n  .select-field .select__multi-value__label {\n    color: #fff;\n    font-size: 14px; }\n  .select-field .select__multi-value__remove {\n    color: #fff;\n    opacity: 0.6;\n    cursor: pointer;\n    transition: opacity 300ms ease-in-out; }\n    .select-field .select__multi-value__remove:hover {\n      color: #fff;\n      opacity: 1;\n      background: unset; }\n  .select-field .select__multi-value:hover {\n    background-color: var(--value-bg-hover, #96a1bd); }\n\n.select-field .select__menu {\n  z-index: 10;\n  margin: 0;\n  border-radius: 0;\n  border: 0;\n  background-color: #96a1bd;\n  color: #fff;\n  font-size: 14px;\n  box-shadow: none; }\n\n.select-field .select__menu-list {\n  padding: 0; }\n\n.select-field .select__menu-notice--no-options {\n  display: none; }\n\n.select-field .select__option {\n  background-color: transparent;\n  padding: 6px 10px;\n  cursor: pointer; }\n  .select-field .select__option--is-focused {\n    background-color: #aab5d0; }\n  .select-field .select__option--is-selected {\n    background-color: #5d6a8c; }\n\n.select-field .select__indicator-separator {\n  display: none; }\n\n.select-field .select__dropdown-indicator {\n  color: #fff; }\n  .select-field .select__dropdown-indicator:before {\n    content: '';\n    border-top: 4px solid currentColor;\n    border-right: 4px solid transparent;\n    border-left: 4px solid transparent; }\n  .select-field .select__dropdown-indicator svg {\n    display: none; }\n\n.select-field--search .select__dropdown-indicator {\n  display: none; }\n\n.select-field--search .select__loading-indicator {\n  position: relative; }\n  .select-field--search .select__loading-indicator span {\n    display: none; }\n  .select-field--search .select__loading-indicator::after {\n    content: '';\n    box-sizing: border-box;\n    border: 3px solid #445076;\n    border-left-color: #f3f4f6;\n    border-radius: 20px;\n    display: block;\n    animation: spinner 2s linear infinite;\n    position: absolute;\n    top: -2px;\n    right: -1px;\n    width: 20px;\n    height: 20px; }\n\n.select-field--search .select__menu-notice--loading {\n  display: none; }\n\n.select-field--search .select__option {\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden; }\n\n@keyframes spinner {\n  100% {\n    transform: rotate(360deg); } }\n\n.form-row-dark .select-field .select__control:hover {\n  border-bottom-color: #4b577e; }\n\n.form-row-dark .select-field .select__control--is-focused {\n  background-color: #fff;\n  border-bottom-color: transparent; }\n  .form-row-dark .select-field .select__control--is-focused:hover {\n    border-bottom-color: transparent; }\n\n.form-row-dark .select-field .select__placeholder {\n  color: #8897ae; }\n\n.form-row-dark .select-field .select__single-value {\n  color: #4b577e; }\n\n.form-row-dark .select-field .select__dropdown-indicator {\n  color: #96a1bd; }\n";
styleInject(css_248z);

const SelectField = (_a) => {
    var { name, options, disabled, isMulti = false, isClearable = false, testId } = _a, restProps = __rest(_a, ["name", "options", "disabled", "isMulti", "isClearable", "testId"]);
    const classes = classnames('select-field', testId);
    return (React__default.createElement(index, Object.assign({}, restProps, { className: classes, classNamePrefix: "select", blurInputOnSelect: true, isDisabled: disabled, options: options, name: name, isMulti: isMulti, isClearable: isClearable })));
};

function _extends$K() { _extends$K = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$K.apply(this, arguments); }

function _objectWithoutPropertiesLoose$5(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose$6(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
var defaultProps$2 = {
  cacheOptions: false,
  defaultOptions: false,
  filterOption: null,
  isLoading: false
};
var makeAsyncSelect = function makeAsyncSelect(SelectComponent) {
  var _class, _temp;

  return _temp = _class =
  /*#__PURE__*/
  function (_Component) {
    _inheritsLoose$6(Async, _Component);

    function Async(props) {
      var _this;

      _this = _Component.call(this) || this;
      _this.select = void 0;
      _this.lastRequest = void 0;
      _this.mounted = false;
      _this.optionsCache = {};

      _this.handleInputChange = function (newValue, actionMeta) {
        var _this$props = _this.props,
            cacheOptions = _this$props.cacheOptions,
            onInputChange = _this$props.onInputChange; // TODO

        var inputValue = handleInputChange(newValue, actionMeta, onInputChange);

        if (!inputValue) {
          delete _this.lastRequest;

          _this.setState({
            inputValue: '',
            loadedInputValue: '',
            loadedOptions: [],
            isLoading: false,
            passEmptyOptions: false
          });

          return;
        }

        if (cacheOptions && _this.optionsCache[inputValue]) {
          _this.setState({
            inputValue: inputValue,
            loadedInputValue: inputValue,
            loadedOptions: _this.optionsCache[inputValue],
            isLoading: false,
            passEmptyOptions: false
          });
        } else {
          var request = _this.lastRequest = {};

          _this.setState({
            inputValue: inputValue,
            isLoading: true,
            passEmptyOptions: !_this.state.loadedInputValue
          }, function () {
            _this.loadOptions(inputValue, function (options) {
              if (!_this.mounted) return;

              if (options) {
                _this.optionsCache[inputValue] = options;
              }

              if (request !== _this.lastRequest) return;
              delete _this.lastRequest;

              _this.setState({
                isLoading: false,
                loadedInputValue: inputValue,
                loadedOptions: options || [],
                passEmptyOptions: false
              });
            });
          });
        }

        return inputValue;
      };

      _this.state = {
        defaultOptions: Array.isArray(props.defaultOptions) ? props.defaultOptions : undefined,
        inputValue: typeof props.inputValue !== 'undefined' ? props.inputValue : '',
        isLoading: props.defaultOptions === true,
        loadedOptions: [],
        passEmptyOptions: false
      };
      return _this;
    }

    var _proto = Async.prototype;

    _proto.componentDidMount = function componentDidMount() {
      var _this2 = this;

      this.mounted = true;
      var defaultOptions = this.props.defaultOptions;
      var inputValue = this.state.inputValue;

      if (defaultOptions === true) {
        this.loadOptions(inputValue, function (options) {
          if (!_this2.mounted) return;
          var isLoading = !!_this2.lastRequest;

          _this2.setState({
            defaultOptions: options || [],
            isLoading: isLoading
          });
        });
      }
    };

    _proto.UNSAFE_componentWillReceiveProps = function UNSAFE_componentWillReceiveProps(nextProps) {
      // if the cacheOptions prop changes, clear the cache
      if (nextProps.cacheOptions !== this.props.cacheOptions) {
        this.optionsCache = {};
      }

      if (nextProps.defaultOptions !== this.props.defaultOptions) {
        this.setState({
          defaultOptions: Array.isArray(nextProps.defaultOptions) ? nextProps.defaultOptions : undefined
        });
      }
    };

    _proto.componentWillUnmount = function componentWillUnmount() {
      this.mounted = false;
    };

    _proto.focus = function focus() {
      this.select.focus();
    };

    _proto.blur = function blur() {
      this.select.blur();
    };

    _proto.loadOptions = function loadOptions(inputValue, callback) {
      var loadOptions = this.props.loadOptions;
      if (!loadOptions) return callback();
      var loader = loadOptions(inputValue, callback);

      if (loader && typeof loader.then === 'function') {
        loader.then(callback, function () {
          return callback();
        });
      }
    };

    _proto.render = function render() {
      var _this3 = this;

      var _this$props2 = this.props,
          loadOptions = _this$props2.loadOptions,
          isLoadingProp = _this$props2.isLoading,
          props = _objectWithoutPropertiesLoose$5(_this$props2, ["loadOptions", "isLoading"]);

      var _this$state = this.state,
          defaultOptions = _this$state.defaultOptions,
          inputValue = _this$state.inputValue,
          isLoading = _this$state.isLoading,
          loadedInputValue = _this$state.loadedInputValue,
          loadedOptions = _this$state.loadedOptions,
          passEmptyOptions = _this$state.passEmptyOptions;
      var options = passEmptyOptions ? [] : inputValue && loadedInputValue ? loadedOptions : defaultOptions || [];
      return React__default.createElement(SelectComponent, _extends$K({}, props, {
        ref: function ref(_ref) {
          _this3.select = _ref;
        },
        options: options,
        isLoading: isLoading || isLoadingProp,
        onInputChange: this.handleInputChange
      }));
    };

    return Async;
  }(Component), _class.defaultProps = defaultProps$2, _temp;
};
var SelectState = manageState(Select);
var Async = makeAsyncSelect(SelectState);

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

var lodash_debounce = debounce;

const SelectSearchField = (_a) => {
    var { disabled = false, debounceTime = 500, loadOptions } = _a, restProps = __rest(_a, ["disabled", "debounceTime", "loadOptions"]);
    const debouncedLoadOptions = useCallback(lodash_debounce((term, callback) => {
        loadOptions(term)
            .then(result => callback(result))
            .catch(() => callback([]));
    }, debounceTime), [loadOptions, debounceTime]);
    return (React__default.createElement(Async, Object.assign({}, restProps, { className: "select-field select-field--search", classNamePrefix: "select", blurInputOnSelect: true, isDisabled: disabled, loadOptions: debouncedLoadOptions })));
};

const MenuFooter = ({ currentUserEmail, currentAccountName, currentAccountId, isSuperAdmin, accounts, switchAccount, searchAccount, logout, t, }) => {
    const accountOptions = accounts.map(item => ({
        value: item.id,
        label: item.name,
    }));
    const onSwitchAccount = (option) => {
        if (!option || Array.isArray(option)) {
            return;
        }
        switchAccount(+option.value);
    };
    return (React__default.createElement("div", { className: "main-menu__footer" },
        React__default.createElement("div", { className: "main-menu__user-info" },
            !isSuperAdmin && accountOptions.length > 1 && (React__default.createElement("div", { className: "main-menu__account-select" },
                React__default.createElement(SelectField, { name: "current-account", options: accountOptions, defaultValue: {
                        label: currentAccountName,
                        value: currentAccountId,
                    }, onChange: onSwitchAccount }))),
            isSuperAdmin && (React__default.createElement("div", { className: "main-menu__account-select" },
                React__default.createElement("div", { className: "main-menu__account-name" }, `${t('label.account')}: ${currentAccountName}`),
                React__default.createElement(SelectSearchField, { name: "current-account", placeholder: t('label.select-account'), onChange: onSwitchAccount, loadOptions: searchAccount }))),
            React__default.createElement("div", { className: "main-menu__login-email" },
                React__default.createElement("div", null, t('label.logged-in-as')),
                React__default.createElement("span", null, currentUserEmail))),
        React__default.createElement("div", { className: "main-menu__logout" },
            React__default.createElement("button", { className: "main-menu__logout-button", onClick: logout }, t('action.logout')))));
};

var css_248z$1 = ".main-menu {\n  height: 100%;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  font-size: 1em; }\n  @media screen and (max-width: 700px) {\n    .main-menu {\n      font-size: 1.1em; } }\n  .main-menu__header {\n    flex: 0 0 auto;\n    padding: 20px 0; }\n    .main-menu__header--with-items {\n      margin-bottom: 30px;\n      background-color: #40496f; }\n    .main-menu__header .main-menu__list {\n      margin-top: 20px; }\n  .main-menu__list {\n    margin: 0;\n    padding: 0;\n    list-style: none; }\n  .main-menu__logo-button {\n    display: block;\n    width: 100%;\n    line-height: 0;\n    padding: 0 20px;\n    background-color: transparent;\n    text-align: start;\n    border: none;\n    cursor: pointer;\n    user-select: none; }\n    @media screen and (max-width: 700px) {\n      .main-menu__logo-button {\n        margin: 5px 0; } }\n    .main-menu__logo-button:hover {\n      background-color: transparent; }\n  .main-menu__logo {\n    height: 28px; }\n    @media screen and (max-width: 700px) {\n      .main-menu__logo {\n        height: 22px; } }\n  .main-menu__content {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    flex: 1 1 0%;\n    overflow: auto; }\n  .main-menu__list li {\n    border: none;\n    transition: background-color 0.3s ease-in-out; }\n    .main-menu__list li > a {\n      display: flex;\n      align-items: center;\n      padding: 11px 0 11px 20px;\n      color: #fff;\n      text-decoration: none;\n      cursor: pointer; }\n      @media screen and (max-width: 700px) {\n        .main-menu__list li > a {\n          padding-top: 10px;\n          padding-bottom: 10px;\n          font-size: 0.8em; } }\n    .main-menu__list li.active > a, .main-menu__list li:hover > a {\n      color: #fff; }\n    .main-menu__list li.active {\n      background-color: #96a1bd; }\n    .main-menu__list li:not(.active):hover {\n      background-color: #5d6a8c; }\n  .main-menu__list-icon {\n    width: 28px;\n    height: 16px;\n    margin-right: 10px; }\n    @media screen and (max-width: 700px) {\n      .main-menu__list-icon {\n        height: 14px; } }\n  .main-menu__footer {\n    margin-top: auto;\n    padding: 20px;\n    font-size: 0.9em;\n    flex: 0 0 auto; }\n  .main-menu__user-info {\n    color: #fff;\n    font-size: 1em;\n    margin-bottom: 10px; }\n  .main-menu__account-name {\n    padding: 3px 0;\n    margin-bottom: 5px; }\n    @media screen and (max-width: 700px) {\n      .main-menu__account-name {\n        font-size: 0.9em; } }\n  .main-menu__account-select {\n    margin-bottom: 15px; }\n    @media screen and (max-width: 700px) {\n      .main-menu__account-select {\n        margin-bottom: 10px; } }\n    .main-menu__account-select .select__menu-list {\n      max-height: 108px; }\n  .main-menu__login-email {\n    padding-top: 10px;\n    line-height: 22px; }\n    @media screen and (max-width: 700px) {\n      .main-menu__login-email {\n        font-size: 0.9em; } }\n  .main-menu__logout {\n    padding-bottom: 15px; }\n  .main-menu__logout-button {\n    display: block;\n    width: 100%;\n    margin-bottom: 10px;\n    border-radius: 2px;\n    transition: background-color .3s ease-in-out, box-shadow .3s ease-in-out;\n    border: none;\n    box-shadow: none;\n    color: #fff;\n    background-color: #96a1bd;\n    padding: 8px 10px;\n    text-transform: uppercase;\n    text-align: center;\n    font-size: .9em;\n    letter-spacing: .02em;\n    cursor: pointer; }\n    .main-menu__logout-button:hover {\n      background-color: #f05656; }\n\n@media screen and (max-width: 700px) {\n  .hide-for-mobile {\n    display: none; } }\n";
styleInject(css_248z$1);

const MainMenu = props => {
    const { currentUser, currentAccount, accounts, switchAccount, searchAccount, baseUrl, activeLink, language, logout, toggleSidebar, t, } = props;
    if (!currentUser || !currentAccount) {
        return null;
    }
    const isSuperAdmin = currentUser.super_admin;
    const isTermsPage = activeLink === 'terms';
    const isPaymentSetupPending = currentAccount.missing_payment_information &&
        !currentAccount.in_demo_period &&
        !currentAccount.running &&
        !currentAccount.disabled;
    const linkVisibleProps = getVisibleProps(currentUser, currentAccount);
    const visibleLinks = getNavbarConfig(t, toggleSidebar)
        .map((link) => (Object.assign(Object.assign({}, link), { url: generateUrl(link, baseUrl, linkVisibleProps), isVisible: link.checkVisibility(linkVisibleProps) })))
        .filter((link) => link.isVisible);
    const navbarLinks = getSortedLinks(visibleLinks);
    return (React__default.createElement("div", { className: "main-menu" },
        React__default.createElement(MenuHeader, { activeLink: activeLink, toggleSidebar: toggleSidebar, linkConfigList: navbarLinks.logo }),
        !isPaymentSetupPending && !isTermsPage && (React__default.createElement(MenuContent, { activeLink: activeLink, language: language, linkConfigListTop: navbarLinks.top, linkConfigListBottom: navbarLinks.bottom, t: t })),
        React__default.createElement(MenuFooter, { currentUserEmail: currentUser.email, currentAccountName: currentAccount.name, currentAccountId: currentAccount.id, isSuperAdmin: isSuperAdmin, accounts: accounts, switchAccount: switchAccount, searchAccount: searchAccount, logout: logout, t: t })));
};

var lodash_isempty = createCommonjsModule(function (module, exports) {
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Detect free variable `exports`. */
var freeExports =  exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
    nativeKeys = overArg(Object.keys, Object);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView'),
    Map = getNative(root, 'Map'),
    Promise = getNative(root, 'Promise'),
    Set = getNative(root, 'Set'),
    WeakMap = getNative(root, 'WeakMap');

/** Detect if properties shadowing those on `Object.prototype` are non-enumerable. */
var nonEnumShadows = !propertyIsEnumerable.call({ 'valueOf': 1 }, 'valueOf');

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * The base implementation of `getTag`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  return objectToString.call(value);
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11,
// for data views in Edge < 14, and promises in Node.js.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = objectToString.call(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : undefined;

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

/**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */
function isEmpty(value) {
  if (isArrayLike(value) &&
      (isArray(value) || typeof value == 'string' ||
        typeof value.splice == 'function' || isBuffer(value) || isArguments(value))) {
    return !value.length;
  }
  var tag = getTag(value);
  if (tag == mapTag || tag == setTag) {
    return !value.size;
  }
  if (nonEnumShadows || isPrototype(value)) {
    return !nativeKeys(value).length;
  }
  for (var key in value) {
    if (hasOwnProperty.call(value, key)) {
      return false;
    }
  }
  return true;
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = isEmpty;
});

/**
 * Used when there is no specific error message on input field
 * but we still want the validation to fail
 */
const NO_MSG = 'no-error-msg';
/**
 * Validate a field based on specified set of rules
 */
const validate = (validations) => (...args) => {
    let idx = 0;
    while (idx < validations.length) {
        const [runValidation, getMessage] = validations[idx];
        if (runValidation(...args)) {
            return getMessage();
        }
        idx += 1;
    }
};
const checkType = (type) => (value) => {
    const valueType = typeof value;
    return valueType === type;
};
const isBoolean = checkType('boolean');
const isNumber = checkType('number');
/**
 * Checks if the input has some value
 */
const isRequired = (value) => !isBoolean(value) && !isNumber(value) && lodash_isempty(value);

/**
 * Wraps the passed field component with label and error message
 */
function FieldWithLabel(Wrapped) {
    const wrappedWithFieldWithLabel = (_a) => {
        var { hasError, errorMsg, label, unitLabel, name, light, info, inline, margin } = _a, restProps = __rest(_a, ["hasError", "errorMsg", "label", "unitLabel", "name", "light", "info", "inline", "margin"]);
        const formClasses = classnames('form-row', {
            error: hasError,
            'no-error-msg': errorMsg === NO_MSG || !errorMsg,
            'form-row-dark': light,
            'form-row-inline': inline,
            [`form-row-${margin}`]: margin,
        });
        return (React__default.createElement("div", { className: formClasses },
            label && React__default.createElement("label", { htmlFor: name }, label),
            errorMsg && errorMsg !== NO_MSG && React__default.createElement("span", { className: "error-msg" }, errorMsg),
            React__default.createElement(Wrapped, Object.assign({ name: name }, restProps)),
            unitLabel && React__default.createElement("label", { htmlFor: name }, unitLabel),
            info && React__default.createElement("span", { className: "info" }, info)));
    };
    return wrappedWithFieldWithLabel;
}

const getValue = (option) => {
    if (!option) {
        return option;
    }
    if (Array.isArray(option)) {
        return option.map(item => item.value);
    }
    return option.value;
};
const getOptionValue$1 = (options, value) => {
    if (value === undefined || value === null) {
        return;
    }
    if (Array.isArray(value)) {
        return options.filter(option => value.includes(option.value));
    }
    return options.find(option => option.value === value);
};

const SelectFieldFormAdapter = (_a) => {
    var { options, value, defaultValue, onChange } = _a, restProps = __rest(_a, ["options", "value", "defaultValue", "onChange"]);
    return (React__default.createElement(SelectField, Object.assign({}, restProps, { options: options, value: getOptionValue$1(options, value), defaultValue: getOptionValue$1(options, defaultValue), onChange: option => onChange(getValue(option)) })));
};
const SelectFieldWithLabel = FieldWithLabel(SelectFieldFormAdapter);

function _inheritsLoose$7(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _extends$L() { _extends$L = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$L.apply(this, arguments); }

var compareOption = function compareOption(inputValue, option) {
  if (inputValue === void 0) {
    inputValue = '';
  }

  var candidate = String(inputValue).toLowerCase();
  var optionValue = String(option.value).toLowerCase();
  var optionLabel = String(option.label).toLowerCase();
  return optionValue === candidate || optionLabel === candidate;
};

var builtins = {
  formatCreateLabel: function formatCreateLabel(inputValue) {
    return "Create \"" + inputValue + "\"";
  },
  isValidNewOption: function isValidNewOption(inputValue, selectValue, selectOptions) {
    return !(!inputValue || selectValue.some(function (option) {
      return compareOption(inputValue, option);
    }) || selectOptions.some(function (option) {
      return compareOption(inputValue, option);
    }));
  },
  getNewOptionData: function getNewOptionData(inputValue, optionLabel) {
    return {
      label: optionLabel,
      value: inputValue,
      __isNew__: true
    };
  }
};
var defaultProps$3 = _extends$L({
  allowCreateWhileLoading: false,
  createOptionPosition: 'last'
}, builtins);
var makeCreatableSelect = function makeCreatableSelect(SelectComponent) {
  var _class, _temp;

  return _temp = _class =
  /*#__PURE__*/
  function (_Component) {
    _inheritsLoose$7(Creatable, _Component);

    function Creatable(props) {
      var _this;

      _this = _Component.call(this, props) || this;
      _this.select = void 0;

      _this.onChange = function (newValue, actionMeta) {
        var _this$props = _this.props,
            getNewOptionData = _this$props.getNewOptionData,
            inputValue = _this$props.inputValue,
            isMulti = _this$props.isMulti,
            onChange = _this$props.onChange,
            onCreateOption = _this$props.onCreateOption,
            value = _this$props.value,
            name = _this$props.name;

        if (actionMeta.action !== 'select-option') {
          return onChange(newValue, actionMeta);
        }

        var newOption = _this.state.newOption;
        var valueArray = Array.isArray(newValue) ? newValue : [newValue];

        if (valueArray[valueArray.length - 1] === newOption) {
          if (onCreateOption) onCreateOption(inputValue);else {
            var newOptionData = getNewOptionData(inputValue, inputValue);
            var newActionMeta = {
              action: 'create-option',
              name: name
            };

            if (isMulti) {
              onChange([].concat(cleanValue(value), [newOptionData]), newActionMeta);
            } else {
              onChange(newOptionData, newActionMeta);
            }
          }
          return;
        }

        onChange(newValue, actionMeta);
      };

      var options = props.options || [];
      _this.state = {
        newOption: undefined,
        options: options
      };
      return _this;
    }

    var _proto = Creatable.prototype;

    _proto.UNSAFE_componentWillReceiveProps = function UNSAFE_componentWillReceiveProps(nextProps) {
      var allowCreateWhileLoading = nextProps.allowCreateWhileLoading,
          createOptionPosition = nextProps.createOptionPosition,
          formatCreateLabel = nextProps.formatCreateLabel,
          getNewOptionData = nextProps.getNewOptionData,
          inputValue = nextProps.inputValue,
          isLoading = nextProps.isLoading,
          isValidNewOption = nextProps.isValidNewOption,
          value = nextProps.value;
      var options = nextProps.options || [];
      var newOption = this.state.newOption;

      if (isValidNewOption(inputValue, cleanValue(value), options)) {
        newOption = getNewOptionData(inputValue, formatCreateLabel(inputValue));
      } else {
        newOption = undefined;
      }

      this.setState({
        newOption: newOption,
        options: (allowCreateWhileLoading || !isLoading) && newOption ? createOptionPosition === 'first' ? [newOption].concat(options) : [].concat(options, [newOption]) : options
      });
    };

    _proto.focus = function focus() {
      this.select.focus();
    };

    _proto.blur = function blur() {
      this.select.blur();
    };

    _proto.render = function render() {
      var _this2 = this;

      var options = this.state.options;
      return React__default.createElement(SelectComponent, _extends$L({}, this.props, {
        ref: function ref(_ref) {
          _this2.select = _ref;
        },
        options: options,
        onChange: this.onChange
      }));
    };

    return Creatable;
  }(Component), _class.defaultProps = defaultProps$3, _temp;
}; // TODO: do this in package entrypoint

var SelectCreatable = makeCreatableSelect(Select);
var Creatable = manageState(SelectCreatable);

//
// Main
//

function memoize$1 (fn, options) {
  var cache = options && options.cache
    ? options.cache
    : cacheDefault;

  var serializer = options && options.serializer
    ? options.serializer
    : serializerDefault;

  var strategy = options && options.strategy
    ? options.strategy
    : strategyDefault;

  return strategy(fn, {
    cache: cache,
    serializer: serializer
  })
}

//
// Strategy
//

function isPrimitive (value) {
  return value == null || typeof value === 'number' || typeof value === 'boolean' // || typeof value === "string" 'unsafe' primitive for our needs
}

function monadic (fn, cache, serializer, arg) {
  var cacheKey = isPrimitive(arg) ? arg : serializer(arg);

  var computedValue = cache.get(cacheKey);
  if (typeof computedValue === 'undefined') {
    computedValue = fn.call(this, arg);
    cache.set(cacheKey, computedValue);
  }

  return computedValue
}

function variadic (fn, cache, serializer) {
  var args = Array.prototype.slice.call(arguments, 3);
  var cacheKey = serializer(args);

  var computedValue = cache.get(cacheKey);
  if (typeof computedValue === 'undefined') {
    computedValue = fn.apply(this, args);
    cache.set(cacheKey, computedValue);
  }

  return computedValue
}

function assemble (fn, context, strategy, cache, serialize) {
  return strategy.bind(
    context,
    fn,
    cache,
    serialize
  )
}

function strategyDefault (fn, options) {
  var strategy = fn.length === 1 ? monadic : variadic;

  return assemble(
    fn,
    this,
    strategy,
    options.cache.create(),
    options.serializer
  )
}

function strategyVariadic (fn, options) {
  var strategy = variadic;

  return assemble(
    fn,
    this,
    strategy,
    options.cache.create(),
    options.serializer
  )
}

function strategyMonadic (fn, options) {
  var strategy = monadic;

  return assemble(
    fn,
    this,
    strategy,
    options.cache.create(),
    options.serializer
  )
}

//
// Serializer
//

function serializerDefault () {
  return JSON.stringify(arguments)
}

//
// Cache
//

function ObjectWithoutPrototypeCache () {
  this.cache = Object.create(null);
}

ObjectWithoutPrototypeCache.prototype.has = function (key) {
  return (key in this.cache)
};

ObjectWithoutPrototypeCache.prototype.get = function (key) {
  return this.cache[key]
};

ObjectWithoutPrototypeCache.prototype.set = function (key, value) {
  this.cache[key] = value;
};

var cacheDefault = {
  create: function create () {
    return new ObjectWithoutPrototypeCache()
  }
};

//
// API
//

var src = memoize$1;
var strategies = {
  variadic: strategyVariadic,
  monadic: strategyMonadic
};
src.strategies = strategies;

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** `Object#toString` result references. */
var symbolTag$1 = '[object Symbol]';

/** Detect free variable `global` from Node.js. */
var freeGlobal$1 = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

/** Detect free variable `self`. */
var freeSelf$1 = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root$1 = freeGlobal$1 || freeSelf$1 || Function('return this')();

/** Used for built-in method references. */
var objectProto$1 = Object.prototype;

/** Used to generate unique IDs. */
var idCounter = 0;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString$1 = objectProto$1.toString;

/** Built-in value references. */
var Symbol$1 = root$1.Symbol;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol$1 ? Symbol$1.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isSymbol$1(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike$1(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol$1(value) {
  return typeof value == 'symbol' ||
    (isObjectLike$1(value) && objectToString$1.call(value) == symbolTag$1);
}

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

/**
 * Generates a unique ID. If `prefix` is given, the ID is appended to it.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {string} [prefix=''] The value to prefix the ID with.
 * @returns {string} Returns the unique ID.
 * @example
 *
 * _.uniqueId('contact_');
 * // => 'contact_104'
 *
 * _.uniqueId();
 * // => '105'
 */
function uniqueId(prefix) {
  var id = ++idCounter;
  return toString(prefix) + id;
}

var lodash_uniqueid = uniqueId;

const getValuesFromTags = (options) => {
    if (!options) {
        return [];
    }
    if (Array.isArray(options)) {
        return options.map(item => item.label);
    }
    return [options.label];
};

const styles = {
    multiValue: (styles, { data }) => (Object.assign(Object.assign({}, styles), { '--value-border': data.isInvalid && '#ed3131', '--value-bg': data.isInvalid && '#f05656', '--value-bg-hover': data.isInvalid && '#ed3131' })),
    multiValueRemove: (styles, { data }) => (Object.assign(Object.assign({}, styles), { display: data.hideRemoveButton ? 'none' : 'flex' })),
    multiValueLabel: (styles, { data }) => (Object.assign(Object.assign({}, styles), { paddingRight: data.hideRemoveButton ? '6px' : '3px', opacity: data.hideRemoveButton ? '0.6' : '1' })),
};
class TaggingField extends React__default.Component {
    constructor() {
        super(...arguments);
        this.state = {
            inputValue: '',
            value: this.props.value,
        };
        /**
         * Handle the change in tags (tag deletion)
         */
        this.handleChange = (tags, { action }) => {
            const value = getValuesFromTags(tags);
            // Prevent tag deletion via backspace for unclearable tags
            if (this.props.fixedValues && action === 'pop-value' && value.length < this.props.fixedValues.length) {
                return;
            }
            this.setState({
                value,
            }, this.dispatchChangeEvent);
        };
        /**
         * Handle the input change and update state
         */
        this.handleInputChange = (inputValue) => {
            this.setState({ inputValue });
        };
        /**
         * Handle the blur event and create tag if input is not empty
         */
        this.handleBlur = (event) => {
            const { inputValue, value } = this.state;
            if (inputValue) {
                this.setState({
                    inputValue: '',
                    value: [...value, inputValue],
                }, this.dispatchChangeEvent);
            }
            this.dispatchBlurEvent(event);
        };
        /**
         * Handle the keydown event and create a tag based on:
         * - Enter key
         * - Tab key
         * - TaggingTokens (if specified)
         */
        this.handleKeyDown = (event) => {
            const { inputValue, value } = this.state;
            if (!inputValue) {
                return;
            }
            if (event.key === 'Enter' || event.key === 'Tab' || this.props.taggingTokens.includes(event.keyCode)) {
                this.setState({
                    inputValue: '',
                    value: [...value, inputValue],
                }, this.dispatchChangeEvent);
                event.preventDefault();
            }
        };
        /**
         * Get the current value from state and dispatch onChange event
         */
        this.dispatchChangeEvent = () => {
            this.props.onChange(this.state.value);
        };
        /**
         * Dispatch onBlur event
         */
        this.dispatchBlurEvent = (event) => {
            this.props.onBlur && this.props.onBlur(event);
        };
        /**
         * Convert array of string based values to react-select compatible array of objects
         * We need uniqueId here because react-select uses `value` as `key` for iteration
         */
        this.getTags = src((values) => values.map((value, index) => ({
            label: value,
            value: lodash_uniqueid(value),
            isInvalid: this.props.validation(value),
            hideRemoveButton: this.shouldHideRemoveButton(value, index),
        })));
        /**
         * Check if Remove button should be hidden
         */
        this.shouldHideRemoveButton = (value, valueIndex) => {
            if (!this.props.fixedValues) {
                return false;
            }
            return !!this.props.fixedValues.find((item, index) => {
                return value === item && valueIndex === index;
            });
        };
    }
    render() {
        const { inputValue, value } = this.state;
        const _a = this.props, { isClearable = false, disabled } = _a, restProps = __rest(_a, ["isClearable", "disabled"]);
        return (React__default.createElement(Creatable, Object.assign({}, restProps, { className: "select-field", classNamePrefix: "select", styles: styles, value: this.getTags(value), components: {
                DropdownIndicator: null,
            }, inputValue: inputValue, isClearable: isClearable, isDisabled: disabled, isMulti: true, menuIsOpen: false, onBlur: this.handleBlur, onChange: this.handleChange, onInputChange: this.handleInputChange, onKeyDown: this.handleKeyDown })));
    }
}
TaggingField.defaultProps = {
    value: [],
    taggingTokens: [],
    validation: () => false,
};
const TaggingFieldWithLabel = FieldWithLabel(TaggingField);

const SelectSearchFieldFormAdapter = (_a) => {
    var { onChange } = _a, restProps = __rest(_a, ["onChange"]);
    return (React__default.createElement(SelectSearchField, Object.assign({}, restProps, { onChange: option => onChange(getValue(option)) })));
};
const SelectSearchFieldWithLabel = FieldWithLabel(SelectSearchFieldFormAdapter);

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT$1 = 'Expected a function';

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used as references for various `Number` constants. */
var INFINITY$1 = 1 / 0;

/** `Object#toString` result references. */
var funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    symbolTag$2 = '[object Symbol]';

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/,
    reLeadingDot = /^\./,
    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Detect free variable `global` from Node.js. */
var freeGlobal$2 = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

/** Detect free variable `self`. */
var freeSelf$2 = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root$2 = freeGlobal$2 || freeSelf$2 || Function('return this')();

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue$1(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto$2 = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root$2['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty$2 = objectProto$2.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString$2 = objectProto$2.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty$2).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Symbol$2 = root$2.Symbol,
    splice = arrayProto.splice;

/* Built-in method references that are verified to be native. */
var Map$1 = getNative(root$2, 'Map'),
    nativeCreate = getNative(Object, 'create');

/** Used to convert symbols to primitives and strings. */
var symbolProto$1 = Symbol$2 ? Symbol$2.prototype : undefined,
    symbolToString$1 = symbolProto$1 ? symbolProto$1.toString : undefined;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  return this.has(key) && delete this.__data__[key];
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty$2.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty$2.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map$1 || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  return getMapData(this, key)['delete'](key);
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  getMapData(this, key).set(key, value);
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = isKey(path, object) ? [path] : castPath(path);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject$1(value) || isMasked(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString$1(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isSymbol$2(value)) {
    return symbolToString$1 ? symbolToString$1.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY$1) ? '-0' : result;
}

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value) {
  return isArray$1(value) ? value : stringToPath(value);
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue$1(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray$1(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol$2(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoize$2(function(string) {
  string = toString$1(string);

  var result = [];
  if (reLeadingDot.test(string)) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, string) {
    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol$2(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY$1) ? '-0' : result;
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize$2(func, resolver) {
  if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT$1);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result);
    return result;
  };
  memoized.cache = new (memoize$2.Cache || MapCache);
  return memoized;
}

// Assign cache to `_.memoize`.
memoize$2.Cache = MapCache;

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray$1 = Array.isArray;

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject$1(value) ? objectToString$2.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject$1(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike$2(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol$2(value) {
  return typeof value == 'symbol' ||
    (isObjectLike$2(value) && objectToString$2.call(value) == symbolTag$2);
}

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString$1(value) {
  return value == null ? '' : baseToString$1(value);
}

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

var lodash_get = get;

/**
 * Combines the props from Wrapped component with field props from formik
 * and returns a new component
 */
const withFieldProps = (Wrapped) => ({ field, form: { touched, errors, setFieldValue, setFieldTouched }, }) => {
    const fieldErrorMsg = lodash_get(errors, field.name);
    return React__default.cloneElement(Wrapped, Object.assign(Object.assign(Object.assign({}, field), Wrapped.props), { onChange: (value) => {
            setFieldValue(field.name, value);
            if (Wrapped.props.onChange) {
                Wrapped.props.onChange(value);
            }
        }, 
        // TODO: get rid of setTimeout, once Formik v3 is released
        // We call setFieldTouched in the next tick to use proper values for validation
        // related issue: https://github.com/formium/formik/issues/2083
        onBlur: () => setTimeout(() => setFieldTouched(field.name, true)), hasError: !!fieldErrorMsg && lodash_get(touched, field.name, false), errorMsg: fieldErrorMsg }));
};

function _extends$M() {
  _extends$M = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$M.apply(this, arguments);
}

function _objectWithoutPropertiesLoose$6(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _inheritsLoose$8(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

function hasClass(element, className) {
  if (element.classList) return !!className && element.classList.contains(className);
  return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}

function addClass(element, className) {
  if (element.classList) element.classList.add(className);else if (!hasClass(element, className)) if (typeof element.className === 'string') element.className = element.className + " " + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + " " + className);
}

function replaceClassName(origClass, classToRemove) {
  return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}

function removeClass(element, className) {
  if (element.classList) {
    element.classList.remove(className);
  } else if (typeof element.className === 'string') {
    element.className = replaceClassName(element.className, className);
  } else {
    element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
  }
}

var config = {
  disabled: false
};

var timeoutsShape = process.env.NODE_ENV !== 'production' ? propTypes.oneOfType([propTypes.number, propTypes.shape({
  enter: propTypes.number,
  exit: propTypes.number,
  appear: propTypes.number
}).isRequired]) : null;
var classNamesShape = process.env.NODE_ENV !== 'production' ? propTypes.oneOfType([propTypes.string, propTypes.shape({
  enter: propTypes.string,
  exit: propTypes.string,
  active: propTypes.string
}), propTypes.shape({
  enter: propTypes.string,
  enterDone: propTypes.string,
  enterActive: propTypes.string,
  exit: propTypes.string,
  exitDone: propTypes.string,
  exitActive: propTypes.string
})]) : null;

var TransitionGroupContext = React__default.createContext(null);

var UNMOUNTED = 'unmounted';
var EXITED = 'exited';
var ENTERING = 'entering';
var ENTERED = 'entered';
var EXITING = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */

var Transition = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose$8(Transition, _React$Component);

  function Transition(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    var parentGroup = context; // In the context of a TransitionGroup all enters are really appears

    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
    var initialStatus;
    _this.appearStatus = null;

    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.appearStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }

    _this.state = {
      status: initialStatus
    };
    _this.nextCallback = null;
    return _this;
  }

  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var nextIn = _ref.in;

    if (nextIn && prevState.status === UNMOUNTED) {
      return {
        status: EXITED
      };
    }

    return null;
  } // getSnapshotBeforeUpdate(prevProps) {
  //   let nextStatus = null
  //   if (prevProps !== this.props) {
  //     const { status } = this.state
  //     if (this.props.in) {
  //       if (status !== ENTERING && status !== ENTERED) {
  //         nextStatus = ENTERING
  //       }
  //     } else {
  //       if (status === ENTERING || status === ENTERED) {
  //         nextStatus = EXITING
  //       }
  //     }
  //   }
  //   return { nextStatus }
  // }
  ;

  var _proto = Transition.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.updateStatus(true, this.appearStatus);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var nextStatus = null;

    if (prevProps !== this.props) {
      var status = this.state.status;

      if (this.props.in) {
        if (status !== ENTERING && status !== ENTERED) {
          nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          nextStatus = EXITING;
        }
      }
    }

    this.updateStatus(false, nextStatus);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };

  _proto.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;
    var exit, enter, appear;
    exit = enter = appear = timeout;

    if (timeout != null && typeof timeout !== 'number') {
      exit = timeout.exit;
      enter = timeout.enter; // TODO: remove fallback for next major

      appear = timeout.appear !== undefined ? timeout.appear : enter;
    }

    return {
      exit: exit,
      enter: enter,
      appear: appear
    };
  };

  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
    if (mounting === void 0) {
      mounting = false;
    }

    if (nextStatus !== null) {
      // nextStatus will always be ENTERING or EXITING.
      this.cancelNextCallback();

      if (nextStatus === ENTERING) {
        this.performEnter(mounting);
      } else {
        this.performExit();
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({
        status: UNMOUNTED
      });
    }
  };

  _proto.performEnter = function performEnter(mounting) {
    var _this2 = this;

    var enter = this.props.enter;
    var appearing = this.context ? this.context.isMounting : mounting;

    var _ref2 = this.props.nodeRef ? [appearing] : [ReactDOM.findDOMNode(this), appearing],
        maybeNode = _ref2[0],
        maybeAppearing = _ref2[1];

    var timeouts = this.getTimeouts();
    var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
    // if we are mounting and running this it means appear _must_ be set

    if (!mounting && !enter || config.disabled) {
      this.safeSetState({
        status: ENTERED
      }, function () {
        _this2.props.onEntered(maybeNode);
      });
      return;
    }

    this.props.onEnter(maybeNode, maybeAppearing);
    this.safeSetState({
      status: ENTERING
    }, function () {
      _this2.props.onEntering(maybeNode, maybeAppearing);

      _this2.onTransitionEnd(enterTimeout, function () {
        _this2.safeSetState({
          status: ENTERED
        }, function () {
          _this2.props.onEntered(maybeNode, maybeAppearing);
        });
      });
    });
  };

  _proto.performExit = function performExit() {
    var _this3 = this;

    var exit = this.props.exit;
    var timeouts = this.getTimeouts();
    var maybeNode = this.props.nodeRef ? undefined : ReactDOM.findDOMNode(this); // no exit animation skip right to EXITED

    if (!exit || config.disabled) {
      this.safeSetState({
        status: EXITED
      }, function () {
        _this3.props.onExited(maybeNode);
      });
      return;
    }

    this.props.onExit(maybeNode);
    this.safeSetState({
      status: EXITING
    }, function () {
      _this3.props.onExiting(maybeNode);

      _this3.onTransitionEnd(timeouts.exit, function () {
        _this3.safeSetState({
          status: EXITED
        }, function () {
          _this3.props.onExited(maybeNode);
        });
      });
    });
  };

  _proto.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };

  _proto.safeSetState = function safeSetState(nextState, callback) {
    // This shouldn't be necessary, but there are weird race conditions with
    // setState callbacks and unmounting in testing, so always make sure that
    // we can cancel any pending setState callbacks after we unmount.
    callback = this.setNextCallback(callback);
    this.setState(nextState, callback);
  };

  _proto.setNextCallback = function setNextCallback(callback) {
    var _this4 = this;

    var active = true;

    this.nextCallback = function (event) {
      if (active) {
        active = false;
        _this4.nextCallback = null;
        callback(event);
      }
    };

    this.nextCallback.cancel = function () {
      active = false;
    };

    return this.nextCallback;
  };

  _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
    this.setNextCallback(handler);
    var node = this.props.nodeRef ? this.props.nodeRef.current : ReactDOM.findDOMNode(this);
    var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;

    if (!node || doesNotHaveTimeoutOrListener) {
      setTimeout(this.nextCallback, 0);
      return;
    }

    if (this.props.addEndListener) {
      var _ref3 = this.props.nodeRef ? [this.nextCallback] : [node, this.nextCallback],
          maybeNode = _ref3[0],
          maybeNextCallback = _ref3[1];

      this.props.addEndListener(maybeNode, maybeNextCallback);
    }

    if (timeout != null) {
      setTimeout(this.nextCallback, timeout);
    }
  };

  _proto.render = function render() {
    var status = this.state.status;

    if (status === UNMOUNTED) {
      return null;
    }

    var _this$props = this.props,
        children = _this$props.children,
        _in = _this$props.in,
        _mountOnEnter = _this$props.mountOnEnter,
        _unmountOnExit = _this$props.unmountOnExit,
        _appear = _this$props.appear,
        _enter = _this$props.enter,
        _exit = _this$props.exit,
        _timeout = _this$props.timeout,
        _addEndListener = _this$props.addEndListener,
        _onEnter = _this$props.onEnter,
        _onEntering = _this$props.onEntering,
        _onEntered = _this$props.onEntered,
        _onExit = _this$props.onExit,
        _onExiting = _this$props.onExiting,
        _onExited = _this$props.onExited,
        _nodeRef = _this$props.nodeRef,
        childProps = _objectWithoutPropertiesLoose$6(_this$props, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);

    return (
      /*#__PURE__*/
      // allows for nested Transitions
      React__default.createElement(TransitionGroupContext.Provider, {
        value: null
      }, typeof children === 'function' ? children(status, childProps) : React__default.cloneElement(React__default.Children.only(children), childProps))
    );
  };

  return Transition;
}(React__default.Component);

Transition.contextType = TransitionGroupContext;
Transition.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * A React reference to DOM element that need to transition:
   * https://stackoverflow.com/a/51127130/4671932
   *
   *   - When `nodeRef` prop is used, `node` is not passed to callback functions
   *      (e.g. `onEnter`) because user already has direct access to the node.
   *   - When changing `key` prop of `Transition` in a `TransitionGroup` a new
   *     `nodeRef` need to be provided to `Transition` with changed `key` prop
   *     (see
   *     [test/CSSTransition-test.js](https://github.com/reactjs/react-transition-group/blob/13435f897b3ab71f6e19d724f145596f5910581c/test/CSSTransition-test.js#L362-L437)).
   */
  nodeRef: propTypes.shape({
    current: typeof Element === 'undefined' ? propTypes.any : propTypes.instanceOf(Element)
  }),

  /**
   * A `function` child can be used instead of a React element. This function is
   * called with the current transition status (`'entering'`, `'entered'`,
   * `'exiting'`, `'exited'`), which can be used to apply context
   * specific props to a component.
   *
   * ```jsx
   * <Transition in={this.state.in} timeout={150}>
   *   {state => (
   *     <MyComponent className={`fade fade-${state}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: propTypes.oneOfType([propTypes.func.isRequired, propTypes.element.isRequired]).isRequired,

  /**
   * Show the component; triggers the enter or exit states
   */
  in: propTypes.bool,

  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: propTypes.bool,

  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: propTypes.bool,

  /**
   * By default the child component does not perform the enter transition when
   * it first mounts, regardless of the value of `in`. If you want this
   * behavior, set both `appear` and `in` to `true`.
   *
   * > **Note**: there are no special appear states like `appearing`/`appeared`, this prop
   * > only adds an additional enter transition. However, in the
   * > `<CSSTransition>` component that first enter transition does result in
   * > additional `.appear-*` classes, that way you can choose to style it
   * > differently.
   */
  appear: propTypes.bool,

  /**
   * Enable or disable enter transitions.
   */
  enter: propTypes.bool,

  /**
   * Enable or disable exit transitions.
   */
  exit: propTypes.bool,

  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided.
   *
   * You may specify a single timeout for all transitions:
   *
   * ```jsx
   * timeout={500}
   * ```
   *
   * or individually:
   *
   * ```jsx
   * timeout={{
   *  appear: 500,
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * - `appear` defaults to the value of `enter`
   * - `enter` defaults to `0`
   * - `exit` defaults to `0`
   *
   * @type {number | { enter?: number, exit?: number, appear?: number }}
   */
  timeout: function timeout(props) {
    var pt = timeoutsShape;
    if (!props.addEndListener) pt = pt.isRequired;

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return pt.apply(void 0, [props].concat(args));
  },

  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. Timeouts are still used as a fallback if provided.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: propTypes.func,

  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: propTypes.func,

  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: propTypes.func,

  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: propTypes.func,

  /**
   * Callback fired before the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: propTypes.func,

  /**
   * Callback fired after the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: propTypes.func,

  /**
   * Callback fired after the "exited" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: propTypes.func
} : {}; // Name the function so it is clearer in the documentation

function noop$1() {}

Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,
  onEnter: noop$1,
  onEntering: noop$1,
  onEntered: noop$1,
  onExit: noop$1,
  onExiting: noop$1,
  onExited: noop$1
};
Transition.UNMOUNTED = UNMOUNTED;
Transition.EXITED = EXITED;
Transition.ENTERING = ENTERING;
Transition.ENTERED = ENTERED;
Transition.EXITING = EXITING;

var _addClass = function addClass$1(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return addClass(node, c);
  });
};

var removeClass$1 = function removeClass$1(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return removeClass(node, c);
  });
};
/**
 * A transition component inspired by the excellent
 * [ng-animate](https://docs.angularjs.org/api/ngAnimate) library, you should
 * use it if you're using CSS transitions or animations. It's built upon the
 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
 * component, so it inherits all of its props.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` states of the transition. The first class is applied and then a
 * second `*-active` class in order to activate the CSS transition. After the
 * transition, matching `*-done` class names are applied to persist the
 * transition state.
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
 *         <div>
 *           {"I'll receive my-node-* classes"}
 *         </div>
 *       </CSSTransition>
 *       <button type="button" onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the `in` prop is set to `true`, the child component will first receive
 * the class `example-enter`, then the `example-enter-active` will be added in
 * the next tick. `CSSTransition` [forces a
 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * between before adding the `example-enter-active`. This is an important trick
 * because it allows us to transition between `example-enter` and
 * `example-enter-active` even though they were added immediately one after
 * another. Most notably, this is what makes it possible for us to animate
 * _appearance_.
 *
 * ```css
 * .my-node-enter {
 *   opacity: 0;
 * }
 * .my-node-enter-active {
 *   opacity: 1;
 *   transition: opacity 200ms;
 * }
 * .my-node-exit {
 *   opacity: 1;
 * }
 * .my-node-exit-active {
 *   opacity: 0;
 *   transition: opacity 200ms;
 * }
 * ```
 *
 * `*-active` classes represent which styles you want to animate **to**, so it's
 * important to add `transition` declaration only to them, otherwise transitions
 * might not behave as intended! This might not be obvious when the transitions
 * are symmetrical, i.e. when `*-enter-active` is the same as `*-exit`, like in
 * the example above (minus `transition`), but it becomes apparent in more
 * complex transitions.
 *
 * **Note**: If you're using the
 * [`appear`](http://reactcommunity.org/react-transition-group/transition#Transition-prop-appear)
 * prop, make sure to define styles for `.appear-*` classes as well.
 */


var CSSTransition = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose$8(CSSTransition, _React$Component);

  function CSSTransition() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.appliedClasses = {
      appear: {},
      enter: {},
      exit: {}
    };

    _this.onEnter = function (maybeNode, maybeAppearing) {
      var _this$resolveArgument = _this.resolveArguments(maybeNode, maybeAppearing),
          node = _this$resolveArgument[0],
          appearing = _this$resolveArgument[1];

      _this.removeClasses(node, 'exit');

      _this.addClass(node, appearing ? 'appear' : 'enter', 'base');

      if (_this.props.onEnter) {
        _this.props.onEnter(maybeNode, maybeAppearing);
      }
    };

    _this.onEntering = function (maybeNode, maybeAppearing) {
      var _this$resolveArgument2 = _this.resolveArguments(maybeNode, maybeAppearing),
          node = _this$resolveArgument2[0],
          appearing = _this$resolveArgument2[1];

      var type = appearing ? 'appear' : 'enter';

      _this.addClass(node, type, 'active');

      if (_this.props.onEntering) {
        _this.props.onEntering(maybeNode, maybeAppearing);
      }
    };

    _this.onEntered = function (maybeNode, maybeAppearing) {
      var _this$resolveArgument3 = _this.resolveArguments(maybeNode, maybeAppearing),
          node = _this$resolveArgument3[0],
          appearing = _this$resolveArgument3[1];

      var type = appearing ? 'appear' : 'enter';

      _this.removeClasses(node, type);

      _this.addClass(node, type, 'done');

      if (_this.props.onEntered) {
        _this.props.onEntered(maybeNode, maybeAppearing);
      }
    };

    _this.onExit = function (maybeNode) {
      var _this$resolveArgument4 = _this.resolveArguments(maybeNode),
          node = _this$resolveArgument4[0];

      _this.removeClasses(node, 'appear');

      _this.removeClasses(node, 'enter');

      _this.addClass(node, 'exit', 'base');

      if (_this.props.onExit) {
        _this.props.onExit(maybeNode);
      }
    };

    _this.onExiting = function (maybeNode) {
      var _this$resolveArgument5 = _this.resolveArguments(maybeNode),
          node = _this$resolveArgument5[0];

      _this.addClass(node, 'exit', 'active');

      if (_this.props.onExiting) {
        _this.props.onExiting(maybeNode);
      }
    };

    _this.onExited = function (maybeNode) {
      var _this$resolveArgument6 = _this.resolveArguments(maybeNode),
          node = _this$resolveArgument6[0];

      _this.removeClasses(node, 'exit');

      _this.addClass(node, 'exit', 'done');

      if (_this.props.onExited) {
        _this.props.onExited(maybeNode);
      }
    };

    _this.resolveArguments = function (maybeNode, maybeAppearing) {
      return _this.props.nodeRef ? [_this.props.nodeRef.current, maybeNode] // here `maybeNode` is actually `appearing`
      : [maybeNode, maybeAppearing];
    };

    _this.getClassNames = function (type) {
      var classNames = _this.props.classNames;
      var isStringClassNames = typeof classNames === 'string';
      var prefix = isStringClassNames && classNames ? classNames + "-" : '';
      var baseClassName = isStringClassNames ? "" + prefix + type : classNames[type];
      var activeClassName = isStringClassNames ? baseClassName + "-active" : classNames[type + "Active"];
      var doneClassName = isStringClassNames ? baseClassName + "-done" : classNames[type + "Done"];
      return {
        baseClassName: baseClassName,
        activeClassName: activeClassName,
        doneClassName: doneClassName
      };
    };

    return _this;
  }

  var _proto = CSSTransition.prototype;

  _proto.addClass = function addClass(node, type, phase) {
    var className = this.getClassNames(type)[phase + "ClassName"];

    var _this$getClassNames = this.getClassNames('enter'),
        doneClassName = _this$getClassNames.doneClassName;

    if (type === 'appear' && phase === 'done' && doneClassName) {
      className += " " + doneClassName;
    } // This is for to force a repaint,
    // which is necessary in order to transition styles when adding a class name.


    if (phase === 'active') {
      /* eslint-disable no-unused-expressions */
      node && node.scrollTop;
    }

    if (className) {
      this.appliedClasses[type][phase] = className;

      _addClass(node, className);
    }
  };

  _proto.removeClasses = function removeClasses(node, type) {
    var _this$appliedClasses$ = this.appliedClasses[type],
        baseClassName = _this$appliedClasses$.base,
        activeClassName = _this$appliedClasses$.active,
        doneClassName = _this$appliedClasses$.done;
    this.appliedClasses[type] = {};

    if (baseClassName) {
      removeClass$1(node, baseClassName);
    }

    if (activeClassName) {
      removeClass$1(node, activeClassName);
    }

    if (doneClassName) {
      removeClass$1(node, doneClassName);
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        _ = _this$props.classNames,
        props = _objectWithoutPropertiesLoose$6(_this$props, ["classNames"]);

    return /*#__PURE__*/React__default.createElement(Transition, _extends$M({}, props, {
      onEnter: this.onEnter,
      onEntered: this.onEntered,
      onEntering: this.onEntering,
      onExit: this.onExit,
      onExiting: this.onExiting,
      onExited: this.onExited
    }));
  };

  return CSSTransition;
}(React__default.Component);

CSSTransition.defaultProps = {
  classNames: ''
};
CSSTransition.propTypes = process.env.NODE_ENV !== "production" ? _extends$M({}, Transition.propTypes, {
  /**
   * The animation classNames applied to the component as it appears, enters,
   * exits or has finished the transition. A single name can be provided, which
   * will be suffixed for each stage, e.g. `classNames="fade"` applies:
   *
   * - `fade-appear`, `fade-appear-active`, `fade-appear-done`
   * - `fade-enter`, `fade-enter-active`, `fade-enter-done`
   * - `fade-exit`, `fade-exit-active`, `fade-exit-done`
   *
   * A few details to note about how these classes are applied:
   *
   * 1. They are _joined_ with the ones that are already defined on the child
   *    component, so if you want to add some base styles, you can use
   *    `className` without worrying that it will be overridden.
   *
   * 2. If the transition component mounts with `in={false}`, no classes are
   *    applied yet. You might be expecting `*-exit-done`, but if you think
   *    about it, a component cannot finish exiting if it hasn't entered yet.
   *
   * 2. `fade-appear-done` and `fade-enter-done` will _both_ be applied. This
   *    allows you to define different behavior for when appearing is done and
   *    when regular entering is done, using selectors like
   *    `.fade-enter-done:not(.fade-appear-done)`. For example, you could apply
   *    an epic entrance animation when element first appears in the DOM using
   *    [Animate.css](https://daneden.github.io/animate.css/). Otherwise you can
   *    simply use `fade-enter-done` for defining both cases.
   *
   * Each individual classNames can also be specified independently like:
   *
   * ```js
   * classNames={{
   *  appear: 'my-appear',
   *  appearActive: 'my-active-appear',
   *  appearDone: 'my-done-appear',
   *  enter: 'my-enter',
   *  enterActive: 'my-active-enter',
   *  enterDone: 'my-done-enter',
   *  exit: 'my-exit',
   *  exitActive: 'my-active-exit',
   *  exitDone: 'my-done-exit',
   * }}
   * ```
   *
   * If you want to set these classes using CSS Modules:
   *
   * ```js
   * import styles from './styles.css';
   * ```
   *
   * you might want to use camelCase in your CSS file, that way could simply
   * spread them instead of listing them one by one:
   *
   * ```js
   * classNames={{ ...styles }}
   * ```
   *
   * @type {string | {
   *  appear?: string,
   *  appearActive?: string,
   *  appearDone?: string,
   *  enter?: string,
   *  enterActive?: string,
   *  enterDone?: string,
   *  exit?: string,
   *  exitActive?: string,
   *  exitDone?: string,
   * }}
   */
  classNames: classNamesShape,

  /**
   * A `<Transition>` callback fired immediately after the 'enter' or 'appear' class is
   * applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEnter: propTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'enter-active' or
   * 'appear-active' class is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: propTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'enter' or
   * 'appear' classes are **removed** and the `done` class is added to the DOM node.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntered: propTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit' class is
   * applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */
  onExit: propTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit-active' is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */
  onExiting: propTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit' classes
   * are **removed** and the `exit-done` class is added to the DOM node.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */
  onExited: propTypes.func
}) : {};

var css_248z$2 = "@keyframes spinner {\n  100% {\n    transform: rotate(360deg); } }\n\n.overlay-spinner:after {\n  content: '';\n  border: 3px solid #cfd5dd;\n  border-left-color: #445076;\n  height: 40px;\n  width: 40px;\n  display: block;\n  margin: 0 auto 20px;\n  border-radius: 20px;\n  animation: spinner 2s linear infinite; }\n\n.overlay-spinner:after {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  margin: -20px 0 0 -20px; }\n\n@keyframes loadingDone {\n  0% {\n    opacity: 1;\n    visibility: visible; }\n  100% {\n    opacity: 0;\n    visibility: hidden; } }\n\n.overlay-spinner {\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 23;\n  background-color: #f3f4f6; }\n\n.overlay-spinner-exit-active {\n  animation: 300ms 500ms ease-in-out forwards loadingDone; }\n";
styleInject(css_248z$2);

// It must be greater than animation duration.
const defaultCssTransitionTimeout = 1000;
var OverlaySpinnerType;
(function (OverlaySpinnerType) {
    OverlaySpinnerType["Pale"] = "pale";
    OverlaySpinnerType["Alt"] = "alt";
    OverlaySpinnerType["White"] = "white";
})(OverlaySpinnerType || (OverlaySpinnerType = {}));
const OverlaySpinner = ({ isLoading, timeout, backgroundType }) => {
    const backgroundClassName = classnames('loader-overlay loader-overlay-show', {
        [`${backgroundType}`]: !!backgroundType,
    });
    return (React__default.createElement(CSSTransition, { in: isLoading, classNames: "overlay-spinner", timeout: timeout || defaultCssTransitionTimeout, unmountOnExit: true },
        React__default.createElement("div", { className: backgroundClassName })));
};

/**
 * Wraps the passed component with the loading spinner
 */
function withLoading(Wrapped, isMountedOnLoadingParam, spinnerType) {
    const wrappedWithLoading = (_a) => {
        var { isLoading } = _a, restProps = __rest(_a, ["isLoading"]);
        return (React__default.createElement(React__default.Fragment, null,
            (!isLoading || isMountedOnLoadingParam) && React__default.createElement(Wrapped, Object.assign({}, restProps)),
            React__default.createElement(OverlaySpinner, { isLoading: isLoading, backgroundType: spinnerType })));
    };
    return wrappedWithLoading;
}

/*! @license DOMPurify | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/2.2.2/LICENSE */

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var hasOwnProperty$3 = Object.hasOwnProperty,
    setPrototypeOf = Object.setPrototypeOf,
    isFrozen = Object.isFrozen;
var freeze = Object.freeze,
    seal = Object.seal,
    create = Object.create; // eslint-disable-line import/no-mutable-exports

var _ref$I = typeof Reflect !== 'undefined' && Reflect,
    apply = _ref$I.apply,
    construct = _ref$I.construct;

if (!apply) {
  apply = function apply(fun, thisValue, args) {
    return fun.apply(thisValue, args);
  };
}

if (!freeze) {
  freeze = function freeze(x) {
    return x;
  };
}

if (!seal) {
  seal = function seal(x) {
    return x;
  };
}

if (!construct) {
  construct = function construct(Func, args) {
    return new (Function.prototype.bind.apply(Func, [null].concat(_toConsumableArray(args))))();
  };
}

var arrayForEach = unapply(Array.prototype.forEach);
var arrayPop = unapply(Array.prototype.pop);
var arrayPush = unapply(Array.prototype.push);

var stringToLowerCase = unapply(String.prototype.toLowerCase);
var stringMatch = unapply(String.prototype.match);
var stringReplace = unapply(String.prototype.replace);
var stringIndexOf = unapply(String.prototype.indexOf);
var stringTrim = unapply(String.prototype.trim);

var regExpTest = unapply(RegExp.prototype.test);

var typeErrorCreate = unconstruct(TypeError);

function unapply(func) {
  return function (thisArg) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return apply(func, thisArg, args);
  };
}

function unconstruct(func) {
  return function () {
    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return construct(func, args);
  };
}

/* Add properties to a lookup table */
function addToSet(set, array) {
  if (setPrototypeOf) {
    // Make 'in' and truthy checks like Boolean(set.constructor)
    // independent of any properties defined on Object.prototype.
    // Prevent prototype setters from intercepting set as a this value.
    setPrototypeOf(set, null);
  }

  var l = array.length;
  while (l--) {
    var element = array[l];
    if (typeof element === 'string') {
      var lcElement = stringToLowerCase(element);
      if (lcElement !== element) {
        // Config presets (e.g. tags.js, attrs.js) are immutable.
        if (!isFrozen(array)) {
          array[l] = lcElement;
        }

        element = lcElement;
      }
    }

    set[element] = true;
  }

  return set;
}

/* Shallow clone an object */
function clone(object) {
  var newObject = create(null);

  var property = void 0;
  for (property in object) {
    if (apply(hasOwnProperty$3, object, [property])) {
      newObject[property] = object[property];
    }
  }

  return newObject;
}

var html = freeze(['a', 'abbr', 'acronym', 'address', 'area', 'article', 'aside', 'audio', 'b', 'bdi', 'bdo', 'big', 'blink', 'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'center', 'cite', 'code', 'col', 'colgroup', 'content', 'data', 'datalist', 'dd', 'decorator', 'del', 'details', 'dfn', 'dialog', 'dir', 'div', 'dl', 'dt', 'element', 'em', 'fieldset', 'figcaption', 'figure', 'font', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'i', 'img', 'input', 'ins', 'kbd', 'label', 'legend', 'li', 'main', 'map', 'mark', 'marquee', 'menu', 'menuitem', 'meter', 'nav', 'nobr', 'ol', 'optgroup', 'option', 'output', 'p', 'picture', 'pre', 'progress', 'q', 'rp', 'rt', 'ruby', 's', 'samp', 'section', 'select', 'shadow', 'small', 'source', 'spacer', 'span', 'strike', 'strong', 'style', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'time', 'tr', 'track', 'tt', 'u', 'ul', 'var', 'video', 'wbr']);

// SVG
var svg = freeze(['svg', 'a', 'altglyph', 'altglyphdef', 'altglyphitem', 'animatecolor', 'animatemotion', 'animatetransform', 'audio', 'canvas', 'circle', 'clippath', 'defs', 'desc', 'ellipse', 'filter', 'font', 'g', 'glyph', 'glyphref', 'hkern', 'image', 'line', 'lineargradient', 'marker', 'mask', 'metadata', 'mpath', 'path', 'pattern', 'polygon', 'polyline', 'radialgradient', 'rect', 'stop', 'style', 'switch', 'symbol', 'text', 'textpath', 'title', 'tref', 'tspan', 'video', 'view', 'vkern']);

var svgFilters = freeze(['feBlend', 'feColorMatrix', 'feComponentTransfer', 'feComposite', 'feConvolveMatrix', 'feDiffuseLighting', 'feDisplacementMap', 'feDistantLight', 'feFlood', 'feFuncA', 'feFuncB', 'feFuncG', 'feFuncR', 'feGaussianBlur', 'feMerge', 'feMergeNode', 'feMorphology', 'feOffset', 'fePointLight', 'feSpecularLighting', 'feSpotLight', 'feTile', 'feTurbulence']);

var mathMl = freeze(['math', 'menclose', 'merror', 'mfenced', 'mfrac', 'mglyph', 'mi', 'mlabeledtr', 'mmultiscripts', 'mn', 'mo', 'mover', 'mpadded', 'mphantom', 'mroot', 'mrow', 'ms', 'mspace', 'msqrt', 'mstyle', 'msub', 'msup', 'msubsup', 'mtable', 'mtd', 'mtext', 'mtr', 'munder', 'munderover']);

var text = freeze(['#text']);

var html$1 = freeze(['accept', 'action', 'align', 'alt', 'autocapitalize', 'autocomplete', 'autopictureinpicture', 'autoplay', 'background', 'bgcolor', 'border', 'capture', 'cellpadding', 'cellspacing', 'checked', 'cite', 'class', 'clear', 'color', 'cols', 'colspan', 'controls', 'controlslist', 'coords', 'crossorigin', 'datetime', 'decoding', 'default', 'dir', 'disabled', 'disablepictureinpicture', 'disableremoteplayback', 'download', 'draggable', 'enctype', 'enterkeyhint', 'face', 'for', 'headers', 'height', 'hidden', 'high', 'href', 'hreflang', 'id', 'inputmode', 'integrity', 'ismap', 'kind', 'label', 'lang', 'list', 'loading', 'loop', 'low', 'max', 'maxlength', 'media', 'method', 'min', 'minlength', 'multiple', 'muted', 'name', 'noshade', 'novalidate', 'nowrap', 'open', 'optimum', 'pattern', 'placeholder', 'playsinline', 'poster', 'preload', 'pubdate', 'radiogroup', 'readonly', 'rel', 'required', 'rev', 'reversed', 'role', 'rows', 'rowspan', 'spellcheck', 'scope', 'selected', 'shape', 'size', 'sizes', 'span', 'srclang', 'start', 'src', 'srcset', 'step', 'style', 'summary', 'tabindex', 'title', 'translate', 'type', 'usemap', 'valign', 'value', 'width', 'xmlns']);

var svg$1 = freeze(['accent-height', 'accumulate', 'additive', 'alignment-baseline', 'ascent', 'attributename', 'attributetype', 'azimuth', 'basefrequency', 'baseline-shift', 'begin', 'bias', 'by', 'class', 'clip', 'clippathunits', 'clip-path', 'clip-rule', 'color', 'color-interpolation', 'color-interpolation-filters', 'color-profile', 'color-rendering', 'cx', 'cy', 'd', 'dx', 'dy', 'diffuseconstant', 'direction', 'display', 'divisor', 'dur', 'edgemode', 'elevation', 'end', 'fill', 'fill-opacity', 'fill-rule', 'filter', 'filterunits', 'flood-color', 'flood-opacity', 'font-family', 'font-size', 'font-size-adjust', 'font-stretch', 'font-style', 'font-variant', 'font-weight', 'fx', 'fy', 'g1', 'g2', 'glyph-name', 'glyphref', 'gradientunits', 'gradienttransform', 'height', 'href', 'id', 'image-rendering', 'in', 'in2', 'k', 'k1', 'k2', 'k3', 'k4', 'kerning', 'keypoints', 'keysplines', 'keytimes', 'lang', 'lengthadjust', 'letter-spacing', 'kernelmatrix', 'kernelunitlength', 'lighting-color', 'local', 'marker-end', 'marker-mid', 'marker-start', 'markerheight', 'markerunits', 'markerwidth', 'maskcontentunits', 'maskunits', 'max', 'mask', 'media', 'method', 'mode', 'min', 'name', 'numoctaves', 'offset', 'operator', 'opacity', 'order', 'orient', 'orientation', 'origin', 'overflow', 'paint-order', 'path', 'pathlength', 'patterncontentunits', 'patterntransform', 'patternunits', 'points', 'preservealpha', 'preserveaspectratio', 'primitiveunits', 'r', 'rx', 'ry', 'radius', 'refx', 'refy', 'repeatcount', 'repeatdur', 'restart', 'result', 'rotate', 'scale', 'seed', 'shape-rendering', 'specularconstant', 'specularexponent', 'spreadmethod', 'startoffset', 'stddeviation', 'stitchtiles', 'stop-color', 'stop-opacity', 'stroke-dasharray', 'stroke-dashoffset', 'stroke-linecap', 'stroke-linejoin', 'stroke-miterlimit', 'stroke-opacity', 'stroke', 'stroke-width', 'style', 'surfacescale', 'systemlanguage', 'tabindex', 'targetx', 'targety', 'transform', 'text-anchor', 'text-decoration', 'text-rendering', 'textlength', 'type', 'u1', 'u2', 'unicode', 'values', 'viewbox', 'visibility', 'version', 'vert-adv-y', 'vert-origin-x', 'vert-origin-y', 'width', 'word-spacing', 'wrap', 'writing-mode', 'xchannelselector', 'ychannelselector', 'x', 'x1', 'x2', 'xmlns', 'y', 'y1', 'y2', 'z', 'zoomandpan']);

var mathMl$1 = freeze(['accent', 'accentunder', 'align', 'bevelled', 'close', 'columnsalign', 'columnlines', 'columnspan', 'denomalign', 'depth', 'dir', 'display', 'displaystyle', 'encoding', 'fence', 'frame', 'height', 'href', 'id', 'largeop', 'length', 'linethickness', 'lspace', 'lquote', 'mathbackground', 'mathcolor', 'mathsize', 'mathvariant', 'maxsize', 'minsize', 'movablelimits', 'notation', 'numalign', 'open', 'rowalign', 'rowlines', 'rowspacing', 'rowspan', 'rspace', 'rquote', 'scriptlevel', 'scriptminsize', 'scriptsizemultiplier', 'selection', 'separator', 'separators', 'stretchy', 'subscriptshift', 'supscriptshift', 'symmetric', 'voffset', 'width', 'xmlns']);

var xml = freeze(['xlink:href', 'xml:id', 'xlink:title', 'xml:space', 'xmlns:xlink']);

// eslint-disable-next-line unicorn/better-regex
var MUSTACHE_EXPR = seal(/\{\{[\s\S]*|[\s\S]*\}\}/gm); // Specify template detection regex for SAFE_FOR_TEMPLATES mode
var ERB_EXPR = seal(/<%[\s\S]*|[\s\S]*%>/gm);
var DATA_ATTR = seal(/^data-[\-\w.\u00B7-\uFFFF]/); // eslint-disable-line no-useless-escape
var ARIA_ATTR = seal(/^aria-[\-\w]+$/); // eslint-disable-line no-useless-escape
var IS_ALLOWED_URI = seal(/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i // eslint-disable-line no-useless-escape
);
var IS_SCRIPT_OR_DATA = seal(/^(?:\w+script|data):/i);
var ATTR_WHITESPACE = seal(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g // eslint-disable-line no-control-regex
);

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _toConsumableArray$1(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var getGlobal = function getGlobal() {
  return typeof window === 'undefined' ? null : window;
};

/**
 * Creates a no-op policy for internal use only.
 * Don't export this function outside this module!
 * @param {?TrustedTypePolicyFactory} trustedTypes The policy factory.
 * @param {Document} document The document object (to determine policy name suffix)
 * @return {?TrustedTypePolicy} The policy created (or null, if Trusted Types
 * are not supported).
 */
var _createTrustedTypesPolicy = function _createTrustedTypesPolicy(trustedTypes, document) {
  if ((typeof trustedTypes === 'undefined' ? 'undefined' : _typeof(trustedTypes)) !== 'object' || typeof trustedTypes.createPolicy !== 'function') {
    return null;
  }

  // Allow the callers to control the unique policy name
  // by adding a data-tt-policy-suffix to the script element with the DOMPurify.
  // Policy creation with duplicate names throws in Trusted Types.
  var suffix = null;
  var ATTR_NAME = 'data-tt-policy-suffix';
  if (document.currentScript && document.currentScript.hasAttribute(ATTR_NAME)) {
    suffix = document.currentScript.getAttribute(ATTR_NAME);
  }

  var policyName = 'dompurify' + (suffix ? '#' + suffix : '');

  try {
    return trustedTypes.createPolicy(policyName, {
      createHTML: function createHTML(html$$1) {
        return html$$1;
      }
    });
  } catch (_) {
    // Policy creation failed (most likely another DOMPurify script has
    // already run). Skip creating the policy, as this will only cause errors
    // if TT are enforced.
    console.warn('TrustedTypes policy ' + policyName + ' could not be created.');
    return null;
  }
};

function createDOMPurify() {
  var window = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getGlobal();

  var DOMPurify = function DOMPurify(root) {
    return createDOMPurify(root);
  };

  /**
   * Version label, exposed for easier checks
   * if DOMPurify is up to date or not
   */
  DOMPurify.version = '2.2.4';

  /**
   * Array of elements that DOMPurify removed during sanitation.
   * Empty if nothing was removed.
   */
  DOMPurify.removed = [];

  if (!window || !window.document || window.document.nodeType !== 9) {
    // Not running in a browser, provide a factory function
    // so that you can pass your own Window
    DOMPurify.isSupported = false;

    return DOMPurify;
  }

  var originalDocument = window.document;

  var document = window.document;
  var DocumentFragment = window.DocumentFragment,
      HTMLTemplateElement = window.HTMLTemplateElement,
      Node = window.Node,
      NodeFilter = window.NodeFilter,
      _window$NamedNodeMap = window.NamedNodeMap,
      NamedNodeMap = _window$NamedNodeMap === undefined ? window.NamedNodeMap || window.MozNamedAttrMap : _window$NamedNodeMap,
      Text = window.Text,
      Comment = window.Comment,
      DOMParser = window.DOMParser,
      trustedTypes = window.trustedTypes;

  // As per issue #47, the web-components registry is inherited by a
  // new document created via createHTMLDocument. As per the spec
  // (http://w3c.github.io/webcomponents/spec/custom/#creating-and-passing-registries)
  // a new empty registry is used when creating a template contents owner
  // document, so we use that as our parent document to ensure nothing
  // is inherited.

  if (typeof HTMLTemplateElement === 'function') {
    var template = document.createElement('template');
    if (template.content && template.content.ownerDocument) {
      document = template.content.ownerDocument;
    }
  }

  var trustedTypesPolicy = _createTrustedTypesPolicy(trustedTypes, originalDocument);
  var emptyHTML = trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML('') : '';

  var _document = document,
      implementation = _document.implementation,
      createNodeIterator = _document.createNodeIterator,
      getElementsByTagName = _document.getElementsByTagName,
      createDocumentFragment = _document.createDocumentFragment;
  var importNode = originalDocument.importNode;


  var documentMode = {};
  try {
    documentMode = clone(document).documentMode ? document.documentMode : {};
  } catch (_) {}

  var hooks = {};

  /**
   * Expose whether this browser supports running the full DOMPurify.
   */
  DOMPurify.isSupported = implementation && typeof implementation.createHTMLDocument !== 'undefined' && documentMode !== 9;

  var MUSTACHE_EXPR$$1 = MUSTACHE_EXPR,
      ERB_EXPR$$1 = ERB_EXPR,
      DATA_ATTR$$1 = DATA_ATTR,
      ARIA_ATTR$$1 = ARIA_ATTR,
      IS_SCRIPT_OR_DATA$$1 = IS_SCRIPT_OR_DATA,
      ATTR_WHITESPACE$$1 = ATTR_WHITESPACE;
  var IS_ALLOWED_URI$$1 = IS_ALLOWED_URI;

  /**
   * We consider the elements and attributes below to be safe. Ideally
   * don't add any new ones but feel free to remove unwanted ones.
   */

  /* allowed element names */

  var ALLOWED_TAGS = null;
  var DEFAULT_ALLOWED_TAGS = addToSet({}, [].concat(_toConsumableArray$1(html), _toConsumableArray$1(svg), _toConsumableArray$1(svgFilters), _toConsumableArray$1(mathMl), _toConsumableArray$1(text)));

  /* Allowed attribute names */
  var ALLOWED_ATTR = null;
  var DEFAULT_ALLOWED_ATTR = addToSet({}, [].concat(_toConsumableArray$1(html$1), _toConsumableArray$1(svg$1), _toConsumableArray$1(mathMl$1), _toConsumableArray$1(xml)));

  /* Explicitly forbidden tags (overrides ALLOWED_TAGS/ADD_TAGS) */
  var FORBID_TAGS = null;

  /* Explicitly forbidden attributes (overrides ALLOWED_ATTR/ADD_ATTR) */
  var FORBID_ATTR = null;

  /* Decide if ARIA attributes are okay */
  var ALLOW_ARIA_ATTR = true;

  /* Decide if custom data attributes are okay */
  var ALLOW_DATA_ATTR = true;

  /* Decide if unknown protocols are okay */
  var ALLOW_UNKNOWN_PROTOCOLS = false;

  /* Output should be safe for common template engines.
   * This means, DOMPurify removes data attributes, mustaches and ERB
   */
  var SAFE_FOR_TEMPLATES = false;

  /* Decide if document with <html>... should be returned */
  var WHOLE_DOCUMENT = false;

  /* Track whether config is already set on this instance of DOMPurify. */
  var SET_CONFIG = false;

  /* Decide if all elements (e.g. style, script) must be children of
   * document.body. By default, browsers might move them to document.head */
  var FORCE_BODY = false;

  /* Decide if a DOM `HTMLBodyElement` should be returned, instead of a html
   * string (or a TrustedHTML object if Trusted Types are supported).
   * If `WHOLE_DOCUMENT` is enabled a `HTMLHtmlElement` will be returned instead
   */
  var RETURN_DOM = false;

  /* Decide if a DOM `DocumentFragment` should be returned, instead of a html
   * string  (or a TrustedHTML object if Trusted Types are supported) */
  var RETURN_DOM_FRAGMENT = false;

  /* If `RETURN_DOM` or `RETURN_DOM_FRAGMENT` is enabled, decide if the returned DOM
   * `Node` is imported into the current `Document`. If this flag is not enabled the
   * `Node` will belong (its ownerDocument) to a fresh `HTMLDocument`, created by
   * DOMPurify.
   *
   * This defaults to `true` starting DOMPurify 2.2.0. Note that setting it to `false`
   * might cause XSS from attacks hidden in closed shadowroots in case the browser
   * supports Declarative Shadow: DOM https://web.dev/declarative-shadow-dom/
   */
  var RETURN_DOM_IMPORT = true;

  /* Try to return a Trusted Type object instead of a string, return a string in
   * case Trusted Types are not supported  */
  var RETURN_TRUSTED_TYPE = false;

  /* Output should be free from DOM clobbering attacks? */
  var SANITIZE_DOM = true;

  /* Keep element content when removing element? */
  var KEEP_CONTENT = true;

  /* If a `Node` is passed to sanitize(), then performs sanitization in-place instead
   * of importing it into a new Document and returning a sanitized copy */
  var IN_PLACE = false;

  /* Allow usage of profiles like html, svg and mathMl */
  var USE_PROFILES = {};

  /* Tags to ignore content of when KEEP_CONTENT is true */
  var FORBID_CONTENTS = addToSet({}, ['annotation-xml', 'audio', 'colgroup', 'desc', 'foreignobject', 'head', 'iframe', 'math', 'mi', 'mn', 'mo', 'ms', 'mtext', 'noembed', 'noframes', 'plaintext', 'script', 'style', 'svg', 'template', 'thead', 'title', 'video', 'xmp']);

  /* Tags that are safe for data: URIs */
  var DATA_URI_TAGS = null;
  var DEFAULT_DATA_URI_TAGS = addToSet({}, ['audio', 'video', 'img', 'source', 'image', 'track']);

  /* Attributes safe for values like "javascript:" */
  var URI_SAFE_ATTRIBUTES = null;
  var DEFAULT_URI_SAFE_ATTRIBUTES = addToSet({}, ['alt', 'class', 'for', 'id', 'label', 'name', 'pattern', 'placeholder', 'summary', 'title', 'value', 'style', 'xmlns']);

  /* Keep a reference to config to pass to hooks */
  var CONFIG = null;

  /* Ideally, do not touch anything below this line */
  /* ______________________________________________ */

  var formElement = document.createElement('form');

  /**
   * _parseConfig
   *
   * @param  {Object} cfg optional config literal
   */
  // eslint-disable-next-line complexity
  var _parseConfig = function _parseConfig(cfg) {
    if (CONFIG && CONFIG === cfg) {
      return;
    }

    /* Shield configuration object from tampering */
    if (!cfg || (typeof cfg === 'undefined' ? 'undefined' : _typeof(cfg)) !== 'object') {
      cfg = {};
    }

    /* Shield configuration object from prototype pollution */
    cfg = clone(cfg);

    /* Set configuration parameters */
    ALLOWED_TAGS = 'ALLOWED_TAGS' in cfg ? addToSet({}, cfg.ALLOWED_TAGS) : DEFAULT_ALLOWED_TAGS;
    ALLOWED_ATTR = 'ALLOWED_ATTR' in cfg ? addToSet({}, cfg.ALLOWED_ATTR) : DEFAULT_ALLOWED_ATTR;
    URI_SAFE_ATTRIBUTES = 'ADD_URI_SAFE_ATTR' in cfg ? addToSet(clone(DEFAULT_URI_SAFE_ATTRIBUTES), cfg.ADD_URI_SAFE_ATTR) : DEFAULT_URI_SAFE_ATTRIBUTES;
    DATA_URI_TAGS = 'ADD_DATA_URI_TAGS' in cfg ? addToSet(clone(DEFAULT_DATA_URI_TAGS), cfg.ADD_DATA_URI_TAGS) : DEFAULT_DATA_URI_TAGS;
    FORBID_TAGS = 'FORBID_TAGS' in cfg ? addToSet({}, cfg.FORBID_TAGS) : {};
    FORBID_ATTR = 'FORBID_ATTR' in cfg ? addToSet({}, cfg.FORBID_ATTR) : {};
    USE_PROFILES = 'USE_PROFILES' in cfg ? cfg.USE_PROFILES : false;
    ALLOW_ARIA_ATTR = cfg.ALLOW_ARIA_ATTR !== false; // Default true
    ALLOW_DATA_ATTR = cfg.ALLOW_DATA_ATTR !== false; // Default true
    ALLOW_UNKNOWN_PROTOCOLS = cfg.ALLOW_UNKNOWN_PROTOCOLS || false; // Default false
    SAFE_FOR_TEMPLATES = cfg.SAFE_FOR_TEMPLATES || false; // Default false
    WHOLE_DOCUMENT = cfg.WHOLE_DOCUMENT || false; // Default false
    RETURN_DOM = cfg.RETURN_DOM || false; // Default false
    RETURN_DOM_FRAGMENT = cfg.RETURN_DOM_FRAGMENT || false; // Default false
    RETURN_DOM_IMPORT = cfg.RETURN_DOM_IMPORT !== false; // Default true
    RETURN_TRUSTED_TYPE = cfg.RETURN_TRUSTED_TYPE || false; // Default false
    FORCE_BODY = cfg.FORCE_BODY || false; // Default false
    SANITIZE_DOM = cfg.SANITIZE_DOM !== false; // Default true
    KEEP_CONTENT = cfg.KEEP_CONTENT !== false; // Default true
    IN_PLACE = cfg.IN_PLACE || false; // Default false
    IS_ALLOWED_URI$$1 = cfg.ALLOWED_URI_REGEXP || IS_ALLOWED_URI$$1;
    if (SAFE_FOR_TEMPLATES) {
      ALLOW_DATA_ATTR = false;
    }

    if (RETURN_DOM_FRAGMENT) {
      RETURN_DOM = true;
    }

    /* Parse profile info */
    if (USE_PROFILES) {
      ALLOWED_TAGS = addToSet({}, [].concat(_toConsumableArray$1(text)));
      ALLOWED_ATTR = [];
      if (USE_PROFILES.html === true) {
        addToSet(ALLOWED_TAGS, html);
        addToSet(ALLOWED_ATTR, html$1);
      }

      if (USE_PROFILES.svg === true) {
        addToSet(ALLOWED_TAGS, svg);
        addToSet(ALLOWED_ATTR, svg$1);
        addToSet(ALLOWED_ATTR, xml);
      }

      if (USE_PROFILES.svgFilters === true) {
        addToSet(ALLOWED_TAGS, svgFilters);
        addToSet(ALLOWED_ATTR, svg$1);
        addToSet(ALLOWED_ATTR, xml);
      }

      if (USE_PROFILES.mathMl === true) {
        addToSet(ALLOWED_TAGS, mathMl);
        addToSet(ALLOWED_ATTR, mathMl$1);
        addToSet(ALLOWED_ATTR, xml);
      }
    }

    /* Merge configuration parameters */
    if (cfg.ADD_TAGS) {
      if (ALLOWED_TAGS === DEFAULT_ALLOWED_TAGS) {
        ALLOWED_TAGS = clone(ALLOWED_TAGS);
      }

      addToSet(ALLOWED_TAGS, cfg.ADD_TAGS);
    }

    if (cfg.ADD_ATTR) {
      if (ALLOWED_ATTR === DEFAULT_ALLOWED_ATTR) {
        ALLOWED_ATTR = clone(ALLOWED_ATTR);
      }

      addToSet(ALLOWED_ATTR, cfg.ADD_ATTR);
    }

    if (cfg.ADD_URI_SAFE_ATTR) {
      addToSet(URI_SAFE_ATTRIBUTES, cfg.ADD_URI_SAFE_ATTR);
    }

    /* Add #text in case KEEP_CONTENT is set to true */
    if (KEEP_CONTENT) {
      ALLOWED_TAGS['#text'] = true;
    }

    /* Add html, head and body to ALLOWED_TAGS in case WHOLE_DOCUMENT is true */
    if (WHOLE_DOCUMENT) {
      addToSet(ALLOWED_TAGS, ['html', 'head', 'body']);
    }

    /* Add tbody to ALLOWED_TAGS in case tables are permitted, see #286, #365 */
    if (ALLOWED_TAGS.table) {
      addToSet(ALLOWED_TAGS, ['tbody']);
      delete FORBID_TAGS.tbody;
    }

    // Prevent further manipulation of configuration.
    // Not available in IE8, Safari 5, etc.
    if (freeze) {
      freeze(cfg);
    }

    CONFIG = cfg;
  };

  /**
   * _forceRemove
   *
   * @param  {Node} node a DOM node
   */
  var _forceRemove = function _forceRemove(node) {
    arrayPush(DOMPurify.removed, { element: node });
    try {
      node.parentNode.removeChild(node);
    } catch (_) {
      try {
        node.outerHTML = emptyHTML;
      } catch (_) {
        node.remove();
      }
    }
  };

  /**
   * _removeAttribute
   *
   * @param  {String} name an Attribute name
   * @param  {Node} node a DOM node
   */
  var _removeAttribute = function _removeAttribute(name, node) {
    try {
      arrayPush(DOMPurify.removed, {
        attribute: node.getAttributeNode(name),
        from: node
      });
    } catch (_) {
      arrayPush(DOMPurify.removed, {
        attribute: null,
        from: node
      });
    }

    node.removeAttribute(name);
  };

  /**
   * _initDocument
   *
   * @param  {String} dirty a string of dirty markup
   * @return {Document} a DOM, filled with the dirty markup
   */
  var _initDocument = function _initDocument(dirty) {
    /* Create a HTML document */
    var doc = void 0;
    var leadingWhitespace = void 0;

    if (FORCE_BODY) {
      dirty = '<remove></remove>' + dirty;
    } else {
      /* If FORCE_BODY isn't used, leading whitespace needs to be preserved manually */
      var matches = stringMatch(dirty, /^[\r\n\t ]+/);
      leadingWhitespace = matches && matches[0];
    }

    var dirtyPayload = trustedTypesPolicy ? trustedTypesPolicy.createHTML(dirty) : dirty;
    /* Use the DOMParser API by default, fallback later if needs be */
    try {
      doc = new DOMParser().parseFromString(dirtyPayload, 'text/html');
    } catch (_) {}

    /* Use createHTMLDocument in case DOMParser is not available */
    if (!doc || !doc.documentElement) {
      doc = implementation.createHTMLDocument('');
      var _doc = doc,
          body = _doc.body;

      body.parentNode.removeChild(body.parentNode.firstElementChild);
      body.outerHTML = dirtyPayload;
    }

    if (dirty && leadingWhitespace) {
      doc.body.insertBefore(document.createTextNode(leadingWhitespace), doc.body.childNodes[0] || null);
    }

    /* Work on whole document or just its body */
    return getElementsByTagName.call(doc, WHOLE_DOCUMENT ? 'html' : 'body')[0];
  };

  /**
   * _createIterator
   *
   * @param  {Document} root document/fragment to create iterator for
   * @return {Iterator} iterator instance
   */
  var _createIterator = function _createIterator(root) {
    return createNodeIterator.call(root.ownerDocument || root, root, NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_COMMENT | NodeFilter.SHOW_TEXT, function () {
      return NodeFilter.FILTER_ACCEPT;
    }, false);
  };

  /**
   * _isClobbered
   *
   * @param  {Node} elm element to check for clobbering attacks
   * @return {Boolean} true if clobbered, false if safe
   */
  var _isClobbered = function _isClobbered(elm) {
    if (elm instanceof Text || elm instanceof Comment) {
      return false;
    }

    if (typeof elm.nodeName !== 'string' || typeof elm.textContent !== 'string' || typeof elm.removeChild !== 'function' || !(elm.attributes instanceof NamedNodeMap) || typeof elm.removeAttribute !== 'function' || typeof elm.setAttribute !== 'function' || typeof elm.namespaceURI !== 'string') {
      return true;
    }

    return false;
  };

  /**
   * _isNode
   *
   * @param  {Node} obj object to check whether it's a DOM node
   * @return {Boolean} true is object is a DOM node
   */
  var _isNode = function _isNode(object) {
    return (typeof Node === 'undefined' ? 'undefined' : _typeof(Node)) === 'object' ? object instanceof Node : object && (typeof object === 'undefined' ? 'undefined' : _typeof(object)) === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string';
  };

  /**
   * _executeHook
   * Execute user configurable hooks
   *
   * @param  {String} entryPoint  Name of the hook's entry point
   * @param  {Node} currentNode node to work on with the hook
   * @param  {Object} data additional hook parameters
   */
  var _executeHook = function _executeHook(entryPoint, currentNode, data) {
    if (!hooks[entryPoint]) {
      return;
    }

    arrayForEach(hooks[entryPoint], function (hook) {
      hook.call(DOMPurify, currentNode, data, CONFIG);
    });
  };

  /**
   * _sanitizeElements
   *
   * @protect nodeName
   * @protect textContent
   * @protect removeChild
   *
   * @param   {Node} currentNode to check for permission to exist
   * @return  {Boolean} true if node was killed, false if left alive
   */
  var _sanitizeElements = function _sanitizeElements(currentNode) {
    var content = void 0;

    /* Execute a hook if present */
    _executeHook('beforeSanitizeElements', currentNode, null);

    /* Check if element is clobbered or can clobber */
    if (_isClobbered(currentNode)) {
      _forceRemove(currentNode);
      return true;
    }

    /* Check if tagname contains Unicode */
    if (stringMatch(currentNode.nodeName, /[\u0080-\uFFFF]/)) {
      _forceRemove(currentNode);
      return true;
    }

    /* Now let's check the element's type and name */
    var tagName = stringToLowerCase(currentNode.nodeName);

    /* Execute a hook if present */
    _executeHook('uponSanitizeElement', currentNode, {
      tagName: tagName,
      allowedTags: ALLOWED_TAGS
    });

    /* Detect mXSS attempts abusing namespace confusion */
    if (!_isNode(currentNode.firstElementChild) && (!_isNode(currentNode.content) || !_isNode(currentNode.content.firstElementChild)) && regExpTest(/<[/\w]/g, currentNode.innerHTML) && regExpTest(/<[/\w]/g, currentNode.textContent)) {
      _forceRemove(currentNode);
      return true;
    }

    /* Remove element if anything forbids its presence */
    if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) {
      /* Keep content except for bad-listed elements */
      if (KEEP_CONTENT && !FORBID_CONTENTS[tagName] && typeof currentNode.insertAdjacentHTML === 'function') {
        try {
          var htmlToInsert = currentNode.innerHTML;
          currentNode.insertAdjacentHTML('AfterEnd', trustedTypesPolicy ? trustedTypesPolicy.createHTML(htmlToInsert) : htmlToInsert);
        } catch (_) {}
      }

      _forceRemove(currentNode);
      return true;
    }

    if ((tagName === 'noscript' || tagName === 'noembed') && regExpTest(/<\/no(script|embed)/i, currentNode.innerHTML)) {
      _forceRemove(currentNode);
      return true;
    }

    if (tagName === 'math' && _isNode(currentNode.firstElementChild) && currentNode.querySelectorAll(':not(' + mathMl.join('):not(') + ')').length > 0) {
      _forceRemove(currentNode);
      return true;
    }

    /* Take care of an mXSS using HTML inside SVG affecting old Chrome */
    if (tagName === 'svg' && currentNode.querySelectorAll('p, br, table, form, noscript').length > 0) {
      _forceRemove(currentNode);
      return true;
    }

    /* Sanitize element content to be template-safe */
    if (SAFE_FOR_TEMPLATES && currentNode.nodeType === 3) {
      /* Get the element's text content */
      content = currentNode.textContent;
      content = stringReplace(content, MUSTACHE_EXPR$$1, ' ');
      content = stringReplace(content, ERB_EXPR$$1, ' ');
      if (currentNode.textContent !== content) {
        arrayPush(DOMPurify.removed, { element: currentNode.cloneNode() });
        currentNode.textContent = content;
      }
    }

    /* Execute a hook if present */
    _executeHook('afterSanitizeElements', currentNode, null);

    return false;
  };

  /**
   * _isValidAttribute
   *
   * @param  {string} lcTag Lowercase tag name of containing element.
   * @param  {string} lcName Lowercase attribute name.
   * @param  {string} value Attribute value.
   * @return {Boolean} Returns true if `value` is valid, otherwise false.
   */
  // eslint-disable-next-line complexity
  var _isValidAttribute = function _isValidAttribute(lcTag, lcName, value) {
    /* Make sure attribute cannot clobber */
    if (SANITIZE_DOM && (lcName === 'id' || lcName === 'name') && (value in document || value in formElement)) {
      return false;
    }

    /* Allow valid data-* attributes: At least one character after "-"
        (https://html.spec.whatwg.org/multipage/dom.html#embedding-custom-non-visible-data-with-the-data-*-attributes)
        XML-compatible (https://html.spec.whatwg.org/multipage/infrastructure.html#xml-compatible and http://www.w3.org/TR/xml/#d0e804)
        We don't need to check the value; it's always URI safe. */
    if (ALLOW_DATA_ATTR && regExpTest(DATA_ATTR$$1, lcName)) ; else if (ALLOW_ARIA_ATTR && regExpTest(ARIA_ATTR$$1, lcName)) ; else if (!ALLOWED_ATTR[lcName] || FORBID_ATTR[lcName]) {
      return false;

      /* Check value is safe. First, is attr inert? If so, is safe */
    } else if (URI_SAFE_ATTRIBUTES[lcName]) ; else if (regExpTest(IS_ALLOWED_URI$$1, stringReplace(value, ATTR_WHITESPACE$$1, ''))) ; else if ((lcName === 'src' || lcName === 'xlink:href' || lcName === 'href') && lcTag !== 'script' && stringIndexOf(value, 'data:') === 0 && DATA_URI_TAGS[lcTag]) ; else if (ALLOW_UNKNOWN_PROTOCOLS && !regExpTest(IS_SCRIPT_OR_DATA$$1, stringReplace(value, ATTR_WHITESPACE$$1, ''))) ; else if (!value) ; else {
      return false;
    }

    return true;
  };

  /**
   * _sanitizeAttributes
   *
   * @protect attributes
   * @protect nodeName
   * @protect removeAttribute
   * @protect setAttribute
   *
   * @param  {Node} currentNode to sanitize
   */
  var _sanitizeAttributes = function _sanitizeAttributes(currentNode) {
    var attr = void 0;
    var value = void 0;
    var lcName = void 0;
    var l = void 0;
    /* Execute a hook if present */
    _executeHook('beforeSanitizeAttributes', currentNode, null);

    var attributes = currentNode.attributes;

    /* Check if we have attributes; if not we might have a text node */

    if (!attributes) {
      return;
    }

    var hookEvent = {
      attrName: '',
      attrValue: '',
      keepAttr: true,
      allowedAttributes: ALLOWED_ATTR
    };
    l = attributes.length;

    /* Go backwards over all attributes; safely remove bad ones */
    while (l--) {
      attr = attributes[l];
      var _attr = attr,
          name = _attr.name,
          namespaceURI = _attr.namespaceURI;

      value = stringTrim(attr.value);
      lcName = stringToLowerCase(name);

      /* Execute a hook if present */
      hookEvent.attrName = lcName;
      hookEvent.attrValue = value;
      hookEvent.keepAttr = true;
      hookEvent.forceKeepAttr = undefined; // Allows developers to see this is a property they can set
      _executeHook('uponSanitizeAttribute', currentNode, hookEvent);
      value = hookEvent.attrValue;
      /* Did the hooks approve of the attribute? */
      if (hookEvent.forceKeepAttr) {
        continue;
      }

      /* Remove attribute */
      _removeAttribute(name, currentNode);

      /* Did the hooks approve of the attribute? */
      if (!hookEvent.keepAttr) {
        continue;
      }

      /* Work around a security issue in jQuery 3.0 */
      if (regExpTest(/\/>/i, value)) {
        _removeAttribute(name, currentNode);
        continue;
      }

      /* Sanitize attribute content to be template-safe */
      if (SAFE_FOR_TEMPLATES) {
        value = stringReplace(value, MUSTACHE_EXPR$$1, ' ');
        value = stringReplace(value, ERB_EXPR$$1, ' ');
      }

      /* Is `value` valid for this attribute? */
      var lcTag = currentNode.nodeName.toLowerCase();
      if (!_isValidAttribute(lcTag, lcName, value)) {
        continue;
      }

      /* Handle invalid data-* attribute set by try-catching it */
      try {
        if (namespaceURI) {
          currentNode.setAttributeNS(namespaceURI, name, value);
        } else {
          /* Fallback to setAttribute() for browser-unrecognized namespaces e.g. "x-schema". */
          currentNode.setAttribute(name, value);
        }

        arrayPop(DOMPurify.removed);
      } catch (_) {}
    }

    /* Execute a hook if present */
    _executeHook('afterSanitizeAttributes', currentNode, null);
  };

  /**
   * _sanitizeShadowDOM
   *
   * @param  {DocumentFragment} fragment to iterate over recursively
   */
  var _sanitizeShadowDOM = function _sanitizeShadowDOM(fragment) {
    var shadowNode = void 0;
    var shadowIterator = _createIterator(fragment);

    /* Execute a hook if present */
    _executeHook('beforeSanitizeShadowDOM', fragment, null);

    while (shadowNode = shadowIterator.nextNode()) {
      /* Execute a hook if present */
      _executeHook('uponSanitizeShadowNode', shadowNode, null);

      /* Sanitize tags and elements */
      if (_sanitizeElements(shadowNode)) {
        continue;
      }

      /* Deep shadow DOM detected */
      if (shadowNode.content instanceof DocumentFragment) {
        _sanitizeShadowDOM(shadowNode.content);
      }

      /* Check attributes, sanitize if necessary */
      _sanitizeAttributes(shadowNode);
    }

    /* Execute a hook if present */
    _executeHook('afterSanitizeShadowDOM', fragment, null);
  };

  /**
   * Sanitize
   * Public method providing core sanitation functionality
   *
   * @param {String|Node} dirty string or DOM node
   * @param {Object} configuration object
   */
  // eslint-disable-next-line complexity
  DOMPurify.sanitize = function (dirty, cfg) {
    var body = void 0;
    var importedNode = void 0;
    var currentNode = void 0;
    var oldNode = void 0;
    var returnNode = void 0;
    /* Make sure we have a string to sanitize.
      DO NOT return early, as this will return the wrong type if
      the user has requested a DOM object rather than a string */
    if (!dirty) {
      dirty = '<!-->';
    }

    /* Stringify, in case dirty is an object */
    if (typeof dirty !== 'string' && !_isNode(dirty)) {
      // eslint-disable-next-line no-negated-condition
      if (typeof dirty.toString !== 'function') {
        throw typeErrorCreate('toString is not a function');
      } else {
        dirty = dirty.toString();
        if (typeof dirty !== 'string') {
          throw typeErrorCreate('dirty is not a string, aborting');
        }
      }
    }

    /* Check we can run. Otherwise fall back or ignore */
    if (!DOMPurify.isSupported) {
      if (_typeof(window.toStaticHTML) === 'object' || typeof window.toStaticHTML === 'function') {
        if (typeof dirty === 'string') {
          return window.toStaticHTML(dirty);
        }

        if (_isNode(dirty)) {
          return window.toStaticHTML(dirty.outerHTML);
        }
      }

      return dirty;
    }

    /* Assign config vars */
    if (!SET_CONFIG) {
      _parseConfig(cfg);
    }

    /* Clean up removed elements */
    DOMPurify.removed = [];

    /* Check if dirty is correctly typed for IN_PLACE */
    if (typeof dirty === 'string') {
      IN_PLACE = false;
    }

    if (IN_PLACE) ; else if (dirty instanceof Node) {
      /* If dirty is a DOM element, append to an empty document to avoid
         elements being stripped by the parser */
      body = _initDocument('<!---->');
      importedNode = body.ownerDocument.importNode(dirty, true);
      if (importedNode.nodeType === 1 && importedNode.nodeName === 'BODY') {
        /* Node is already a body, use as is */
        body = importedNode;
      } else if (importedNode.nodeName === 'HTML') {
        body = importedNode;
      } else {
        // eslint-disable-next-line unicorn/prefer-node-append
        body.appendChild(importedNode);
      }
    } else {
      /* Exit directly if we have nothing to do */
      if (!RETURN_DOM && !SAFE_FOR_TEMPLATES && !WHOLE_DOCUMENT &&
      // eslint-disable-next-line unicorn/prefer-includes
      dirty.indexOf('<') === -1) {
        return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(dirty) : dirty;
      }

      /* Initialize the document to work on */
      body = _initDocument(dirty);

      /* Check we have a DOM node from the data */
      if (!body) {
        return RETURN_DOM ? null : emptyHTML;
      }
    }

    /* Remove first element node (ours) if FORCE_BODY is set */
    if (body && FORCE_BODY) {
      _forceRemove(body.firstChild);
    }

    /* Get node iterator */
    var nodeIterator = _createIterator(IN_PLACE ? dirty : body);

    /* Now start iterating over the created document */
    while (currentNode = nodeIterator.nextNode()) {
      /* Fix IE's strange behavior with manipulated textNodes #89 */
      if (currentNode.nodeType === 3 && currentNode === oldNode) {
        continue;
      }

      /* Sanitize tags and elements */
      if (_sanitizeElements(currentNode)) {
        continue;
      }

      /* Shadow DOM detected, sanitize it */
      if (currentNode.content instanceof DocumentFragment) {
        _sanitizeShadowDOM(currentNode.content);
      }

      /* Check attributes, sanitize if necessary */
      _sanitizeAttributes(currentNode);

      oldNode = currentNode;
    }

    oldNode = null;

    /* If we sanitized `dirty` in-place, return it. */
    if (IN_PLACE) {
      return dirty;
    }

    /* Return sanitized string or DOM */
    if (RETURN_DOM) {
      if (RETURN_DOM_FRAGMENT) {
        returnNode = createDocumentFragment.call(body.ownerDocument);

        while (body.firstChild) {
          // eslint-disable-next-line unicorn/prefer-node-append
          returnNode.appendChild(body.firstChild);
        }
      } else {
        returnNode = body;
      }

      if (RETURN_DOM_IMPORT) {
        /*
          AdoptNode() is not used because internal state is not reset
          (e.g. the past names map of a HTMLFormElement), this is safe
          in theory but we would rather not risk another attack vector.
          The state that is cloned by importNode() is explicitly defined
          by the specs.
        */
        returnNode = importNode.call(originalDocument, returnNode, true);
      }

      return returnNode;
    }

    var serializedHTML = WHOLE_DOCUMENT ? body.outerHTML : body.innerHTML;

    /* Sanitize final string template-safe */
    if (SAFE_FOR_TEMPLATES) {
      serializedHTML = stringReplace(serializedHTML, MUSTACHE_EXPR$$1, ' ');
      serializedHTML = stringReplace(serializedHTML, ERB_EXPR$$1, ' ');
    }

    return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(serializedHTML) : serializedHTML;
  };

  /**
   * Public method to set the configuration once
   * setConfig
   *
   * @param {Object} cfg configuration object
   */
  DOMPurify.setConfig = function (cfg) {
    _parseConfig(cfg);
    SET_CONFIG = true;
  };

  /**
   * Public method to remove the configuration
   * clearConfig
   *
   */
  DOMPurify.clearConfig = function () {
    CONFIG = null;
    SET_CONFIG = false;
  };

  /**
   * Public method to check if an attribute value is valid.
   * Uses last set config, if any. Otherwise, uses config defaults.
   * isValidAttribute
   *
   * @param  {string} tag Tag name of containing element.
   * @param  {string} attr Attribute name.
   * @param  {string} value Attribute value.
   * @return {Boolean} Returns true if `value` is valid. Otherwise, returns false.
   */
  DOMPurify.isValidAttribute = function (tag, attr, value) {
    /* Initialize shared config vars if necessary. */
    if (!CONFIG) {
      _parseConfig({});
    }

    var lcTag = stringToLowerCase(tag);
    var lcName = stringToLowerCase(attr);
    return _isValidAttribute(lcTag, lcName, value);
  };

  /**
   * AddHook
   * Public method to add DOMPurify hooks
   *
   * @param {String} entryPoint entry point for the hook to add
   * @param {Function} hookFunction function to execute
   */
  DOMPurify.addHook = function (entryPoint, hookFunction) {
    if (typeof hookFunction !== 'function') {
      return;
    }

    hooks[entryPoint] = hooks[entryPoint] || [];
    arrayPush(hooks[entryPoint], hookFunction);
  };

  /**
   * RemoveHook
   * Public method to remove a DOMPurify hook at a given entryPoint
   * (pops it from the stack of hooks if more are present)
   *
   * @param {String} entryPoint entry point for the hook to remove
   */
  DOMPurify.removeHook = function (entryPoint) {
    if (hooks[entryPoint]) {
      arrayPop(hooks[entryPoint]);
    }
  };

  /**
   * RemoveHooks
   * Public method to remove all DOMPurify hooks at a given entryPoint
   *
   * @param  {String} entryPoint entry point for the hooks to remove
   */
  DOMPurify.removeHooks = function (entryPoint) {
    if (hooks[entryPoint]) {
      hooks[entryPoint] = [];
    }
  };

  /**
   * RemoveAllHooks
   * Public method to remove all DOMPurify hooks
   *
   */
  DOMPurify.removeAllHooks = function () {
    hooks = {};
  };

  return DOMPurify;
}

var purify = createDOMPurify();

const sanitizeHtml = purify(window).sanitize;
const sanitizeAllowBasic = (dirty, extraAllowedTags) => sanitizeHtml(dirty, {
    ALLOWED_TAGS: ['p', 'a', 'ul', 'ol', 'li', 'b', 'i', 'strong', 'em', 'br', 'div'].concat(extraAllowedTags),
    ADD_ATTR: ['target'],
});
const sanitize = (dirty) => sanitizeHtml(dirty, {
    ALLOWED_TAGS: [],
});

const HtmlString = ({ children, extraAllowedTags = [] }) => {
    return React__default.createElement("span", { dangerouslySetInnerHTML: { __html: sanitizeAllowBasic(children, extraAllowedTags) } });
};

function createId(prefix) {
    return prefix ? lodash_uniqueid(`${prefix}-`) : lodash_uniqueid();
}
const usePrefixId = (prefix) => {
    const [id, setId] = useState();
    useEffect(() => {
        setId(createId(prefix));
    }, [prefix]);
    return id;
};

var css_248z$3 = ".switcher-field {\n  display: flex;\n  align-items: center; }\n  .switcher-field--new {\n    flex-direction: row-reverse;\n    justify-content: flex-end; }\n    .switcher-field--new .switcher.active:not(.disabled) {\n      background-color: #00bed5; }\n    .switcher-field--new .switcher.disabled {\n      opacity: 0.45; }\n    .switcher-field--new .label-block {\n      margin-right: 10px;\n      color: #fff; }\n    .switcher-field--new .disabled + .label-block {\n      color: #96a1bd; }\n";
styleInject(css_248z$3);

const Switcher = ({ name, disabled, value, label, subLabel, onChange, id: incomingId, isNew, testId, }) => {
    const prefixId = usePrefixId(name);
    const id = incomingId || prefixId;
    return (React__default.createElement("div", { className: classnames('switcher-field', {
            'switcher-field--new': isNew,
        }), "data-testid": testId },
        React__default.createElement("div", { className: classnames('switcher', {
                active: value,
                disabled: disabled,
                'with-sublabel': subLabel,
            }), "data-label-on": t('label.on'), "data-label-off": t('label.off') },
            React__default.createElement("input", { type: "checkbox", id: id, name: name, disabled: disabled, checked: value, onChange: onChange }),
            React__default.createElement("label", { htmlFor: id })),
        label && (React__default.createElement("label", { className: "label-block", htmlFor: id, title: label },
            React__default.createElement("span", { className: "switch-label" }, label),
            subLabel && React__default.createElement("span", { className: "switch-sublabel" }, subLabel)))));
};

const SwitcherField = (_a) => {
    var { name, onChange, validate } = _a, rest = __rest(_a, ["name", "onChange", "validate"]);
    return (React__default.createElement(Field, { name: name, validate: validate }, ({ field }) => {
        const handleSwitcherChange = (event) => {
            if (onChange) {
                onChange(event);
            }
            field.onChange(event);
        };
        return React__default.createElement(Switcher, Object.assign({}, field, rest, { onChange: handleSwitcherChange }));
    }));
};

const defaultContext = {
    isClosing: false,
};
const SidebarContext = React__default.createContext(defaultContext);

var lodash_isequal = createCommonjsModule(function (module, exports) {
/**
 * Lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright JS Foundation and other contributors <https://js.foundation/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    asyncTag = '[object AsyncFunction]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    nullTag = '[object Null]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    proxyTag = '[object Proxy]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    undefinedTag = '[object Undefined]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Detect free variable `exports`. */
var freeExports =  exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    Symbol = root.Symbol,
    Uint8Array = root.Uint8Array,
    propertyIsEnumerable = objectProto.propertyIsEnumerable,
    splice = arrayProto.splice,
    symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols,
    nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
    nativeKeys = overArg(Object.keys, Object);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView'),
    Map = getNative(root, 'Map'),
    Promise = getNative(root, 'Promise'),
    Set = getNative(root, 'Set'),
    WeakMap = getNative(root, 'WeakMap'),
    nativeCreate = getNative(Object, 'create');

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(array);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(object);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual(value, other) {
  return baseIsEqual(value, other);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = isEqual;
});

/**
 * Lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright JS Foundation and other contributors <https://js.foundation/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag$1 = '[object Function]',
    genTag$1 = '[object GeneratorFunction]',
    nullTag = '[object Null]',
    proxyTag = '[object Proxy]',
    undefinedTag = '[object Undefined]';

/** Detect free variable `global` from Node.js. */
var freeGlobal$3 = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

/** Detect free variable `self`. */
var freeSelf$3 = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root$3 = freeGlobal$3 || freeSelf$3 || Function('return this')();

/** Used for built-in method references. */
var objectProto$3 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$4 = objectProto$3.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto$3.toString;

/** Built-in value references. */
var Symbol$3 = root$3.Symbol,
    symToStringTag = Symbol$3 ? Symbol$3.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString$3(value);
}

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty$4.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString$3(value) {
  return nativeObjectToString.call(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction$1(value) {
  if (!isObject$2(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag$1 || tag == genTag$1 || tag == asyncTag || tag == proxyTag;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject$2(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

var lodash_isfunction = isFunction$1;

const BreadcrumbGenericItem = ({ label, onClick }) => (React__default.createElement("div", { className: "react-breadcrumbs__item", onClick: onClick },
    React__default.createElement("div", { className: "react-breadcrumbs__arrow" }),
    React__default.createElement("div", { className: "react-breadcrumbs__label" }, label)));

const BreadcrumbsContext = React__default.createContext(null);
class BreadcrumbsProvider extends React__default.Component {
    constructor() {
        super(...arguments);
        this.state = {
            breadcrumbs: [],
        };
        this.setBreadcrumbs = (newItems) => {
            this.setState({
                breadcrumbs: newItems,
            });
        };
        this.pushBreadcrumb = (newItem) => {
            this.setState(state => ({
                breadcrumbs: [...state.breadcrumbs, newItem],
            }));
        };
        this.removeBreadcrumb = (itemId) => {
            this.setState(state => ({
                breadcrumbs: state.breadcrumbs.filter(item => item.id !== itemId),
            }));
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When the sidebar starts closing the breadcrumbs gets unset to also
        // play the closing animation and avoid visual glitches.
        if (props.isClosing) {
            return Object.assign(Object.assign({}, state), { breadcrumbs: [] });
        }
        return null;
    }
    render() {
        const context = {
            sidebarName: this.props.sidebarName,
            breadcrumbs: this.state.breadcrumbs,
            setBreadcrumbs: this.setBreadcrumbs,
            pushBreadcrumb: this.pushBreadcrumb,
            removeBreadcrumb: this.removeBreadcrumb,
        };
        return React__default.createElement(BreadcrumbsContext.Provider, { value: context }, this.props.children);
    }
}
function withBreadcrumbsContext(selectData) {
    return (Wrapped) => {
        const wrappedWithContext = (props) => (React__default.createElement(BreadcrumbsContext.Consumer, null, context => {
            if (!context) {
                throw new Error('BreadcrumbsContext was not initialized');
            }
            const contextProps = selectData(context);
            return React__default.createElement(Wrapped, Object.assign({}, props, contextProps));
        }));
        return wrappedWithContext;
    };
}

var css_248z$4 = ".react-breadcrumbs {\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 100%;\n  z-index: 1;\n  transition: transform 200ms ease-in-out;\n  transform: translate3d(calc(var(--count, 0) * -1 * 44px), 0, 0);\n  display: inline-flex;\n  flex-flow: row nowrap;\n  justify-content: flex-end; }\n  .react-breadcrumbs__item {\n    background: #4b577e;\n    width: 44px;\n    border-right: 2px solid #96a1bd;\n    display: inline-flex;\n    flex-flow: row nowrap;\n    justify-content: flex-start;\n    align-items: center;\n    writing-mode: vertical-lr;\n    transition: background 200ms ease-in-out;\n    cursor: pointer;\n    user-select: none;\n    box-sizing: border-box; }\n    .react-breadcrumbs__item:hover {\n      background: #515e88; }\n      .react-breadcrumbs__item:hover .react-breadcrumbs__arrow::before {\n        transform: rotate(-90deg);\n        opacity: 1; }\n  .react-breadcrumbs__arrow {\n    line-height: 12px;\n    height: 12px;\n    width: 12px;\n    position: relative;\n    margin-top: 24px;\n    flex-shrink: 0; }\n    .react-breadcrumbs__arrow::before {\n      content: '';\n      width: 0;\n      height: 0;\n      border-style: solid;\n      border-width: 6px 8px 6px 0;\n      border-color: transparent white transparent transparent;\n      position: absolute;\n      transition: all 100ms ease-in-out;\n      left: 50%;\n      top: 50%;\n      margin: -6px 0 0 -4px;\n      opacity: .3; }\n  .react-breadcrumbs__label {\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    margin-top: 22px;\n    flex-grow: 1;\n    color: white; }\n  .react-breadcrumbs__app-details {\n    margin: 20px 0;\n    display: inline-flex;\n    flex-flow: row nowrap;\n    align-items: center; }\n  .react-breadcrumbs__app-platforms {\n    display: inline-flex;\n    flex-flow: row nowrap;\n    align-items: center;\n    margin-bottom: 25px; }\n  .react-breadcrumbs__app-platform {\n    width: 22px;\n    height: 22px;\n    font-size: 22px;\n    margin-top: 10px;\n    display: inline-flex;\n    flex-flow: row nowrap;\n    align-items: center;\n    justify-content: center; }\n    .react-breadcrumbs__app-platform:first-of-type {\n      margin-top: 0; }\n";
styleInject(css_248z$4);

var BreadcrumbsDirection;
(function (BreadcrumbsDirection) {
    BreadcrumbsDirection[BreadcrumbsDirection["Left"] = 0] = "Left";
    BreadcrumbsDirection[BreadcrumbsDirection["Right"] = 1] = "Right";
})(BreadcrumbsDirection || (BreadcrumbsDirection = {}));
class Breadcrumbs extends React__default.Component {
    constructor() {
        super(...arguments);
        this.state = {
            rendered: [],
            nextCount: 0,
            direction: BreadcrumbsDirection.Left,
        };
        this.handleClick = (item) => () => {
            const { action, shouldSkipBlock } = item;
            if (this.props.isBlocked && !shouldSkipBlock) {
                return;
            }
            if (typeof action === 'string') {
                window.location.href = action;
            }
            else if (lodash_isfunction(action)) {
                action();
            }
            else {
                throw new Error('Type not supported');
            }
        };
        this.handleTransitionEnd = (event) => {
            // Only run this callback if the event was originated by the container
            if (event.target.className !== 'react-breadcrumbs') {
                return;
            }
            /*
            Drilling up:
            List of rendered elements gets updated after the animation happened,
            Element removal that remains off-screen.
            */
            if (this.state.direction === BreadcrumbsDirection.Left) {
                const nextRendered = this.props.breadcrumbs;
                this.setState({
                    rendered: nextRendered,
                    nextCount: nextRendered.length,
                });
            }
        };
    }
    static getDerivedStateFromProps(props, state) {
        const direction = props.breadcrumbs.length > state.rendered.length ? BreadcrumbsDirection.Right : BreadcrumbsDirection.Left;
        /*
        Drilling down:
        List of rendered elements gets updated before the animation happens,
        Element addition remains off-screen.
        */
        const nextRendered = direction === BreadcrumbsDirection.Right ? props.breadcrumbs : state.rendered;
        /*
        Triggering the animation:
        A fresh count of the context breadcrumbs is always stored in `nextCount`
        and this is what triggers the animation, regardless of the direction.
        */
        return {
            nextCount: props.breadcrumbs.length,
            rendered: nextRendered,
            direction,
        };
    }
    shouldComponentUpdate(nextProps, nextState) {
        return !lodash_isequal(nextState, this.state);
    }
    render() {
        const styles = {
            '--count': this.state.nextCount,
        };
        return (React__default.createElement("div", { className: "react-breadcrumbs", onTransitionEnd: this.handleTransitionEnd, style: styles }, this.state.rendered.map(item => this.props.customBreadcrumbItem ? (this.props.customBreadcrumbItem(item, this.handleClick(item))) : (React__default.createElement(BreadcrumbGenericItem, { key: item.id, label: item.label, onClick: this.handleClick(item) })))));
    }
}
const mapContextToProps = (context) => ({
    breadcrumbs: context.breadcrumbs,
});
var Breadcrumbs$1 = withBreadcrumbsContext(mapContextToProps)(Breadcrumbs);

const findOrCreateRootNode = () => {
    const id = 'react-sidebar-container';
    const existing = document.getElementById(id);
    if (existing) {
        return existing;
    }
    const newRoot = Object.assign(document.createElement('div'), { id });
    document.body.appendChild(newRoot);
    return newRoot;
};

var css_248z$5 = ".react-sidebar-backdrop, .react-sidebar {\n  position: fixed;\n  top: 0;\n  height: 100%;\n  box-sizing: border-box;\n  animation-duration: 200ms;\n  animation-timing-function: ease-in-out; }\n\n#react-sidebar-container {\n  z-index: 9000; }\n\n.react-sidebar-backdrop {\n  left: 0;\n  width: 100%;\n  background: rgba(45, 79, 99, 0.4); }\n\n.react-sidebar {\n  width: 450px;\n  color: #96a1bd;\n  background: #4b577e;\n  text-align: left;\n  transform: translate3d(0, 0, 0); }\n  .react-sidebar--right {\n    right: 0; }\n  .react-sidebar--left {\n    left: 0; }\n  .react-sidebar__wrapper {\n    position: relative;\n    height: 100%;\n    overflow: visible; }\n  .react-sidebar__content {\n    background: #4b577e;\n    position: relative;\n    display: inline-flex;\n    height: 100%;\n    width: 100%;\n    z-index: 2; }\n  .react-sidebar .loader-overlay {\n    background: #4b577e; }\n    .react-sidebar .loader-overlay::after {\n      border-color: #445076;\n      border-left-color: #f3f4f6; }\n\n@keyframes sidebarBackdropFadeIn {\n  0% {\n    opacity: 0; }\n  100% {\n    opacity: 1; } }\n\n@keyframes sidebarBackdropFadeOut {\n  0% {\n    opacity: 1; }\n  100% {\n    opacity: 0; } }\n\n@keyframes rightSidebarContentSlideIn {\n  0% {\n    transform: translate3d(100%, 0, 0); }\n  100% {\n    transform: translate3d(0, 0, 0); } }\n\n@keyframes rightSidebarContentSlideOut {\n  0% {\n    transform: translate3d(0, 0, 0); }\n  100% {\n    transform: translate3d(100%, 0, 0); } }\n\n@keyframes leftSidebarContentSlideIn {\n  0% {\n    transform: translate3d(-100%, 0, 0); }\n  100% {\n    transform: translate3d(0, 0, 0); } }\n\n@keyframes leftSidebarContentSlideOut {\n  0% {\n    transform: translate3d(0, 0, 0); }\n  100% {\n    transform: translate3d(-100%, 0, 0); } }\n";
styleInject(css_248z$5);

var SidebarDirection;
(function (SidebarDirection) {
    SidebarDirection["Right"] = "right";
    SidebarDirection["Left"] = "left";
})(SidebarDirection || (SidebarDirection = {}));
const SimpleSidebar = ({ isVisible = true, hasBackdrop = true, isBlocked = false, direction = SidebarDirection.Right, onCloseAttempt = () => true, children, name, onClose, customBreadcrumbItem, }) => {
    const [isRendered, setIsRendered] = useState(false);
    const [shouldRender, setShouldRender] = useState(false);
    const root = useRef(null);
    useEffect(() => {
        root.current = findOrCreateRootNode();
    }, []);
    const handleBackdropAnimationEnd = useCallback(() => {
        if (!shouldRender) {
            setIsRendered(false);
            onClose === null || onClose === void 0 ? void 0 : onClose();
        }
    }, [shouldRender, onClose]);
    const handleContentAnimationEnd = useCallback(() => {
        !hasBackdrop && handleBackdropAnimationEnd();
    }, [hasBackdrop, handleBackdropAnimationEnd]);
    const handleClose = useCallback(() => {
        if (onCloseAttempt() && !isBlocked) {
            setShouldRender(false);
        }
    }, [isBlocked, onCloseAttempt]);
    useEffect(() => {
        // Ensure the internal state gets updated whenever the isVisible prop changes
        if (isVisible && !isRendered) {
            setShouldRender(true);
            setIsRendered(true);
        }
        // ...and also trigger the close handler
        if (isVisible === false && isRendered) {
            handleClose();
        }
    }, [isVisible]);
    const styles = {
        backdrop: {
            animationName: shouldRender ? 'sidebarBackdropFadeIn' : 'sidebarBackdropFadeOut',
        },
        sidebar: {
            animationName: shouldRender ? `${direction}SidebarContentSlideIn` : `${direction}SidebarContentSlideOut`,
        },
    };
    if (!root.current) {
        return null;
    }
    return ReactDOM.createPortal(isRendered && (React__default.createElement(BreadcrumbsProvider, { sidebarName: name, isClosing: !shouldRender },
        hasBackdrop && (React__default.createElement("div", { className: "react-sidebar-backdrop", style: styles.backdrop, onClick: handleClose, onAnimationEnd: handleBackdropAnimationEnd })),
        React__default.createElement("div", { className: `react-sidebar react-sidebar--${direction}`, style: styles.sidebar, onAnimationEnd: handleContentAnimationEnd },
            React__default.createElement("div", { className: "react-sidebar__wrapper" },
                React__default.createElement(Breadcrumbs$1, { isBlocked: isBlocked, customBreadcrumbItem: customBreadcrumbItem }),
                React__default.createElement("div", { className: "react-sidebar__content", id: name },
                    React__default.createElement(SidebarContext.Provider, { value: {
                            isClosing: !shouldRender,
                        } }, children({ closeSidebar: handleClose }))))))), root.current);
};

var tabbable_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = findTabbableDescendants;
/*!
 * Adapted from jQuery UI core
 *
 * http://jqueryui.com
 *
 * Copyright 2014 jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/category/ui-core/
 */

var tabbableNode = /input|select|textarea|button|object/;

function hidesContents(element) {
  var zeroSize = element.offsetWidth <= 0 && element.offsetHeight <= 0;

  // If the node is empty, this is good enough
  if (zeroSize && !element.innerHTML) return true;

  // Otherwise we need to check some styles
  var style = window.getComputedStyle(element);
  return zeroSize ? style.getPropertyValue("overflow") !== "visible" ||
  // if 'overflow: visible' set, check if there is actually any overflow
  element.scrollWidth <= 0 && element.scrollHeight <= 0 : style.getPropertyValue("display") == "none";
}

function visible(element) {
  var parentElement = element;
  while (parentElement) {
    if (parentElement === document.body) break;
    if (hidesContents(parentElement)) return false;
    parentElement = parentElement.parentNode;
  }
  return true;
}

function focusable(element, isTabIndexNotNaN) {
  var nodeName = element.nodeName.toLowerCase();
  var res = tabbableNode.test(nodeName) && !element.disabled || (nodeName === "a" ? element.href || isTabIndexNotNaN : isTabIndexNotNaN);
  return res && visible(element);
}

function tabbable(element) {
  var tabIndex = element.getAttribute("tabindex");
  if (tabIndex === null) tabIndex = undefined;
  var isTabIndexNaN = isNaN(tabIndex);
  return (isTabIndexNaN || tabIndex >= 0) && focusable(element, !isTabIndexNaN);
}

function findTabbableDescendants(element) {
  return [].slice.call(element.querySelectorAll("*"), 0).filter(tabbable);
}
module.exports = exports["default"];
});

var focusManager = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleBlur = handleBlur;
exports.handleFocus = handleFocus;
exports.markForFocusLater = markForFocusLater;
exports.returnFocus = returnFocus;
exports.popWithoutFocus = popWithoutFocus;
exports.setupScopedFocus = setupScopedFocus;
exports.teardownScopedFocus = teardownScopedFocus;



var _tabbable2 = _interopRequireDefault(tabbable_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var focusLaterElements = [];
var modalElement = null;
var needToFocus = false;

function handleBlur() {
  needToFocus = true;
}

function handleFocus() {
  if (needToFocus) {
    needToFocus = false;
    if (!modalElement) {
      return;
    }
    // need to see how jQuery shims document.on('focusin') so we don't need the
    // setTimeout, firefox doesn't support focusin, if it did, we could focus
    // the element outside of a setTimeout. Side-effect of this implementation
    // is that the document.body gets focus, and then we focus our element right
    // after, seems fine.
    setTimeout(function () {
      if (modalElement.contains(document.activeElement)) {
        return;
      }
      var el = (0, _tabbable2.default)(modalElement)[0] || modalElement;
      el.focus();
    }, 0);
  }
}

function markForFocusLater() {
  focusLaterElements.push(document.activeElement);
}

/* eslint-disable no-console */
function returnFocus() {
  var preventScroll = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

  var toFocus = null;
  try {
    if (focusLaterElements.length !== 0) {
      toFocus = focusLaterElements.pop();
      toFocus.focus({ preventScroll: preventScroll });
    }
    return;
  } catch (e) {
    console.warn(["You tried to return focus to", toFocus, "but it is not in the DOM anymore"].join(" "));
  }
}
/* eslint-enable no-console */

function popWithoutFocus() {
  focusLaterElements.length > 0 && focusLaterElements.pop();
}

function setupScopedFocus(element) {
  modalElement = element;

  if (window.addEventListener) {
    window.addEventListener("blur", handleBlur, false);
    document.addEventListener("focus", handleFocus, true);
  } else {
    window.attachEvent("onBlur", handleBlur);
    document.attachEvent("onFocus", handleFocus);
  }
}

function teardownScopedFocus() {
  modalElement = null;

  if (window.addEventListener) {
    window.removeEventListener("blur", handleBlur);
    document.removeEventListener("focus", handleFocus);
  } else {
    window.detachEvent("onBlur", handleBlur);
    document.detachEvent("onFocus", handleFocus);
  }
}
});

var scopeTab_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = scopeTab;



var _tabbable2 = _interopRequireDefault(tabbable_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function scopeTab(node, event) {
  var tabbable = (0, _tabbable2.default)(node);

  if (!tabbable.length) {
    // Do nothing, since there are no elements that can receive focus.
    event.preventDefault();
    return;
  }

  var target = void 0;

  var shiftKey = event.shiftKey;
  var head = tabbable[0];
  var tail = tabbable[tabbable.length - 1];

  // proceed with default browser behavior on tab.
  // Focus on last element on shift + tab.
  if (node === document.activeElement) {
    if (!shiftKey) return;
    target = tail;
  }

  if (tail === document.activeElement && !shiftKey) {
    target = head;
  }

  if (head === document.activeElement && shiftKey) {
    target = tail;
  }

  if (target) {
    event.preventDefault();
    target.focus();
    return;
  }

  // Safari radio issue.
  //
  // Safari does not move the focus to the radio button,
  // so we need to force it to really walk through all elements.
  //
  // This is very error prone, since we are trying to guess
  // if it is a safari browser from the first occurence between
  // chrome or safari.
  //
  // The chrome user agent contains the first ocurrence
  // as the 'chrome/version' and later the 'safari/version'.
  var checkSafari = /(\bChrome\b|\bSafari\b)\//.exec(navigator.userAgent);
  var isSafariDesktop = checkSafari != null && checkSafari[1] != "Chrome" && /\biPod\b|\biPad\b/g.exec(navigator.userAgent) == null;

  // If we are not in safari desktop, let the browser control
  // the focus
  if (!isSafariDesktop) return;

  var x = tabbable.indexOf(document.activeElement);

  if (x > -1) {
    x += shiftKey ? -1 : 1;
  }

  target = tabbable[x];

  // If the tabbable element does not exist,
  // focus head/tail based on shiftKey
  if (typeof target === "undefined") {
    event.preventDefault();
    target = shiftKey ? tail : head;
    target.focus();
    return;
  }

  event.preventDefault();

  target.focus();
}
module.exports = exports["default"];
});

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = process.env.NODE_ENV !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning$2 = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);
    for (var key = 1; key < len; key++) {
      args[key - 1] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning$2.apply(null, [format].concat(args));
    }
  };
}

var warning_1 = warning;

var exenv = createCommonjsModule(function (module) {
/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/
/* global define */

(function () {

	var canUseDOM = !!(
		typeof window !== 'undefined' &&
		window.document &&
		window.document.createElement
	);

	var ExecutionEnvironment = {

		canUseDOM: canUseDOM,

		canUseWorkers: typeof Worker !== 'undefined',

		canUseEventListeners:
			canUseDOM && !!(window.addEventListener || window.attachEvent),

		canUseViewport: canUseDOM && !!window.screen

	};

	if ( module.exports) {
		module.exports = ExecutionEnvironment;
	} else {
		window.ExecutionEnvironment = ExecutionEnvironment;
	}

}());
});

var safeHTMLElement = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.canUseDOM = undefined;



var _exenv2 = _interopRequireDefault(exenv);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EE = _exenv2.default;

var SafeHTMLElement = EE.canUseDOM ? window.HTMLElement : {};

var canUseDOM = exports.canUseDOM = EE.canUseDOM;

exports.default = SafeHTMLElement;
});

var ariaAppHider = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.assertNodeList = assertNodeList;
exports.setElement = setElement;
exports.validateElement = validateElement;
exports.hide = hide;
exports.show = show;
exports.documentNotReadyOrSSRTesting = documentNotReadyOrSSRTesting;
exports.resetForTesting = resetForTesting;



var _warning2 = _interopRequireDefault(warning_1);



function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var globalElement = null;

function assertNodeList(nodeList, selector) {
  if (!nodeList || !nodeList.length) {
    throw new Error("react-modal: No elements were found for selector " + selector + ".");
  }
}

function setElement(element) {
  var useElement = element;
  if (typeof useElement === "string" && safeHTMLElement.canUseDOM) {
    var el = document.querySelectorAll(useElement);
    assertNodeList(el, useElement);
    useElement = "length" in el ? el[0] : el;
  }
  globalElement = useElement || globalElement;
  return globalElement;
}

function validateElement(appElement) {
  if (!appElement && !globalElement) {
    (0, _warning2.default)(false, ["react-modal: App element is not defined.", "Please use `Modal.setAppElement(el)` or set `appElement={el}`.", "This is needed so screen readers don't see main content", "when modal is opened. It is not recommended, but you can opt-out", "by setting `ariaHideApp={false}`."].join(" "));

    return false;
  }

  return true;
}

function hide(appElement) {
  if (validateElement(appElement)) {
    (appElement || globalElement).setAttribute("aria-hidden", "true");
  }
}

function show(appElement) {
  if (validateElement(appElement)) {
    (appElement || globalElement).removeAttribute("aria-hidden");
  }
}

function documentNotReadyOrSSRTesting() {
  globalElement = null;
}

function resetForTesting() {
  globalElement = null;
}
});

var classList = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dumpClassLists = dumpClassLists;
var htmlClassList = {};
var docBodyClassList = {};

function dumpClassLists() {
  if (process.env.NODE_ENV !== "production") {
    var classes = document.getElementsByTagName("html")[0].className;
    var buffer = "Show tracked classes:\n\n";

    buffer += "<html /> (" + classes + "):\n";
    for (var x in htmlClassList) {
      buffer += "  " + x + " " + htmlClassList[x] + "\n";
    }

    classes = document.body.className;

    // eslint-disable-next-line max-len
    buffer += "\n\ndoc.body (" + classes + "):\n";
    for (var _x in docBodyClassList) {
      buffer += "  " + _x + " " + docBodyClassList[_x] + "\n";
    }

    buffer += "\n";

    // eslint-disable-next-line no-console
    console.log(buffer);
  }
}

/**
 * Track the number of reference of a class.
 * @param {object} poll The poll to receive the reference.
 * @param {string} className The class name.
 * @return {string}
 */
var incrementReference = function incrementReference(poll, className) {
  if (!poll[className]) {
    poll[className] = 0;
  }
  poll[className] += 1;
  return className;
};

/**
 * Drop the reference of a class.
 * @param {object} poll The poll to receive the reference.
 * @param {string} className The class name.
 * @return {string}
 */
var decrementReference = function decrementReference(poll, className) {
  if (poll[className]) {
    poll[className] -= 1;
  }
  return className;
};

/**
 * Track a class and add to the given class list.
 * @param {Object} classListRef A class list of an element.
 * @param {Object} poll         The poll to be used.
 * @param {Array}  classes      The list of classes to be tracked.
 */
var trackClass = function trackClass(classListRef, poll, classes) {
  classes.forEach(function (className) {
    incrementReference(poll, className);
    classListRef.add(className);
  });
};

/**
 * Untrack a class and remove from the given class list if the reference
 * reaches 0.
 * @param {Object} classListRef A class list of an element.
 * @param {Object} poll         The poll to be used.
 * @param {Array}  classes      The list of classes to be untracked.
 */
var untrackClass = function untrackClass(classListRef, poll, classes) {
  classes.forEach(function (className) {
    decrementReference(poll, className);
    poll[className] === 0 && classListRef.remove(className);
  });
};

/**
 * Public inferface to add classes to the document.body.
 * @param {string} bodyClass The class string to be added.
 *                           It may contain more then one class
 *                           with ' ' as separator.
 */
var add = exports.add = function add(element, classString) {
  return trackClass(element.classList, element.nodeName.toLowerCase() == "html" ? htmlClassList : docBodyClassList, classString.split(" "));
};

/**
 * Public inferface to remove classes from the document.body.
 * @param {string} bodyClass The class string to be added.
 *                           It may contain more then one class
 *                           with ' ' as separator.
 */
var remove = exports.remove = function remove(element, classString) {
  return untrackClass(element.classList, element.nodeName.toLowerCase() == "html" ? htmlClassList : docBodyClassList, classString.split(" "));
};
});

var portalOpenInstances_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// Tracks portals that are open and emits events to subscribers

var PortalOpenInstances = function PortalOpenInstances() {
  var _this = this;

  _classCallCheck(this, PortalOpenInstances);

  this.register = function (openInstance) {
    if (_this.openInstances.indexOf(openInstance) !== -1) {
      if (process.env.NODE_ENV !== "production") {
        // eslint-disable-next-line no-console
        console.warn("React-Modal: Cannot register modal instance that's already open");
      }
      return;
    }
    _this.openInstances.push(openInstance);
    _this.emit("register");
  };

  this.deregister = function (openInstance) {
    var index = _this.openInstances.indexOf(openInstance);
    if (index === -1) {
      if (process.env.NODE_ENV !== "production") {
        // eslint-disable-next-line no-console
        console.warn("React-Modal: Unable to deregister " + openInstance + " as " + "it was never registered");
      }
      return;
    }
    _this.openInstances.splice(index, 1);
    _this.emit("deregister");
  };

  this.subscribe = function (callback) {
    _this.subscribers.push(callback);
  };

  this.emit = function (eventType) {
    _this.subscribers.forEach(function (subscriber) {
      return subscriber(eventType,
      // shallow copy to avoid accidental mutation
      _this.openInstances.slice());
    });
  };

  this.openInstances = [];
  this.subscribers = [];
};

var portalOpenInstances = new PortalOpenInstances();

exports.default = portalOpenInstances;
module.exports = exports["default"];
});

var bodyTrap_1 = createCommonjsModule(function (module) {



var _portalOpenInstances2 = _interopRequireDefault(portalOpenInstances_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Body focus trap see Issue #742

var before = void 0,
    after = void 0,
    instances = [];

function focusContent() {
  if (instances.length === 0) {
    if (process.env.NODE_ENV !== "production") {
      // eslint-disable-next-line no-console
      console.warn("React-Modal: Open instances > 0 expected");
    }
    return;
  }
  instances[instances.length - 1].focusContent();
}

function bodyTrap(eventType, openInstances) {
  if (!before || !after) {
    before = document.createElement("div");
    before.setAttribute("data-react-modal-body-trap", "");
    before.style.position = "absolute";
    before.style.opacity = "0";
    before.setAttribute("tabindex", "0");
    before.addEventListener("focus", focusContent);
    after = before.cloneNode();
    after.addEventListener("focus", focusContent);
  }

  instances = openInstances;

  if (instances.length > 0) {
    // Add focus trap
    if (document.body.firstChild !== before) {
      document.body.insertBefore(before, document.body.firstChild);
    }
    if (document.body.lastChild !== after) {
      document.body.appendChild(after);
    }
  } else {
    // Remove focus trap
    if (before.parentElement) {
      before.parentElement.removeChild(before);
    }
    if (after.parentElement) {
      after.parentElement.removeChild(after);
    }
  }
}

_portalOpenInstances2.default.subscribe(bodyTrap);
});

var ModalPortal_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();





var _propTypes2 = _interopRequireDefault(propTypes);



var focusManager$1 = _interopRequireWildcard(focusManager);



var _scopeTab2 = _interopRequireDefault(scopeTab_1);



var ariaAppHider$1 = _interopRequireWildcard(ariaAppHider);



var classList$1 = _interopRequireWildcard(classList);



var _safeHTMLElement2 = _interopRequireDefault(safeHTMLElement);



var _portalOpenInstances2 = _interopRequireDefault(portalOpenInstances_1);



function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// so that our CSS is statically analyzable
var CLASS_NAMES = {
  overlay: "ReactModal__Overlay",
  content: "ReactModal__Content"
};

var TAB_KEY = 9;
var ESC_KEY = 27;

var ariaHiddenInstances = 0;

var ModalPortal = function (_Component) {
  _inherits(ModalPortal, _Component);

  function ModalPortal(props) {
    _classCallCheck(this, ModalPortal);

    var _this = _possibleConstructorReturn(this, (ModalPortal.__proto__ || Object.getPrototypeOf(ModalPortal)).call(this, props));

    _this.setOverlayRef = function (overlay) {
      _this.overlay = overlay;
      _this.props.overlayRef && _this.props.overlayRef(overlay);
    };

    _this.setContentRef = function (content) {
      _this.content = content;
      _this.props.contentRef && _this.props.contentRef(content);
    };

    _this.afterClose = function () {
      var _this$props = _this.props,
          appElement = _this$props.appElement,
          ariaHideApp = _this$props.ariaHideApp,
          htmlOpenClassName = _this$props.htmlOpenClassName,
          bodyOpenClassName = _this$props.bodyOpenClassName;

      // Remove classes.

      bodyOpenClassName && classList$1.remove(document.body, bodyOpenClassName);

      htmlOpenClassName && classList$1.remove(document.getElementsByTagName("html")[0], htmlOpenClassName);

      // Reset aria-hidden attribute if all modals have been removed
      if (ariaHideApp && ariaHiddenInstances > 0) {
        ariaHiddenInstances -= 1;

        if (ariaHiddenInstances === 0) {
          ariaAppHider$1.show(appElement);
        }
      }

      if (_this.props.shouldFocusAfterRender) {
        if (_this.props.shouldReturnFocusAfterClose) {
          focusManager$1.returnFocus(_this.props.preventScroll);
          focusManager$1.teardownScopedFocus();
        } else {
          focusManager$1.popWithoutFocus();
        }
      }

      if (_this.props.onAfterClose) {
        _this.props.onAfterClose();
      }

      _portalOpenInstances2.default.deregister(_this);
    };

    _this.open = function () {
      _this.beforeOpen();
      if (_this.state.afterOpen && _this.state.beforeClose) {
        clearTimeout(_this.closeTimer);
        _this.setState({ beforeClose: false });
      } else {
        if (_this.props.shouldFocusAfterRender) {
          focusManager$1.setupScopedFocus(_this.node);
          focusManager$1.markForFocusLater();
        }

        _this.setState({ isOpen: true }, function () {
          _this.setState({ afterOpen: true });

          if (_this.props.isOpen && _this.props.onAfterOpen) {
            _this.props.onAfterOpen({
              overlayEl: _this.overlay,
              contentEl: _this.content
            });
          }
        });
      }
    };

    _this.close = function () {
      if (_this.props.closeTimeoutMS > 0) {
        _this.closeWithTimeout();
      } else {
        _this.closeWithoutTimeout();
      }
    };

    _this.focusContent = function () {
      return _this.content && !_this.contentHasFocus() && _this.content.focus({ preventScroll: true });
    };

    _this.closeWithTimeout = function () {
      var closesAt = Date.now() + _this.props.closeTimeoutMS;
      _this.setState({ beforeClose: true, closesAt: closesAt }, function () {
        _this.closeTimer = setTimeout(_this.closeWithoutTimeout, _this.state.closesAt - Date.now());
      });
    };

    _this.closeWithoutTimeout = function () {
      _this.setState({
        beforeClose: false,
        isOpen: false,
        afterOpen: false,
        closesAt: null
      }, _this.afterClose);
    };

    _this.handleKeyDown = function (event) {
      if (event.keyCode === TAB_KEY) {
        (0, _scopeTab2.default)(_this.content, event);
      }

      if (_this.props.shouldCloseOnEsc && event.keyCode === ESC_KEY) {
        event.stopPropagation();
        _this.requestClose(event);
      }
    };

    _this.handleOverlayOnClick = function (event) {
      if (_this.shouldClose === null) {
        _this.shouldClose = true;
      }

      if (_this.shouldClose && _this.props.shouldCloseOnOverlayClick) {
        if (_this.ownerHandlesClose()) {
          _this.requestClose(event);
        } else {
          _this.focusContent();
        }
      }
      _this.shouldClose = null;
    };

    _this.handleContentOnMouseUp = function () {
      _this.shouldClose = false;
    };

    _this.handleOverlayOnMouseDown = function (event) {
      if (!_this.props.shouldCloseOnOverlayClick && event.target == _this.overlay) {
        event.preventDefault();
      }
    };

    _this.handleContentOnClick = function () {
      _this.shouldClose = false;
    };

    _this.handleContentOnMouseDown = function () {
      _this.shouldClose = false;
    };

    _this.requestClose = function (event) {
      return _this.ownerHandlesClose() && _this.props.onRequestClose(event);
    };

    _this.ownerHandlesClose = function () {
      return _this.props.onRequestClose;
    };

    _this.shouldBeClosed = function () {
      return !_this.state.isOpen && !_this.state.beforeClose;
    };

    _this.contentHasFocus = function () {
      return document.activeElement === _this.content || _this.content.contains(document.activeElement);
    };

    _this.buildClassName = function (which, additional) {
      var classNames = (typeof additional === "undefined" ? "undefined" : _typeof(additional)) === "object" ? additional : {
        base: CLASS_NAMES[which],
        afterOpen: CLASS_NAMES[which] + "--after-open",
        beforeClose: CLASS_NAMES[which] + "--before-close"
      };
      var className = classNames.base;
      if (_this.state.afterOpen) {
        className = className + " " + classNames.afterOpen;
      }
      if (_this.state.beforeClose) {
        className = className + " " + classNames.beforeClose;
      }
      return typeof additional === "string" && additional ? className + " " + additional : className;
    };

    _this.attributesFromObject = function (prefix, items) {
      return Object.keys(items).reduce(function (acc, name) {
        acc[prefix + "-" + name] = items[name];
        return acc;
      }, {});
    };

    _this.state = {
      afterOpen: false,
      beforeClose: false
    };

    _this.shouldClose = null;
    _this.moveFromContentToOverlay = null;
    return _this;
  }

  _createClass(ModalPortal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.isOpen) {
        this.open();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (process.env.NODE_ENV !== "production") {
        if (prevProps.bodyOpenClassName !== this.props.bodyOpenClassName) {
          // eslint-disable-next-line no-console
          console.warn('React-Modal: "bodyOpenClassName" prop has been modified. ' + "This may cause unexpected behavior when multiple modals are open.");
        }
        if (prevProps.htmlOpenClassName !== this.props.htmlOpenClassName) {
          // eslint-disable-next-line no-console
          console.warn('React-Modal: "htmlOpenClassName" prop has been modified. ' + "This may cause unexpected behavior when multiple modals are open.");
        }
      }

      if (this.props.isOpen && !prevProps.isOpen) {
        this.open();
      } else if (!this.props.isOpen && prevProps.isOpen) {
        this.close();
      }

      // Focus only needs to be set once when the modal is being opened
      if (this.props.shouldFocusAfterRender && this.state.isOpen && !prevState.isOpen) {
        this.focusContent();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.state.isOpen) {
        this.afterClose();
      }
      clearTimeout(this.closeTimer);
    }
  }, {
    key: "beforeOpen",
    value: function beforeOpen() {
      var _props = this.props,
          appElement = _props.appElement,
          ariaHideApp = _props.ariaHideApp,
          htmlOpenClassName = _props.htmlOpenClassName,
          bodyOpenClassName = _props.bodyOpenClassName;

      // Add classes.

      bodyOpenClassName && classList$1.add(document.body, bodyOpenClassName);

      htmlOpenClassName && classList$1.add(document.getElementsByTagName("html")[0], htmlOpenClassName);

      if (ariaHideApp) {
        ariaHiddenInstances += 1;
        ariaAppHider$1.hide(appElement);
      }

      _portalOpenInstances2.default.register(this);
    }

    // Don't steal focus from inner elements

  }, {
    key: "render",
    value: function render() {
      var _props2 = this.props,
          id = _props2.id,
          className = _props2.className,
          overlayClassName = _props2.overlayClassName,
          defaultStyles = _props2.defaultStyles,
          children = _props2.children;

      var contentStyles = className ? {} : defaultStyles.content;
      var overlayStyles = overlayClassName ? {} : defaultStyles.overlay;

      if (this.shouldBeClosed()) {
        return null;
      }

      var overlayProps = {
        ref: this.setOverlayRef,
        className: this.buildClassName("overlay", overlayClassName),
        style: _extends({}, overlayStyles, this.props.style.overlay),
        onClick: this.handleOverlayOnClick,
        onMouseDown: this.handleOverlayOnMouseDown
      };

      var contentProps = _extends({
        id: id,
        ref: this.setContentRef,
        style: _extends({}, contentStyles, this.props.style.content),
        className: this.buildClassName("content", className),
        tabIndex: "-1",
        onKeyDown: this.handleKeyDown,
        onMouseDown: this.handleContentOnMouseDown,
        onMouseUp: this.handleContentOnMouseUp,
        onClick: this.handleContentOnClick,
        role: this.props.role,
        "aria-label": this.props.contentLabel
      }, this.attributesFromObject("aria", _extends({ modal: true }, this.props.aria)), this.attributesFromObject("data", this.props.data || {}), {
        "data-testid": this.props.testId
      });

      var contentElement = this.props.contentElement(contentProps, children);
      return this.props.overlayElement(overlayProps, contentElement);
    }
  }]);

  return ModalPortal;
}(React__default.Component);

ModalPortal.defaultProps = {
  style: {
    overlay: {},
    content: {}
  },
  defaultStyles: {}
};
ModalPortal.propTypes = {
  isOpen: _propTypes2.default.bool.isRequired,
  defaultStyles: _propTypes2.default.shape({
    content: _propTypes2.default.object,
    overlay: _propTypes2.default.object
  }),
  style: _propTypes2.default.shape({
    content: _propTypes2.default.object,
    overlay: _propTypes2.default.object
  }),
  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  overlayClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  bodyOpenClassName: _propTypes2.default.string,
  htmlOpenClassName: _propTypes2.default.string,
  ariaHideApp: _propTypes2.default.bool,
  appElement: _propTypes2.default.instanceOf(_safeHTMLElement2.default),
  onAfterOpen: _propTypes2.default.func,
  onAfterClose: _propTypes2.default.func,
  onRequestClose: _propTypes2.default.func,
  closeTimeoutMS: _propTypes2.default.number,
  shouldFocusAfterRender: _propTypes2.default.bool,
  shouldCloseOnOverlayClick: _propTypes2.default.bool,
  shouldReturnFocusAfterClose: _propTypes2.default.bool,
  preventScroll: _propTypes2.default.bool,
  role: _propTypes2.default.string,
  contentLabel: _propTypes2.default.string,
  aria: _propTypes2.default.object,
  data: _propTypes2.default.object,
  children: _propTypes2.default.node,
  shouldCloseOnEsc: _propTypes2.default.bool,
  overlayRef: _propTypes2.default.func,
  contentRef: _propTypes2.default.func,
  id: _propTypes2.default.string,
  overlayElement: _propTypes2.default.func,
  contentElement: _propTypes2.default.func,
  testId: _propTypes2.default.string
};
exports.default = ModalPortal;
module.exports = exports["default"];
});

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function componentWillMount() {
  // Call this.constructor.gDSFP to support sub-classes.
  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
  if (state !== null && state !== undefined) {
    this.setState(state);
  }
}

function componentWillReceiveProps(nextProps) {
  // Call this.constructor.gDSFP to support sub-classes.
  // Use the setState() updater to ensure state isn't stale in certain edge cases.
  function updater(prevState) {
    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
    return state !== null && state !== undefined ? state : null;
  }
  // Binding "this" is important for shallow renderer support.
  this.setState(updater.bind(this));
}

function componentWillUpdate(nextProps, nextState) {
  try {
    var prevProps = this.props;
    var prevState = this.state;
    this.props = nextProps;
    this.state = nextState;
    this.__reactInternalSnapshotFlag = true;
    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
      prevProps,
      prevState
    );
  } finally {
    this.props = prevProps;
    this.state = prevState;
  }
}

// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;

function polyfill(Component) {
  var prototype = Component.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  }

  if (
    typeof Component.getDerivedStateFromProps !== 'function' &&
    typeof prototype.getSnapshotBeforeUpdate !== 'function'
  ) {
    return Component;
  }

  // If new component APIs are defined, "unsafe" lifecycles won't be called.
  // Error if any of these lifecycles are present,
  // Because they would work differently between older and newer (16.3+) versions of React.
  var foundWillMountName = null;
  var foundWillReceivePropsName = null;
  var foundWillUpdateName = null;
  if (typeof prototype.componentWillMount === 'function') {
    foundWillMountName = 'componentWillMount';
  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
    foundWillMountName = 'UNSAFE_componentWillMount';
  }
  if (typeof prototype.componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'componentWillReceiveProps';
  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
  }
  if (typeof prototype.componentWillUpdate === 'function') {
    foundWillUpdateName = 'componentWillUpdate';
  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
  }
  if (
    foundWillMountName !== null ||
    foundWillReceivePropsName !== null ||
    foundWillUpdateName !== null
  ) {
    var componentName = Component.displayName || Component.name;
    var newApiName =
      typeof Component.getDerivedStateFromProps === 'function'
        ? 'getDerivedStateFromProps()'
        : 'getSnapshotBeforeUpdate()';

    throw Error(
      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
        componentName +
        ' uses ' +
        newApiName +
        ' but also contains the following legacy lifecycles:' +
        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
        (foundWillReceivePropsName !== null
          ? '\n  ' + foundWillReceivePropsName
          : '') +
        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
        'https://fb.me/react-async-component-lifecycle-hooks'
    );
  }

  // React <= 16.2 does not support static getDerivedStateFromProps.
  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
  // Newer versions of React will ignore these lifecycles if gDSFP exists.
  if (typeof Component.getDerivedStateFromProps === 'function') {
    prototype.componentWillMount = componentWillMount;
    prototype.componentWillReceiveProps = componentWillReceiveProps;
  }

  // React <= 16.2 does not support getSnapshotBeforeUpdate.
  // As a workaround, use cWU to invoke the new lifecycle.
  // Newer versions of React will ignore that lifecycle if gSBU exists.
  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
    if (typeof prototype.componentDidUpdate !== 'function') {
      throw new Error(
        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
      );
    }

    prototype.componentWillUpdate = componentWillUpdate;

    var componentDidUpdate = prototype.componentDidUpdate;

    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
      prevProps,
      prevState,
      maybeSnapshot
    ) {
      // 16.3+ will not execute our will-update method;
      // It will pass a snapshot value to did-update though.
      // Older versions will require our polyfilled will-update value.
      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
      // Because for <= 15.x versions this might be a "prevContext" object.
      // We also can't just check "__reactInternalSnapshot",
      // Because get-snapshot might return a falsy value.
      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
      var snapshot = this.__reactInternalSnapshotFlag
        ? this.__reactInternalSnapshot
        : maybeSnapshot;

      componentDidUpdate.call(this, prevProps, prevState, snapshot);
    };
  }

  return Component;
}

var reactLifecyclesCompat_es = /*#__PURE__*/Object.freeze({
    __proto__: null,
    polyfill: polyfill
});

var Modal_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bodyOpenClassName = exports.portalClassName = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



var _react2 = _interopRequireDefault(React__default);



var _reactDom2 = _interopRequireDefault(ReactDOM);



var _propTypes2 = _interopRequireDefault(propTypes);



var _ModalPortal2 = _interopRequireDefault(ModalPortal_1);



var ariaAppHider$1 = _interopRequireWildcard(ariaAppHider);



var _safeHTMLElement2 = _interopRequireDefault(safeHTMLElement);



function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var portalClassName = exports.portalClassName = "ReactModalPortal";
var bodyOpenClassName = exports.bodyOpenClassName = "ReactModal__Body--open";

var isReact16 = safeHTMLElement.canUseDOM && _reactDom2.default.createPortal !== undefined;

var getCreatePortal = function getCreatePortal() {
  return isReact16 ? _reactDom2.default.createPortal : _reactDom2.default.unstable_renderSubtreeIntoContainer;
};

function getParentElement(parentSelector) {
  return parentSelector();
}

var Modal = function (_Component) {
  _inherits(Modal, _Component);

  function Modal() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Modal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Modal.__proto__ || Object.getPrototypeOf(Modal)).call.apply(_ref, [this].concat(args))), _this), _this.removePortal = function () {
      !isReact16 && _reactDom2.default.unmountComponentAtNode(_this.node);
      var parent = getParentElement(_this.props.parentSelector);
      if (parent && parent.contains(_this.node)) {
        parent.removeChild(_this.node);
      } else {
        // eslint-disable-next-line no-console
        console.warn('React-Modal: "parentSelector" prop did not returned any DOM ' + "element. Make sure that the parent element is unmounted to " + "avoid any memory leaks.");
      }
    }, _this.portalRef = function (ref) {
      _this.portal = ref;
    }, _this.renderPortal = function (props) {
      var createPortal = getCreatePortal();
      var portal = createPortal(_this, _react2.default.createElement(_ModalPortal2.default, _extends({ defaultStyles: Modal.defaultStyles }, props)), _this.node);
      _this.portalRef(portal);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Modal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!safeHTMLElement.canUseDOM) return;

      if (!isReact16) {
        this.node = document.createElement("div");
      }
      this.node.className = this.props.portalClassName;

      var parent = getParentElement(this.props.parentSelector);
      parent.appendChild(this.node);

      !isReact16 && this.renderPortal(this.props);
    }
  }, {
    key: "getSnapshotBeforeUpdate",
    value: function getSnapshotBeforeUpdate(prevProps) {
      var prevParent = getParentElement(prevProps.parentSelector);
      var nextParent = getParentElement(this.props.parentSelector);
      return { prevParent: prevParent, nextParent: nextParent };
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, _, snapshot) {
      if (!safeHTMLElement.canUseDOM) return;
      var _props = this.props,
          isOpen = _props.isOpen,
          portalClassName = _props.portalClassName;


      if (prevProps.portalClassName !== portalClassName) {
        this.node.className = portalClassName;
      }

      var prevParent = snapshot.prevParent,
          nextParent = snapshot.nextParent;

      if (nextParent !== prevParent) {
        prevParent.removeChild(this.node);
        nextParent.appendChild(this.node);
      }

      // Stop unnecessary renders if modal is remaining closed
      if (!prevProps.isOpen && !isOpen) return;

      !isReact16 && this.renderPortal(this.props);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (!safeHTMLElement.canUseDOM || !this.node || !this.portal) return;

      var state = this.portal.state;
      var now = Date.now();
      var closesAt = state.isOpen && this.props.closeTimeoutMS && (state.closesAt || now + this.props.closeTimeoutMS);

      if (closesAt) {
        if (!state.beforeClose) {
          this.portal.closeWithTimeout();
        }

        setTimeout(this.removePortal, closesAt - now);
      } else {
        this.removePortal();
      }
    }
  }, {
    key: "render",
    value: function render() {
      if (!safeHTMLElement.canUseDOM || !isReact16) {
        return null;
      }

      if (!this.node && isReact16) {
        this.node = document.createElement("div");
      }

      var createPortal = getCreatePortal();
      return createPortal(_react2.default.createElement(_ModalPortal2.default, _extends({
        ref: this.portalRef,
        defaultStyles: Modal.defaultStyles
      }, this.props)), this.node);
    }
  }], [{
    key: "setAppElement",
    value: function setAppElement(element) {
      ariaAppHider$1.setElement(element);
    }

    /* eslint-disable react/no-unused-prop-types */

    /* eslint-enable react/no-unused-prop-types */

  }]);

  return Modal;
}(React__default.Component);

Modal.propTypes = {
  isOpen: _propTypes2.default.bool.isRequired,
  style: _propTypes2.default.shape({
    content: _propTypes2.default.object,
    overlay: _propTypes2.default.object
  }),
  portalClassName: _propTypes2.default.string,
  bodyOpenClassName: _propTypes2.default.string,
  htmlOpenClassName: _propTypes2.default.string,
  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
    base: _propTypes2.default.string.isRequired,
    afterOpen: _propTypes2.default.string.isRequired,
    beforeClose: _propTypes2.default.string.isRequired
  })]),
  overlayClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
    base: _propTypes2.default.string.isRequired,
    afterOpen: _propTypes2.default.string.isRequired,
    beforeClose: _propTypes2.default.string.isRequired
  })]),
  appElement: _propTypes2.default.instanceOf(_safeHTMLElement2.default),
  onAfterOpen: _propTypes2.default.func,
  onRequestClose: _propTypes2.default.func,
  closeTimeoutMS: _propTypes2.default.number,
  ariaHideApp: _propTypes2.default.bool,
  shouldFocusAfterRender: _propTypes2.default.bool,
  shouldCloseOnOverlayClick: _propTypes2.default.bool,
  shouldReturnFocusAfterClose: _propTypes2.default.bool,
  preventScroll: _propTypes2.default.bool,
  parentSelector: _propTypes2.default.func,
  aria: _propTypes2.default.object,
  data: _propTypes2.default.object,
  role: _propTypes2.default.string,
  contentLabel: _propTypes2.default.string,
  shouldCloseOnEsc: _propTypes2.default.bool,
  overlayRef: _propTypes2.default.func,
  contentRef: _propTypes2.default.func,
  id: _propTypes2.default.string,
  overlayElement: _propTypes2.default.func,
  contentElement: _propTypes2.default.func
};
Modal.defaultProps = {
  isOpen: false,
  portalClassName: portalClassName,
  bodyOpenClassName: bodyOpenClassName,
  role: "dialog",
  ariaHideApp: true,
  closeTimeoutMS: 0,
  shouldFocusAfterRender: true,
  shouldCloseOnEsc: true,
  shouldCloseOnOverlayClick: true,
  shouldReturnFocusAfterClose: true,
  preventScroll: false,
  parentSelector: function parentSelector() {
    return document.body;
  },
  overlayElement: function overlayElement(props, contentEl) {
    return _react2.default.createElement(
      "div",
      props,
      contentEl
    );
  },
  contentElement: function contentElement(props, children) {
    return _react2.default.createElement(
      "div",
      props,
      children
    );
  }
};
Modal.defaultStyles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(255, 255, 255, 0.75)"
  },
  content: {
    position: "absolute",
    top: "40px",
    left: "40px",
    right: "40px",
    bottom: "40px",
    border: "1px solid #ccc",
    background: "#fff",
    overflow: "auto",
    WebkitOverflowScrolling: "touch",
    borderRadius: "4px",
    outline: "none",
    padding: "20px"
  }
};


(0, reactLifecyclesCompat_es.polyfill)(Modal);

exports.default = Modal;
});

var lib = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var _Modal2 = _interopRequireDefault(Modal_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Modal2.default;
module.exports = exports["default"];
});

var ReactModal = /*@__PURE__*/unwrapExports(lib);

var css_248z$6 = ".react-modal__overlay {\n  position: absolute;\n  z-index: 200;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  justify-content: center;\n  transition: opacity 300ms cubic-bezier(0, 0, 0.2, 1);\n  opacity: 0;\n  background: rgba(216, 222, 229, 0.3); }\n  .react-modal__overlay.ReactModal__Overlay--after-open {\n    opacity: 1; }\n\n.react-modal__content {\n  position: relative;\n  display: flex;\n  overflow: auto;\n  align-items: flex-start;\n  flex-direction: column;\n  justify-content: flex-start;\n  width: 700px;\n  padding: 20px;\n  opacity: 1;\n  border: 1px solid #dee3e8;\n  outline: none;\n  background: #fff;\n  -webkit-overflow-scrolling: touch; }\n  .react-modal__content--small {\n    width: 360px;\n    height: 360px; }\n  .react-modal__content--medium {\n    width: 500px;\n    height: 500px; }\n\n.react-modal__actions {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  margin-top: auto; }\n";
styleInject(css_248z$6);

const getDocumentBody = () => document.body;
const Modal = (_a) => {
    var { closeTimeoutMS = 0, shouldFocusAfterRender = true, shouldCloseOnOverlayClick = true, shouldCloseOnEsc = false, shouldReturnFocusAfterClose = true, parentSelector = getDocumentBody, size, extraClasses, extraOverlayClasses } = _a, props = __rest(_a, ["closeTimeoutMS", "shouldFocusAfterRender", "shouldCloseOnOverlayClick", "shouldCloseOnEsc", "shouldReturnFocusAfterClose", "parentSelector", "size", "extraClasses", "extraOverlayClasses"]);
    const classes = classnames('react-modal__content', size && `react-modal__content--${size}`, extraClasses);
    const overlayClassName = classnames('react-modal__overlay', extraOverlayClasses);
    return (React__default.createElement(ReactModal, Object.assign({ closeTimeoutMS: closeTimeoutMS, shouldFocusAfterRender: shouldFocusAfterRender, shouldCloseOnOverlayClick: shouldCloseOnOverlayClick, shouldCloseOnEsc: shouldCloseOnEsc, shouldReturnFocusAfterClose: shouldReturnFocusAfterClose, parentSelector: parentSelector, ariaHideApp: false, className: classes, overlayClassName: overlayClassName, bodyOpenClassName: "react-modal-body--open", htmlOpenClassName: "react-modal-html--open", portalClassName: "react-modal-portal" }, props)));
};

const getParent = (selector) => document.querySelector(selector);
const getParentById = (id) => getParent(`#${id}`);

var css_248z$7 = "@keyframes zoomOut {\n  from {\n    opacity: 1; }\n  50% {\n    opacity: 0;\n    transform: scale3d(0.2, 0.2, 0.2); }\n  to {\n    opacity: 0; } }\n\n@keyframes slideInRight {\n  from {\n    transform: translate3d(100%, 0, 0);\n    visibility: visible; }\n  to {\n    transform: translate3d(0, 0, 0); } }\n\n.react-modal__overlay--sidebar-modal {\n  background-color: rgba(75, 87, 126, 0.8); }\n  .react-modal__overlay--sidebar-modal.ReactModal__Overlay--before-close {\n    animation: 300ms zoomOut cubic-bezier(0, 0, 0.2, 1) both; }\n\n.react-modal__content--sidebar-modal {\n  width: 100%;\n  height: auto;\n  background-color: #445076;\n  color: #fff;\n  border: none;\n  padding-bottom: 0;\n  font-size: .9em; }\n  .react-modal__content--sidebar-modal.ReactModal__Content--after-open {\n    animation: 300ms slideInRight cubic-bezier(0, 0, 0.2, 1); }\n  .react-modal__content--sidebar-modal .react-modal__actions {\n    justify-content: center;\n    border-top: 2px solid #5d6a8c;\n    height: 55px;\n    margin: 0 -20px;\n    padding: 0 20px;\n    width: calc(100% + 40px); }\n    .react-modal__content--sidebar-modal .react-modal__actions .react-modal__actions__btn {\n      background: transparent;\n      opacity: .5;\n      font-size: 13px;\n      transition: opacity .3s ease-in-out; }\n      .react-modal__content--sidebar-modal .react-modal__actions .react-modal__actions__btn:hover, .react-modal__content--sidebar-modal .react-modal__actions .react-modal__actions__btn:focus {\n        opacity: 1; }\n      .react-modal__content--sidebar-modal .react-modal__actions .react-modal__actions__btn:disabled {\n        opacity: .2; }\n      .react-modal__content--sidebar-modal .react-modal__actions .react-modal__actions__btn:focus {\n        outline: 1px solid #5d6a8c; }\n\n.react-modal__content__title {\n  color: #fff;\n  font-size: 1em;\n  margin-bottom: 20px; }\n\n.react-modal__content__message {\n  margin-top: 0;\n  margin-bottom: 20px; }\n\n.react-modal__content--empty {\n  padding-top: 0; }\n  .react-modal__content--empty .react-modal__actions {\n    border-top: none; }\n\n.react-modal__content--info {\n  background-color: #00bed5; }\n\n.react-modal__content--error {\n  background-color: #f05656; }\n\n.sidebar-view,\n.sidebar-view-inside {\n  background-color: #4b577e; }\n";
styleInject(css_248z$7);

var SidebarModalType;
(function (SidebarModalType) {
    SidebarModalType["Info"] = "info";
    SidebarModalType["Error"] = "error";
})(SidebarModalType || (SidebarModalType = {}));
const SIDEBAR_VIEW_ID = 'sidebar-view';
function withSidebarModal(Wrapped, name) {
    return function innerSideBarModal(_a) {
        var { extraClasses, extraOverlayClasses, type, parentSidebarId = SIDEBAR_VIEW_ID } = _a, props = __rest(_a, ["extraClasses", "extraOverlayClasses", "type", "parentSidebarId"]);
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const { isClosing } = useContext(SidebarContext);
        const className = classnames('react-modal__content--sidebar-modal', type && `react-modal__content--${type}`, name && `react-modal__content--${name}`, extraClasses);
        const overlayClassName = classnames('react-modal__overlay--sidebar-modal', type && `react-modal__overlay--${type}`, name && `react-modal__overlay--${name}`, extraOverlayClasses);
        return (React__default.createElement(Modal, Object.assign({ shouldCloseOnOverlayClick: false, shouldCloseOnEsc: false, extraClasses: className, extraOverlayClasses: overlayClassName, parentSelector: () => getParentById(parentSidebarId), closeTimeoutMS: isClosing ? 0 : 300 }, props),
            React__default.createElement(Wrapped, Object.assign({}, props))));
    };
}

const ModalActions = ({ extraClasses, children }) => {
    const classes = classnames('react-modal__actions', extraClasses);
    return React__default.createElement("div", { className: classes }, children);
};

/**
 * Debounce the wrapped component prop 'onChange'
 */
function FieldWithDebounce(Wrapped) {
    const debouncedField = (_a) => {
        var { wait = 300, onChange } = _a, restProps = __rest(_a, ["wait", "onChange"]);
        return (React__default.createElement(Wrapped, Object.assign({}, restProps, { onChange: lodash_debounce(onChange, wait) })));
    };
    return debouncedField;
}

const InputFieldBase = (_a) => {
    var { name, disabled, value, type = 'text', onChange, extraClasses, isControllable = false } = _a, restProps = __rest(_a, ["name", "disabled", "value", "type", "onChange", "extraClasses", "isControllable"]);
    return (React__default.createElement("input", Object.assign({}, restProps, { id: name, name: name }, (isControllable ? { value: value } : { defaultValue: value }), { type: type, className: classnames('input', extraClasses), disabled: disabled, onChange: evt => onChange(evt.target.value) })));
};
const InputField = FieldWithLabel(InputFieldBase);
const DebouncedInputField = FieldWithDebounce(InputField);

var css_248z$8 = ".react-modal__content--confirm-password {\n  padding-top: 32px; }\n  .react-modal__content--confirm-password .react-modal__actions {\n    margin-top: 35px; }\n  .react-modal__content--confirm-password .react-modal__form {\n    width: 100%;\n    margin-top: 20px;\n    padding-bottom: 0; }\n";
styleInject(css_248z$8);

const validation = {
    password: [[isRequired, () => t('field.password.error')]],
};
const ConfirmPasswordBase = ({ onConfirm, onCancel }) => (React__default.createElement(React__default.Fragment, null,
    t('label.enter-password'),
    React__default.createElement(Formik, { initialValues: { password: '' }, onSubmit: onConfirm }, ({ isValid, dirty }) => (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(Form, { className: "react-modal__form" },
            React__default.createElement(Field, { name: "password", validate: validate(validation.password) }, withFieldProps(React__default.createElement(InputField, { label: t('field.password'), type: "password", autoFocus: true }))),
            React__default.createElement(ModalActions, null,
                React__default.createElement("button", { className: "react-modal__actions__btn btn", type: "button", onClick: onCancel },
                    React__default.createElement(SvgIcon, { name: IconName.Times, width: 13 })),
                React__default.createElement("button", { className: "react-modal__actions__btn btn", type: "submit", disabled: !isValid || !dirty },
                    React__default.createElement(SvgIcon, { name: IconName.Checkmark, width: 17 })))))))));
const ConfirmPassword = withSidebarModal(ConfirmPasswordBase, 'confirm-password');

function useTimeoutWhen(callback, delay, cond) {
    useEffect(() => {
        if (!cond) {
            return;
        }
        const timer = setTimeout(callback, delay);
        return () => clearTimeout(timer);
    }, [callback, delay, cond]);
}

var css_248z$9 = ".react-modal__content--alert {\n  text-transform: uppercase;\n  flex-direction: row;\n  padding: 0 20px;\n  justify-content: center;\n  min-height: 52px; }\n  .react-modal__content--alert .react-modal__content__icon {\n    width: 45px;\n    display: block;\n    margin: auto;\n    margin-right: 10px; }\n  .react-modal__content--alert .react-modal__content__message {\n    padding: 18px 0;\n    margin: 0;\n    line-height: 20px;\n    width: 100%; }\n  .react-modal__content--alert .react-modal__actions {\n    width: 40px;\n    margin: auto;\n    padding: 0;\n    border-top: none; }\n";
styleInject(css_248z$9);

const AlertBase = ({ icon, message, isOpen, onConfirm, isAutoConfirm, autoConfirmDelay = 2000, }) => {
    useTimeoutWhen(onConfirm, autoConfirmDelay, !!(isOpen && isAutoConfirm));
    return (React__default.createElement(React__default.Fragment, null,
        icon && React__default.createElement("div", { className: "react-modal__content__icon" }, icon),
        message && React__default.createElement("p", { className: "react-modal__content__message" }, message),
        !isAutoConfirm && (React__default.createElement(ModalActions, null,
            React__default.createElement("button", { className: "react-modal__actions__btn btn", type: "button", title: t('action.ok'), onClick: onConfirm },
                React__default.createElement(SvgIcon, { name: IconName.Checkmark, width: 17 }))))));
};
const Alert = withSidebarModal(AlertBase, 'alert');

const AutoConfirmedAlert = props => (React__default.createElement(Alert, Object.assign({}, props, { isAutoConfirm: props.type === SidebarModalType.Info })));

var css_248z$a = ".react-modal__content--confirm {\n  padding-top: 0; }\n  .react-modal__content--confirm .react-modal__description {\n    padding-top: 20px;\n    width: 100%; }\n  .react-modal__content--confirm .react-modal__content__subtitle {\n    text-transform: uppercase; }\n  .react-modal__content--confirm .react-modal__content__body a {\n    color: white;\n    text-decoration: underline; }\n    .react-modal__content--confirm .react-modal__content__body a:hover {\n      text-decoration: none; }\n  .react-modal__content--confirm .react-modal__actions {\n    justify-content: space-between; }\n    .react-modal__content--confirm .react-modal__actions-block:only-child {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      width: 100%; }\n  .react-modal__content--confirm.react-modal__content--info, .react-modal__content--confirm.react-modal__content--error {\n    background-color: #445076; }\n    .react-modal__content--confirm.react-modal__content--info .react-modal__actions, .react-modal__content--confirm.react-modal__content--error .react-modal__actions {\n      border-top: none; }\n  .react-modal__content--confirm.react-modal__content--info .react-modal__actions {\n    background-color: #00bed5; }\n  .react-modal__content--confirm.react-modal__content--error .react-modal__actions {\n    background-color: #f05656; }\n  .react-modal__content--confirm .react-modal__actions-block {\n    flex-shrink: 0; }\n";
styleInject(css_248z$a);

const ConfirmBase = ({ title, subtitle, message, children, onConfirm, onCancel }) => (React__default.createElement(React__default.Fragment, null,
    (title || message || children) && (React__default.createElement("div", { className: "react-modal__description" },
        title && React__default.createElement("h3", { className: "react-modal__content__title" }, title),
        (message || children) && (React__default.createElement("div", { className: "react-modal__content__body" },
            message && React__default.createElement("p", null, message),
            children)))),
    React__default.createElement(ModalActions, null,
        subtitle && React__default.createElement("span", { className: "react-modal__content__subtitle" }, subtitle),
        React__default.createElement("div", { className: "react-modal__actions-block" },
            onCancel && (React__default.createElement("button", { className: "react-modal__actions__btn btn", type: "button", title: t('action.cancel'), onClick: onCancel },
                React__default.createElement(SvgIcon, { name: IconName.Times, width: 13 }))),
            onConfirm && (React__default.createElement("button", { className: "react-modal__actions__btn btn", type: "button", title: t('action.ok'), onClick: onConfirm },
                React__default.createElement(SvgIcon, { name: IconName.Checkmark, width: 17 })))))));
const Confirm = withSidebarModal(ConfirmBase, 'confirm');

/* global DOMException */

var clipboardCopy_1 = clipboardCopy;

function clipboardCopy (text) {
  // Use the Async Clipboard API when available. Requires a secure browing
  // context (i.e. HTTPS)
  if (navigator.clipboard) {
    return navigator.clipboard.writeText(text).catch(function (err) {
      throw (err !== undefined ? err : new DOMException('The request is not allowed', 'NotAllowedError'))
    })
  }

  // ...Otherwise, use document.execCommand() fallback

  // Put the text to copy into a <span>
  var span = document.createElement('span');
  span.textContent = text;

  // Preserve consecutive spaces and newlines
  span.style.whiteSpace = 'pre';

  // Add the <span> to the page
  document.body.appendChild(span);

  // Make a selection object representing the range of text selected by the user
  var selection = window.getSelection();
  var range = window.document.createRange();
  selection.removeAllRanges();
  range.selectNode(span);
  selection.addRange(range);

  // Copy text to the clipboard
  var success = false;
  try {
    success = window.document.execCommand('copy');
  } catch (err) {
    console.log('error', err);
  }

  // Cleanup
  selection.removeAllRanges();
  window.document.body.removeChild(span);

  return success
    ? Promise.resolve()
    : Promise.reject(new DOMException('The request is not allowed', 'NotAllowedError'))
}

var css_248z$b = ".fade-tooltip {\n  word-break: keep-all;\n  position: absolute;\n  right: 0;\n  top: 100%;\n  margin-top: 4px;\n  padding: 4px 10px;\n  border-radius: 6px;\n  background-color: black;\n  color: #fff;\n  font-size: 14px;\n  z-index: 100;\n  transition: opacity ease-in-out; }\n\n.fade-transition-enter {\n  opacity: 0; }\n\n.fade-transition-enter-active {\n  opacity: 1; }\n\n.fade-transition-exit {\n  opacity: 1; }\n\n.fade-transition-exit-active {\n  opacity: 0; }\n";
styleInject(css_248z$b);

const defaultTransitionTime = 250;
const FadeTooltip = ({ children, isVisible, extraClasses, transitionTime = defaultTransitionTime, }) => (React__default.createElement(CSSTransition, { in: isVisible, classNames: "fade-transition", timeout: transitionTime, unmountOnExit: true },
    React__default.createElement("div", { className: classnames('fade-tooltip', extraClasses), style: { transitionDuration: `${transitionTime}ms` } }, children)));

var css_248z$c = ".CopyClipboard-module_container__3HAav {\n  position: relative; }\n\n.CopyClipboard-module_btn__3gYYC {\n  cursor: pointer;\n  user-select: none;\n  color: #96a1bd;\n  transition: color 200ms ease-in-out; }\n  .CopyClipboard-module_btn__3gYYC:hover {\n    color: #fff; }\n\n.CopyClipboard-module_disabled__2Zt1i {\n  pointer-events: none; }\n";
var styles$1 = {"container":"CopyClipboard-module_container__3HAav","btn":"CopyClipboard-module_btn__3gYYC","disabled":"CopyClipboard-module_disabled__2Zt1i"};
styleInject(css_248z$c);

const copyTrimmedContent = param => clipboardCopy_1(param.trim());
const CopyClipboard = ({ content, tooltipTitle, children, testId, isDisabled, extraClasses, }) => {
    const [isTooltipVisible, setIsTooltipVisible] = useState(false);
    useTimeoutWhen(() => {
        setIsTooltipVisible(false);
    }, 2000, isTooltipVisible);
    const handleCopy = useCallback(() => {
        copyTrimmedContent(content);
        setIsTooltipVisible(true);
    }, [content]);
    return (React__default.createElement("div", { className: classnames(styles$1.container, extraClasses === null || extraClasses === void 0 ? void 0 : extraClasses.main) },
        React__default.createElement("a", { className: classnames(styles$1.btn, extraClasses === null || extraClasses === void 0 ? void 0 : extraClasses.content, isDisabled && styles$1.disabled), title: tooltipTitle, onClick: handleCopy, "data-testid": testId }, children ? children : React__default.createElement("i", { className: "icon-clipboard" })),
        React__default.createElement(FadeTooltip, { isVisible: isTooltipVisible, extraClasses: extraClasses === null || extraClasses === void 0 ? void 0 : extraClasses.tooltip }, t('label.copied'))));
};

var css_248z$d = ".closing-tag {\n  white-space: nowrap; }\n\n.closing-tag__value {\n  color: #fff;\n  font-size: 13px; }\n\n.closing-tag__close-button {\n  cursor: pointer;\n  margin-left: 10px;\n  display: flex; }\n  .closing-tag__close-button svg {\n    fill: #8a95b3; }\n    .closing-tag__close-button svg:hover {\n      fill: #aab5d0; }\n";
styleInject(css_248z$d);

const Tag = ({ children, onClose, testId }) => (React__default.createElement("div", { className: "flex-box-row flex-align-center closing-tag" },
    React__default.createElement("div", { className: "monospace-text closing-tag__value" }, children),
    onClose && (React__default.createElement("span", { className: "closing-tag__close-button", onClick: onClose, "data-testid": testId },
        React__default.createElement(SvgIcon, { name: IconName.Times, width: 8 })))));

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

var COMMON_MIME_TYPES = new Map([
    ['avi', 'video/avi'],
    ['gif', 'image/gif'],
    ['ico', 'image/x-icon'],
    ['jpeg', 'image/jpeg'],
    ['jpg', 'image/jpeg'],
    ['mkv', 'video/x-matroska'],
    ['mov', 'video/quicktime'],
    ['mp4', 'video/mp4'],
    ['pdf', 'application/pdf'],
    ['png', 'image/png'],
    ['zip', 'application/zip'],
    ['doc', 'application/msword'],
    ['docx', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document']
]);
function toFileWithPath(file, path) {
    var f = withMimeType(file);
    if (typeof f.path !== 'string') { // on electron, path is already set to the absolute path
        var webkitRelativePath = file.webkitRelativePath;
        Object.defineProperty(f, 'path', {
            value: typeof path === 'string'
                ? path
                // If <input webkitdirectory> is set,
                // the File will have a {webkitRelativePath} property
                // https://developer.mozilla.org/en-US/docs/Web/API/HTMLInputElement/webkitdirectory
                : typeof webkitRelativePath === 'string' && webkitRelativePath.length > 0
                    ? webkitRelativePath
                    : file.name,
            writable: false,
            configurable: false,
            enumerable: true
        });
    }
    return f;
}
function withMimeType(file) {
    var name = file.name;
    var hasExtension = name && name.lastIndexOf('.') !== -1;
    if (hasExtension && !file.type) {
        var ext = name.split('.')
            .pop().toLowerCase();
        var type = COMMON_MIME_TYPES.get(ext);
        if (type) {
            Object.defineProperty(file, 'type', {
                value: type,
                writable: false,
                configurable: false,
                enumerable: true
            });
        }
    }
    return file;
}

var FILES_TO_IGNORE = [
    // Thumbnail cache files for macOS and Windows
    '.DS_Store',
    'Thumbs.db' // Windows
];
/**
 * Convert a DragEvent's DataTrasfer object to a list of File objects
 * NOTE: If some of the items are folders,
 * everything will be flattened and placed in the same list but the paths will be kept as a {path} property.
 * @param evt
 */
function fromEvent(evt) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, isDragEvt(evt) && evt.dataTransfer
                    ? getDataTransferFiles(evt.dataTransfer, evt.type)
                    : getInputFiles(evt)];
        });
    });
}
function isDragEvt(value) {
    return !!value.dataTransfer;
}
function getInputFiles(evt) {
    var files = isInput(evt.target)
        ? evt.target.files
            ? fromList(evt.target.files)
            : []
        : [];
    return files.map(function (file) { return toFileWithPath(file); });
}
function isInput(value) {
    return value !== null;
}
function getDataTransferFiles(dt, type) {
    return __awaiter(this, void 0, void 0, function () {
        var items, files;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!dt.items) return [3 /*break*/, 2];
                    items = fromList(dt.items)
                        .filter(function (item) { return item.kind === 'file'; });
                    // According to https://html.spec.whatwg.org/multipage/dnd.html#dndevents,
                    // only 'dragstart' and 'drop' has access to the data (source node)
                    if (type !== 'drop') {
                        return [2 /*return*/, items];
                    }
                    return [4 /*yield*/, Promise.all(items.map(toFilePromises))];
                case 1:
                    files = _a.sent();
                    return [2 /*return*/, noIgnoredFiles(flatten(files))];
                case 2: return [2 /*return*/, noIgnoredFiles(fromList(dt.files)
                        .map(function (file) { return toFileWithPath(file); }))];
            }
        });
    });
}
function noIgnoredFiles(files) {
    return files.filter(function (file) { return FILES_TO_IGNORE.indexOf(file.name) === -1; });
}
// IE11 does not support Array.from()
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/from#Browser_compatibility
// https://developer.mozilla.org/en-US/docs/Web/API/FileList
// https://developer.mozilla.org/en-US/docs/Web/API/DataTransferItemList
function fromList(items) {
    var files = [];
    // tslint:disable: prefer-for-of
    for (var i = 0; i < items.length; i++) {
        var file = items[i];
        files.push(file);
    }
    return files;
}
// https://developer.mozilla.org/en-US/docs/Web/API/DataTransferItem
function toFilePromises(item) {
    if (typeof item.webkitGetAsEntry !== 'function') {
        return fromDataTransferItem(item);
    }
    var entry = item.webkitGetAsEntry();
    // Safari supports dropping an image node from a different window and can be retrieved using
    // the DataTransferItem.getAsFile() API
    // NOTE: FileSystemEntry.file() throws if trying to get the file
    if (entry && entry.isDirectory) {
        return fromDirEntry(entry);
    }
    return fromDataTransferItem(item);
}
function flatten(items) {
    return items.reduce(function (acc, files) { return __spread(acc, (Array.isArray(files) ? flatten(files) : [files])); }, []);
}
function fromDataTransferItem(item) {
    var file = item.getAsFile();
    if (!file) {
        return Promise.reject(item + " is not a File");
    }
    var fwp = toFileWithPath(file);
    return Promise.resolve(fwp);
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemEntry
function fromEntry(entry) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, entry.isDirectory ? fromDirEntry(entry) : fromFileEntry(entry)];
        });
    });
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryEntry
function fromDirEntry(entry) {
    var reader = entry.createReader();
    return new Promise(function (resolve, reject) {
        var entries = [];
        function readEntries() {
            var _this = this;
            // https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryEntry/createReader
            // https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryReader/readEntries
            reader.readEntries(function (batch) { return __awaiter(_this, void 0, void 0, function () {
                var files, err_1, items;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!!batch.length) return [3 /*break*/, 5];
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, , 4]);
                            return [4 /*yield*/, Promise.all(entries)];
                        case 2:
                            files = _a.sent();
                            resolve(files);
                            return [3 /*break*/, 4];
                        case 3:
                            err_1 = _a.sent();
                            reject(err_1);
                            return [3 /*break*/, 4];
                        case 4: return [3 /*break*/, 6];
                        case 5:
                            items = Promise.all(batch.map(fromEntry));
                            entries.push(items);
                            // Continue reading
                            readEntries();
                            _a.label = 6;
                        case 6: return [2 /*return*/];
                    }
                });
            }); }, function (err) {
                reject(err);
            });
        }
        readEntries();
    });
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemFileEntry
function fromFileEntry(entry) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, new Promise(function (resolve, reject) {
                    entry.file(function (file) {
                        var fwp = toFileWithPath(file, entry.fullPath);
                        resolve(fwp);
                    }, function (err) {
                        reject(err);
                    });
                })];
        });
    });
}

var es = createCommonjsModule(function (module, exports) {

exports.__esModule = true;

exports.default = function (file, acceptedFiles) {
  if (file && acceptedFiles) {
    var acceptedFilesArray = Array.isArray(acceptedFiles) ? acceptedFiles : acceptedFiles.split(',');
    var fileName = file.name || '';
    var mimeType = (file.type || '').toLowerCase();
    var baseMimeType = mimeType.replace(/\/.*$/, '');
    return acceptedFilesArray.some(function (type) {
      var validType = type.trim().toLowerCase();

      if (validType.charAt(0) === '.') {
        return fileName.toLowerCase().endsWith(validType);
      } else if (validType.endsWith('/*')) {
        // This is something like a image/* mime type
        return baseMimeType === validType.replace(/\/.*$/, '');
      }

      return mimeType === validType;
    });
  }

  return true;
};
});

var accepts = /*@__PURE__*/unwrapExports(es);

// that MIME type will always be accepted

function fileAccepted(file, accept) {
  return file.type === 'application/x-moz-file' || accepts(file, accept);
}
function fileMatchSize(file, minSize, maxSize) {
  if (isDefined(file.size)) {
    if (isDefined(minSize) && isDefined(maxSize)) return file.size >= minSize && file.size <= maxSize;else if (isDefined(minSize)) return file.size >= minSize;else if (isDefined(maxSize)) return file.size <= maxSize;
  }

  return true;
}

function isDefined(value) {
  return value !== undefined && value !== null;
}

function allFilesAccepted(files, accept, minSize, maxSize) {
  return files.every(function (file) {
    return fileAccepted(file, accept) && fileMatchSize(file, minSize, maxSize);
  });
} // React's synthetic events has event.isPropagationStopped,
// but to remain compatibility with other libs (Preact) fall back
// to check event.cancelBubble

function isPropagationStopped(event) {
  if (typeof event.isPropagationStopped === 'function') {
    return event.isPropagationStopped();
  } else if (typeof event.cancelBubble !== 'undefined') {
    return event.cancelBubble;
  }

  return false;
}
function isEvtWithFiles(event) {
  if (!event.dataTransfer) {
    return !!event.target && !!event.target.files;
  } // https://developer.mozilla.org/en-US/docs/Web/API/DataTransfer/types
  // https://developer.mozilla.org/en-US/docs/Web/API/HTML_Drag_and_Drop_API/Recommended_drag_types#file


  return Array.prototype.some.call(event.dataTransfer.types, function (type) {
    return type === 'Files' || type === 'application/x-moz-file';
  });
}

function onDocumentDragOver(event) {
  event.preventDefault();
}

function isIe(userAgent) {
  return userAgent.indexOf('MSIE') !== -1 || userAgent.indexOf('Trident/') !== -1;
}

function isEdge(userAgent) {
  return userAgent.indexOf('Edge/') !== -1;
}

function isIeOrEdge() {
  var userAgent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.navigator.userAgent;
  return isIe(userAgent) || isEdge(userAgent);
}
/**
 * This is intended to be used to compose event handlers
 * They are executed in order until one of them calls `event.isPropagationStopped()`.
 * Note that the check is done on the first invoke too,
 * meaning that if propagation was stopped before invoking the fns,
 * no handlers will be executed.
 *
 * @param {Function} fns the event hanlder functions
 * @return {Function} the event handler to add to an element
 */

function composeEventHandlers() {
  for (var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++) {
    fns[_key] = arguments[_key];
  }

  return function (event) {
    for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      args[_key2 - 1] = arguments[_key2];
    }

    return fns.some(function (fn) {
      if (!isPropagationStopped(event) && fn) {
        fn.apply(void 0, [event].concat(args));
      }

      return isPropagationStopped(event);
    });
  };
}

function _toConsumableArray$2(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$7(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$7(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
/**
 * Convenience wrapper component for the `useDropzone` hook
 *
 * ```jsx
 * <Dropzone>
 *   {({getRootProps, getInputProps}) => (
 *     <div {...getRootProps()}>
 *       <input {...getInputProps()} />
 *       <p>Drag 'n' drop some files here, or click to select files</p>
 *     </div>
 *   )}
 * </Dropzone>
 * ```
 */

var Dropzone = forwardRef(function (_ref, ref) {
  var children = _ref.children,
      params = _objectWithoutProperties(_ref, ["children"]);

  var _useDropzone = useDropzone(params),
      open = _useDropzone.open,
      props = _objectWithoutProperties(_useDropzone, ["open"]);

  useImperativeHandle(ref, function () {
    return {
      open: open
    };
  }, [open]); // TODO: Figure out why react-styleguidist cannot create docs if we don't return a jsx element

  return React__default.createElement(Fragment$1, null, children(_objectSpread({}, props, {
    open: open
  })));
});
Dropzone.displayName = 'Dropzone';
Dropzone.propTypes = {
  /**
   * Render function that exposes the dropzone state and prop getter fns
   *
   * @param {object} params
   * @param {Function} params.getRootProps Returns the props you should apply to the root drop container you render
   * @param {Function} params.getInputProps Returns the props you should apply to hidden file input you render
   * @param {Function} params.open Open the native file selection dialog
   * @param {boolean} params.isFocused Dropzone area is in focus
   * @param {boolean} params.isFileDialogActive File dialog is opened
   * @param {boolean} params.isDragActive Active drag is in progress
   * @param {boolean} params.isDragAccept Dragged files are accepted
   * @param {boolean} params.isDragReject Some dragged files are rejected
   * @param {File[]} params.draggedFiles Files in active drag
   * @param {File[]} params.acceptedFiles Accepted files
   * @param {File[]} params.rejectedFiles Rejected files
   */
  children: propTypes.func,

  /**
   * Set accepted file types.
   * See https://github.com/okonet/attr-accept for more information.
   * Keep in mind that mime type determination is not reliable across platforms. CSV files,
   * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
   * Windows. In some cases there might not be a mime type set at all.
   * See: https://github.com/react-dropzone/react-dropzone/issues/276
   */
  accept: propTypes.oneOfType([propTypes.string, propTypes.arrayOf(propTypes.string)]),

  /**
   * Allow drag 'n' drop (or selection from the file dialog) of multiple files
   */
  multiple: propTypes.bool,

  /**
   * If false, allow dropped items to take over the current browser window
   */
  preventDropOnDocument: propTypes.bool,

  /**
   * If true, disables click to open the native file selection dialog
   */
  noClick: propTypes.bool,

  /**
   * If true, disables SPACE/ENTER to open the native file selection dialog.
   * Note that it also stops tracking the focus state.
   */
  noKeyboard: propTypes.bool,

  /**
   * If true, disables drag 'n' drop
   */
  noDrag: propTypes.bool,

  /**
   * If true, stops drag event propagation to parents
   */
  noDragEventsBubbling: propTypes.bool,

  /**
   * Minimum file size (in bytes)
   */
  minSize: propTypes.number,

  /**
   * Maximum file size (in bytes)
   */
  maxSize: propTypes.number,

  /**
   * Enable/disable the dropzone
   */
  disabled: propTypes.bool,

  /**
   * Use this to provide a custom file aggregator
   *
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */
  getFilesFromEvent: propTypes.func,

  /**
   * Cb for when closing the file dialog with no selection
   */
  onFileDialogCancel: propTypes.func,

  /**
   * Cb for when the `dragenter` event occurs.
   *
   * @param {DragEvent} event
   */
  onDragEnter: propTypes.func,

  /**
   * Cb for when the `dragleave` event occurs
   *
   * @param {DragEvent} event
   */
  onDragLeave: propTypes.func,

  /**
   * Cb for when the `dragover` event occurs
   *
   * @param {DragEvent} event
   */
  onDragOver: propTypes.func,

  /**
   * Cb for when the `drop` event occurs.
   * Note that this callback is invoked after the `getFilesFromEvent` callback is done.
   *
   * Files are accepted or rejected based on the `accept`, `multiple`, `minSize` and `maxSize` props.
   * `accept` must be a valid [MIME type](http://www.iana.org/assignments/media-types/media-types.xhtml) according to [input element specification](https://www.w3.org/wiki/HTML/Elements/input/file) or a valid file extension.
   * If `multiple` is set to false and additional files are droppped,
   * all files besides the first will be rejected.
   * Any file which does not have a size in the [`minSize`, `maxSize`] range, will be rejected as well.
   *
   * Note that the `onDrop` callback will always be invoked regardless if the dropped files were accepted or rejected.
   * If you'd like to react to a specific scenario, use the `onDropAccepted`/`onDropRejected` props.
   *
   * `onDrop` will provide you with an array of [File](https://developer.mozilla.org/en-US/docs/Web/API/File) objects which you can then process and send to a server.
   * For example, with [SuperAgent](https://github.com/visionmedia/superagent) as a http/ajax library:
   *
   * ```js
   * function onDrop(acceptedFiles) {
   *   const req = request.post('/upload')
   *   acceptedFiles.forEach(file => {
   *     req.attach(file.name, file)
   *   })
   *   req.end(callback)
   * }
   * ```
   *
   * @param {File[]} acceptedFiles
   * @param {File[]} rejectedFiles
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */
  onDrop: propTypes.func,

  /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are accepted, this callback is not invoked.
   *
   * @param {File[]} files
   * @param {(DragEvent|Event)} event
   */
  onDropAccepted: propTypes.func,

  /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are rejected, this callback is not invoked.
   *
   * @param {object[]} files
   * @param {(DragEvent|Event)} event
   */
  onDropRejected: propTypes.func
};
/**
 * A function that is invoked for the `dragenter`,
 * `dragover` and `dragleave` events.
 * It is not invoked if the items are not files (such as link, text, etc.).
 *
 * @callback dragCb
 * @param {DragEvent} event
 */

/**
 * A function that is invoked for the `drop` or input change event.
 * It is not invoked if the items are not files (such as link, text, etc.).
 *
 * @callback dropCb
 * @param {File[]} acceptedFiles List of accepted files
 * @param {File[]} rejectedFiles List of rejected files
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */

/**
 * A function that is invoked for the `drop` or input change event.
 * It is not invoked if the items are files (such as link, text, etc.).
 *
 * @callback dropAcceptedCb
 * @param {File[]} files List of accepted files that meet the given criteria
 * (`accept`, `multiple`, `minSize`, `maxSize`)
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */

/**
 * A function that is invoked for the `drop` or input change event.
 *
 * @callback dropRejectedCb
 * @param {File[]} files List of rejected files that do not meet the given criteria
 * (`accept`, `multiple`, `minSize`, `maxSize`)
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */

/**
 * A function that is used aggregate files,
 * in a asynchronous fashion, from drag or input change events.
 *
 * @callback getFilesFromEvent
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 * @returns {(File[]|Promise<File[]>)}
 */

/**
 * An object with the current dropzone state and some helper functions.
 *
 * @typedef {object} DropzoneState
 * @property {Function} getRootProps Returns the props you should apply to the root drop container you render
 * @property {Function} getInputProps Returns the props you should apply to hidden file input you render
 * @property {Function} open Open the native file selection dialog
 * @property {boolean} isFocused Dropzone area is in focus
 * @property {boolean} isFileDialogActive File dialog is opened
 * @property {boolean} isDragActive Active drag is in progress
 * @property {boolean} isDragAccept Dragged files are accepted
 * @property {boolean} isDragReject Some dragged files are rejected
 * @property {File[]} draggedFiles Files in active drag
 * @property {File[]} acceptedFiles Accepted files
 * @property {File[]} rejectedFiles Rejected files
 */

var initialState = {
  isFocused: false,
  isFileDialogActive: false,
  isDragActive: false,
  isDragAccept: false,
  isDragReject: false,
  draggedFiles: [],
  acceptedFiles: [],
  rejectedFiles: []
};
/**
 * A React hook that creates a drag 'n' drop area.
 *
 * ```jsx
 * function MyDropzone(props) {
 *   const {getRootProps, getInputProps} = useDropzone({
 *     onDrop: acceptedFiles => {
 *       // do something with the File objects, e.g. upload to some server
 *     }
 *   });
 *   return (
 *     <div {...getRootProps()}>
 *       <input {...getInputProps()} />
 *       <p>Drag and drop some files here, or click to select files</p>
 *     </div>
 *   )
 * }
 * ```
 *
 * @function useDropzone
 *
 * @param {object} props
 * @param {string|string[]} [props.accept] Set accepted file types.
 * See https://github.com/okonet/attr-accept for more information.
 * Keep in mind that mime type determination is not reliable across platforms. CSV files,
 * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
 * Windows. In some cases there might not be a mime type set at all.
 * See: https://github.com/react-dropzone/react-dropzone/issues/276
 * @param {boolean} [props.multiple=true] Allow drag 'n' drop (or selection from the file dialog) of multiple files
 * @param {boolean} [props.preventDropOnDocument=true] If false, allow dropped items to take over the current browser window
 * @param {boolean} [props.noClick=false] If true, disables click to open the native file selection dialog
 * @param {boolean} [props.noKeyboard=false] If true, disables SPACE/ENTER to open the native file selection dialog.
 * Note that it also stops tracking the focus state.
 * @param {boolean} [props.noDrag=false] If true, disables drag 'n' drop
 * @param {boolean} [props.noDragEventsBubbling=false] If true, stops drag event propagation to parents
 * @param {number} [props.minSize=0] Minimum file size (in bytes)
 * @param {number} [props.maxSize=Infinity] Maximum file size (in bytes)
 * @param {boolean} [props.disabled=false] Enable/disable the dropzone
 * @param {getFilesFromEvent} [props.getFilesFromEvent] Use this to provide a custom file aggregator
 * @param {Function} [props.onFileDialogCancel] Cb for when closing the file dialog with no selection
 * @param {dragCb} [props.onDragEnter] Cb for when the `dragenter` event occurs.
 * @param {dragCb} [props.onDragLeave] Cb for when the `dragleave` event occurs
 * @param {dragCb} [props.onDragOver] Cb for when the `dragover` event occurs
 * @param {dropCb} [props.onDrop] Cb for when the `drop` event occurs.
 * Note that this callback is invoked after the `getFilesFromEvent` callback is done.
 *
 * Files are accepted or rejected based on the `accept`, `multiple`, `minSize` and `maxSize` props.
 * `accept` must be a valid [MIME type](http://www.iana.org/assignments/media-types/media-types.xhtml) according to [input element specification](https://www.w3.org/wiki/HTML/Elements/input/file) or a valid file extension.
 * If `multiple` is set to false and additional files are droppped,
 * all files besides the first will be rejected.
 * Any file which does not have a size in the [`minSize`, `maxSize`] range, will be rejected as well.
 *
 * Note that the `onDrop` callback will always be invoked regardless if the dropped files were accepted or rejected.
 * If you'd like to react to a specific scenario, use the `onDropAccepted`/`onDropRejected` props.
 *
 * `onDrop` will provide you with an array of [File](https://developer.mozilla.org/en-US/docs/Web/API/File) objects which you can then process and send to a server.
 * For example, with [SuperAgent](https://github.com/visionmedia/superagent) as a http/ajax library:
 *
 * ```js
 * function onDrop(acceptedFiles) {
 *   const req = request.post('/upload')
 *   acceptedFiles.forEach(file => {
 *     req.attach(file.name, file)
 *   })
 *   req.end(callback)
 * }
 * ```
 * @param {dropAcceptedCb} [props.onDropAccepted]
 * @param {dropRejectedCb} [props.onDropRejected]
 *
 * @returns {DropzoneState}
 */

function useDropzone() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      accept = _ref2.accept,
      _ref2$disabled = _ref2.disabled,
      disabled = _ref2$disabled === void 0 ? false : _ref2$disabled,
      _ref2$getFilesFromEve = _ref2.getFilesFromEvent,
      getFilesFromEvent = _ref2$getFilesFromEve === void 0 ? fromEvent : _ref2$getFilesFromEve,
      _ref2$maxSize = _ref2.maxSize,
      maxSize = _ref2$maxSize === void 0 ? Infinity : _ref2$maxSize,
      _ref2$minSize = _ref2.minSize,
      minSize = _ref2$minSize === void 0 ? 0 : _ref2$minSize,
      _ref2$multiple = _ref2.multiple,
      multiple = _ref2$multiple === void 0 ? true : _ref2$multiple,
      onDragEnter = _ref2.onDragEnter,
      onDragLeave = _ref2.onDragLeave,
      onDragOver = _ref2.onDragOver,
      onDrop = _ref2.onDrop,
      onDropAccepted = _ref2.onDropAccepted,
      onDropRejected = _ref2.onDropRejected,
      onFileDialogCancel = _ref2.onFileDialogCancel,
      _ref2$preventDropOnDo = _ref2.preventDropOnDocument,
      preventDropOnDocument = _ref2$preventDropOnDo === void 0 ? true : _ref2$preventDropOnDo,
      _ref2$noClick = _ref2.noClick,
      noClick = _ref2$noClick === void 0 ? false : _ref2$noClick,
      _ref2$noKeyboard = _ref2.noKeyboard,
      noKeyboard = _ref2$noKeyboard === void 0 ? false : _ref2$noKeyboard,
      _ref2$noDrag = _ref2.noDrag,
      noDrag = _ref2$noDrag === void 0 ? false : _ref2$noDrag,
      _ref2$noDragEventsBub = _ref2.noDragEventsBubbling,
      noDragEventsBubbling = _ref2$noDragEventsBub === void 0 ? false : _ref2$noDragEventsBub;

  var rootRef = useRef(null);
  var inputRef = useRef(null);

  var _useReducer = useReducer(reducer, initialState),
      _useReducer2 = _slicedToArray(_useReducer, 2),
      state = _useReducer2[0],
      dispatch = _useReducer2[1];

  var isFocused = state.isFocused,
      isFileDialogActive = state.isFileDialogActive,
      draggedFiles = state.draggedFiles; // Fn for opening the file dialog programmatically

  var openFileDialog = useCallback(function () {
    if (inputRef.current) {
      dispatch({
        type: 'openDialog'
      });
      inputRef.current.value = null;
      inputRef.current.click();
    }
  }, [dispatch]); // Update file dialog active state when the window is focused on

  var onWindowFocus = function onWindowFocus() {
    // Execute the timeout only if the file dialog is opened in the browser
    if (isFileDialogActive) {
      setTimeout(function () {
        if (inputRef.current) {
          var files = inputRef.current.files;

          if (!files.length) {
            dispatch({
              type: 'closeDialog'
            });

            if (typeof onFileDialogCancel === 'function') {
              onFileDialogCancel();
            }
          }
        }
      }, 300);
    }
  };

  useEffect(function () {
    window.addEventListener('focus', onWindowFocus, false);
    return function () {
      window.removeEventListener('focus', onWindowFocus, false);
    };
  }, [inputRef, isFileDialogActive, onFileDialogCancel]); // Cb to open the file dialog when SPACE/ENTER occurs on the dropzone

  var onKeyDownCb = useCallback(function (event) {
    // Ignore keyboard events bubbling up the DOM tree
    if (!rootRef.current || !rootRef.current.isEqualNode(event.target)) {
      return;
    }

    if (event.keyCode === 32 || event.keyCode === 13) {
      event.preventDefault();
      openFileDialog();
    }
  }, [rootRef, inputRef]); // Update focus state for the dropzone

  var onFocusCb = useCallback(function () {
    dispatch({
      type: 'focus'
    });
  }, []);
  var onBlurCb = useCallback(function () {
    dispatch({
      type: 'blur'
    });
  }, []); // Cb to open the file dialog when click occurs on the dropzone

  var onClickCb = useCallback(function () {
    if (noClick) {
      return;
    } // In IE11/Edge the file-browser dialog is blocking, therefore, use setTimeout()
    // to ensure React can handle state changes
    // See: https://github.com/react-dropzone/react-dropzone/issues/450


    if (isIeOrEdge()) {
      setTimeout(openFileDialog, 0);
    } else {
      openFileDialog();
    }
  }, [inputRef, noClick]);
  var dragTargetsRef = useRef([]);

  var onDocumentDrop = function onDocumentDrop(event) {
    if (rootRef.current && rootRef.current.contains(event.target)) {
      // If we intercepted an event for our instance, let it propagate down to the instance's onDrop handler
      return;
    }

    event.preventDefault();
    dragTargetsRef.current = [];
  };

  useEffect(function () {
    if (preventDropOnDocument) {
      document.addEventListener('dragover', onDocumentDragOver, false);
      document.addEventListener('drop', onDocumentDrop, false);
    }

    return function () {
      if (preventDropOnDocument) {
        document.removeEventListener('dragover', onDocumentDragOver);
        document.removeEventListener('drop', onDocumentDrop);
      }
    };
  }, [rootRef, preventDropOnDocument]);
  var onDragEnterCb = useCallback(function (event) {
    event.preventDefault(); // Persist here because we need the event later after getFilesFromEvent() is done

    event.persist();
    stopPropagation(event); // Count the dropzone and any children that are entered.

    if (dragTargetsRef.current.indexOf(event.target) === -1) {
      dragTargetsRef.current = [].concat(_toConsumableArray$2(dragTargetsRef.current), [event.target]);
    }

    if (isEvtWithFiles(event)) {
      Promise.resolve(getFilesFromEvent(event)).then(function (draggedFiles) {
        if (isPropagationStopped(event) && !noDragEventsBubbling) {
          return;
        }

        dispatch({
          draggedFiles: draggedFiles,
          isDragActive: true,
          type: 'setDraggedFiles'
        });

        if (onDragEnter) {
          onDragEnter(event);
        }
      });
    }
  }, [getFilesFromEvent, onDragEnter, noDragEventsBubbling]);
  var onDragOverCb = useCallback(function (event) {
    event.preventDefault();
    event.persist();
    stopPropagation(event);

    if (event.dataTransfer) {
      try {
        event.dataTransfer.dropEffect = 'copy';
      } catch (_unused) {}
      /* eslint-disable-line no-empty */

    }

    if (isEvtWithFiles(event) && onDragOver) {
      onDragOver(event);
    }

    return false;
  }, [onDragOver, noDragEventsBubbling]);
  var onDragLeaveCb = useCallback(function (event) {
    event.preventDefault();
    event.persist();
    stopPropagation(event); // Only deactivate once the dropzone and all children have been left

    var targets = dragTargetsRef.current.filter(function (target) {
      return target !== event.target && rootRef.current && rootRef.current.contains(target);
    });
    dragTargetsRef.current = targets;

    if (targets.length > 0) {
      return;
    }

    dispatch({
      isDragActive: false,
      type: 'setDraggedFiles',
      draggedFiles: []
    });

    if (isEvtWithFiles(event) && onDragLeave) {
      onDragLeave(event);
    }
  }, [rootRef, onDragLeave, noDragEventsBubbling]);
  var onDropCb = useCallback(function (event) {
    event.preventDefault(); // Persist here because we need the event later after getFilesFromEvent() is done

    event.persist();
    stopPropagation(event);
    dragTargetsRef.current = [];
    dispatch({
      type: 'reset'
    });

    if (isEvtWithFiles(event)) {
      Promise.resolve(getFilesFromEvent(event)).then(function (files) {
        if (isPropagationStopped(event) && !noDragEventsBubbling) {
          return;
        }

        var acceptedFiles = [];
        var rejectedFiles = [];
        files.forEach(function (file) {
          if (fileAccepted(file, accept) && fileMatchSize(file, minSize, maxSize)) {
            acceptedFiles.push(file);
          } else {
            rejectedFiles.push(file);
          }
        });

        if (!multiple && acceptedFiles.length > 1) {
          rejectedFiles.push.apply(rejectedFiles, _toConsumableArray$2(acceptedFiles.splice(0))); // Reject everything and empty accepted files
        }

        dispatch({
          acceptedFiles: acceptedFiles,
          rejectedFiles: rejectedFiles,
          type: 'setFiles'
        });

        if (onDrop) {
          onDrop(acceptedFiles, rejectedFiles, event);
        }

        if (rejectedFiles.length > 0 && onDropRejected) {
          onDropRejected(rejectedFiles, event);
        }

        if (acceptedFiles.length > 0 && onDropAccepted) {
          onDropAccepted(acceptedFiles, event);
        }
      });
    }
  }, [multiple, accept, minSize, maxSize, getFilesFromEvent, onDrop, onDropAccepted, onDropRejected, noDragEventsBubbling]);

  var composeHandler = function composeHandler(fn) {
    return disabled ? null : fn;
  };

  var composeKeyboardHandler = function composeKeyboardHandler(fn) {
    return noKeyboard ? null : composeHandler(fn);
  };

  var composeDragHandler = function composeDragHandler(fn) {
    return noDrag ? null : composeHandler(fn);
  };

  var stopPropagation = function stopPropagation(event) {
    if (noDragEventsBubbling) {
      event.stopPropagation();
    }
  };

  var getRootProps = useMemo(function () {
    return function () {
      var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref3$refKey = _ref3.refKey,
          refKey = _ref3$refKey === void 0 ? 'ref' : _ref3$refKey,
          onKeyDown = _ref3.onKeyDown,
          onFocus = _ref3.onFocus,
          onBlur = _ref3.onBlur,
          onClick = _ref3.onClick,
          onDragEnter = _ref3.onDragEnter,
          onDragOver = _ref3.onDragOver,
          onDragLeave = _ref3.onDragLeave,
          onDrop = _ref3.onDrop,
          rest = _objectWithoutProperties(_ref3, ["refKey", "onKeyDown", "onFocus", "onBlur", "onClick", "onDragEnter", "onDragOver", "onDragLeave", "onDrop"]);

      return _objectSpread(_defineProperty({
        onKeyDown: composeKeyboardHandler(composeEventHandlers(onKeyDown, onKeyDownCb)),
        onFocus: composeKeyboardHandler(composeEventHandlers(onFocus, onFocusCb)),
        onBlur: composeKeyboardHandler(composeEventHandlers(onBlur, onBlurCb)),
        onClick: composeHandler(composeEventHandlers(onClick, onClickCb)),
        onDragEnter: composeDragHandler(composeEventHandlers(onDragEnter, onDragEnterCb)),
        onDragOver: composeDragHandler(composeEventHandlers(onDragOver, onDragOverCb)),
        onDragLeave: composeDragHandler(composeEventHandlers(onDragLeave, onDragLeaveCb)),
        onDrop: composeDragHandler(composeEventHandlers(onDrop, onDropCb))
      }, refKey, rootRef), !disabled && !noKeyboard ? {
        tabIndex: 0
      } : {}, {}, rest);
    };
  }, [rootRef, onKeyDownCb, onFocusCb, onBlurCb, onClickCb, onDragEnterCb, onDragOverCb, onDragLeaveCb, onDropCb, noKeyboard, noDrag, disabled]);
  var onInputElementClick = useCallback(function (event) {
    event.stopPropagation();
  }, []);
  var getInputProps = useMemo(function () {
    return function () {
      var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref4$refKey = _ref4.refKey,
          refKey = _ref4$refKey === void 0 ? 'ref' : _ref4$refKey,
          onChange = _ref4.onChange,
          onClick = _ref4.onClick,
          rest = _objectWithoutProperties(_ref4, ["refKey", "onChange", "onClick"]);

      var inputProps = _defineProperty({
        accept: accept,
        multiple: multiple,
        type: 'file',
        style: {
          display: 'none'
        },
        onChange: composeHandler(composeEventHandlers(onChange, onDropCb)),
        onClick: composeHandler(composeEventHandlers(onClick, onInputElementClick)),
        autoComplete: 'off',
        tabIndex: -1
      }, refKey, inputRef);

      return _objectSpread({}, inputProps, {}, rest);
    };
  }, [inputRef, accept, multiple, onDropCb, disabled]);
  var fileCount = draggedFiles.length;
  var isMultipleAllowed = multiple || fileCount <= 1;
  var isDragAccept = fileCount > 0 && allFilesAccepted(draggedFiles, accept, minSize, maxSize);
  var isDragReject = fileCount > 0 && (!isDragAccept || !isMultipleAllowed);
  return _objectSpread({}, state, {
    isDragAccept: isDragAccept,
    isDragReject: isDragReject,
    isFocused: isFocused && !disabled,
    getRootProps: getRootProps,
    getInputProps: getInputProps,
    rootRef: rootRef,
    inputRef: inputRef,
    open: composeHandler(openFileDialog)
  });
}

function reducer(state, action) {
  /* istanbul ignore next */
  switch (action.type) {
    case 'focus':
      return _objectSpread({}, state, {
        isFocused: true
      });

    case 'blur':
      return _objectSpread({}, state, {
        isFocused: false
      });

    case 'openDialog':
      return _objectSpread({}, state, {
        isFileDialogActive: true
      });

    case 'closeDialog':
      return _objectSpread({}, state, {
        isFileDialogActive: false
      });

    case 'setDraggedFiles':
      /* eslint no-case-declarations: 0 */
      var isDragActive = action.isDragActive,
          draggedFiles = action.draggedFiles;
      return _objectSpread({}, state, {
        draggedFiles: draggedFiles,
        isDragActive: isDragActive
      });

    case 'setFiles':
      return _objectSpread({}, state, {
        acceptedFiles: action.acceptedFiles,
        rejectedFiles: action.rejectedFiles
      });

    case 'reset':
      return _objectSpread({}, state, {
        isFileDialogActive: false,
        isDragActive: false,
        draggedFiles: []
      });

    default:
      return state;
  }
}

var css_248z$e = ".upload-file:focus {\n  outline: none; }\n\n.upload-file__button {\n  width: 100%; }\n\n.upload-file__button--drop-active {\n  color: #fff;\n  background-color: #00bed5; }\n\n.upload-file__selected-files-list {\n  overflow: hidden; }\n  .upload-file__selected-files-list .closing-tag {\n    margin-left: 10px; }\n  .upload-file__selected-files-list .closing-tag:first-child {\n    margin-left: 0; }\n\n.upload-file__selected-files-upload-button {\n  cursor: pointer;\n  display: flex; }\n  .upload-file__selected-files-upload-button svg {\n    fill: #96a1bd; }\n    .upload-file__selected-files-upload-button svg:hover {\n      fill: #aab5d0; }\n";
styleInject(css_248z$e);

const stopEvent = (event) => event.stopPropagation();
// Prevents all click events from bubbling to prevent the Upload Dialog to open if a user click any of Tag.
const UploadSelectedFiles = ({ selected, onDeselect, testId }) => (React__default.createElement("div", { className: "flex-box-row flex-align-center upload-file__selected-files-list", onClick: stopEvent }, selected === null || selected === void 0 ? void 0 : selected.map((selectedFile, index) => (React__default.createElement(Tag, { key: `${selectedFile}_${index}`, onClose: onDeselect && (() => onDeselect(selectedFile)), testId: testId }, selectedFile)))));
const Upload = (_a) => {
    var { onSelect, onDeselect, buttonLabel, selected, selectedTitle, multiple = false, // enforces `false` by default in order not to accept many files by default
    info, testId } = _a, restProps = __rest(_a, ["onSelect", "onDeselect", "buttonLabel", "selected", "selectedTitle", "multiple", "info", "testId"]);
    const onDrop = useCallback(acceptedFiles => onSelect(acceptedFiles), [onSelect]);
    const { getRootProps, getInputProps, isDragActive } = useDropzone(Object.assign(Object.assign({}, restProps), { multiple, onDrop }));
    const isAnythingSelected = !!(selected === null || selected === void 0 ? void 0 : selected.length);
    return (React__default.createElement("div", Object.assign({}, getRootProps(), { className: "upload-file" }),
        React__default.createElement("input", Object.assign({}, getInputProps())),
        !isAnythingSelected && (React__default.createElement("button", { type: "button", "data-testid": `${testId}_upload-button`, className: classnames('btn', 'btn-main', 'upload-file__button', {
                'upload-file__button--drop-active': isDragActive,
            }) }, buttonLabel)),
        isAnythingSelected && (React__default.createElement("div", { className: "flex-box-row flex-align-center flex-justify-between" },
            React__default.createElement(UploadSelectedFiles, { selected: selected, onDeselect: onDeselect, testId: `${testId}_drop-file-button` }),
            React__default.createElement("span", { className: "upload-file__selected-files-upload-button", title: selectedTitle, "data-testid": `${testId}_re-upload-button` },
                React__default.createElement(SvgIcon, { name: IconName.Upload, width: 12 })))),
        info && React__default.createElement("span", { className: "info" }, info)));
};

const UploadWithLabel = (_a) => {
    var { label, selected } = _a, uploadProps = __rest(_a, ["label", "selected"]);
    return (React__default.createElement("div", { className: "upload-with-label" },
        label,
        React__default.createElement(Upload, Object.assign({}, uploadProps, { selected: selected }))));
};

const isEscapeClick = (event) => event.keyCode === 27;
const isNotEnterClick = (event) => event.keyCode !== 13;
const getSearchActions = ({ setInputValue, setIsResetting }) => {
    const changeResetView = (value) => setIsResetting(!!value);
    const onChangeDefault = (value, onChange) => {
        setInputValue(value);
        changeResetView(value);
        if (onChange) {
            onChange(value);
        }
    };
    const onResetDefault = (event, onReset) => {
        onChangeDefault('');
        if (onReset) {
            onReset(event);
        }
    };
    const onKeyDown = (event, value, onReset) => {
        // Clear the field with escape
        if (isEscapeClick(event) && !!value) {
            onResetDefault(event, onReset);
            return;
        }
        // Prevent Enter to avoid form submission
        if (isNotEnterClick(event)) {
            return;
        }
        event.preventDefault();
    };
    return {
        changeResetView,
        onChangeDefault,
        onKeyDown,
        onResetDefault,
    };
};

var css_248z$f = ".search-field {\n  position: relative;\n  display: flex;\n  align-items: center;\n  background: none;\n  width: 100%;\n  border: none; }\n  .search-field__icon {\n    position: absolute;\n    left: 0;\n    display: flex;\n    margin-left: 7px; }\n  .search-field__icon svg,\n  .search-field__reset svg {\n    fill: #96a1bd; }\n    .search-field__icon svg:focus, .search-field__icon svg:hover,\n    .search-field__reset svg:focus,\n    .search-field__reset svg:hover {\n      fill: #fff; }\n    input:active ~ .search-field__icon svg,\n    input:focus ~ .search-field__icon svg,\n    input:hover ~ .search-field__icon svg, input:active ~\n    .search-field__reset svg,\n    input:focus ~\n    .search-field__reset svg,\n    input:hover ~\n    .search-field__reset svg {\n      fill: #fff; }\n    .form-row-dark input:hover ~ .search-field__icon svg, .form-row-dark input:hover ~\n    .search-field__reset svg {\n      fill: #4b577e; }\n    .form-row-dark input:disabled:hover ~ .search-field__icon svg,\n    .form-row-dark input:active ~ .search-field__icon svg,\n    .form-row-dark input:focus ~ .search-field__icon svg,\n    input:disabled:hover ~ .search-field__icon svg, .form-row-dark input:disabled:hover ~\n    .search-field__reset svg,\n    .form-row-dark input:active ~\n    .search-field__reset svg,\n    .form-row-dark input:focus ~\n    .search-field__reset svg,\n    input:disabled:hover ~\n    .search-field__reset svg {\n      fill: #96a1bd; }\n    .form-row-dark .search-field__icon svg, .form-row-dark\n    .search-field__reset svg {\n      fill: #96a1bd; }\n      .form-row-dark .search-field__icon svg:focus, .form-row-dark .search-field__icon svg:hover, .form-row-dark\n      .search-field__reset svg:focus, .form-row-dark\n      .search-field__reset svg:hover {\n        fill: #96a1bd; }\n  .search-field input,\n  .search-field input:active,\n  .search-field input:focus,\n  .search-field input:disabled:hover,\n  .search-field input:disabled:focus,\n  .search-field input:disabled:active {\n    padding: 0 30px;\n    margin: 0; }\n  .search-field__reset {\n    position: absolute;\n    right: 0;\n    margin-right: 10px; }\n    .search-field__reset .clear {\n      font-size: 10px;\n      background: transparent;\n      margin: 0;\n      padding: 0; }\n      .search-field__reset .clear:disabled {\n        background: transparent; }\n\n.borderless input[type=text], .borderless input[type=text]:active, .borderless input[type=text]:focus, .borderless input[type=text]:hover {\n  border-bottom: none;\n  border: none; }\n";
styleInject(css_248z$f);

const SearchField = ({ disabled, onChange, onReset, border = true, light, name, placeholder, value, }) => {
    const [inputValue, setInputValue] = useState(value || '');
    const [isResetting, setIsResetting] = useState(false);
    const { changeResetView, onChangeDefault, onResetDefault, onKeyDown } = getSearchActions({
        setInputValue,
        setIsResetting,
    });
    const containerClasses = classnames('search-field', 'flex-auto', 'flex-box-row', {
        'form-row-dark': light,
        borderless: !border,
    });
    useEffect(() => {
        changeResetView(inputValue);
    }, [inputValue, changeResetView]);
    return (React__default.createElement("div", { className: containerClasses },
        React__default.createElement("input", { id: name, name: name, value: inputValue, type: "text", placeholder: placeholder, className: "search-field__input", disabled: disabled, onKeyDown: (event) => onKeyDown(event, inputValue, onReset), onChange: (event) => onChangeDefault(event.target.value, onChange) }),
        React__default.createElement("div", { className: "flex-auto search-field__icon" },
            React__default.createElement(SvgIcon, { name: IconName.Search, width: 16, height: 16 })),
        isResetting && (React__default.createElement("div", { className: "flex-auto search-field__reset" },
            React__default.createElement("button", { disabled: disabled, onClick: event => onResetDefault(event, onReset), className: "clear" },
                React__default.createElement(SvgIcon, { name: IconName.Times, width: 10, height: 10 }))))));
};
const SearchFieldWithDebounce = FieldWithDebounce(SearchField);

var css_248z$g = ".tile-toggle {\n  border: none;\n  background: #fff;\n  position: relative;\n  margin: 0 0 20px 20px;\n  text-align: left;\n  vertical-align: top;\n  min-width: 290px;\n  padding: 20px 20px 0; }\n  .tile-toggle h3 {\n    text-align: left;\n    white-space: normal;\n    max-width: 190px;\n    display: table-cell;\n    vertical-align: middle;\n    padding-left: 10px;\n    line-height: 18px; }\n    .tile-toggle h3 a {\n      color: rgba(37, 37, 37, 0.9); }\n      .tile-toggle h3 a:hover {\n        color: #00bed5; }\n  .tile-toggle h4 {\n    text-transform: uppercase;\n    font-size: 0.7em;\n    margin: 20px 0 5px;\n    color: #fff; }\n  .tile-toggle .actions-list-beta {\n    display: block;\n    height: 0;\n    min-height: 0;\n    overflow: hidden;\n    position: absolute;\n    left: 0;\n    bottom: 0;\n    width: 100%;\n    opacity: 0;\n    z-index: 21;\n    background: #4b577e;\n    text-align: left;\n    -webkit-transition: all 0.3s ease 0s;\n    -moz-transition: all 0.3s ease 0s;\n    -o-transition: all 0.3s ease 0s;\n    transition: all 0.3s ease 0s; }\n    .tile-toggle .actions-list-beta h4 {\n      font-size: 13px;\n      color: #252525;\n      margin: 12px 0 8px; }\n    .tile-toggle .actions-list-beta .actions-list-inside {\n      opacity: 0;\n      padding: 15px 0 0 15px;\n      -webkit-transition: all 0.3s ease 0;\n      -moz-transition: all 0.3s ease 0;\n      -o-transition: all 0.3s ease 0;\n      transition: all 0.3s ease 0; }\n    .tile-toggle .actions-list-beta .actions-list-section {\n      margin-top: 20px; }\n      .tile-toggle .actions-list-beta .actions-list-section h4 {\n        color: #96a1bd;\n        margin: 0 0 4px; }\n      .tile-toggle .actions-list-beta .actions-list-section li {\n        padding: 4px 0; }\n        .tile-toggle .actions-list-beta .actions-list-section li a {\n          color: #c9d4f0;\n          font-size: 13px; }\n          .tile-toggle .actions-list-beta .actions-list-section li a i {\n            display: inline-block;\n            margin-right: 10px;\n            width: 15px;\n            vertical-align: middle;\n            text-align: center; }\n            .tile-toggle .actions-list-beta .actions-list-section li a i.icon-link {\n              font-size: 9px; }\n          .tile-toggle .actions-list-beta .actions-list-section li a:hover {\n            color: #fff; }\n    .tile-toggle .actions-list-beta.open {\n      height: 100%;\n      opacity: 1;\n      -webkit-transition: all 0.3s ease 0s;\n      -moz-transition: all 0.3s ease 0s;\n      -o-transition: all 0.3s ease 0s;\n      transition: all 0.3s ease 0s; }\n      .tile-toggle .actions-list-beta.open .actions-list-inside {\n        opacity: 1;\n        padding-top: 0;\n        -webkit-transition: all 0.15s ease 0.15s;\n        -moz-transition: all 0.15s ease 0.15s;\n        -o-transition: all 0.15s ease 0.15s;\n        transition: all 0.15s ease 0.15s; }\n  .tile-toggle .actions-opener {\n    display: flex;\n    margin-left: -20px;\n    margin-right: -20px;\n    border-top: 2px solid #f3f4f6;\n    color: #96a1bd;\n    height: 34px;\n    padding-top: 0;\n    font-size: 12px;\n    text-align: center;\n    position: relative;\n    z-index: 22;\n    -webkit-transition: all 0.2s ease;\n    -moz-transition: all 0.2s ease;\n    -o-transition: all 0.2s ease;\n    transition: all 0.2s ease; }\n    .tile-toggle .actions-opener svg {\n      display: inline-block;\n      -webkit-transition: transform 0.2s ease;\n      -moz-transition: transform 0.2s ease;\n      -o-transition: transform 0.2s ease;\n      transition: transform 0.2s ease; }\n      .tile-toggle .actions-opener svg.icon-triangle-top {\n        font-size: 8px; }\n    .tile-toggle .actions-opener button {\n      background-color: transparent;\n      color: #96a1bd;\n      border-radius: 0; }\n    .tile-toggle .actions-opener.open {\n      border-top-color: #96a1bd; }\n      .tile-toggle .actions-opener.open .icon-triangle-top {\n        -webkit-transform: scaleY(-1);\n        -moz-transform: scaleY(-1);\n        -o-transform: scaleY(-1);\n        transform: scaleY(-1); }\n  .tile-toggle .icon-triangle-top {\n    fill: #8d96b4; }\n";
styleInject(css_248z$g);

const TileToggle = ({ front, back, isLoading = false, toggled = false, onToggle, extraClasses, }) => {
    const tileClasses = classnames('tile-toggle', extraClasses);
    const actionListClasses = classnames('actions-list-beta', {
        open: toggled,
    });
    const toggleClasses = classnames('actions-opener', 'flex-box-row', {
        open: toggled,
    });
    return (React__default.createElement("div", { className: tileClasses },
        front,
        React__default.createElement("div", { className: actionListClasses },
            React__default.createElement("div", { className: "actions-list-inside" },
                React__default.createElement("div", { className: "actions-list-section" }, back))),
        React__default.createElement("div", { className: toggleClasses },
            React__default.createElement("button", { className: "flex-one", onClick: onToggle },
                React__default.createElement(SvgIcon, { name: IconName.TriangleTop, width: 12, className: "icon-triangle-top" }))),
        React__default.createElement(OverlaySpinner, { isLoading: isLoading, backgroundType: OverlaySpinnerType.White })));
};

const INITIAL_STATE = { isLoading: true, isError: false };
function withIconImage(Wrapped) {
    const WrappedWithIconImage = (_a) => {
        var { imageUrl } = _a, restProps = __rest(_a, ["imageUrl"]);
        const [state, setState] = useState(INITIAL_STATE);
        const handleImageLoaded = () => {
            setState({
                isLoading: false,
                isError: false,
            });
        };
        const handleImageErrored = () => {
            setState({
                isLoading: false,
                isError: true,
            });
        };
        return (React__default.createElement(Wrapped, Object.assign({}, state, restProps),
            React__default.createElement("img", { src: imageUrl, onLoad: handleImageLoaded, onError: handleImageErrored })));
    };
    return WrappedWithIconImage;
}

var css_248z$h = ".app-icon {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 60px;\n  height: 60px;\n  border-radius: 15px;\n  overflow: hidden; }\n  .app-icon img {\n    opacity: 1;\n    width: 100%;\n    height: 100%;\n    transition: opacity 200ms ease-in-out; }\n  .app-icon--small {\n    display: inline-flex;\n    vertical-align: middle;\n    width: 26px;\n    height: 26px;\n    border-radius: 5px; }\n  .app-icon--loading, .app-icon--error {\n    border: 1px dashed #96a1bd; }\n    .app-icon--loading img, .app-icon--error img {\n      opacity: 0; }\n    .app-icon--loading .loading, .app-icon--error .loading {\n      position: absolute;\n      margin: 0;\n      top: 50%;\n      left: 50%;\n      transform: translate(-50%, -50%); }\n  .app-icon--error {\n    background-color: #fff; }\n    .app-icon--error:after {\n      content: '!';\n      position: absolute;\n      color: #96a1bd;\n      font-size: 30px; }\n  .app-icon.skeleton, .app-icon.skeleton.error {\n    border: 0; }\n    .app-icon.skeleton .loading, .app-icon.skeleton.error .loading {\n      display: none; }\n    .app-icon.skeleton:after, .app-icon.skeleton.error:after {\n      display: none; }\n  .app-icon.skeleton-style-page-bg {\n    background-color: #dee3e8; }\n  .app-icon.skeleton-style-tile {\n    background-color: rgba(75, 87, 126, 0.08); }\n  .app-icon.skeleton-style-list {\n    background-color: rgba(255, 255, 255, 0.1); }\n";
styleInject(css_248z$h);

const AppIconBase = ({ skeletonStyle, size, isLoading, isError, children }) => {
    const classes = classnames('app-icon', {
        [`app-icon--${size}`]: size,
        [`skeleton skeleton-style-${skeletonStyle}`]: skeletonStyle,
        'app-icon--loading': isLoading,
        'app-icon--error': isError,
    });
    return (React__default.createElement("div", { className: classes },
        isLoading && React__default.createElement("span", { className: "loading small" }),
        children));
};
const AppIcon = withIconImage(AppIconBase);

const PlatformItem = ({ title, icon, isActive }) => (React__default.createElement("li", { title: t(title), className: classnames('platform', { active: isActive }) },
    React__default.createElement("i", { className: `icon-${icon}` })));

const webPlatform = {
    store: 'web',
    title: gettext('store.web'),
    key: gettext('web'),
    icon: IconName.Web,
};
const stores = [
    {
        title: gettext('store.itunes'),
        store: 'itunes',
        key: gettext('ios'),
        regexp: /^\d+$/,
        icon: IconName.Ios,
    },
    {
        title: gettext('store.google-play'),
        store: 'google',
        key: gettext('android'),
        regexp: /^[a-z].+/,
        icon: IconName.Android,
    },
    {
        title: gettext('store.windows-phone'),
        store: 'windows-phone',
        key: gettext('windows-phone'),
        regexp: /^\w{8}-\w{4}-\w{4}-\w{4}-\w{12}$/,
        icon: IconName.WindowsPhone,
    },
    {
        title: gettext('store.windows'),
        store: 'windows',
        key: gettext('windows'),
        regexp: /^\w{8}-\w{4}-\w{4}-\w{4}-\w{12}$/,
        icon: IconName.Windows,
    },
];
const ctvStores = [
    {
        title: gettext('store.android-tv'),
        store: 'google',
        key: gettext('android-tv'),
        regexp: /^[a-z].+/,
        icon: IconName.AndroidTv,
    },
    {
        title: gettext('store.fire-tv'),
        store: 'amazon',
        key: gettext('fire-tv'),
        regexp: /^[a-z].+/,
        icon: IconName.FireTv,
    },
];

const renderDefaultPlatformItem = (store, isActive, 
// eslint-disable-next-line @typescript-eslint/no-unused-vars
platforms) => {
    const { key, title } = store;
    return React__default.createElement(PlatformItem, { key: key, title: title, icon: key, isActive: isActive });
};

var css_248z$i = ".platforms {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  margin: 5px 0 10px 0; }\n  .platforms li {\n    display: inline-flex;\n    justify-content: center;\n    align-items: center;\n    margin: 5px 0;\n    color: #e1e6ea;\n    border-right: 1px solid #dee3e8;\n    width: 21%;\n    font-size: 1.3em; }\n    .platforms li [class*=icon-],\n    .platforms li [class^=icon-] {\n      font-size: 23px; }\n    .platforms li .icon-windows-phone {\n      font-size: 25px; }\n    .platforms li .icon-windows {\n      font-size: 21px; }\n    .platforms li.active {\n      color: #4b577e; }\n    .platforms li:last-child {\n      border-right: none; }\n";
styleInject(css_248z$i);

const Platforms = ({ platforms, attributionPlatform, hasWebAttributionPackage, hideUnconfigured, renderPlatformItem = renderDefaultPlatformItem, }) => {
    const isWebPlatformActive = attributionPlatform === 'web' || attributionPlatform === 'both';
    const isWebPlatformOnly = attributionPlatform === 'web';
    const hideAllButWeb = isWebPlatformOnly && hideUnconfigured;
    const showWebPlatform = hideUnconfigured ? hasWebAttributionPackage && isWebPlatformActive : hasWebAttributionPackage;
    const availableStores = hideUnconfigured ? stores.filter(store => platforms[store.key].configured) : stores;
    return (React__default.createElement("ul", { className: "platforms" },
        showWebPlatform && (React__default.createElement(PlatformItem, { title: webPlatform.title, icon: webPlatform.key, isActive: isWebPlatformActive })),
        !hideAllButWeb &&
            availableStores.map(store => {
                const isActive = !isWebPlatformOnly && platforms[store.key].configured;
                return renderPlatformItem(store, isActive, platforms);
            })));
};

function withCSS(WrappedComponent, componentSpecificStyles) {
    const withCSS = ({ css, style, ...rest }) => {
        if (style && process.env.NODE_ENV === 'development') {
            // eslint-disable-next-line no-console
            console.warn(`Please replace the "style" prop with the "css" prop.
        \nMore information can be found on https://atlas.adjust.com/docs/components/custom-styles`);
        }
        const defaultStyles = { display: 'inline-flex', verticalAlign: 'middle' };
        const styles = {
            ...defaultStyles,
            ...componentSpecificStyles,
            ...css
        };
        return (React__default.createElement("div", { style: styles, "data-testid": "cssWrapper" },
            React__default.createElement(WrappedComponent, Object.assign({}, rest))));
    };
    return withCSS;
}

const ColorSchemeContext = createContext('light');

/** Detect free variable `global` from Node.js. */
var freeGlobal$4 = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf$4 = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root$4 = freeGlobal$4 || freeSelf$4 || Function('return this')();

/** Built-in value references. */
var Symbol$4 = root$4.Symbol;

/** Used for built-in method references. */
var objectProto$4 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$5 = objectProto$4.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString$1 = objectProto$4.toString;

/** Built-in value references. */
var symToStringTag$1 = Symbol$4 ? Symbol$4.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag$1(value) {
  var isOwn = hasOwnProperty$5.call(value, symToStringTag$1),
      tag = value[symToStringTag$1];

  try {
    value[symToStringTag$1] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString$1.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag$1] = tag;
    } else {
      delete value[symToStringTag$1];
    }
  }
  return result;
}

/** Used for built-in method references. */
var objectProto$5 = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString$2 = objectProto$5.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString$4(value) {
  return nativeObjectToString$2.call(value);
}

/** `Object#toString` result references. */
var nullTag$1 = '[object Null]',
    undefinedTag$1 = '[object Undefined]';

/** Built-in value references. */
var symToStringTag$2 = Symbol$4 ? Symbol$4.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag$1(value) {
  if (value == null) {
    return value === undefined ? undefinedTag$1 : nullTag$1;
  }
  return (symToStringTag$2 && symToStringTag$2 in Object(value))
    ? getRawTag$1(value)
    : objectToString$4(value);
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike$3(value) {
  return value != null && typeof value == 'object';
}

/** `Object#toString` result references. */
var symbolTag$3 = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol$3(value) {
  return typeof value == 'symbol' ||
    (isObjectLike$3(value) && baseGetTag$1(value) == symbolTag$3);
}

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray$2 = Array.isArray;

/** Used as references for various `Number` constants. */
var INFINITY$2 = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto$2 = Symbol$4 ? Symbol$4.prototype : undefined,
    symbolToString$2 = symbolProto$2 ? symbolProto$2.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString$2(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray$2(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString$2) + '';
  }
  if (isSymbol$3(value)) {
    return symbolToString$2 ? symbolToString$2.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY$2) ? '-0' : result;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject$3(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

/** `Object#toString` result references. */
var asyncTag$1 = '[object AsyncFunction]',
    funcTag$2 = '[object Function]',
    genTag$2 = '[object GeneratorFunction]',
    proxyTag$1 = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction$2(value) {
  if (!isObject$3(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag$1(value);
  return tag == funcTag$2 || tag == genTag$2 || tag == asyncTag$1 || tag == proxyTag$1;
}

/** Used to detect overreaching core-js shims. */
var coreJsData$1 = root$4['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey$1 = (function() {
  var uid = /[^.]+$/.exec(coreJsData$1 && coreJsData$1.keys && coreJsData$1.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked$1(func) {
  return !!maskSrcKey$1 && (maskSrcKey$1 in func);
}

/** Used for built-in method references. */
var funcProto$1 = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString$1 = funcProto$1.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource$1(func) {
  if (func != null) {
    try {
      return funcToString$1.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar$1 = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor$1 = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto$2 = Function.prototype,
    objectProto$6 = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString$2 = funcProto$2.toString;

/** Used to check objects for own properties. */
var hasOwnProperty$6 = objectProto$6.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative$1 = RegExp('^' +
  funcToString$2.call(hasOwnProperty$6).replace(reRegExpChar$1, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative$1(value) {
  if (!isObject$3(value) || isMasked$1(value)) {
    return false;
  }
  var pattern = isFunction$2(value) ? reIsNative$1 : reIsHostCtor$1;
  return pattern.test(toSource$1(value));
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue$2(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative$1(object, key) {
  var value = getValue$2(object, key);
  return baseIsNative$1(value) ? value : undefined;
}

/* Built-in method references that are verified to be native. */
var WeakMap$1 = getNative$1(root$4, 'WeakMap');

var defineProperty = (function() {
  try {
    var func = getNative$1(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq$1(value, other) {
  return value === other || (value !== value && other !== other);
}

/** Used for built-in method references. */
var objectProto$7 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$7 = objectProto$7.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty$7.call(object, key) && eq$1(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER$1 = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER$1;
}

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction$2(value);
}

/** Used for built-in method references. */
var objectProto$8 = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto$8;

  return value === proto;
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike$3(value) && baseGetTag$1(value) == argsTag;
}

/** Used for built-in method references. */
var objectProto$9 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$8 = objectProto$9.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto$9.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike$3(value) && hasOwnProperty$8.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root$4.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

/** `Object#toString` result references. */
var argsTag$1 = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag$3 = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag$1] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag$3] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike$3(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag$1(value)];
}

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

/** Detect free variable `exports`. */
var freeExports$1 = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule$1 = freeExports$1 && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports$1 = freeModule$1 && freeModule$1.exports === freeExports$1;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports$1 && freeGlobal$4.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule$1 && freeModule$1.require && freeModule$1.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

/** Used for built-in method references. */
var objectProto$a = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$9 = objectProto$a.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray$2(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty$9.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

/** Used for built-in method references. */
var objectProto$b = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$a = objectProto$b.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty$a.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

/** Used for built-in method references. */
var objectProto$c = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$b = objectProto$c.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject$3(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty$b.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

/** Used to match property names within property paths. */
var reIsDeepProp$1 = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp$1 = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey$1(value, object) {
  if (isArray$2(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol$3(value)) {
    return true;
  }
  return reIsPlainProp$1.test(value) || !reIsDeepProp$1.test(value) ||
    (object != null && value in Object(object));
}

/* Built-in method references that are verified to be native. */
var nativeCreate$1 = getNative$1(Object, 'create');

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear$1() {
  this.__data__ = nativeCreate$1 ? nativeCreate$1(null) : {};
  this.size = 0;
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete$1(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED$1 = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto$d = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$c = objectProto$d.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet$1(key) {
  var data = this.__data__;
  if (nativeCreate$1) {
    var result = data[key];
    return result === HASH_UNDEFINED$1 ? undefined : result;
  }
  return hasOwnProperty$c.call(data, key) ? data[key] : undefined;
}

/** Used for built-in method references. */
var objectProto$e = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$d = objectProto$e.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas$1(key) {
  var data = this.__data__;
  return nativeCreate$1 ? (data[key] !== undefined) : hasOwnProperty$d.call(data, key);
}

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED$2 = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet$1(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate$1 && value === undefined) ? HASH_UNDEFINED$2 : value;
  return this;
}

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash$1(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash$1.prototype.clear = hashClear$1;
Hash$1.prototype['delete'] = hashDelete$1;
Hash$1.prototype.get = hashGet$1;
Hash$1.prototype.has = hashHas$1;
Hash$1.prototype.set = hashSet$1;

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear$1() {
  this.__data__ = [];
  this.size = 0;
}

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf$1(array, key) {
  var length = array.length;
  while (length--) {
    if (eq$1(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/** Used for built-in method references. */
var arrayProto$1 = Array.prototype;

/** Built-in value references. */
var splice$1 = arrayProto$1.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete$1(key) {
  var data = this.__data__,
      index = assocIndexOf$1(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice$1.call(data, index, 1);
  }
  --this.size;
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet$1(key) {
  var data = this.__data__,
      index = assocIndexOf$1(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas$1(key) {
  return assocIndexOf$1(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet$1(key, value) {
  var data = this.__data__,
      index = assocIndexOf$1(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache$1(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache$1.prototype.clear = listCacheClear$1;
ListCache$1.prototype['delete'] = listCacheDelete$1;
ListCache$1.prototype.get = listCacheGet$1;
ListCache$1.prototype.has = listCacheHas$1;
ListCache$1.prototype.set = listCacheSet$1;

/* Built-in method references that are verified to be native. */
var Map$2 = getNative$1(root$4, 'Map');

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear$1() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash$1,
    'map': new (Map$2 || ListCache$1),
    'string': new Hash$1
  };
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable$1(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData$1(map, key) {
  var data = map.__data__;
  return isKeyable$1(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete$1(key) {
  var result = getMapData$1(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet$1(key) {
  return getMapData$1(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas$1(key) {
  return getMapData$1(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet$1(key, value) {
  var data = getMapData$1(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache$1(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache$1.prototype.clear = mapCacheClear$1;
MapCache$1.prototype['delete'] = mapCacheDelete$1;
MapCache$1.prototype.get = mapCacheGet$1;
MapCache$1.prototype.has = mapCacheHas$1;
MapCache$1.prototype.set = mapCacheSet$1;

/** Error message constants. */
var FUNC_ERROR_TEXT$2 = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize$3(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT$2);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize$3.Cache || MapCache$1);
  return memoized;
}

// Expose `MapCache`.
memoize$3.Cache = MapCache$1;

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize$3(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

/** Used to match property names within property paths. */
var rePropName$1 = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar$1 = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath$1 = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName$1, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar$1, '$1') : (number || match));
  });
  return result;
});

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString$2(value) {
  return value == null ? '' : baseToString$2(value);
}

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath$1(value, object) {
  if (isArray$2(value)) {
    return value;
  }
  return isKey$1(value, object) ? [value] : stringToPath$1(toString$2(value));
}

/** Used as references for various `Number` constants. */
var INFINITY$3 = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey$1(value) {
  if (typeof value == 'string' || isSymbol$3(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY$3) ? '-0' : result;
}

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet$1(object, path) {
  path = castPath$1(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey$1(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get$1(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet$1(object, path);
  return result === undefined ? defaultValue : result;
}

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush$1(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache$1;
  this.size = 0;
}

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache$1) {
    var pairs = data.__data__;
    if (!Map$2 || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache$1(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache$1(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

/** Used for built-in method references. */
var objectProto$f = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable$1 = objectProto$f.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable$1.call(object, symbol);
  });
};

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols$1 = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbolsIn = !nativeGetSymbols$1 ? stubArray : function(object) {
  var result = [];
  while (object) {
    arrayPush$1(result, getSymbols(object));
    object = getPrototype(object);
  }
  return result;
};

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray$2(object) ? result : arrayPush$1(result, symbolsFunc(object));
}

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeysIn(object) {
  return baseGetAllKeys(object, keysIn, getSymbolsIn);
}

/* Built-in method references that are verified to be native. */
var DataView = getNative$1(root$4, 'DataView');

/* Built-in method references that are verified to be native. */
var Promise$1 = getNative$1(root$4, 'Promise');

/* Built-in method references that are verified to be native. */
var Set = getNative$1(root$4, 'Set');

/** `Object#toString` result references. */
var mapTag$1 = '[object Map]',
    objectTag$1 = '[object Object]',
    promiseTag = '[object Promise]',
    setTag$1 = '[object Set]',
    weakMapTag$1 = '[object WeakMap]';

var dataViewTag$1 = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource$1(DataView),
    mapCtorString = toSource$1(Map$2),
    promiseCtorString = toSource$1(Promise$1),
    setCtorString = toSource$1(Set),
    weakMapCtorString = toSource$1(WeakMap$1);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag$1;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag$1) ||
    (Map$2 && getTag(new Map$2) != mapTag$1) ||
    (Promise$1 && getTag(Promise$1.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag$1) ||
    (WeakMap$1 && getTag(new WeakMap$1) != weakMapTag$1)) {
  getTag = function(value) {
    var result = baseGetTag$1(value),
        Ctor = result == objectTag$1 ? value.constructor : undefined,
        ctorString = Ctor ? toSource$1(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag$1;
        case mapCtorString: return mapTag$1;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag$1;
        case weakMapCtorString: return weakMapTag$1;
      }
    }
    return result;
  };
}

var getTag$1 = getTag;

/** Built-in value references. */
var Uint8Array = root$4.Uint8Array;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED$3 = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED$3);
  return this;
}

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache$1;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(array);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$1 = 1,
    COMPARE_UNORDERED_FLAG$1 = 2;

/** `Object#toString` result references. */
var boolTag$1 = '[object Boolean]',
    dateTag$1 = '[object Date]',
    errorTag$1 = '[object Error]',
    mapTag$2 = '[object Map]',
    numberTag$1 = '[object Number]',
    regexpTag$1 = '[object RegExp]',
    setTag$2 = '[object Set]',
    stringTag$1 = '[object String]',
    symbolTag$4 = '[object Symbol]';

var arrayBufferTag$1 = '[object ArrayBuffer]',
    dataViewTag$2 = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto$3 = Symbol$4 ? Symbol$4.prototype : undefined,
    symbolValueOf = symbolProto$3 ? symbolProto$3.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag$2:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag$1:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag$1:
    case dateTag$1:
    case numberTag$1:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq$1(+object, +other);

    case errorTag$1:
      return object.name == other.name && object.message == other.message;

    case regexpTag$1:
    case stringTag$1:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag$2:
      var convert = mapToArray;

    case setTag$2:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG$1;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG$1;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag$4:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$2 = 1;

/** Used for built-in method references. */
var objectProto$g = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$e = objectProto$g.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG$2,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty$e.call(other, key))) {
      return false;
    }
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(object);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$3 = 1;

/** `Object#toString` result references. */
var argsTag$2 = '[object Arguments]',
    arrayTag$1 = '[object Array]',
    objectTag$2 = '[object Object]';

/** Used for built-in method references. */
var objectProto$h = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$f = objectProto$h.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray$2(object),
      othIsArr = isArray$2(other),
      objTag = objIsArr ? arrayTag$1 : getTag$1(object),
      othTag = othIsArr ? arrayTag$1 : getTag$1(other);

  objTag = objTag == argsTag$2 ? objectTag$2 : objTag;
  othTag = othTag == argsTag$2 ? objectTag$2 : othTag;

  var objIsObj = objTag == objectTag$2,
      othIsObj = othTag == objectTag$2,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG$3)) {
    var objIsWrapped = objIsObj && hasOwnProperty$f.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty$f.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike$3(value) && !isObjectLike$3(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$4 = 1,
    COMPARE_UNORDERED_FLAG$2 = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG$4 | COMPARE_UNORDERED_FLAG$2, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject$3(value);
}

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath$1(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey$1(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray$2(object) || isArguments(object));
}

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$5 = 1,
    COMPARE_UNORDERED_FLAG$3 = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey$1(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey$1(path), srcValue);
  }
  return function(object) {
    var objValue = get$1(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG$5 | COMPARE_UNORDERED_FLAG$3);
  };
}

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet$1(object, path);
  };
}

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey$1(path) ? baseProperty(toKey$1(path)) : basePropertyDeep(path);
}

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray$2(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */
function baseSet(object, path, value, customizer) {
  if (!isObject$3(object)) {
    return object;
  }
  path = castPath$1(path, object);

  var index = -1,
      length = path.length,
      lastIndex = length - 1,
      nested = object;

  while (nested != null && ++index < length) {
    var key = toKey$1(path[index]),
        newValue = value;

    if (index != lastIndex) {
      var objValue = nested[key];
      newValue = customizer ? customizer(objValue, key, nested) : undefined;
      if (newValue === undefined) {
        newValue = isObject$3(objValue)
          ? objValue
          : (isIndex(path[index + 1]) ? [] : {});
      }
    }
    assignValue(nested, key, newValue);
    nested = nested[key];
  }
  return object;
}

/**
 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @param {Function} predicate The function invoked per property.
 * @returns {Object} Returns the new object.
 */
function basePickBy(object, paths, predicate) {
  var index = -1,
      length = paths.length,
      result = {};

  while (++index < length) {
    var path = paths[index],
        value = baseGet$1(object, path);

    if (predicate(value, path)) {
      baseSet(result, castPath$1(path, object), value);
    }
  }
  return result;
}

/**
 * Creates an object composed of the `object` properties `predicate` returns
 * truthy for. The predicate is invoked with two arguments: (value, key).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The source object.
 * @param {Function} [predicate=_.identity] The function invoked per property.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pickBy(object, _.isNumber);
 * // => { 'a': 1, 'c': 3 }
 */
function pickBy(object, predicate) {
  if (object == null) {
    return {};
  }
  var props = arrayMap(getAllKeysIn(object), function(prop) {
    return [prop];
  });
  predicate = baseIteratee(predicate);
  return basePickBy(object, props, function(value, path) {
    return predicate(value, path[0]);
  });
}

function filterDataProps(props) {
    return pickBy(props, function (value, key) {
        // allow props that have the prefix "data-"
        return key.startsWith('data-');
    });
}

const ColorWhite = "#ffffff";
const ColorBlack = "#222222";
const ColorFocus = "#1a62ff"; // Used to mark controls, eg. text inputs which are in focus state
const ColorNeutral5 = "#f9fafc";
const ColorNeutral10 = "#f4f6f9";
const ColorNeutral20 = "#eceef4";
const ColorNeutral30 = "#e0e2ec";
const ColorNeutral40 = "#cdd0e0";
const ColorNeutral50 = "#b5bad0";
const ColorNeutral60 = "#9ca2bd";
const ColorNeutral70 = "#848ba9";
const ColorNeutral80 = "#6e7492";
const ColorNeutral90 = "#565c78";
const ColorNeutral100 = "#434862";
const ColorNeutral110 = "#353a52";
const ColorNeutral120 = "#2a2f45";
const ColorNeutral130 = "#21253a";
const ColorNeutral140 = "#191d2f";
const ColorNeutral150 = "#121523";
const ColorNeutral160 = "#0b0d18";
const ColorNeutral80Rgb = "110, 116, 146";
const ColorPrimary5 = "#f4f9fd";
const ColorPrimary10 = "#e9f7fd";
const ColorPrimary20 = "#d6f3fb";
const ColorPrimary30 = "#baeef8";
const ColorPrimary40 = "#9ce7f3";
const ColorPrimary50 = "#7adaea";
const ColorPrimary60 = "#59cce0";
const ColorPrimary70 = "#31bed5";
const ColorPrimary80 = "#00a3be";
const ColorPrimary90 = "#038ea8";
const ColorPrimary100 = "#05778f";
const ColorPrimary110 = "#085f74";
const ColorPrimary120 = "#0b495c";
const ColorPrimary130 = "#0d3647";
const ColorPrimary140 = "#0d2839";
const ColorPrimary150 = "#0c1d2b";
const ColorPrimary160 = "#0b121f";
const ColorNegative5 = "#fbf5f9";
const ColorNegative10 = "#f9eef3";
const ColorNegative20 = "#f8e2e7";
const ColorNegative30 = "#f6cfd5";
const ColorNegative40 = "#f3bdc2";
const ColorNegative50 = "#efa3aa";
const ColorNegative60 = "#eb868d";
const ColorNegative70 = "#e26971";
const ColorNegative80 = "#d3434e";
const ColorNegative90 = "#af3743";
const ColorNegative100 = "#93303e";
const ColorNegative110 = "#772c39";
const ColorNegative120 = "#5d2734";
const ColorNegative130 = "#3f202c";
const ColorNegative140 = "#2e1b28";
const ColorNegative150 = "#221926";
const ColorNegative160 = "#171624";
const ColorWarning5 = "#faf7f4";
const ColorWarning10 = "#fbf2e6";
const ColorWarning20 = "#f9ebd6";
const ColorWarning30 = "#f6e3c7";
const ColorWarning40 = "#f5daae";
const ColorWarning50 = "#f6cd90";
const ColorWarning60 = "#f4bf6e";
const ColorWarning70 = "#f1b251";
const ColorWarning80 = "#e9a032";
const ColorWarning90 = "#c1862f";
const ColorWarning100 = "#a2722d";
const ColorWarning110 = "#835d2a";
const ColorWarning120 = "#664b29";
const ColorWarning130 = "#443626";
const ColorWarning140 = "#312824";
const ColorWarning150 = "#242123";
const ColorWarning160 = "#171823";
const ColorPositive5 = "#f4fafb";
const ColorPositive10 = "#e7f7f8";
const ColorPositive20 = "#dcf5f4";
const ColorPositive30 = "#ccf1ea";
const ColorPositive40 = "#b2eadf";
const ColorPositive50 = "#92e1d1";
const ColorPositive60 = "#6dd8c2";
const ColorPositive70 = "#44cbae";
const ColorPositive80 = "#1bba97";
const ColorPositive90 = "#199b81";
const ColorPositive100 = "#178371";
const ColorPositive110 = "#166b60";
const ColorPositive120 = "#15534e";
const ColorPositive130 = "#133c3e";
const ColorPositive140 = "#132c33";
const ColorPositive150 = "#12232c";
const ColorPositive160 = "#111c24";

var color = /*#__PURE__*/Object.freeze({
    __proto__: null,
    ColorBlack: ColorBlack,
    ColorFocus: ColorFocus,
    ColorNegative10: ColorNegative10,
    ColorNegative100: ColorNegative100,
    ColorNegative110: ColorNegative110,
    ColorNegative120: ColorNegative120,
    ColorNegative130: ColorNegative130,
    ColorNegative140: ColorNegative140,
    ColorNegative150: ColorNegative150,
    ColorNegative160: ColorNegative160,
    ColorNegative20: ColorNegative20,
    ColorNegative30: ColorNegative30,
    ColorNegative40: ColorNegative40,
    ColorNegative5: ColorNegative5,
    ColorNegative50: ColorNegative50,
    ColorNegative60: ColorNegative60,
    ColorNegative70: ColorNegative70,
    ColorNegative80: ColorNegative80,
    ColorNegative90: ColorNegative90,
    ColorNeutral10: ColorNeutral10,
    ColorNeutral100: ColorNeutral100,
    ColorNeutral110: ColorNeutral110,
    ColorNeutral120: ColorNeutral120,
    ColorNeutral130: ColorNeutral130,
    ColorNeutral140: ColorNeutral140,
    ColorNeutral150: ColorNeutral150,
    ColorNeutral160: ColorNeutral160,
    ColorNeutral20: ColorNeutral20,
    ColorNeutral30: ColorNeutral30,
    ColorNeutral40: ColorNeutral40,
    ColorNeutral5: ColorNeutral5,
    ColorNeutral50: ColorNeutral50,
    ColorNeutral60: ColorNeutral60,
    ColorNeutral70: ColorNeutral70,
    ColorNeutral80: ColorNeutral80,
    ColorNeutral80Rgb: ColorNeutral80Rgb,
    ColorNeutral90: ColorNeutral90,
    ColorPositive10: ColorPositive10,
    ColorPositive100: ColorPositive100,
    ColorPositive110: ColorPositive110,
    ColorPositive120: ColorPositive120,
    ColorPositive130: ColorPositive130,
    ColorPositive140: ColorPositive140,
    ColorPositive150: ColorPositive150,
    ColorPositive160: ColorPositive160,
    ColorPositive20: ColorPositive20,
    ColorPositive30: ColorPositive30,
    ColorPositive40: ColorPositive40,
    ColorPositive5: ColorPositive5,
    ColorPositive50: ColorPositive50,
    ColorPositive60: ColorPositive60,
    ColorPositive70: ColorPositive70,
    ColorPositive80: ColorPositive80,
    ColorPositive90: ColorPositive90,
    ColorPrimary10: ColorPrimary10,
    ColorPrimary100: ColorPrimary100,
    ColorPrimary110: ColorPrimary110,
    ColorPrimary120: ColorPrimary120,
    ColorPrimary130: ColorPrimary130,
    ColorPrimary140: ColorPrimary140,
    ColorPrimary150: ColorPrimary150,
    ColorPrimary160: ColorPrimary160,
    ColorPrimary20: ColorPrimary20,
    ColorPrimary30: ColorPrimary30,
    ColorPrimary40: ColorPrimary40,
    ColorPrimary5: ColorPrimary5,
    ColorPrimary50: ColorPrimary50,
    ColorPrimary60: ColorPrimary60,
    ColorPrimary70: ColorPrimary70,
    ColorPrimary80: ColorPrimary80,
    ColorPrimary90: ColorPrimary90,
    ColorWarning10: ColorWarning10,
    ColorWarning100: ColorWarning100,
    ColorWarning110: ColorWarning110,
    ColorWarning120: ColorWarning120,
    ColorWarning130: ColorWarning130,
    ColorWarning140: ColorWarning140,
    ColorWarning150: ColorWarning150,
    ColorWarning160: ColorWarning160,
    ColorWarning20: ColorWarning20,
    ColorWarning30: ColorWarning30,
    ColorWarning40: ColorWarning40,
    ColorWarning5: ColorWarning5,
    ColorWarning50: ColorWarning50,
    ColorWarning60: ColorWarning60,
    ColorWarning70: ColorWarning70,
    ColorWarning80: ColorWarning80,
    ColorWarning90: ColorWarning90,
    ColorWhite: ColorWhite
});

var css_248z$j = ".Icon_Icon__22GPH {\n  vertical-align: middle; }\n";
var style = {"Icon":"Icon_Icon__22GPH"};
          styleInject(css_248z$j);

function _extends$N() { _extends$N = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$N.apply(this, arguments); }

var _ref$J = /*#__PURE__*/createElement("path", {
  d: "M3.5 3v3.5H7m-2.52 4.283a4.5 4.5 0 10-.61-4.535"
});

function SvgArrowCircleLeft(props) {
  return /*#__PURE__*/createElement("svg", _extends$N({
    width: 16,
    height: 16,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 16 16"
  }, props), _ref$J);
}

function _extends$O() { _extends$O = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$O.apply(this, arguments); }

var _ref$K = /*#__PURE__*/createElement("path", {
  d: "M12.516 3v3.5h-3.5m2.52 4.283a4.5 4.5 0 11.61-4.535"
});

function SvgArrowCircleRight(props) {
  return /*#__PURE__*/createElement("svg", _extends$O({
    width: 16,
    height: 16,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 16 16"
  }, props), _ref$K);
}

function _extends$P() { _extends$P = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$P.apply(this, arguments); }

var _ref$L = /*#__PURE__*/createElement("path", {
  d: "M4 9l4 4 4-4M8 3v10"
});

function SvgArrowDown(props) {
  return /*#__PURE__*/createElement("svg", _extends$P({
    width: 16,
    height: 16,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 16 16"
  }, props), _ref$L);
}

function _extends$Q() { _extends$Q = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$Q.apply(this, arguments); }

var _ref$M = /*#__PURE__*/createElement("path", {
  d: "M10 11.5H4.5V6m0 5.5l7-7"
});

function SvgArrowDownLeft(props) {
  return /*#__PURE__*/createElement("svg", _extends$Q({
    width: 16,
    height: 16,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 16 16"
  }, props), _ref$M);
}

function _extends$R() { _extends$R = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$R.apply(this, arguments); }

var _ref$N = /*#__PURE__*/createElement("path", {
  d: "M6 11.5h5.5V6m0 5.5l-7-7"
});

function SvgArrowDownRight(props) {
  return /*#__PURE__*/createElement("svg", _extends$R({
    width: 16,
    height: 16,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 16 16"
  }, props), _ref$N);
}

function _extends$S() { _extends$S = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$S.apply(this, arguments); }

var _ref$O = /*#__PURE__*/createElement("path", {
  d: "M7 4L3 8l4 4m6-4H3"
});

function SvgArrowLeft(props) {
  return /*#__PURE__*/createElement("svg", _extends$S({
    width: 16,
    height: 16,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 16 16"
  }, props), _ref$O);
}

function _extends$T() { _extends$T = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$T.apply(this, arguments); }

var _ref$P = /*#__PURE__*/createElement("path", {
  d: "M9 12l4-4-4-4M3 8h10"
});

function SvgArrowRight(props) {
  return /*#__PURE__*/createElement("svg", _extends$T({
    width: 16,
    height: 16,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 16 16"
  }, props), _ref$P);
}

function _extends$U() { _extends$U = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$U.apply(this, arguments); }

var _ref$Q = /*#__PURE__*/createElement("path", {
  d: "M12 7L8 3 4 7m4 6V3"
});

function SvgArrowUp(props) {
  return /*#__PURE__*/createElement("svg", _extends$U({
    width: 16,
    height: 16,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 16 16"
  }, props), _ref$Q);
}

function _extends$V() { _extends$V = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$V.apply(this, arguments); }

var _ref$R = /*#__PURE__*/createElement("path", {
  d: "M10 4.5H4.5V10m0-5.5l7 7"
});

function SvgArrowUpLeft(props) {
  return /*#__PURE__*/createElement("svg", _extends$V({
    width: 16,
    height: 16,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 16 16"
  }, props), _ref$R);
}

function _extends$W() { _extends$W = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$W.apply(this, arguments); }

var _ref$S = /*#__PURE__*/createElement("path", {
  d: "M6 4.5h5.5V10m0-5.5l-7 7"
});

function SvgArrowUpRight(props) {
  return /*#__PURE__*/createElement("svg", _extends$W({
    width: 16,
    height: 16,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 16 16"
  }, props), _ref$S);
}

function _extends$X() { _extends$X = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$X.apply(this, arguments); }

var _ref$T = /*#__PURE__*/createElement("path", {
  d: "M2.5 2v11.5H14m-9-3h3m-3-3h7m-7-3h6"
});

function SvgBarChartHorizontal(props) {
  return /*#__PURE__*/createElement("svg", _extends$X({
    width: 16,
    height: 16,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 16 16"
  }, props), _ref$T);
}

function _extends$Y() { _extends$Y = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$Y.apply(this, arguments); }

var _ref$U = /*#__PURE__*/createElement("path", {
  d: "M2.5 2v11.5H14M5.5 11V8m3 3V4m3 7V5"
});

function SvgBarChartVertical(props) {
  return /*#__PURE__*/createElement("svg", _extends$Y({
    width: 16,
    height: 16,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 16 16"
  }, props), _ref$U);
}

function _extends$Z() { _extends$Z = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$Z.apply(this, arguments); }

var _ref$V = /*#__PURE__*/createElement("path", {
  d: "M14.09 12.5H1.91c.844 0 1.59-1.636 1.59-2.5V7c0-2.813 2-4.5 4.5-4.5s4.5 1.687 4.5 4.5v3c0 .864.748 2.5 1.592 2.5zM8.974 14a.844.844 0 11-1.687 0"
});

function SvgBell(props) {
  return /*#__PURE__*/createElement("svg", _extends$Z({
    width: 16,
    height: 16,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 16 16"
  }, props), _ref$V);
}

function _extends$_() { _extends$_ = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$_.apply(this, arguments); }

var _ref$W = /*#__PURE__*/createElement("path", {
  d: "M10.5 1v3m-5-3v3m7.5 9.5H3a.5.5 0 01-.5-.5V3a.5.5 0 01.5-.5h10a.5.5 0 01.5.5v10a.5.5 0 01-.5.5zm-10-8h10"
});

function SvgCalendar(props) {
  return /*#__PURE__*/createElement("svg", _extends$_({
    width: 16,
    height: 16,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 16 16"
  }, props), _ref$W);
}

function _extends$$() { _extends$$ = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$$.apply(this, arguments); }

var _ref$X = /*#__PURE__*/createElement("path", {
  d: "M14 14.5H8a.5.5 0 01-.5-.5V8a.5.5 0 01.5-.5h6a.5.5 0 01.5.5v6a.5.5 0 01-.5.5zm-8-6H2a.5.5 0 01-.5-.5V2a.5.5 0 01.5-.5h6a.5.5 0 01.5.5v4"
});

var _ref2$g = /*#__PURE__*/createElement("path", {
  d: "M8.567 12.88l1.207-1.774 1.207.604 1.862-3.018M3.5 7V4m2 3V3"
});

function SvgCharts(props) {
  return /*#__PURE__*/createElement("svg", _extends$$({
    width: 16,
    height: 16,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 16 16"
  }, props), _ref$X, _ref2$g);
}

function _extends$10() { _extends$10 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$10.apply(this, arguments); }

var _ref$Y = /*#__PURE__*/createElement("path", {
  d: "M12.5 4.5L7 11 3.5 7.5"
});

function SvgCheck(props) {
  return /*#__PURE__*/createElement("svg", _extends$10({
    width: 16,
    height: 16,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 16 16"
  }, props), _ref$Y);
}

function _extends$11() { _extends$11 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$11.apply(this, arguments); }

var _ref$Z = /*#__PURE__*/createElement("path", {
  d: "M3.5 6L8 10l4.5-4"
});

function SvgChevronDown(props) {
  return /*#__PURE__*/createElement("svg", _extends$11({
    width: 16,
    height: 16,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 16 16"
  }, props), _ref$Z);
}

function _extends$12() { _extends$12 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$12.apply(this, arguments); }

var _ref$_ = /*#__PURE__*/createElement("path", {
  d: "M10 3.5L6 8l4 4.5"
});

function SvgChevronLeft(props) {
  return /*#__PURE__*/createElement("svg", _extends$12({
    width: 16,
    height: 16,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 16 16"
  }, props), _ref$_);
}

function _extends$13() { _extends$13 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$13.apply(this, arguments); }

var _ref$$ = /*#__PURE__*/createElement("path", {
  d: "M6 12.5L10 8 6 3.5"
});

function SvgChevronRight(props) {
  return /*#__PURE__*/createElement("svg", _extends$13({
    width: 16,
    height: 16,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 16 16"
  }, props), _ref$$);
}

function _extends$14() { _extends$14 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$14.apply(this, arguments); }

var _ref$10 = /*#__PURE__*/createElement("path", {
  d: "M12.5 10L8 6l-4.5 4"
});

function SvgChevronUp(props) {
  return /*#__PURE__*/createElement("svg", _extends$14({
    width: 16,
    height: 16,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 16 16"
  }, props), _ref$10);
}

function _extends$15() { _extends$15 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$15.apply(this, arguments); }

var _ref$11 = /*#__PURE__*/createElement("path", {
  d: "M5.5 2v1.5h5V2a.5.5 0 00-.5-.5H6a.5.5 0 00-.5.5"
});

var _ref2$h = /*#__PURE__*/createElement("path", {
  d: "M10.499 2.5H12a.5.5 0 01.5.5v10a.5.5 0 01-.5.5H4a.5.5 0 01-.5-.5V3a.5.5 0 01.5-.5h1.5"
});

function SvgClipboard$1(props) {
  return /*#__PURE__*/createElement("svg", _extends$15({
    width: 16,
    height: 16,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 16 16"
  }, props), _ref$11, _ref2$h);
}

function _extends$16() { _extends$16 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$16.apply(this, arguments); }

var _ref$12 = /*#__PURE__*/createElement("path", {
  d: "M8 13.5a5.5 5.5 0 100-11 5.5 5.5 0 000 11z"
});

var _ref2$i = /*#__PURE__*/createElement("path", {
  d: "M7.5 5v3.5L9 10"
});

function SvgClock(props) {
  return /*#__PURE__*/createElement("svg", _extends$16({
    width: 16,
    height: 16,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 16 16"
  }, props), _ref$12, _ref2$i);
}

function _extends$17() { _extends$17 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$17.apply(this, arguments); }

var _ref$13 = /*#__PURE__*/createElement("path", {
  d: "M5.5 4.5L2 8l3.5 3.5m5 0L14 8l-3.5-3.5M9 4l-2 8"
});

function SvgCode(props) {
  return /*#__PURE__*/createElement("svg", _extends$17({
    width: 16,
    height: 16,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 16 16"
  }, props), _ref$13);
}

function _extends$18() { _extends$18 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$18.apply(this, arguments); }

var _ref$14 = /*#__PURE__*/createElement("path", {
  d: "M9.5 8a1.5 1.5 0 10-3 0 1.5 1.5 0 003 0z"
});

var _ref2$j = /*#__PURE__*/createElement("path", {
  d: "M2.737 9.884l.726-.907a.561.561 0 00.097-.373 4.531 4.531 0 01-.002-1.21.563.563 0 00-.097-.371l-.724-.907 1-1.732 1.148.175a.56.56 0 00.373-.102 4.435 4.435 0 011.045-.606.56.56 0 00.273-.27L7 2.5h2l.424 1.08a.56.56 0 00.273.27c.377.156.727.36 1.045.607a.558.558 0 00.372.102l1.148-.175 1 1.732-.723.907a.558.558 0 00-.098.372c.055.405.053.81-.002 1.209a.568.568 0 00.098.373l.725.907-1 1.732-1.148-.174a.558.558 0 00-.372.1 4.5 4.5 0 01-1.046.608.479.479 0 00-.272.27L9 13.5H7l-.424-1.08a.556.556 0 00-.273-.27 4.473 4.473 0 01-1.045-.607.559.559 0 00-.373-.101l-1.148.174-1-1.732z"
});

function SvgCogWheel(props) {
  return /*#__PURE__*/createElement("svg", _extends$18({
    width: 16,
    height: 16,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 16 16"
  }, props), _ref$14, _ref2$j);
}

function _extends$19() { _extends$19 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$19.apply(this, arguments); }

var _ref$15 = /*#__PURE__*/createElement("path", {
  d: "M13 13.5H8a.5.5 0 01-.5-.5V8a.5.5 0 01.5-.5h5a.5.5 0 01.5.5v5a.5.5 0 01-.5.5zm-7-5H3a.5.5 0 01-.5-.5V3a.5.5 0 01.5-.5h5a.5.5 0 01.5.5v3"
});

function SvgCopy(props) {
  return /*#__PURE__*/createElement("svg", _extends$19({
    width: 16,
    height: 16,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 16 16"
  }, props), _ref$15);
}

function _extends$1a() { _extends$1a = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1a.apply(this, arguments); }

var _ref$16 = /*#__PURE__*/createElement("path", {
  d: "M12 4l-8 8m0-8l8 8"
});

function SvgCross(props) {
  return /*#__PURE__*/createElement("svg", _extends$1a({
    width: 16,
    height: 16,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 16 16"
  }, props), _ref$16);
}

function _extends$1b() { _extends$1b = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1b.apply(this, arguments); }

var _ref$17 = /*#__PURE__*/createElement("path", {
  d: "M12.5 3.455c0-.527-2.567-.955-4.5-.955-1.933 0-4.5.428-4.5.955 0 .527 2.567.955 4.5.955 1.933 0 4.5-.428 4.5-.955zm-9 4.59C3.5 8.572 6.067 9 8 9c1.933 0 4.5-.428 4.5-.955"
});

var _ref2$k = /*#__PURE__*/createElement("path", {
  d: "M12.5 3.5v9.136c0 .527-2.567.955-4.5.955-1.933 0-4.5-.428-4.5-.955V3.5"
});

function SvgData(props) {
  return /*#__PURE__*/createElement("svg", _extends$1b({
    width: 16,
    height: 16,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 16 16"
  }, props), _ref$17, _ref2$k);
}

function _extends$1c() { _extends$1c = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1c.apply(this, arguments); }

var _ref$18 = /*#__PURE__*/createElement("path", {
  d: "M12 13.5H4a.5.5 0 01-.5-.5V3a.5.5 0 01.5-.5h4.293a.5.5 0 01.353.146l3.708 3.708a.501.501 0 01.146.353V13a.5.5 0 01-.5.5z"
});

var _ref2$l = /*#__PURE__*/createElement("path", {
  d: "M8.5 2.545V6.5h3.955"
});

function SvgDocument(props) {
  return /*#__PURE__*/createElement("svg", _extends$1c({
    width: 16,
    height: 16,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 16 16"
  }, props), _ref$18, _ref2$l);
}

function _extends$1d() { _extends$1d = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1d.apply(this, arguments); }

var _ref$19 = /*#__PURE__*/createElement("path", {
  d: "M4.5 8a.5.5 0 11-1 0 .5.5 0 011 0zm4 0a.5.5 0 11-1 0 .5.5 0 011 0zm4 0a.5.5 0 11-1 0 .5.5 0 011 0z"
});

function SvgDotsHorizontal(props) {
  return /*#__PURE__*/createElement("svg", _extends$1d({
    width: 16,
    height: 16,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 16 16"
  }, props), _ref$19);
}

function _extends$1e() { _extends$1e = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1e.apply(this, arguments); }

var _ref$1a = /*#__PURE__*/createElement("path", {
  d: "M12 9a1.001 1.001 0 010-2 1.001 1.001 0 010 2M8 9a1.001 1.001 0 010-2 1.001 1.001 0 010 2M4 9a1.001 1.001 0 010-2 1.001 1.001 0 010 2m8-4H4a3 3 0 100 6h8a3 3 0 100-6"
});

function SvgDotsHorizontalFilled(props) {
  return /*#__PURE__*/createElement("svg", _extends$1e({
    width: 16,
    height: 16,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 16 16"
  }, props), _ref$1a);
}

function _extends$1f() { _extends$1f = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1f.apply(this, arguments); }

var _ref$1b = /*#__PURE__*/createElement("path", {
  d: "M8.5 4a.5.5 0 11-1 0 .5.5 0 011 0zm0 4a.5.5 0 11-1 0 .5.5 0 011 0zm0 4a.5.5 0 11-1 0 .5.5 0 011 0z"
});

function SvgDotsVertical(props) {
  return /*#__PURE__*/createElement("svg", _extends$1f({
    width: 16,
    height: 16,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 16 16"
  }, props), _ref$1b);
}

function _extends$1g() { _extends$1g = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1g.apply(this, arguments); }

var _ref$1c = /*#__PURE__*/createElement("path", {
  d: "M7 12a1.001 1.001 0 012 0 1.001 1.001 0 01-2 0m0-4a1.001 1.001 0 012 0 1.001 1.001 0 01-2 0m0-4a1.001 1.001 0 012 0 1.001 1.001 0 01-2 0m4 8V4a3 3 0 10-6 0v8a3 3 0 106 0"
});

function SvgDotsVerticalFilled(props) {
  return /*#__PURE__*/createElement("svg", _extends$1g({
    width: 16,
    height: 16,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 16 16"
  }, props), _ref$1c);
}

function _extends$1h() { _extends$1h = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1h.apply(this, arguments); }

var _ref$1d = /*#__PURE__*/createElement("path", {
  d: "M13.5 10v3c0 .276-.273.5-.611.5H3.111c-.338 0-.611-.224-.611-.5v-3M8 3v7"
});

var _ref2$m = /*#__PURE__*/createElement("path", {
  d: "M11 7l-3 3-3-3"
});

function SvgDownload$1(props) {
  return /*#__PURE__*/createElement("svg", _extends$1h({
    width: 16,
    height: 16,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 16 16"
  }, props), _ref$1d, _ref2$m);
}

function _extends$1i() { _extends$1i = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1i.apply(this, arguments); }

var _ref$1e = /*#__PURE__*/createElement("path", {
  d: "M8 9l4.779-6.5H3z"
});

var _ref2$n = /*#__PURE__*/createElement("path", {
  d: "M5 7.5H3l5 6 5-6h-2"
});

function SvgDrillDown(props) {
  return /*#__PURE__*/createElement("svg", _extends$1i({
    width: 16,
    height: 16,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 16 16"
  }, props), _ref$1e, _ref2$n);
}

function _extends$1j() { _extends$1j = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1j.apply(this, arguments); }

var _ref$1f = /*#__PURE__*/createElement("path", {
  d: "M6.977 10.035l.668-2.673L11.75 2.04a.501.501 0 01.672-.099l1.128.772a.5.5 0 01.109.725L9.649 8.7l-2.672 1.336z"
});

var _ref2$o = /*#__PURE__*/createElement("path", {
  d: "M13.5 7v6a.5.5 0 01-.5.5H3a.5.5 0 01-.5-.5V3a.5.5 0 01.5-.5h5"
});

function SvgEdit(props) {
  return /*#__PURE__*/createElement("svg", _extends$1j({
    width: 16,
    height: 16,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 16 16"
  }, props), _ref$1f, _ref2$o);
}

function _extends$1k() { _extends$1k = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1k.apply(this, arguments); }

var _ref$1g = /*#__PURE__*/createElement("path", {
  d: "M2 8s2.265-4 6-4 6 4 6 4-2.265 4-6 4-6-4-6-4z"
});

var _ref2$p = /*#__PURE__*/createElement("path", {
  d: "M8 9.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3z"
});

function SvgEye(props) {
  return /*#__PURE__*/createElement("svg", _extends$1k({
    width: 16,
    height: 16,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 16 16"
  }, props), _ref$1g, _ref2$p);
}

function _extends$1l() { _extends$1l = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1l.apply(this, arguments); }

var _ref$1h = /*#__PURE__*/createElement("path", {
  d: "M13.5 2.5l-11 11m9.694-7.694A9.998 9.998 0 0114 8s-2.265 4-6 4a5.318 5.318 0 01-1.713-.286m-1.349-.651C3.064 9.88 2 7.998 2 7.998S4.264 4 8 4c1.175 0 2.204.394 3.063.936M9.06 6.94a1.5 1.5 0 10-2.12 2.12"
});

function SvgEyeClosed(props) {
  return /*#__PURE__*/createElement("svg", _extends$1l({
    width: 16,
    height: 16,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 16 16"
  }, props), _ref$1h);
}

function _extends$1m() { _extends$1m = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1m.apply(this, arguments); }

var _ref$1i = /*#__PURE__*/createElement("path", {
  d: "M13.5 3.5h-11l4.5 5v3.556l2 1.221V8.5z"
});

function SvgFilter(props) {
  return /*#__PURE__*/createElement("svg", _extends$1m({
    width: 16,
    height: 16,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 16 16"
  }, props), _ref$1i);
}

function _extends$1n() { _extends$1n = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1n.apply(this, arguments); }

var _ref$1j = /*#__PURE__*/createElement("path", {
  d: "M10 3.5H2.5l4.5 5v3.556l2 1.221V8.5l2.021-2.246M14.5 4a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z"
});

function SvgFilterActive(props) {
  return /*#__PURE__*/createElement("svg", _extends$1n({
    width: 16,
    height: 16,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 16 16"
  }, props), _ref$1j);
}

function _extends$1o() { _extends$1o = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1o.apply(this, arguments); }

var _ref$1k = /*#__PURE__*/createElement("path", {
  d: "M4.5 10s.5-.5 2-.5 2.5 1 4 1 2-.5 2-.5V4.5s-.5.5-2 .5-2.5-1-4-1-2 .5-2 .5V10zm0 4V9"
});

function SvgFlag(props) {
  return /*#__PURE__*/createElement("svg", _extends$1o({
    width: 16,
    height: 16,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 16 16"
  }, props), _ref$1k);
}

function _extends$1p() { _extends$1p = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1p.apply(this, arguments); }

var _ref$1l = /*#__PURE__*/createElement("path", {
  d: "M13 12.5H3a.5.5 0 01-.5-.5V5.5H13a.5.5 0 01.5.5v6a.5.5 0 01-.5.5zm-5.5-7l-1-2H3a.5.5 0 00-.5.5v1.5"
});

function SvgFolder(props) {
  return /*#__PURE__*/createElement("svg", _extends$1p({
    width: 16,
    height: 16,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 16 16"
  }, props), _ref$1l);
}

function _extends$1q() { _extends$1q = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1q.apply(this, arguments); }

var _ref$1m = /*#__PURE__*/createElement("path", {
  d: "M8 13.5a5.5 5.5 0 100-11 5.5 5.5 0 000 11z"
});

var _ref2$q = /*#__PURE__*/createElement("path", {
  d: "M8 13.5c1.104 0 2-2.462 2-5.5s-.896-5.5-2-5.5S6 4.962 6 8s.896 5.5 2 5.5z"
});

var _ref3$3 = /*#__PURE__*/createElement("path", {
  d: "M2.5 8c0 .552 2.463 1 5.5 1s5.5-.448 5.5-1"
});

function SvgGlobe(props) {
  return /*#__PURE__*/createElement("svg", _extends$1q({
    width: 16,
    height: 16,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 16 16"
  }, props), _ref$1m, _ref2$q, _ref3$3);
}

function _extends$1r() { _extends$1r = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1r.apply(this, arguments); }

var _ref$1n = /*#__PURE__*/createElement("path", {
  d: "M12.651 4.364a2.865 2.865 0 00-2.047-.864 2.87 2.87 0 00-2.047.864L8 4.934l-.558-.57a2.858 2.858 0 00-4.095 0 2.99 2.99 0 000 4.172L8 13.277l4.651-4.74a2.972 2.972 0 00.85-2.087c0-.782-.306-1.533-.85-2.086z"
});

function SvgHeart(props) {
  return /*#__PURE__*/createElement("svg", _extends$1r({
    width: 16,
    height: 16,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 16 16"
  }, props), _ref$1n);
}

function _extends$1s() { _extends$1s = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1s.apply(this, arguments); }

var _ref$1o = /*#__PURE__*/createElement("path", {
  d: "M13 13.5H3a.5.5 0 01-.5-.5V3a.5.5 0 01.5-.5h10a.5.5 0 01.5.5v10a.5.5 0 01-.5.5z"
});

var _ref2$r = /*#__PURE__*/createElement("path", {
  d: "M2.5 12l8-4.5 3 2.5m-6-4a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z"
});

function SvgImage(props) {
  return /*#__PURE__*/createElement("svg", _extends$1s({
    width: 16,
    height: 16,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 16 16"
  }, props), _ref$1o, _ref2$r);
}

function _extends$1t() { _extends$1t = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1t.apply(this, arguments); }

var _ref$1p = /*#__PURE__*/createElement("path", {
  d: "M13.5 8a5.5 5.5 0 10-11.001.001A5.5 5.5 0 0013.5 8zM8 6V5m-1 5.5h2"
});

var _ref2$s = /*#__PURE__*/createElement("path", {
  d: "M7 7.5h1v3"
});

function SvgInfo(props) {
  return /*#__PURE__*/createElement("svg", _extends$1t({
    width: 16,
    height: 16,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 16 16"
  }, props), _ref$1p, _ref2$s);
}

function _extends$1u() { _extends$1u = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1u.apply(this, arguments); }

var _ref$1q = /*#__PURE__*/createElement("path", {
  d: "M8.75 5.5a.75.75 0 11-1.5 0 .75.75 0 011.5 0zM9 11H7v-1h.5V8H7V7h1.5v3H9v1zM8 2C4.691 2 2 4.691 2 8s2.691 6 6 6 6-2.691 6-6-2.691-6-6-6z"
});

function SvgInfoFilled(props) {
  return /*#__PURE__*/createElement("svg", _extends$1u({
    width: 16,
    height: 16,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 16 16"
  }, props), _ref$1q);
}

function _extends$1v() { _extends$1v = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1v.apply(this, arguments); }

var _ref$1r = /*#__PURE__*/createElement("path", {
  d: "M12.5 8a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0z"
});

var _ref2$t = /*#__PURE__*/createElement("path", {
  d: "M8.5 8a.5.5 0 11-1 0 .5.5 0 011 0z"
});

var _ref3$4 = /*#__PURE__*/createElement("path", {
  d: "M10.5 8a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0zm-2-.5l4-4m1.5 0h-1.5V2l-1 1v1.5H13z"
});

function SvgKpi(props) {
  return /*#__PURE__*/createElement("svg", _extends$1v({
    width: 16,
    height: 16,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 16 16"
  }, props), _ref$1r, _ref2$t, _ref3$4);
}

function _extends$1w() { _extends$1w = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1w.apply(this, arguments); }

var _ref$1s = /*#__PURE__*/createElement("path", {
  d: "M8 3.5a1.5 1.5 0 110 3 1.5 1.5 0 010-3zm0 6a1.5 1.5 0 110 3 1.5 1.5 0 010-3zM4 8h8"
});

function SvgKpiCalculated(props) {
  return /*#__PURE__*/createElement("svg", _extends$1w({
    width: 16,
    height: 16,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 16 16"
  }, props), _ref$1s);
}

function _extends$1x() { _extends$1x = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1x.apply(this, arguments); }

var _ref$1t = /*#__PURE__*/createElement("path", {
  d: "M3 8h8.5c0-1.92-1.58-3.5-3.5-3.5S4.5 6.08 4.5 8s1.58 3.5 3.5 3.5c1.184 0 2.29-.601 2.935-1.593"
});

function SvgKpiEvent(props) {
  return /*#__PURE__*/createElement("svg", _extends$1x({
    width: 16,
    height: 16,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 16 16"
  }, props), _ref$1t);
}

function _extends$1y() { _extends$1y = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1y.apply(this, arguments); }

var _ref$1u = /*#__PURE__*/createElement("path", {
  d: "M11.5 13V3M9 5.5L11.5 3 14 5.5m-11-2h3.396a.25.25 0 01.177.427l-2.944 2.12a.25.25 0 00.146.453H7M6.5 13v-2.5a1 1 0 00-1-1h-1a1 1 0 00-1 1V13m0-1.5h3"
});

function SvgLettersAscending(props) {
  return /*#__PURE__*/createElement("svg", _extends$1y({
    width: 16,
    height: 16,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 16 16"
  }, props), _ref$1u);
}

function _extends$1z() { _extends$1z = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1z.apply(this, arguments); }

var _ref$1v = /*#__PURE__*/createElement("path", {
  d: "M11.5 3v10m2.5-2.5L11.5 13 9 10.5m-6-7h3.396a.25.25 0 01.177.427l-2.944 2.12a.25.25 0 00.146.453H7M6.5 13v-2.5a1 1 0 00-1-1h-1a1 1 0 00-1 1V13m0-1.5h3"
});

function SvgLettersDescending(props) {
  return /*#__PURE__*/createElement("svg", _extends$1z({
    width: 16,
    height: 16,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 16 16"
  }, props), _ref$1v);
}

function _extends$1A() { _extends$1A = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1A.apply(this, arguments); }

var _ref$1w = /*#__PURE__*/createElement("path", {
  d: "M2.5 2v11.5H14"
});

var _ref2$u = /*#__PURE__*/createElement("path", {
  d: "M13.695 5.567L10.81 8.933 8.366 7.01l-3.924 3.923"
});

function SvgLineChart(props) {
  return /*#__PURE__*/createElement("svg", _extends$1A({
    width: 16,
    height: 16,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 16 16"
  }, props), _ref$1w, _ref2$u);
}

function _extends$1B() { _extends$1B = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1B.apply(this, arguments); }

var _ref$1x = /*#__PURE__*/createElement("path", {
  d: "M12.5 9v3a.5.5 0 01-.5.5H4a.5.5 0 01-.5-.5V4a.5.5 0 01.5-.5h3M13.5 7V2.5H9m4.5 0L8 8"
});

function SvgLinkExternal(props) {
  return /*#__PURE__*/createElement("svg", _extends$1B({
    width: 16,
    height: 16,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 16 16"
  }, props), _ref$1x);
}

function _extends$1C() { _extends$1C = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1C.apply(this, arguments); }

var _ref$1y = /*#__PURE__*/createElement("path", {
  d: "M8.5 10.5h-1 1zm3.5 3H4a.5.5 0 01-.5-.5V8a.5.5 0 01.5-.5h8a.5.5 0 01.5.5v5a.5.5 0 01-.5.5zm-6.5-6V6a2.5 2.5 0 115 0v1.5"
});

function SvgLockClosed(props) {
  return /*#__PURE__*/createElement("svg", _extends$1C({
    width: 16,
    height: 16,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 16 16"
  }, props), _ref$1y);
}

function _extends$1D() { _extends$1D = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1D.apply(this, arguments); }

var _ref$1z = /*#__PURE__*/createElement("path", {
  d: "M12 13.5H4a.5.5 0 01-.5-.5V8a.5.5 0 01.5-.5h8a.5.5 0 01.5.5v5a.5.5 0 01-.5.5zM5.5 5a2.5 2.5 0 115 0v2.5m-2 3h-1 1z"
});

function SvgLockOpen(props) {
  return /*#__PURE__*/createElement("svg", _extends$1D({
    width: 16,
    height: 16,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 16 16"
  }, props), _ref$1z);
}

function _extends$1E() { _extends$1E = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1E.apply(this, arguments); }

var _ref$1A = /*#__PURE__*/createElement("path", {
  d: "M5.5 6V3.111c0-.338.224-.611.5-.611h7c.276 0 .5.273.5.611v9.778c0 .338-.224.611-.5.611H6c-.276 0-.5-.273-.5-.611V10M2 8h9"
});

var _ref2$v = /*#__PURE__*/createElement("path", {
  d: "M9 6l2 2-2 2"
});

function SvgLogIn(props) {
  return /*#__PURE__*/createElement("svg", _extends$1E({
    width: 16,
    height: 16,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 16 16"
  }, props), _ref$1A, _ref2$v);
}

function _extends$1F() { _extends$1F = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1F.apply(this, arguments); }

var _ref$1B = /*#__PURE__*/createElement("path", {
  d: "M10.5 6V3.111c0-.338-.224-.611-.5-.611H3c-.276 0-.5.273-.5.611v9.778c0 .338.224.611.5.611h7c.276 0 .5-.273.5-.611V10M6 8h9m-2-2l2 2-2 2"
});

function SvgLogOut(props) {
  return /*#__PURE__*/createElement("svg", _extends$1F({
    width: 16,
    height: 16,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 16 16"
  }, props), _ref$1B);
}

function _extends$1G() { _extends$1G = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1G.apply(this, arguments); }

var _ref$1C = /*#__PURE__*/createElement("path", {
  d: "M13 11.5H3a.5.5 0 01-.5-.5V5a.5.5 0 01.5-.5h10a.5.5 0 01.5.5v6a.5.5 0 01-.5.5z"
});

var _ref2$w = /*#__PURE__*/createElement("path", {
  d: "M13.5 4.5L8 9 2.5 4.5"
});

function SvgMail(props) {
  return /*#__PURE__*/createElement("svg", _extends$1G({
    width: 16,
    height: 16,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 16 16"
  }, props), _ref$1C, _ref2$w);
}

function _extends$1H() { _extends$1H = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1H.apply(this, arguments); }

var _ref$1D = /*#__PURE__*/createElement("path", {
  d: "M10 2.5h3.5V6M9 7l4.5-4.5M6 13.5H2.5V10M7 9l-4.5 4.5"
});

function SvgMaximize(props) {
  return /*#__PURE__*/createElement("svg", _extends$1H({
    width: 16,
    height: 16,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 16 16"
  }, props), _ref$1D);
}

function _extends$1I() { _extends$1I = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1I.apply(this, arguments); }

var _ref$1E = /*#__PURE__*/createElement("path", {
  d: "M7.5 9.5h-5v-2a1 1 0 011-1h4v3zm0-3l6-4v11l-6-4m-2 0V13"
});

function SvgMegaphone(props) {
  return /*#__PURE__*/createElement("svg", _extends$1I({
    width: 16,
    height: 16,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 16 16"
  }, props), _ref$1E);
}

function _extends$1J() { _extends$1J = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1J.apply(this, arguments); }

var _ref$1F = /*#__PURE__*/createElement("path", {
  d: "M3 8h10M3 4.5h10m-10 7h10"
});

function SvgMenu(props) {
  return /*#__PURE__*/createElement("svg", _extends$1J({
    width: 16,
    height: 16,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 16 16"
  }, props), _ref$1F);
}

function _extends$1K() { _extends$1K = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1K.apply(this, arguments); }

var _ref$1G = /*#__PURE__*/createElement("path", {
  d: "M13 6.5H9.5V3M14 2L9.5 6.5M3 9.5h3.5V13M2 14l4.5-4.5"
});

function SvgMinimize(props) {
  return /*#__PURE__*/createElement("svg", _extends$1K({
    width: 16,
    height: 16,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 16 16"
  }, props), _ref$1G);
}

function _extends$1L() { _extends$1L = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1L.apply(this, arguments); }

var _ref$1H = /*#__PURE__*/createElement("path", {
  d: "M3 8h10"
});

function SvgMinus(props) {
  return /*#__PURE__*/createElement("svg", _extends$1L({
    width: 16,
    height: 16,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 16 16"
  }, props), _ref$1H);
}

function _extends$1M() { _extends$1M = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1M.apply(this, arguments); }

var _ref$1I = /*#__PURE__*/createElement("path", {
  d: "M8 2.5v11M13.5 8h-11m9.5 2l2-2-2-2m-2-2L8 2 6 4M4 6L2 8l2 2m2 2l2 2 2-2"
});

function SvgMove(props) {
  return /*#__PURE__*/createElement("svg", _extends$1M({
    width: 16,
    height: 16,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 16 16"
  }, props), _ref$1I);
}

function _extends$1N() { _extends$1N = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1N.apply(this, arguments); }

var _ref$1J = /*#__PURE__*/createElement("path", {
  d: "M10.278 2.5H5.721l-3.22 3.222v4.556L5.72 13.5h4.557l3.222-3.222V5.722zM6 6l4 4m0-4l-4 4"
});

function SvgNegative(props) {
  return /*#__PURE__*/createElement("svg", _extends$1N({
    width: 16,
    height: 16,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 16 16"
  }, props), _ref$1J);
}

function _extends$1O() { _extends$1O = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1O.apply(this, arguments); }

var _ref$1K = /*#__PURE__*/createElement("path", {
  d: "M10.354 9.646l-.707.707L8 8.707l-1.646 1.646-.708-.707L7.293 8 5.646 6.355l.708-.708L8 7.293l1.646-1.647.707.708L8.707 8l1.646 1.646zM10.486 2H5.513L2 5.514v4.971l3.514 3.516h4.971L14 10.486V5.513L10.486 2z"
});

function SvgNegativeFilled(props) {
  return /*#__PURE__*/createElement("svg", _extends$1O({
    width: 16,
    height: 16,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 16 16"
  }, props), _ref$1K);
}

function _extends$1P() { _extends$1P = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1P.apply(this, arguments); }

var _ref$1L = /*#__PURE__*/createElement("path", {
  d: "M9.5 9a1.5 1.5 0 10-3 0 1.5 1.5 0 003 0zm5-6a1.5 1.5 0 10-3 0 1.5 1.5 0 003 0zm-5 0a1.5 1.5 0 10-3 0 1.5 1.5 0 003 0zm-5 10a1.5 1.5 0 10-3 0 1.5 1.5 0 003 0zM8 7.5v-3"
});

var _ref2$x = /*#__PURE__*/createElement("path", {
  d: "M3 11.5v-2a.5.5 0 01.5-.5h3m3 0h3a.5.5 0 00.5-.5v-4"
});

function SvgNetwork(props) {
  return /*#__PURE__*/createElement("svg", _extends$1P({
    width: 16,
    height: 16,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 16 16"
  }, props), _ref$1L, _ref2$x);
}

function _extends$1Q() { _extends$1Q = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1Q.apply(this, arguments); }

var _ref$1M = /*#__PURE__*/createElement("path", {
  d: "M13 13.5H3a.5.5 0 01-.5-.5V3a.5.5 0 01.5-.5h10a.5.5 0 01.5.5v10a.5.5 0 01-.5.5zM4 4l8 8m0-8l-8 8"
});

function SvgNoImage(props) {
  return /*#__PURE__*/createElement("svg", _extends$1Q({
    width: 16,
    height: 16,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 16 16"
  }, props), _ref$1M);
}

function _extends$1R() { _extends$1R = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1R.apply(this, arguments); }

var _ref$1N = /*#__PURE__*/createElement("path", {
  d: "M7.5 12.5a5 5 0 005-5 5 5 0 00-5-5 5 5 0 00-5 5 5 5 0 005 5zm6 1l-2.465-2.465M6 6l3 3m0-3L6 9"
});

function SvgNotFound(props) {
  return /*#__PURE__*/createElement("svg", _extends$1R({
    width: 16,
    height: 16,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 16 16"
  }, props), _ref$1N);
}

function _extends$1S() { _extends$1S = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1S.apply(this, arguments); }

var _ref$1O = /*#__PURE__*/createElement("path", {
  d: "M11.5 13V3M9 5.5L11.5 3 14 5.5M4 10l1.5-.5V13M4 12.5h3m-2-5h.5a1 1 0 001-1v-2"
});

var _ref2$y = /*#__PURE__*/createElement("path", {
  d: "M6 3.5H5a.5.5 0 00-.5.5v1a.5.5 0 00.5.5h1.5V4a.5.5 0 00-.5-.5z"
});

function SvgNumbersAscending(props) {
  return /*#__PURE__*/createElement("svg", _extends$1S({
    width: 16,
    height: 16,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 16 16"
  }, props), _ref$1O, _ref2$y);
}

function _extends$1T() { _extends$1T = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1T.apply(this, arguments); }

var _ref$1P = /*#__PURE__*/createElement("path", {
  d: "M11.5 3v10m2.5-2.5L11.5 13 9 10.5M4 10l1.5-.5V13M4 12.5h3m-2-5h.5a1 1 0 001-1v-2"
});

var _ref2$z = /*#__PURE__*/createElement("path", {
  d: "M6 3.5H5a.5.5 0 00-.5.5v1a.5.5 0 00.5.5h1.5V4a.5.5 0 00-.5-.5z"
});

function SvgNumbersDescending(props) {
  return /*#__PURE__*/createElement("svg", _extends$1T({
    width: 16,
    height: 16,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 16 16"
  }, props), _ref$1P, _ref2$z);
}

function _extends$1U() { _extends$1U = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1U.apply(this, arguments); }

var _ref$1Q = /*#__PURE__*/createElement("path", {
  d: "M2.5 13.5h7v-11h-7zm7 0h4v-9h-4zm2-7.5v1m-7-3v1m2-1v1m0 1v1m-2-1v1"
});

function SvgOffice(props) {
  return /*#__PURE__*/createElement("svg", _extends$1U({
    width: 16,
    height: 16,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 16 16"
  }, props), _ref$1Q);
}

function _extends$1V() { _extends$1V = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1V.apply(this, arguments); }

var _ref$1R = /*#__PURE__*/createElement("path", {
  d: "M3.5 13.5h3v-11h-3zm6 0h3v-11h-3z"
});

function SvgPause(props) {
  return /*#__PURE__*/createElement("svg", _extends$1V({
    width: 16,
    height: 16,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 16 16"
  }, props), _ref$1R);
}

function _extends$1W() { _extends$1W = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1W.apply(this, arguments); }

var _ref$1S = /*#__PURE__*/createElement("path", {
  d: "M5 13l.645-2.638 5.105-6.323a.501.501 0 01.672-.099l1.128.772a.5.5 0 01.108.725l-5.009 6.262L5 13z"
});

function SvgPencil(props) {
  return /*#__PURE__*/createElement("svg", _extends$1W({
    width: 16,
    height: 16,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 16 16"
  }, props), _ref$1S);
}

function _extends$1X() { _extends$1X = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1X.apply(this, arguments); }

var _ref$1T = /*#__PURE__*/createElement("path", {
  d: "M8 8.385c1.347 0 2.438-1.789 2.438-3.135a2.438 2.438 0 10-4.876 0c0 1.346 1.091 3.135 2.438 3.135zM3.472 13.68l.6-3.598a.722.722 0 01.687-.582h6.483c.34 0 .63.246.687.582l.6 3.598"
});

var _ref2$A = /*#__PURE__*/createElement("path", {
  d: "M6.251 9.5L8.028 12l1.721-2.5M8 12v2"
});

function SvgPerson(props) {
  return /*#__PURE__*/createElement("svg", _extends$1X({
    width: 16,
    height: 16,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 16 16"
  }, props), _ref$1T, _ref2$A);
}

function _extends$1Y() { _extends$1Y = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1Y.apply(this, arguments); }

var _ref$1U = /*#__PURE__*/createElement("path", {
  d: "M13.5 8a5.5 5.5 0 10-11 0 5.5 5.5 0 0011 0z"
});

var _ref2$B = /*#__PURE__*/createElement("path", {
  d: "M8 2.5V8l5.417.956m-2.828 3.897L7.999 8l-5.476-.498"
});

function SvgPieChart(props) {
  return /*#__PURE__*/createElement("svg", _extends$1Y({
    width: 16,
    height: 16,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 16 16"
  }, props), _ref$1U, _ref2$B);
}

function _extends$1Z() { _extends$1Z = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1Z.apply(this, arguments); }

var _ref$1V = /*#__PURE__*/createElement("path", {
  d: "M11 12.5H5a.5.5 0 01-.5-.5V6.198c0-1.895 1.419-3.594 3.312-3.693A3.5 3.5 0 0111.5 6v6a.5.5 0 01-.5.5zm.5-10.971l-1.237 1.802M13.5 7v4m-11-4v4m4.075 1.46V15m2.89-2.54V15M4.5 1.529l1.237 1.802M6.5 5v1m3-1v1m-5 1.5h7"
});

function SvgPlatformAndroid(props) {
  return /*#__PURE__*/createElement("svg", _extends$1Z({
    width: 16,
    height: 16,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 16 16"
  }, props), _ref$1V);
}

function _extends$1_() { _extends$1_ = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1_.apply(this, arguments); }

var _ref$1W = /*#__PURE__*/createElement("path", {
  d: "M13 11h1.001V7H13zM2 11h1V7H2zm4-5h1V5H6v1zm3 0h1V5H9v1zM4 7h8V6c0-1.028-.396-1.98-1.094-2.723l1.006-1.465-.824-.566-.947 1.379a4.036 4.036 0 00-2.356-.62c-.695.037-1.339.284-1.899.66l-.974-1.419-.824.566 1.029 1.499A4.309 4.309 0 004 6.198V7zm7 5.5V12h.001l-.001.5zM4 8v4c0 .551.448 1 1 1h1.075v2h1v-2h1.89v2h1v-2H11c.552 0 1-.449 1-1V8H4z"
});

function SvgPlatformAndroidFilled(props) {
  return /*#__PURE__*/createElement("svg", _extends$1_({
    width: 16,
    height: 16,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 16 16"
  }, props), _ref$1W);
}

function _extends$1$() { _extends$1$ = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1$.apply(this, arguments); }

var _ref$1X = /*#__PURE__*/createElement("path", {
  d: "M8.523 3.532a2.491 2.491 0 011.37-1.786c.107-.052.212-.096.315-.132-.069.4-.255.775-.565 1.143-.258.301-.644.651-1.12.775zM6.011 13.5c-.246 0-.51-.13-.79-.39-.232-.203-.522-.553-.875-1.05a7.338 7.338 0 01-.93-1.853 6.754 6.754 0 01-.39-2.194c0-.776.165-1.448.492-1.995.258-.44.588-.774 1.011-1.025a2.677 2.677 0 011.354-.38c.241 0 .6.085 1.055.255.75.282 1 .321 1.156.321.132 0 .328-.029 1.261-.37.441-.16.823-.24 1.133-.24.046 0 .091.001.134.005.745.06 1.327.292 1.765.705-.815.658-1.223 1.525-1.214 2.585.011.97.368 1.787 1.062 2.43.188.18.395.336.616.468l-.067.164c-.18.417-.399.81-.647 1.164-.426.607-.68.878-.819.998-.279.257-.55.38-.84.387-.219 0-.522-.075-.868-.218-.474-.193-.925-.292-1.34-.292-.434 0-.894.098-1.372.291-.453.184-.713.23-.852.233l-.035.001z"
});

function SvgPlatformIos(props) {
  return /*#__PURE__*/createElement("svg", _extends$1$({
    width: 16,
    height: 16,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 16 16"
  }, props), _ref$1X);
}

function _extends$20() { _extends$20 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$20.apply(this, arguments); }

var _ref$1Y = /*#__PURE__*/createElement("path", {
  d: "M10.737 1.26c0 .65-.237 1.257-.71 1.82-.572.667-1.264 1.053-2.013.992A2.142 2.142 0 018 3.825c0-.624.271-1.292.755-1.837.24-.277.546-.507.918-.69.371-.18.721-.28 1.051-.298.01.087.014.174.014.26m2.508 9.871a7.054 7.054 0 01-.698 1.256c-.369.524-.669.887-.9 1.088-.36.331-.746.5-1.158.51-.296 0-.653-.084-1.069-.255-.417-.17-.8-.255-1.15-.255-.368 0-.762.084-1.184.255-.422.171-.762.26-1.023.27-.395.015-.789-.158-1.182-.525-.25-.218-.566-.594-.943-1.126a7.813 7.813 0 01-.995-1.978 7.235 7.235 0 01-.418-2.358c0-.87.188-1.622.565-2.252a3.317 3.317 0 011.184-1.198 3.185 3.185 0 011.601-.45c.314 0 .726.096 1.238.287.511.192.838.29.981.29.108 0 .472-.115 1.09-.342.583-.21 1.076-.296 1.48-.262 1.094.088 1.915.52 2.462 1.296-.979.592-1.462 1.423-1.452 2.488.008.83.31 1.52.901 2.067.267.255.566.451.9.591-.072.21-.149.41-.23.603"
});

function SvgPlatformIosFilled(props) {
  return /*#__PURE__*/createElement("svg", _extends$20({
    width: 16,
    height: 16,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 16 16"
  }, props), _ref$1Y);
}

function _extends$21() { _extends$21 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$21.apply(this, arguments); }

var _ref$1Z = /*#__PURE__*/createElement("path", {
  d: "M8.594 8.665L5.502 11.29l.015-8.319 7.049 4.404zm0 0l2.709 4.785"
});

function SvgPlatformWeb(props) {
  return /*#__PURE__*/createElement("svg", _extends$21({
    width: 16,
    height: 16,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 16 16"
  }, props), _ref$1Z);
}

function _extends$22() { _extends$22 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$22.apply(this, arguments); }

var _ref$1_ = /*#__PURE__*/createElement("path", {
  d: "M12.187 12.96l-1.75.97-2.326-4.199-3.112 2.64.02-10.301 8.727 5.453L9.86 8.762z"
});

function SvgPlatformWebFilled(props) {
  return /*#__PURE__*/createElement("svg", _extends$22({
    width: 16,
    height: 16,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 16 16"
  }, props), _ref$1_);
}

function _extends$23() { _extends$23 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$23.apply(this, arguments); }

var _ref$1$ = /*#__PURE__*/createElement("path", {
  d: "M2.5 3.924v7.759l11 1.605V2.713zm5-.551v9.04M2.5 8h11"
});

function SvgPlatformWindows(props) {
  return /*#__PURE__*/createElement("svg", _extends$23({
    width: 16,
    height: 16,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 16 16"
  }, props), _ref$1$);
}

function _extends$24() { _extends$24 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$24.apply(this, arguments); }

var _ref$20 = /*#__PURE__*/createElement("path", {
  d: "M7 7.5V2.925l-5 .551V7.5zm1 0h6V2.154l-6 .661zm0 1v4.491l6 .875V8.5zm-1 0H2v3.615l5 .73z"
});

function SvgPlatformWindowsFilled(props) {
  return /*#__PURE__*/createElement("svg", _extends$24({
    width: 16,
    height: 16,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 16 16"
  }, props), _ref$20);
}

function _extends$25() { _extends$25 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$25.apply(this, arguments); }

var _ref$21 = /*#__PURE__*/createElement("path", {
  d: "M5.5 4.569V2.986c0-.22.143-.413.353-.477l1-.31a.5.5 0 01.647.479v1.595m3-.445V2.335a.5.5 0 00-.647-.478L9 2.177"
});

var _ref2$C = /*#__PURE__*/createElement("path", {
  d: "M2.5 5.013v7.548l9 1.452 2-.667v-8.86l-2-.806z"
});

var _ref3$5 = /*#__PURE__*/createElement("path", {
  d: "M4.5 6.663v4.233l4 .462V6.314zm2-.175v4.639M4.5 8.5h4"
});

function SvgPlatformWindowsPhone(props) {
  return /*#__PURE__*/createElement("svg", _extends$25({
    width: 16,
    height: 16,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 16 16"
  }, props), _ref$21, _ref2$C, _ref3$5);
}

function _extends$26() { _extends$26 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$26.apply(this, arguments); }

var _ref$22 = /*#__PURE__*/createElement("path", {
  d: "M9 8H7V5.943l2-.174V8zm0 3.919l-2-.231V9h2v2.919zM6 8H4V6.204l2-.174V8zm0 3.573l-2-.231V9h2v2.573zm0-8.587l1-.308v1.163l-1 .148V2.986zm5.561.18L11 3.249v-.914a.99.99 0 00-.406-.804 1.01 1.01 0 00-.917-.142l-.853.32.352.937.824-.311v1.061l-2 .297V2.678a.99.99 0 00-.406-.805.987.987 0 00-.889-.151l-.999.309A.993.993 0 005 2.986v1.152l-3 .444v8.405l9.42 1.52.122.02 2.458-.82v-9.56l-2.439-.981z"
});

function SvgPlatformWindowsPhoneFilled(props) {
  return /*#__PURE__*/createElement("svg", _extends$26({
    width: 16,
    height: 16,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 16 16"
  }, props), _ref$22);
}

function _extends$27() { _extends$27 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$27.apply(this, arguments); }

var _ref$23 = /*#__PURE__*/createElement("path", {
  d: "M4.5 3v10l8-5z"
});

function SvgPlay(props) {
  return /*#__PURE__*/createElement("svg", _extends$27({
    width: 16,
    height: 16,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 16 16"
  }, props), _ref$23);
}

function _extends$28() { _extends$28 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$28.apply(this, arguments); }

var _ref$24 = /*#__PURE__*/createElement("path", {
  d: "M3 8h10M8 3v10"
});

function SvgPlus(props) {
  return /*#__PURE__*/createElement("svg", _extends$28({
    width: 16,
    height: 16,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 16 16"
  }, props), _ref$24);
}

function _extends$29() { _extends$29 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$29.apply(this, arguments); }

var _ref$25 = /*#__PURE__*/createElement("path", {
  d: "M13.5 8a5.5 5.5 0 10-11 0 5.5 5.5 0 0011 0z"
});

var _ref2$D = /*#__PURE__*/createElement("path", {
  d: "M10.5 6.5L7 10 5.5 8.5"
});

function SvgPositive(props) {
  return /*#__PURE__*/createElement("svg", _extends$29({
    width: 16,
    height: 16,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 16 16"
  }, props), _ref$25, _ref2$D);
}

function _extends$2a() { _extends$2a = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2a.apply(this, arguments); }

var _ref$26 = /*#__PURE__*/createElement("path", {
  d: "M7 10.707L5.146 8.853l.708-.707L7 9.293l3.146-3.147.708.707L7 10.707zM8 2a6 6 0 100 12A6 6 0 008 2z"
});

function SvgPositiveFilled(props) {
  return /*#__PURE__*/createElement("svg", _extends$2a({
    width: 16,
    height: 16,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 16 16"
  }, props), _ref$26);
}

function _extends$2b() { _extends$2b = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2b.apply(this, arguments); }

var _ref$27 = /*#__PURE__*/createElement("path", {
  d: "M13.5 8a5.5 5.5 0 10-11 0 5.5 5.5 0 0011 0zM8 10.265V11v-1z"
});

var _ref2$E = /*#__PURE__*/createElement("path", {
  d: "M6.5 6.99c0-1.993 3-1.882 3-.25C9.5 8 8 7.759 8 8.992"
});

function SvgQuestion(props) {
  return /*#__PURE__*/createElement("svg", _extends$2b({
    width: 16,
    height: 16,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 16 16"
  }, props), _ref$27, _ref2$E);
}

function _extends$2c() { _extends$2c = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2c.apply(this, arguments); }

var _ref$28 = /*#__PURE__*/createElement("path", {
  d: "M7.5 12.5a5 5 0 005-5 5 5 0 00-5-5 5 5 0 00-5 5 5 5 0 005 5zm6 1l-2.454-2.477"
});

function SvgSearch$1(props) {
  return /*#__PURE__*/createElement("svg", _extends$2c({
    width: 16,
    height: 16,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 16 16"
  }, props), _ref$28);
}

function _extends$2d() { _extends$2d = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2d.apply(this, arguments); }

var _ref$29 = /*#__PURE__*/createElement("path", {
  d: "M10.5 6L8 9.5 6 8"
});

var _ref2$F = /*#__PURE__*/createElement("path", {
  d: "M8 14c4.5-1.584 4.5-6 4.5-6V4L8 2 3.5 4v4s0 4.416 4.5 6z"
});

function SvgSecure(props) {
  return /*#__PURE__*/createElement("svg", _extends$2d({
    width: 16,
    height: 16,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 16 16"
  }, props), _ref$29, _ref2$F);
}

function _extends$2e() { _extends$2e = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2e.apply(this, arguments); }

var _ref$2a = /*#__PURE__*/createElement("path", {
  d: "M5.5 8a1.5 1.5 0 10-3 0 1.5 1.5 0 003 0zm7-4a1.5 1.5 0 10-3 0 1.5 1.5 0 003 0zm0 8a1.5 1.5 0 10-3 0 1.5 1.5 0 003 0zM5.297 8.741l4.405 2.517m0-6.517L5.297 7.259"
});

function SvgShare(props) {
  return /*#__PURE__*/createElement("svg", _extends$2e({
    width: 16,
    height: 16,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 16 16"
  }, props), _ref$2a);
}

function _extends$2f() { _extends$2f = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2f.apply(this, arguments); }

var _ref$2b = /*#__PURE__*/createElement("path", {
  d: "M6.5 5.5h3M3 8.5h3m4 1h3M11.5 13v-3m0-2V3M8 5V3m0 10V7m-3.5 6V9m0-2V3"
});

function SvgSliders(props) {
  return /*#__PURE__*/createElement("svg", _extends$2f({
    width: 16,
    height: 16,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 16 16"
  }, props), _ref$2b);
}

function _extends$2g() { _extends$2g = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2g.apply(this, arguments); }

var _ref$2c = /*#__PURE__*/createElement("path", {
  d: "M10.5 12V3m-5 1v9M8 10.5L5.5 13 3 10.5m5-5L10.5 3 13 5.5"
});

function SvgSort(props) {
  return /*#__PURE__*/createElement("svg", _extends$2g({
    width: 16,
    height: 16,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 16 16"
  }, props), _ref$2c);
}

function _extends$2h() { _extends$2h = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2h.apply(this, arguments); }

var _ref$2d = /*#__PURE__*/createElement("path", {
  d: "M2.5 4v6a.5.5 0 00.5.5h3v3l4-3h3a.5.5 0 00.5-.5V4a.5.5 0 00-.5-.5H3a.5.5 0 00-.5.5z"
});

function SvgSpeechBubble(props) {
  return /*#__PURE__*/createElement("svg", _extends$2h({
    width: 16,
    height: 16,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 16 16"
  }, props), _ref$2d);
}

function _extends$2i() { _extends$2i = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2i.apply(this, arguments); }

var _ref$2e = /*#__PURE__*/createElement("path", {
  d: "M8 2.573L9.647 5.91a.5.5 0 00.376.274l3.683.535-2.665 2.598a.504.504 0 00-.144.443l.629 3.667-3.294-1.731a.495.495 0 00-.464 0l-3.294 1.73.629-3.666a.504.504 0 00-.144-.443L2.294 6.719l3.683-.535a.5.5 0 00.376-.274L8 2.573z"
});

function SvgStar(props) {
  return /*#__PURE__*/createElement("svg", _extends$2i({
    width: 16,
    height: 16,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 16 16"
  }, props), _ref$2e);
}

function _extends$2j() { _extends$2j = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2j.apply(this, arguments); }

var _ref$2f = /*#__PURE__*/createElement("path", {
  d: "M10.5 5V3.5H5L7.954 8 5 12.5h5.5v-1.214"
});

function SvgSum(props) {
  return /*#__PURE__*/createElement("svg", _extends$2j({
    width: 16,
    height: 16,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 16 16"
  }, props), _ref$2f);
}

function _extends$2k() { _extends$2k = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2k.apply(this, arguments); }

var _ref$2g = /*#__PURE__*/createElement("path", {
  d: "M6.5 4v8M12 6.5H4m8 3H4m9 4H3a.5.5 0 01-.5-.5V3a.5.5 0 01.5-.5h10a.5.5 0 01.5.5v10a.5.5 0 01-.5.5z"
});

function SvgTable(props) {
  return /*#__PURE__*/createElement("svg", _extends$2k({
    width: 16,
    height: 16,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 16 16"
  }, props), _ref$2g);
}

function _extends$2l() { _extends$2l = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2l.apply(this, arguments); }

var _ref$2h = /*#__PURE__*/createElement("path", {
  d: "M11.5 13V3M9 5.5L11.5 3 14 5.5M7.5 8a2.5 2.5 0 10-5 0 2.5 2.5 0 005 0z"
});

var _ref2$G = /*#__PURE__*/createElement("path", {
  d: "M5 7v1l1 1"
});

function SvgTimeAscending(props) {
  return /*#__PURE__*/createElement("svg", _extends$2l({
    width: 16,
    height: 16,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 16 16"
  }, props), _ref$2h, _ref2$G);
}

function _extends$2m() { _extends$2m = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2m.apply(this, arguments); }

var _ref$2i = /*#__PURE__*/createElement("path", {
  d: "M11.5 3v10m2.5-2.5L11.5 13 9 10.5M7.5 8a2.5 2.5 0 10-5 0 2.5 2.5 0 005 0z"
});

var _ref2$H = /*#__PURE__*/createElement("path", {
  d: "M5 7v1l1 1"
});

function SvgTimeDescending(props) {
  return /*#__PURE__*/createElement("svg", _extends$2m({
    width: 16,
    height: 16,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 16 16"
  }, props), _ref$2i, _ref2$H);
}

function _extends$2n() { _extends$2n = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2n.apply(this, arguments); }

var _ref$2j = /*#__PURE__*/createElement("path", {
  d: "M3 4.5h10M6.5 6v6m3-6v6m2-7.5V13a.5.5 0 01-.5.5H5a.5.5 0 01-.5-.5V4.5m5 0v-2h-3v2"
});

function SvgTrash(props) {
  return /*#__PURE__*/createElement("svg", _extends$2n({
    width: 16,
    height: 16,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 16 16"
  }, props), _ref$2j);
}

function _extends$2o() { _extends$2o = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2o.apply(this, arguments); }

var _ref$2k = /*#__PURE__*/createElement("path", {
  d: "M8 14c4.5-1.584 4.5-6 4.5-6V4L8 2 3.5 4v4s0 4.416 4.5 6zM6.586 6.586l2.828 2.828m0-2.828L6.586 9.414"
});

function SvgUnsecure(props) {
  return /*#__PURE__*/createElement("svg", _extends$2o({
    width: 16,
    height: 16,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 16 16"
  }, props), _ref$2k);
}

function _extends$2p() { _extends$2p = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2p.apply(this, arguments); }

var _ref$2l = /*#__PURE__*/createElement("path", {
  d: "M13.5 10v3c0 .276-.273.5-.611.5H3.111c-.338 0-.611-.224-.611-.5v-3M8 11V3M5 6l3-3 3 3"
});

function SvgUpload$1(props) {
  return /*#__PURE__*/createElement("svg", _extends$2p({
    width: 16,
    height: 16,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 16 16"
  }, props), _ref$2l);
}

function _extends$2q() { _extends$2q = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2q.apply(this, arguments); }

var _ref$2m = /*#__PURE__*/createElement("path", {
  d: "M8 9V6m0 4v1m-.302-8.28l-5.137 9.288c-.149.27-.017.492.294.492h10.288c.313 0 .445-.222.295-.493L8.288 2.72c-.163-.292-.428-.292-.59 0z"
});

function SvgWarning$1(props) {
  return /*#__PURE__*/createElement("svg", _extends$2q({
    width: 16,
    height: 16,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 16 16"
  }, props), _ref$2m);
}

function _extends$2r() { _extends$2r = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2r.apply(this, arguments); }

var _ref$2n = /*#__PURE__*/createElement("path", {
  d: "M8.75 10.5a.75.75 0 11-1.5 0 .75.75 0 011.5 0zM7.5 9h1V6h-1v3zm6.376 2.765L8.725 2.477c-.336-.606-1.126-.606-1.464 0l-5.137 9.29c-.159.287-.166.593-.02.841.147.249.421.392.751.392h10.289c.331 0 .604-.143.752-.392.146-.248.139-.554-.02-.843z"
});

function SvgWarningFilled(props) {
  return /*#__PURE__*/createElement("svg", _extends$2r({
    width: 16,
    height: 16,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 16 16"
  }, props), _ref$2n);
}

function _extends$2s() { _extends$2s = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2s.apply(this, arguments); }

var _ref$2o = /*#__PURE__*/createElement("path", {
  d: "M4 9h4.5l-1 3.5L12 7H7.5l1-3.5z"
});

function SvgZap(props) {
  return /*#__PURE__*/createElement("svg", _extends$2s({
    width: 16,
    height: 16,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 16 16"
  }, props), _ref$2o);
}

function _extends$2t() { _extends$2t = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2t.apply(this, arguments); }

var _ref$2p = /*#__PURE__*/createElement("path", {
  d: "M7.5 12.5a5 5 0 005-5 5 5 0 00-5-5 5 5 0 00-5 5 5 5 0 005 5zm6 1l-2.465-2.465M5.5 7.5h4m-2-2v4"
});

function SvgZoomIn(props) {
  return /*#__PURE__*/createElement("svg", _extends$2t({
    width: 16,
    height: 16,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 16 16"
  }, props), _ref$2p);
}

function _extends$2u() { _extends$2u = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2u.apply(this, arguments); }

var _ref$2q = /*#__PURE__*/createElement("path", {
  d: "M7.5 12.5a5 5 0 005-5 5 5 0 00-5-5 5 5 0 00-5 5 5 5 0 005 5zm6 1l-2.453-2.476M5.5 7.5h4"
});

function SvgZoomOut(props) {
  return /*#__PURE__*/createElement("svg", _extends$2u({
    width: 16,
    height: 16,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 16 16"
  }, props), _ref$2q);
}

var index$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    ArrowCircleLeft: SvgArrowCircleLeft,
    ArrowCircleRight: SvgArrowCircleRight,
    ArrowDown: SvgArrowDown,
    ArrowDownLeft: SvgArrowDownLeft,
    ArrowDownRight: SvgArrowDownRight,
    ArrowLeft: SvgArrowLeft,
    ArrowRight: SvgArrowRight,
    ArrowUp: SvgArrowUp,
    ArrowUpLeft: SvgArrowUpLeft,
    ArrowUpRight: SvgArrowUpRight,
    BarChartHorizontal: SvgBarChartHorizontal,
    BarChartVertical: SvgBarChartVertical,
    Bell: SvgBell,
    Calendar: SvgCalendar,
    Charts: SvgCharts,
    Check: SvgCheck,
    ChevronDown: SvgChevronDown,
    ChevronLeft: SvgChevronLeft,
    ChevronRight: SvgChevronRight,
    ChevronUp: SvgChevronUp,
    Clipboard: SvgClipboard$1,
    Clock: SvgClock,
    Code: SvgCode,
    CogWheel: SvgCogWheel,
    Copy: SvgCopy,
    Cross: SvgCross,
    Data: SvgData,
    Document: SvgDocument,
    DotsHorizontal: SvgDotsHorizontal,
    DotsHorizontalFilled: SvgDotsHorizontalFilled,
    DotsVertical: SvgDotsVertical,
    DotsVerticalFilled: SvgDotsVerticalFilled,
    Download: SvgDownload$1,
    DrillDown: SvgDrillDown,
    Edit: SvgEdit,
    Eye: SvgEye,
    EyeClosed: SvgEyeClosed,
    Filter: SvgFilter,
    FilterActive: SvgFilterActive,
    Flag: SvgFlag,
    Folder: SvgFolder,
    Globe: SvgGlobe,
    Heart: SvgHeart,
    Image: SvgImage,
    Info: SvgInfo,
    InfoFilled: SvgInfoFilled,
    Kpi: SvgKpi,
    KpiCalculated: SvgKpiCalculated,
    KpiEvent: SvgKpiEvent,
    LettersAscending: SvgLettersAscending,
    LettersDescending: SvgLettersDescending,
    LineChart: SvgLineChart,
    LinkExternal: SvgLinkExternal,
    LockClosed: SvgLockClosed,
    LockOpen: SvgLockOpen,
    LogIn: SvgLogIn,
    LogOut: SvgLogOut,
    Mail: SvgMail,
    Maximize: SvgMaximize,
    Megaphone: SvgMegaphone,
    Menu: SvgMenu,
    Minimize: SvgMinimize,
    Minus: SvgMinus,
    Move: SvgMove,
    Negative: SvgNegative,
    NegativeFilled: SvgNegativeFilled,
    Network: SvgNetwork,
    NoImage: SvgNoImage,
    NotFound: SvgNotFound,
    NumbersAscending: SvgNumbersAscending,
    NumbersDescending: SvgNumbersDescending,
    Office: SvgOffice,
    Pause: SvgPause,
    Pencil: SvgPencil,
    Person: SvgPerson,
    PieChart: SvgPieChart,
    PlatformAndroid: SvgPlatformAndroid,
    PlatformAndroidFilled: SvgPlatformAndroidFilled,
    PlatformIos: SvgPlatformIos,
    PlatformIosFilled: SvgPlatformIosFilled,
    PlatformWeb: SvgPlatformWeb,
    PlatformWebFilled: SvgPlatformWebFilled,
    PlatformWindows: SvgPlatformWindows,
    PlatformWindowsFilled: SvgPlatformWindowsFilled,
    PlatformWindowsPhone: SvgPlatformWindowsPhone,
    PlatformWindowsPhoneFilled: SvgPlatformWindowsPhoneFilled,
    Play: SvgPlay,
    Plus: SvgPlus,
    Positive: SvgPositive,
    PositiveFilled: SvgPositiveFilled,
    Question: SvgQuestion,
    Search: SvgSearch$1,
    Secure: SvgSecure,
    Share: SvgShare,
    Sliders: SvgSliders,
    Sort: SvgSort,
    SpeechBubble: SvgSpeechBubble,
    Star: SvgStar,
    Sum: SvgSum,
    Table: SvgTable,
    TimeAscending: SvgTimeAscending,
    TimeDescending: SvgTimeDescending,
    Trash: SvgTrash,
    Unsecure: SvgUnsecure,
    Upload: SvgUpload$1,
    Warning: SvgWarning$1,
    WarningFilled: SvgWarningFilled,
    Zap: SvgZap,
    ZoomIn: SvgZoomIn,
    ZoomOut: SvgZoomOut
});

function _extends$2v() { _extends$2v = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2v.apply(this, arguments); }

var _ref$2r = /*#__PURE__*/createElement("path", {
  d: "M5.5 5.5v4h4m-2.608 6.52a6.5 6.5 0 10-.881-6.551"
});

function SvgArrowCircleLeft$1(props) {
  return /*#__PURE__*/createElement("svg", _extends$2v({
    width: 24,
    height: 24,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 24 24"
  }, props), _ref$2r);
}

function _extends$2w() { _extends$2w = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2w.apply(this, arguments); }

var _ref$2s = /*#__PURE__*/createElement("path", {
  d: "M18.5 5.5v4h-4m2.608 6.52a6.5 6.5 0 11.881-6.551"
});

function SvgArrowCircleRight$1(props) {
  return /*#__PURE__*/createElement("svg", _extends$2w({
    width: 24,
    height: 24,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 24 24"
  }, props), _ref$2s);
}

function _extends$2x() { _extends$2x = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2x.apply(this, arguments); }

var _ref$2t = /*#__PURE__*/createElement("path", {
  d: "M5 12.966l7 7 7-7M12 4v16"
});

function SvgArrowDown$1(props) {
  return /*#__PURE__*/createElement("svg", _extends$2x({
    width: 24,
    height: 24,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 24 24"
  }, props), _ref$2t);
}

function _extends$2y() { _extends$2y = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2y.apply(this, arguments); }

var _ref$2u = /*#__PURE__*/createElement("path", {
  d: "M16 17.5H6.5V8m0 9.5l11-11"
});

function SvgArrowDownLeft$1(props) {
  return /*#__PURE__*/createElement("svg", _extends$2y({
    width: 24,
    height: 24,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 24 24"
  }, props), _ref$2u);
}

function _extends$2z() { _extends$2z = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2z.apply(this, arguments); }

var _ref$2v = /*#__PURE__*/createElement("path", {
  d: "M8 17.5h9.5V8m0 9.5l-11-11"
});

function SvgArrowDownRight$1(props) {
  return /*#__PURE__*/createElement("svg", _extends$2z({
    width: 24,
    height: 24,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 24 24"
  }, props), _ref$2v);
}

function _extends$2A() { _extends$2A = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2A.apply(this, arguments); }

var _ref$2w = /*#__PURE__*/createElement("path", {
  d: "M11.034 5l-7 7 7 7M20 12H4"
});

function SvgArrowLeft$1(props) {
  return /*#__PURE__*/createElement("svg", _extends$2A({
    width: 24,
    height: 24,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 24 24"
  }, props), _ref$2w);
}

function _extends$2B() { _extends$2B = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2B.apply(this, arguments); }

var _ref$2x = /*#__PURE__*/createElement("path", {
  d: "M12.966 19l7-7-7-7M4 12h16"
});

function SvgArrowRight$1(props) {
  return /*#__PURE__*/createElement("svg", _extends$2B({
    width: 24,
    height: 24,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 24 24"
  }, props), _ref$2x);
}

function _extends$2C() { _extends$2C = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2C.apply(this, arguments); }

var _ref$2y = /*#__PURE__*/createElement("path", {
  d: "M19 11.034l-7-7-7 7M12 20V4"
});

function SvgArrowUp$1(props) {
  return /*#__PURE__*/createElement("svg", _extends$2C({
    width: 24,
    height: 24,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 24 24"
  }, props), _ref$2y);
}

function _extends$2D() { _extends$2D = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2D.apply(this, arguments); }

var _ref$2z = /*#__PURE__*/createElement("path", {
  d: "M16 6.5H6.5V16m0-9.5l11 11"
});

function SvgArrowUpLeft$1(props) {
  return /*#__PURE__*/createElement("svg", _extends$2D({
    width: 24,
    height: 24,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 24 24"
  }, props), _ref$2z);
}

function _extends$2E() { _extends$2E = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2E.apply(this, arguments); }

var _ref$2A = /*#__PURE__*/createElement("path", {
  d: "M8 6.5h9.5V16m0-9.5l-11 11"
});

function SvgArrowUpRight$1(props) {
  return /*#__PURE__*/createElement("svg", _extends$2E({
    width: 24,
    height: 24,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 24 24"
  }, props), _ref$2A);
}

function _extends$2F() { _extends$2F = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2F.apply(this, arguments); }

var _ref$2B = /*#__PURE__*/createElement("path", {
  d: "M4.5 4v15.5H20m-13-6h9m-5 3H7m0-9h8m3 3H7"
});

function SvgBarChartHorizontal$1(props) {
  return /*#__PURE__*/createElement("svg", _extends$2F({
    width: 24,
    height: 24,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 24 24"
  }, props), _ref$2B);
}

function _extends$2G() { _extends$2G = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2G.apply(this, arguments); }

var _ref$2C = /*#__PURE__*/createElement("path", {
  d: "M4.5 4v15.5H20M10.5 17V8m-3 5v4m9 0V9m-3-3v11"
});

function SvgBarChartVertical$1(props) {
  return /*#__PURE__*/createElement("svg", _extends$2G({
    width: 24,
    height: 24,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 24 24"
  }, props), _ref$2C);
}

function _extends$2H() { _extends$2H = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2H.apply(this, arguments); }

var _ref$2D = /*#__PURE__*/createElement("path", {
  d: "M20 16.5H4c1.326 0 2.5-2 2.5-4V9.321C6.5 6.106 8.907 3.5 12 3.5s5.5 2.606 5.5 5.821V12.5c0 2 1.175 4 2.5 4zM13.5 18a1.5 1.5 0 11-3 0"
});

function SvgBell$1(props) {
  return /*#__PURE__*/createElement("svg", _extends$2H({
    width: 24,
    height: 24,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 24 24"
  }, props), _ref$2D);
}

function _extends$2I() { _extends$2I = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2I.apply(this, arguments); }

var _ref$2E = /*#__PURE__*/createElement("path", {
  d: "M15.5 3v3m-7-3v3m10 13.5h-13a1 1 0 01-1-1v-13a1 1 0 011-1h13a1 1 0 011 1v13a1 1 0 01-1 1zM5 8.538h14"
});

function SvgCalendar$1(props) {
  return /*#__PURE__*/createElement("svg", _extends$2I({
    width: 24,
    height: 24,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 24 24"
  }, props), _ref$2E);
}

function _extends$2J() { _extends$2J = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2J.apply(this, arguments); }

var _ref$2F = /*#__PURE__*/createElement("path", {
  d: "M8 13.5H3.5a1 1 0 01-1-1v-9a1 1 0 011-1h9a1 1 0 011 1V8"
});

var _ref2$I = /*#__PURE__*/createElement("path", {
  d: "M20.5 21.5h-9a1 1 0 01-1-1v-9a1 1 0 011-1h9a1 1 0 011 1v9a1 1 0 01-1 1z"
});

var _ref3$6 = /*#__PURE__*/createElement("path", {
  d: "M12.5 19.436l2-2.936 2 1 3.085-5M5.5 11V5M8 11V6m2.5 2V4"
});

function SvgCharts$1(props) {
  return /*#__PURE__*/createElement("svg", _extends$2J({
    width: 24,
    height: 24,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 24 24"
  }, props), _ref$2F, _ref2$I, _ref3$6);
}

function _extends$2K() { _extends$2K = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2K.apply(this, arguments); }

var _ref$2G = /*#__PURE__*/createElement("path", {
  d: "M19.5 6.5l-9 10-6-6"
});

function SvgCheck$1(props) {
  return /*#__PURE__*/createElement("svg", _extends$2K({
    width: 24,
    height: 24,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 24 24"
  }, props), _ref$2G);
}

function _extends$2L() { _extends$2L = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2L.apply(this, arguments); }

var _ref$2H = /*#__PURE__*/createElement("path", {
  d: "M5.5 9.5l6.5 6 6.5-6"
});

function SvgChevronDown$1(props) {
  return /*#__PURE__*/createElement("svg", _extends$2L({
    width: 24,
    height: 24,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 24 24"
  }, props), _ref$2H);
}

function _extends$2M() { _extends$2M = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2M.apply(this, arguments); }

var _ref$2I = /*#__PURE__*/createElement("path", {
  d: "M15 5.5L9 12l6 6.5"
});

function SvgChevronLeft$1(props) {
  return /*#__PURE__*/createElement("svg", _extends$2M({
    width: 24,
    height: 24,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 24 24"
  }, props), _ref$2I);
}

function _extends$2N() { _extends$2N = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2N.apply(this, arguments); }

var _ref$2J = /*#__PURE__*/createElement("path", {
  d: "M9 18.5l6-6.5-6-6.5"
});

function SvgChevronRight$1(props) {
  return /*#__PURE__*/createElement("svg", _extends$2N({
    width: 24,
    height: 24,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 24 24"
  }, props), _ref$2J);
}

function _extends$2O() { _extends$2O = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2O.apply(this, arguments); }

var _ref$2K = /*#__PURE__*/createElement("path", {
  d: "M18.5 14.5l-6.5-6-6.5 6"
});

function SvgChevronUp$1(props) {
  return /*#__PURE__*/createElement("svg", _extends$2O({
    width: 24,
    height: 24,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 24 24"
  }, props), _ref$2K);
}

function _extends$2P() { _extends$2P = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2P.apply(this, arguments); }

var _ref$2L = /*#__PURE__*/createElement("path", {
  d: "M14.5 4.5h2a1 1 0 011 1v13a1 1 0 01-1 1h-9a1 1 0 01-1-1v-13a1 1 0 011-1h2"
});

var _ref2$J = /*#__PURE__*/createElement("path", {
  d: "M14.5 5.5h-5v-1a1 1 0 011-1h3a1 1 0 011 1v1z"
});

function SvgClipboard$2(props) {
  return /*#__PURE__*/createElement("svg", _extends$2P({
    width: 24,
    height: 24,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 24 24"
  }, props), _ref$2L, _ref2$J);
}

function _extends$2Q() { _extends$2Q = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2Q.apply(this, arguments); }

var _ref$2M = /*#__PURE__*/createElement("path", {
  d: "M12 20.5a8.5 8.5 0 10-.001-17.001A8.5 8.5 0 0012 20.5z"
});

var _ref2$K = /*#__PURE__*/createElement("path", {
  d: "M11.5 7v5.5l4 2"
});

function SvgClock$1(props) {
  return /*#__PURE__*/createElement("svg", _extends$2Q({
    width: 24,
    height: 24,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 24 24"
  }, props), _ref$2M, _ref2$K);
}

function _extends$2R() { _extends$2R = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2R.apply(this, arguments); }

var _ref$2N = /*#__PURE__*/createElement("path", {
  d: "M8 7l-5 5 5 5m8 0l5-5-5-5m-2-2l-4 14"
});

function SvgCode$1(props) {
  return /*#__PURE__*/createElement("svg", _extends$2R({
    width: 24,
    height: 24,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 24 24"
  }, props), _ref$2N);
}

function _extends$2S() { _extends$2S = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2S.apply(this, arguments); }

var _ref$2O = /*#__PURE__*/createElement("path", {
  d: "M14.5 12a2.5 2.5 0 10-5 0 2.5 2.5 0 005 0z"
});

var _ref2$L = /*#__PURE__*/createElement("path", {
  d: "M20.5 13v-2l-1.892-.434a.548.548 0 01-.364-.354 6.528 6.528 0 00-.565-1.362.548.548 0 01.008-.509l1.031-1.644-1.414-1.415-1.645 1.032a.548.548 0 01-.509.007 6.431 6.431 0 00-1.362-.565.548.548 0 01-.354-.365L13 3.5h-2l-.434 1.891a.548.548 0 01-.354.365 6.475 6.475 0 00-1.362.565.548.548 0 01-.509-.007L6.697 5.282 5.282 6.697l1.032 1.644a.548.548 0 01.007.509 6.475 6.475 0 00-.565 1.362.548.548 0 01-.365.354L3.5 11v2l1.891.434c.16.036.32.197.365.354.137.48.328.936.565 1.362.08.143.08.371-.007.509l-1.032 1.645 1.415 1.414 1.644-1.031a.548.548 0 01.509-.008c.427.237.882.427 1.362.565a.548.548 0 01.354.364L11 20.5h2l.434-1.892a.548.548 0 01.354-.364c.48-.138.936-.328 1.362-.565a.548.548 0 01.509.008l1.645 1.031 1.414-1.414-1.031-1.645a.548.548 0 01-.008-.509c.237-.426.427-.882.565-1.362a.548.548 0 01.364-.354L20.5 13z"
});

function SvgCogWheel$1(props) {
  return /*#__PURE__*/createElement("svg", _extends$2S({
    width: 24,
    height: 24,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 24 24"
  }, props), _ref$2O, _ref2$L);
}

function _extends$2T() { _extends$2T = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2T.apply(this, arguments); }

var _ref$2P = /*#__PURE__*/createElement("path", {
  d: "M18.5 19.5h-7a1 1 0 01-1-1v-7a1 1 0 011-1h7a1 1 0 011 1v7a1 1 0 01-1 1z"
});

var _ref2$M = /*#__PURE__*/createElement("path", {
  d: "M8 13.5H5.5a1 1 0 01-1-1v-7a1 1 0 011-1h7a1 1 0 011 1V8"
});

function SvgCopy$1(props) {
  return /*#__PURE__*/createElement("svg", _extends$2T({
    width: 24,
    height: 24,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 24 24"
  }, props), _ref$2P, _ref2$M);
}

function _extends$2U() { _extends$2U = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2U.apply(this, arguments); }

var _ref$2Q = /*#__PURE__*/createElement("path", {
  d: "M18 6L6 18M6 6l12 12"
});

function SvgCross$1(props) {
  return /*#__PURE__*/createElement("svg", _extends$2U({
    width: 24,
    height: 24,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 24 24"
  }, props), _ref$2Q);
}

function _extends$2V() { _extends$2V = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2V.apply(this, arguments); }

var _ref$2R = /*#__PURE__*/createElement("path", {
  d: "M18.5 5.5c0 1.104-2.91 2-6.5 2s-6.5-.896-6.5-2 2.91-2 6.5-2 6.5.896 6.5 2z"
});

var _ref2$N = /*#__PURE__*/createElement("path", {
  d: "M18.5 5.5v13c0 1.104-2.91 2-6.5 2s-6.5-.896-6.5-2v-13"
});

var _ref3$7 = /*#__PURE__*/createElement("path", {
  d: "M18.5 14c0 1.104-2.91 2-6.5 2s-6.5-.896-6.5-2m13-4.5c0 1.104-2.91 2-6.5 2s-6.5-.896-6.5-2"
});

function SvgData$1(props) {
  return /*#__PURE__*/createElement("svg", _extends$2V({
    width: 24,
    height: 24,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 24 24"
  }, props), _ref$2R, _ref2$N, _ref3$7);
}

function _extends$2W() { _extends$2W = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2W.apply(this, arguments); }

var _ref$2S = /*#__PURE__*/createElement("path", {
  d: "M17.5 8.914V18.5a1 1 0 01-1 1h-9a1 1 0 01-1-1v-13a1 1 0 011-1h5.586a1 1 0 01.707.293l3.414 3.414a.997.997 0 01.293.707z"
});

var _ref2$O = /*#__PURE__*/createElement("path", {
  d: "M13.5 4.59V8.5h3.91"
});

function SvgDocument$1(props) {
  return /*#__PURE__*/createElement("svg", _extends$2W({
    width: 24,
    height: 24,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 24 24"
  }, props), _ref$2S, _ref2$O);
}

function _extends$2X() { _extends$2X = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2X.apply(this, arguments); }

var _ref$2T = /*#__PURE__*/createElement("path", {
  d: "M7.5 12a1 1 0 11-2 0 1 1 0 112 0z"
});

var _ref2$P = /*#__PURE__*/createElement("path", {
  d: "M7 12a.5.5 0 11-1 0 .5.5 0 011 0zm6 0a1 1 0 11-2 0 1 1 0 112 0z"
});

var _ref3$8 = /*#__PURE__*/createElement("path", {
  d: "M12.5 12a.5.5 0 11-1 0 .5.5 0 011 0zm6 0a1 1 0 11-2 0 1 1 0 112 0z"
});

var _ref4$1 = /*#__PURE__*/createElement("path", {
  d: "M18 12a.5.5 0 11-1 0 .5.5 0 011 0z"
});

function SvgDotsHorizontal$1(props) {
  return /*#__PURE__*/createElement("svg", _extends$2X({
    width: 24,
    height: 24,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 24 24"
  }, props), _ref$2T, _ref2$P, _ref3$8, _ref4$1);
}

function _extends$2Y() { _extends$2Y = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2Y.apply(this, arguments); }

var _ref$2U = /*#__PURE__*/createElement("path", {
  d: "M17.5 13.5a1.501 1.501 0 010-3 1.501 1.501 0 010 3m-5.5 0c-.827 0-1.5-.673-1.5-1.5s.673-1.5 1.5-1.5 1.5.673 1.5 1.5-.673 1.5-1.5 1.5m-5.5 0c-.827 0-1.5-.673-1.5-1.5s.673-1.5 1.5-1.5S8 11.173 8 12s-.673 1.5-1.5 1.5M18 7H6a5 5 0 000 10h12a5 5 0 100-10"
});

function SvgDotsHorizontalFilled$1(props) {
  return /*#__PURE__*/createElement("svg", _extends$2Y({
    width: 24,
    height: 24,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 24 24"
  }, props), _ref$2U);
}

function _extends$2Z() { _extends$2Z = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2Z.apply(this, arguments); }

var _ref$2V = /*#__PURE__*/createElement("path", {
  d: "M13 6.5a1 1 0 11-2 0 1 1 0 112 0z"
});

var _ref2$Q = /*#__PURE__*/createElement("path", {
  d: "M12.5 6.5a.5.5 0 11-1 0 .5.5 0 011 0zM13 12a1 1 0 11-2 0 1 1 0 112 0z"
});

var _ref3$9 = /*#__PURE__*/createElement("path", {
  d: "M12.5 12a.5.5 0 11-1 0 .5.5 0 011 0zm.5 5.5a1 1 0 11-2 0 1 1 0 112 0z"
});

var _ref4$2 = /*#__PURE__*/createElement("path", {
  d: "M12.5 17.5a.5.5 0 11-1 0 .5.5 0 011 0z"
});

function SvgDotsVertical$1(props) {
  return /*#__PURE__*/createElement("svg", _extends$2Z({
    width: 24,
    height: 24,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 24 24"
  }, props), _ref$2V, _ref2$Q, _ref3$9, _ref4$2);
}

function _extends$2_() { _extends$2_ = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2_.apply(this, arguments); }

var _ref$2W = /*#__PURE__*/createElement("path", {
  d: "M10.5 17.5a1.501 1.501 0 013.002.002A1.502 1.502 0 0110.5 17.5m0-5.5c0-.827.673-1.5 1.5-1.5s1.5.673 1.5 1.5-.673 1.5-1.5 1.5-1.5-.673-1.5-1.5m0-5.5c0-.827.673-1.5 1.5-1.5s1.5.673 1.5 1.5S12.827 8 12 8s-1.5-.673-1.5-1.5M17 18V6A5 5 0 107 6v12a5 5 0 1010 0"
});

function SvgDotsVerticalFilled$1(props) {
  return /*#__PURE__*/createElement("svg", _extends$2_({
    width: 24,
    height: 24,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 24 24"
  }, props), _ref$2W);
}

function _extends$2$() { _extends$2$ = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2$.apply(this, arguments); }

var _ref$2X = /*#__PURE__*/createElement("path", {
  d: "M19.5 15v3.5a1 1 0 01-1 1h-13a1 1 0 01-1-1V15M12 4v11"
});

var _ref2$R = /*#__PURE__*/createElement("path", {
  d: "M16.5 10.5L12 15l-4.5-4.5"
});

function SvgDownload$2(props) {
  return /*#__PURE__*/createElement("svg", _extends$2$({
    width: 24,
    height: 24,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 24 24"
  }, props), _ref$2X, _ref2$R);
}

function _extends$30() { _extends$30 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$30.apply(this, arguments); }

var _ref$2Y = /*#__PURE__*/createElement("path", {
  d: "M11.99 14l7-9.5h-14z"
});

var _ref2$S = /*#__PURE__*/createElement("path", {
  d: "M6.99 10.5h-2l7 9.5 7-9.5h-2"
});

function SvgDrillDown$1(props) {
  return /*#__PURE__*/createElement("svg", _extends$30({
    width: 24,
    height: 24,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 24 24"
  }, props), _ref$2Y, _ref2$S);
}

function _extends$31() { _extends$31 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$31.apply(this, arguments); }

var _ref$2Z = /*#__PURE__*/createElement("path", {
  strokeLinejoin: "round",
  d: "M19.5 9v9.5a1 1 0 01-1 1h-13a1 1 0 01-1-1v-13a1 1 0 011-1H13"
});

var _ref2$T = /*#__PURE__*/createElement("path", {
  d: "M9.5 15.5l1-4 6.494-8.282a1 1 0 011.343-.197l1.273.871c.481.328.58.996.216 1.45L13.5 13.5l-4 2z"
});

var _ref3$a = /*#__PURE__*/createElement("path", {
  strokeLinecap: "round",
  d: "M10.5 11.5l3 2"
});

function SvgEdit$1(props) {
  return /*#__PURE__*/createElement("svg", _extends$31({
    width: 24,
    height: 24,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 24 24"
  }, props), _ref$2Z, _ref2$T, _ref3$a);
}

function _extends$32() { _extends$32 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$32.apply(this, arguments); }

var _ref$2_ = /*#__PURE__*/createElement("path", {
  d: "M3 12s3.273-6.5 9-6.5c5.728 0 9 6.5 9 6.5s-3.272 6.5-9 6.5c-5.727 0-9-6.5-9-6.5z"
});

var _ref2$U = /*#__PURE__*/createElement("path", {
  d: "M12 14.5a2.5 2.5 0 100-5 2.5 2.5 0 000 5z"
});

function SvgEye$1(props) {
  return /*#__PURE__*/createElement("svg", _extends$32({
    width: 24,
    height: 24,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 24 24"
  }, props), _ref$2_, _ref2$U);
}

function _extends$33() { _extends$33 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$33.apply(this, arguments); }

var _ref$2$ = /*#__PURE__*/createElement("path", {
  d: "M19.5 4.5l-15 15M17.944 8.056C19.93 9.876 21 12 21 12s-3.273 6.5-9 6.5c-1.338 0-2.542-.354-3.602-.898m-1.23-.753c-2.697-1.926-4.167-4.85-4.167-4.85s3.272-6.5 9-6.5c1.89 0 3.514.71 4.84 1.66m-5.345 7.291a2.5 2.5 0 002.962-2.906m-.69-1.312a2.5 2.5 0 00-3.535 3.535"
});

function SvgEyeClosed$1(props) {
  return /*#__PURE__*/createElement("svg", _extends$33({
    width: 24,
    height: 24,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 24 24"
  }, props), _ref$2$);
}

function _extends$34() { _extends$34 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$34.apply(this, arguments); }

var _ref$30 = /*#__PURE__*/createElement("path", {
  d: "M19.5 5.5h-15l6 8v4l3 2v-6z"
});

function SvgFilter$1(props) {
  return /*#__PURE__*/createElement("svg", _extends$34({
    width: 24,
    height: 24,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 24 24"
  }, props), _ref$30);
}

function _extends$35() { _extends$35 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$35.apply(this, arguments); }

var _ref$31 = /*#__PURE__*/createElement("path", {
  d: "M14.531 5.5H4.501l6 8v4l3 2v-6l2.88-3.841M21.5 6a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0z"
});

function SvgFilterActive$1(props) {
  return /*#__PURE__*/createElement("svg", _extends$35({
    width: 24,
    height: 24,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 24 24"
  }, props), _ref$31);
}

function _extends$36() { _extends$36 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$36.apply(this, arguments); }

var _ref$32 = /*#__PURE__*/createElement("path", {
  d: "M6.5 14s.75-.5 3-.5 3.75 1.5 6 1.5 3-1 3-1V6s-.75.5-3 .5S11.75 5 9.5 5s-3 1-3 1v8zm0 6v-6"
});

function SvgFlag$1(props) {
  return /*#__PURE__*/createElement("svg", _extends$36({
    width: 24,
    height: 24,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 24 24"
  }, props), _ref$32);
}

function _extends$37() { _extends$37 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$37.apply(this, arguments); }

var _ref$33 = /*#__PURE__*/createElement("path", {
  d: "M18.5 18.5h-13a1 1 0 01-1-1v-9h14a1 1 0 011 1v8a1 1 0 01-1 1zm-7-10l-2-2h-4a1 1 0 00-1 1v1"
});

function SvgFolder$1(props) {
  return /*#__PURE__*/createElement("svg", _extends$37({
    width: 24,
    height: 24,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 24 24"
  }, props), _ref$33);
}

function _extends$38() { _extends$38 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$38.apply(this, arguments); }

var _ref$34 = /*#__PURE__*/createElement("path", {
  d: "M12 20.5a8.5 8.5 0 10-.001-17.001A8.5 8.5 0 0012 20.5z"
});

var _ref2$V = /*#__PURE__*/createElement("path", {
  d: "M12 20.5c2.348 0 4.25-3.806 4.25-8.5S14.348 3.5 12 3.5c-2.347 0-4.25 3.806-4.25 8.5s1.903 8.5 4.25 8.5z"
});

var _ref3$b = /*#__PURE__*/createElement("path", {
  d: "M3.499 11.08c.437 1.148 4.077 2.045 8.501 2.045 4.416 0 8.05-.893 8.499-2.039M12 20V4"
});

function SvgGlobe$1(props) {
  return /*#__PURE__*/createElement("svg", _extends$38({
    width: 24,
    height: 24,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 24 24"
  }, props), _ref$34, _ref2$V, _ref3$b);
}

function _extends$39() { _extends$39 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$39.apply(this, arguments); }

var _ref$35 = /*#__PURE__*/createElement("path", {
  d: "M18.767 6.738A4.207 4.207 0 0015.789 5.5a4.207 4.207 0 00-2.978 1.238L12 7.5l-.811-.762a4.2 4.2 0 00-5.955 0 4.233 4.233 0 000 5.974L12 19.5l6.767-6.788A4.23 4.23 0 0020 9.725a4.23 4.23 0 00-1.233-2.987z"
});

function SvgHeart$1(props) {
  return /*#__PURE__*/createElement("svg", _extends$39({
    width: 24,
    height: 24,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 24 24"
  }, props), _ref$35);
}

function _extends$3a() { _extends$3a = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3a.apply(this, arguments); }

var _ref$36 = /*#__PURE__*/createElement("path", {
  d: "M18.5 19.5h-13a1 1 0 01-1-1v-13a1 1 0 011-1h13a1 1 0 011 1v13a1 1 0 01-1 1z"
});

var _ref2$W = /*#__PURE__*/createElement("path", {
  d: "M10.5 8.5a2 2 0 11-4.001-.001A2 2 0 0110.5 8.5zm-6 9l11-8 4 4"
});

function SvgImage$1(props) {
  return /*#__PURE__*/createElement("svg", _extends$3a({
    width: 24,
    height: 24,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 24 24"
  }, props), _ref$36, _ref2$W);
}

function _extends$3b() { _extends$3b = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3b.apply(this, arguments); }

var _ref$37 = /*#__PURE__*/createElement("path", {
  d: "M20.5 12a8.5 8.5 0 10-17.001.001A8.5 8.5 0 0020.5 12zM12 8.5V8v1zm-2 7h4"
});

var _ref2$X = /*#__PURE__*/createElement("path", {
  d: "M10 11.5h2v4"
});

function SvgInfo$1(props) {
  return /*#__PURE__*/createElement("svg", _extends$3b({
    width: 24,
    height: 24,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 24 24"
  }, props), _ref$37, _ref2$X);
}

function _extends$3c() { _extends$3c = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3c.apply(this, arguments); }

var _ref$38 = /*#__PURE__*/createElement("path", {
  d: "M12.75 8.5a.75.75 0 11-1.5 0 .75.75 0 011.5 0zM14 16h-4v-1h1.5v-3H10v-1h2.5v4H14v1zM12 3c-4.962 0-9 4.038-9 9 0 4.963 4.038 9 9 9 4.963 0 9-4.037 9-9 0-4.962-4.037-9-9-9z"
});

function SvgInfoFilled$1(props) {
  return /*#__PURE__*/createElement("svg", _extends$3c({
    width: 24,
    height: 24,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 24 24"
  }, props), _ref$38);
}

function _extends$3d() { _extends$3d = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3d.apply(this, arguments); }

var _ref$39 = /*#__PURE__*/createElement("path", {
  d: "M22 4.5h-2.5V2l-2 2v2.5H20zM18.5 12a6.5 6.5 0 11-13 0 6.5 6.5 0 0113 0z"
});

var _ref2$Y = /*#__PURE__*/createElement("path", {
  d: "M16.5 12a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0z"
});

var _ref3$c = /*#__PURE__*/createElement("path", {
  d: "M14.5 12a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0z"
});

var _ref4$3 = /*#__PURE__*/createElement("path", {
  d: "M12.5 12a.5.5 0 11-1 0 .5.5 0 011 0zm0-.5l7-7"
});

function SvgKpi$1(props) {
  return /*#__PURE__*/createElement("svg", _extends$3d({
    width: 24,
    height: 24,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 24 24"
  }, props), _ref$39, _ref2$Y, _ref3$c, _ref4$3);
}

function _extends$3e() { _extends$3e = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3e.apply(this, arguments); }

var _ref$3a = /*#__PURE__*/createElement("path", {
  d: "M12 5a2 2 0 11-.001 4.001A2 2 0 0112 5zm0 10a2 2 0 11-.001 4.001A2 2 0 0112 15zm-7-3h14"
});

function SvgKpiCalculated$1(props) {
  return /*#__PURE__*/createElement("svg", _extends$3e({
    width: 24,
    height: 24,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 24 24"
  }, props), _ref$3a);
}

function _extends$3f() { _extends$3f = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3f.apply(this, arguments); }

var _ref$3b = /*#__PURE__*/createElement("path", {
  d: "M4.5 12h13c0-3.017-2.482-5.5-5.5-5.5-3.017 0-5.5 2.483-5.5 5.5 0 3.018 2.483 5.5 5.5 5.5a5.508 5.508 0 004.893-2.987"
});

function SvgKpiEvent$1(props) {
  return /*#__PURE__*/createElement("svg", _extends$3f({
    width: 24,
    height: 24,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 24 24"
  }, props), _ref$3b);
}

function _extends$3g() { _extends$3g = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3g.apply(this, arguments); }

var _ref$3c = /*#__PURE__*/createElement("path", {
  d: "M16.5 20V4m-4 4l4-4 4 4m-14 8.5h3M6 4.5h3.25a.25.25 0 01.2.4l-2.9 5.2a.25.25 0 00.2.4H10m-.5 9v-5a1 1 0 00-1-1h-1a1 1 0 00-1 1v5"
});

function SvgLettersAscending$1(props) {
  return /*#__PURE__*/createElement("svg", _extends$3g({
    width: 24,
    height: 24,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 24 24"
  }, props), _ref$3c);
}

function _extends$3h() { _extends$3h = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3h.apply(this, arguments); }

var _ref$3d = /*#__PURE__*/createElement("path", {
  d: "M16.5 4v16m4-4l-4 4-4-4m-6 .5h3M6 4.5h3.25a.25.25 0 01.2.4l-2.9 5.2a.25.25 0 00.2.4H10m-.5 9v-5a1 1 0 00-1-1h-1a1 1 0 00-1 1v5"
});

function SvgLettersDescending$1(props) {
  return /*#__PURE__*/createElement("svg", _extends$3h({
    width: 24,
    height: 24,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 24 24"
  }, props), _ref$3d);
}

function _extends$3i() { _extends$3i = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3i.apply(this, arguments); }

var _ref$3e = /*#__PURE__*/createElement("path", {
  d: "M4.5 4v15.5H20"
});

var _ref2$Z = /*#__PURE__*/createElement("path", {
  d: "M20.5 7.5l-6 6-3-3-5 5"
});

function SvgLineChart$1(props) {
  return /*#__PURE__*/createElement("svg", _extends$3i({
    width: 24,
    height: 24,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 24 24"
  }, props), _ref$3e, _ref2$Z);
}

function _extends$3j() { _extends$3j = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3j.apply(this, arguments); }

var _ref$3f = /*#__PURE__*/createElement("path", {
  d: "M18.5 11v6.5a1 1 0 01-1 1h-11a1 1 0 01-1-1v-11a1 1 0 011-1H13M19.5 9V3.5H14m5.5 0L12 12"
});

function SvgLinkExternal$1(props) {
  return /*#__PURE__*/createElement("svg", _extends$3j({
    width: 24,
    height: 24,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 24 24"
  }, props), _ref$3f);
}

function _extends$3k() { _extends$3k = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3k.apply(this, arguments); }

var _ref$3g = /*#__PURE__*/createElement("path", {
  d: "M17.5 10.5h-11a1 1 0 00-1 1v7a1 1 0 001 1h11a1 1 0 001-1v-7a1 1 0 00-1-1zm-1.5 0v-2a4 4 0 00-8 0v2m4 3.5v2"
});

function SvgLockClosed$1(props) {
  return /*#__PURE__*/createElement("svg", _extends$3k({
    width: 24,
    height: 24,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 24 24"
  }, props), _ref$3g);
}

function _extends$3l() { _extends$3l = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3l.apply(this, arguments); }

var _ref$3h = /*#__PURE__*/createElement("path", {
  d: "M17.5 10.5h-11a1 1 0 00-1 1v7a1 1 0 001 1h11a1 1 0 001-1v-7a1 1 0 00-1-1zm-1.5 0v-3a4 4 0 00-8 0m4 6.5v2"
});

function SvgLockOpen$1(props) {
  return /*#__PURE__*/createElement("svg", _extends$3l({
    width: 24,
    height: 24,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 24 24"
  }, props), _ref$3h);
}

function _extends$3m() { _extends$3m = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3m.apply(this, arguments); }

var _ref$3i = /*#__PURE__*/createElement("path", {
  d: "M8.5 15v3.5a1 1 0 001 1h9a1 1 0 001-1v-13a1 1 0 00-1-1h-9a1 1 0 00-1 1V9M4 12h12"
});

var _ref2$_ = /*#__PURE__*/createElement("path", {
  d: "M12.5 8.5L16 12l-3.5 3.5"
});

function SvgLogIn$1(props) {
  return /*#__PURE__*/createElement("svg", _extends$3m({
    width: 24,
    height: 24,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 24 24"
  }, props), _ref$3i, _ref2$_);
}

function _extends$3n() { _extends$3n = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3n.apply(this, arguments); }

var _ref$3j = /*#__PURE__*/createElement("path", {
  d: "M15.5 15v3.5a1 1 0 01-1 1h-9a1 1 0 01-1-1v-13a1 1 0 011-1h9a1 1 0 011 1V9M10 12h12m-3.5-3.5L22 12l-3.5 3.5"
});

function SvgLogOut$1(props) {
  return /*#__PURE__*/createElement("svg", _extends$3n({
    width: 24,
    height: 24,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 24 24"
  }, props), _ref$3j);
}

function _extends$3o() { _extends$3o = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3o.apply(this, arguments); }

var _ref$3k = /*#__PURE__*/createElement("path", {
  d: "M19 7l-7 6-7-6"
});

var _ref2$$ = /*#__PURE__*/createElement("path", {
  d: "M18.5 17.5h-13a1 1 0 01-1-1v-9a1 1 0 011-1h13a1 1 0 011 1v9a1 1 0 01-1 1z"
});

function SvgMail$1(props) {
  return /*#__PURE__*/createElement("svg", _extends$3o({
    width: 24,
    height: 24,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 24 24"
  }, props), _ref$3k, _ref2$$);
}

function _extends$3p() { _extends$3p = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3p.apply(this, arguments); }

var _ref$3l = /*#__PURE__*/createElement("path", {
  d: "M14 4.5h5.5V10m-6 .5l6-6m-9.5 15H4.5V14m6-.5l-6 6"
});

function SvgMaximize$1(props) {
  return /*#__PURE__*/createElement("svg", _extends$3p({
    width: 24,
    height: 24,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 24 24"
  }, props), _ref$3l);
}

function _extends$3q() { _extends$3q = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3q.apply(this, arguments); }

var _ref$3m = /*#__PURE__*/createElement("path", {
  d: "M11.5 14.5h-8v-4a1 1 0 011-1h7v5zm0-5l9-6.5v17l-9-5.5m-3 0v4.007a1 1 0 11-2 0V14.5"
});

function SvgMegaphone$1(props) {
  return /*#__PURE__*/createElement("svg", _extends$3q({
    width: 24,
    height: 24,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 24 24"
  }, props), _ref$3m);
}

function _extends$3r() { _extends$3r = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3r.apply(this, arguments); }

var _ref$3n = /*#__PURE__*/createElement("path", {
  d: "M5 12h14M5 6.5h14m-14 11h14"
});

function SvgMenu$1(props) {
  return /*#__PURE__*/createElement("svg", _extends$3r({
    width: 24,
    height: 24,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 24 24"
  }, props), _ref$3n);
}

function _extends$3s() { _extends$3s = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3s.apply(this, arguments); }

var _ref$3o = /*#__PURE__*/createElement("path", {
  d: "M19 10.5h-5.5V5m8-2.5l-8 8m-8.5 3h5.5V19m-8 2.5l8-8"
});

function SvgMinimize$1(props) {
  return /*#__PURE__*/createElement("svg", _extends$3s({
    width: 24,
    height: 24,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 24 24"
  }, props), _ref$3o);
}

function _extends$3t() { _extends$3t = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3t.apply(this, arguments); }

var _ref$3p = /*#__PURE__*/createElement("path", {
  d: "M5 12h14"
});

function SvgMinus$1(props) {
  return /*#__PURE__*/createElement("svg", _extends$3t({
    width: 24,
    height: 24,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 24 24"
  }, props), _ref$3p);
}

function _extends$3u() { _extends$3u = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3u.apply(this, arguments); }

var _ref$3q = /*#__PURE__*/createElement("path", {
  d: "M4 12h16m-8-8v16M9.5 6.5L12 4.112 14.5 6.5m0 11L12 20l-2.5-2.5m8-8L20 12l-2.5 2.5m-11 0L4 12l2.5-2.5"
});

function SvgMove$1(props) {
  return /*#__PURE__*/createElement("svg", _extends$3u({
    width: 24,
    height: 24,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 24 24"
  }, props), _ref$3q);
}

function _extends$3v() { _extends$3v = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3v.apply(this, arguments); }

var _ref$3r = /*#__PURE__*/createElement("path", {
  d: "M15.52 3.5H8.48L3.5 8.479v7.042L8.48 20.5h7.042l4.979-4.979V8.479zM9 9l6 6m0-6l-6 6"
});

function SvgNegative$1(props) {
  return /*#__PURE__*/createElement("svg", _extends$3v({
    width: 24,
    height: 24,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 24 24"
  }, props), _ref$3r);
}

function _extends$3w() { _extends$3w = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3w.apply(this, arguments); }

var _ref$3s = /*#__PURE__*/createElement("path", {
  d: "M15.354 14.646l-.707.707-2.648-2.646-2.646 2.646-.707-.707L11.293 12 8.646 9.355l.707-.707L12 11.293l2.647-2.646.707.707L12.707 12l2.646 2.646zM15.726 3H8.271L3 8.271v7.456L8.271 21h7.456L21 15.727V8.271l-5.273-5.27z"
});

function SvgNegativeFilled$1(props) {
  return /*#__PURE__*/createElement("svg", _extends$3w({
    width: 24,
    height: 24,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 24 24"
  }, props), _ref$3s);
}

function _extends$3x() { _extends$3x = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3x.apply(this, arguments); }

var _ref$3t = /*#__PURE__*/createElement("path", {
  d: "M13.5 14a1.5 1.5 0 10-3 0 1.5 1.5 0 003 0zm7-9a1.5 1.5 0 10-3 0 1.5 1.5 0 003 0zm-7 0a1.5 1.5 0 10-2.999-.001A1.5 1.5 0 0013.5 5zm-7 14a1.5 1.5 0 10-3 0 1.5 1.5 0 003 0zm5.5-6.5v-6"
});

var _ref2$10 = /*#__PURE__*/createElement("path", {
  d: "M10.5 14H6a1 1 0 00-1 1v2.5m8.5-3.5H18a1 1 0 001-1V6.5"
});

function SvgNetwork$1(props) {
  return /*#__PURE__*/createElement("svg", _extends$3x({
    width: 24,
    height: 24,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 24 24"
  }, props), _ref$3t, _ref2$10);
}

function _extends$3y() { _extends$3y = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3y.apply(this, arguments); }

var _ref$3u = /*#__PURE__*/createElement("path", {
  d: "M6 6l12 12m0-12L6 18m12.5 1.5h-13a1 1 0 01-1-1v-13a1 1 0 011-1h13a1 1 0 011 1v13a1 1 0 01-1 1z"
});

function SvgNoImage$1(props) {
  return /*#__PURE__*/createElement("svg", _extends$3y({
    width: 24,
    height: 24,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 24 24"
  }, props), _ref$3u);
}

function _extends$3z() { _extends$3z = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3z.apply(this, arguments); }

var _ref$3v = /*#__PURE__*/createElement("path", {
  d: "M11 17.5a6.5 6.5 0 100-13 6.5 6.5 0 000 13z"
});

var _ref2$11 = /*#__PURE__*/createElement("path", {
  d: "M16.248 14.834l2.959 2.959a.999.999 0 11-1.414 1.414l-2.957-2.956M8.5 8.5l5 5m0-5l-5 5"
});

function SvgNotFound$1(props) {
  return /*#__PURE__*/createElement("svg", _extends$3z({
    width: 24,
    height: 24,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 24 24"
  }, props), _ref$3v, _ref2$11);
}

function _extends$3A() { _extends$3A = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3A.apply(this, arguments); }

var _ref$3w = /*#__PURE__*/createElement("path", {
  d: "M16.5 20V4m-4 4l4-4 4 4M7 19.5h3m-1.5 0V14l-2 1m3-9v2.5a2 2 0 01-2 2H7"
});

var _ref2$12 = /*#__PURE__*/createElement("path", {
  d: "M7.5 7.5h1a1 1 0 001-1v-1a1 1 0 00-1-1h-1a1 1 0 00-1 1v1a1 1 0 001 1z"
});

function SvgNumbersAscending$1(props) {
  return /*#__PURE__*/createElement("svg", _extends$3A({
    width: 24,
    height: 24,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 24 24"
  }, props), _ref$3w, _ref2$12);
}

function _extends$3B() { _extends$3B = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3B.apply(this, arguments); }

var _ref$3x = /*#__PURE__*/createElement("path", {
  d: "M16.5 4v16m4-4l-4 4-4-4M7 19.5h3m-1.5 0V14l-2 1m3-9v2.5a2 2 0 01-2 2H7"
});

var _ref2$13 = /*#__PURE__*/createElement("path", {
  d: "M7.5 7.5h1a1 1 0 001-1v-1a1 1 0 00-1-1h-1a1 1 0 00-1 1v1a1 1 0 001 1z"
});

function SvgNumbersDescending$1(props) {
  return /*#__PURE__*/createElement("svg", _extends$3B({
    width: 24,
    height: 24,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 24 24"
  }, props), _ref$3x, _ref2$13);
}

function _extends$3C() { _extends$3C = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3C.apply(this, arguments); }

var _ref$3y = /*#__PURE__*/createElement("path", {
  d: "M4.5 19.5h9v-15h-9zm9 0h6v-11h-6zM7.5 7v1m3-1v1m6 3v1m0 1v1m-9-4v1m3-1v1m-3 2v1m3-1v1"
});

function SvgOffice$1(props) {
  return /*#__PURE__*/createElement("svg", _extends$3C({
    width: 24,
    height: 24,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 24 24"
  }, props), _ref$3y);
}

function _extends$3D() { _extends$3D = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3D.apply(this, arguments); }

var _ref$3z = /*#__PURE__*/createElement("path", {
  d: "M6.5 19.5h4v-15h-4zm7 0h4v-15h-4z"
});

function SvgPause$1(props) {
  return /*#__PURE__*/createElement("svg", _extends$3D({
    width: 24,
    height: 24,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 24 24"
  }, props), _ref$3z);
}

function _extends$3E() { _extends$3E = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3E.apply(this, arguments); }

var _ref$3A = /*#__PURE__*/createElement("path", {
  d: "M6.5 19.5l1-4 8.494-10.282a1 1 0 011.343-.197l1.273.871c.481.328.58.996.216 1.45L10.5 17.5l-4 2zm1-4l3 2"
});

function SvgPencil$1(props) {
  return /*#__PURE__*/createElement("svg", _extends$3E({
    width: 24,
    height: 24,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 24 24"
  }, props), _ref$3A);
}

function _extends$3F() { _extends$3F = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3F.apply(this, arguments); }

var _ref$3B = /*#__PURE__*/createElement("path", {
  d: "M12 12.5c1.933 0 3.5-2.567 3.5-4.5a3.5 3.5 0 10-7 0c0 1.933 1.567 4.5 3.5 4.5zm-6.5 8l.861-5.164c.076-.46.52-.836.986-.836h9.306c.489 0 .906.354.987.836l.86 5.164"
});

var _ref2$14 = /*#__PURE__*/createElement("path", {
  d: "M9.5 14.5l2.5 3 2.521-3M12 17.5v2.499"
});

function SvgPerson$1(props) {
  return /*#__PURE__*/createElement("svg", _extends$3F({
    width: 24,
    height: 24,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 24 24"
  }, props), _ref$3B, _ref2$14);
}

function _extends$3G() { _extends$3G = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3G.apply(this, arguments); }

var _ref$3C = /*#__PURE__*/createElement("path", {
  d: "M20.5 12a8.5 8.5 0 10-17.001.001A8.5 8.5 0 0020.5 12z"
});

var _ref2$15 = /*#__PURE__*/createElement("path", {
  d: "M12 3.5V12l8.372 1.478M16.001 19.5L12 12l-8.485-.499"
});

function SvgPieChart$1(props) {
  return /*#__PURE__*/createElement("svg", _extends$3G({
    width: 24,
    height: 24,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 24 24"
  }, props), _ref$3C, _ref2$15);
}

function _extends$3H() { _extends$3H = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3H.apply(this, arguments); }

var _ref$3D = /*#__PURE__*/createElement("path", {
  d: "M6.5 9.5c0-4 2.462-6 5.5-6 3.037 0 5.5 2 5.5 6h-11zm11-7l-1 3.338M6.5 2.5l1 3.338m3 .162v1m3-1v1m-7 2.5v7a1 1 0 001 1h1v2a1 1 0 102 0v-2h3v2a1 1 0 102 0v-2h1a1 1 0 001-1v-7m2-.5v6m-15-6v6"
});

function SvgPlatformAndroid$1(props) {
  return /*#__PURE__*/createElement("svg", _extends$3H({
    width: 24,
    height: 24,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 24 24"
  }, props), _ref$3D);
}

function _extends$3I() { _extends$3I = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3I.apply(this, arguments); }

var _ref$3E = /*#__PURE__*/createElement("path", {
  d: "M19 15h1v-5h-1zM4 15h1.001v-5H4zm2 1.5A1.5 1.5 0 007.5 18H8v1.5a1.5 1.5 0 103 0V18h2v1.5a1.5 1.5 0 103 0V18h.5a1.5 1.5 0 001.5-1.5V11H6v5.5zM10 8h1V7h-1v1zm3 0h1V7h-1v1zm-6.972 2h11.944c-.068-1.268-.374-2.386-.911-3.294l.918-3.062-.958-.288-.707 2.362C15.271 4.62 13.793 4 12 4c-1.793 0-3.271.62-4.313 1.718l-.708-2.362-.958.288.917 3.062c-.536.908-.842 2.026-.91 3.294z"
});

function SvgPlatformAndroidFilled$1(props) {
  return /*#__PURE__*/createElement("svg", _extends$3I({
    width: 24,
    height: 24,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 24 24"
  }, props), _ref$3E);
}

function _extends$3J() { _extends$3J = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3J.apply(this, arguments); }

var _ref$3F = /*#__PURE__*/createElement("path", {
  d: "M12.504 5.745c.046-.698.373-1.435.914-2.047a3.56 3.56 0 011.12-.838c.256-.125.506-.219.744-.28-.049.701-.33 1.35-.86 1.977-.423.495-1.087 1.08-1.918 1.188zM9.246 19.5c-.39 0-.803-.199-1.225-.592-.33-.289-.743-.784-1.236-1.482-.53-.745-.972-1.624-1.315-2.615-.366-1.065-.55-2.109-.55-3.1 0-1.11.238-2.073.71-2.862a4.078 4.078 0 011.466-1.485 3.887 3.887 0 011.97-.555c.36 0 .877.123 1.531.367 1.013.381 1.345.432 1.534.432.158 0 .417-.039 1.68-.502.632-.227 1.182-.343 1.633-.343.07 0 .137.003.202.008 1.17.095 2.065.483 2.72 1.186-1.195.89-1.793 2.085-1.779 3.56.012 1.286.486 2.371 1.407 3.224.292.277.615.515.963.705a9.214 9.214 0 01-1.072 2.034c-.48.687-.874 1.163-1.165 1.417-.419.384-.836.572-1.286.582-.336 0-.769-.106-1.277-.315-.634-.259-1.234-.39-1.784-.39-.573 0-1.187.131-1.826.388-.654.266-1.038.33-1.244.336l-.057.002z"
});

function SvgPlatformIos$1(props) {
  return /*#__PURE__*/createElement("svg", _extends$3J({
    width: 24,
    height: 24,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 24 24"
  }, props), _ref$3F);
}

function _extends$3K() { _extends$3K = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3K.apply(this, arguments); }

var _ref$3G = /*#__PURE__*/createElement("path", {
  d: "M15.79 2.36c0 .9-.329 1.74-.984 2.519-.791.925-1.748 1.459-2.786 1.375a2.851 2.851 0 01-.021-.341c0-.865.376-1.79 1.044-2.546a4.043 4.043 0 011.272-.955c.514-.25.999-.388 1.456-.412.013.12.019.24.019.36m3.473 13.667a9.764 9.764 0 01-.968 1.74c-.509.726-.925 1.228-1.246 1.508-.498.457-1.031.69-1.603.705-.41 0-.904-.117-1.479-.354-.577-.235-1.109-.351-1.594-.351-.509 0-1.054.116-1.638.35-.585.238-1.056.36-1.416.373-.548.024-1.093-.218-1.638-.723-.348-.304-.783-.824-1.304-1.561-.559-.786-1.019-1.698-1.379-2.738-.386-1.124-.579-2.212-.579-3.265 0-1.206.261-2.247.783-3.118a4.59 4.59 0 011.639-1.66 4.415 4.415 0 012.217-.624c.435 0 1.005.134 1.714.399.707.265 1.161.4 1.36.4.148 0 .653-.158 1.508-.471.807-.291 1.49-.411 2.048-.364 1.515.122 2.653.719 3.41 1.795-1.355.82-2.025 1.97-2.011 3.444.012 1.149.429 2.104 1.247 2.863.371.353.786.625 1.247.818-.101.29-.206.568-.318.834"
});

function SvgPlatformIosFilled$1(props) {
  return /*#__PURE__*/createElement("svg", _extends$3K({
    width: 24,
    height: 24,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 24 24"
  }, props), _ref$3G);
}

function _extends$3L() { _extends$3L = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3L.apply(this, arguments); }

var _ref$3H = /*#__PURE__*/createElement("path", {
  d: "M11.324 14.132L7.5 17.376 7.525 4.5l10.91 6.817-4.78 1.524 2.974 5.367-2.33 1.292z"
});

function SvgPlatformWeb$1(props) {
  return /*#__PURE__*/createElement("svg", _extends$3L({
    width: 24,
    height: 24,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 24 24"
  }, props), _ref$3H);
}

function _extends$3M() { _extends$3M = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3M.apply(this, arguments); }

var _ref$3I = /*#__PURE__*/createElement("path", {
  d: "M14.105 20.18l-2.923-5.272-4.184 3.55.029-14.86 12.588 7.867-5.227 1.667 2.92 5.27z"
});

function SvgPlatformWebFilled$1(props) {
  return /*#__PURE__*/createElement("svg", _extends$3M({
    width: 24,
    height: 24,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 24 24"
  }, props), _ref$3I);
}

function _extends$3N() { _extends$3N = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3N.apply(this, arguments); }

var _ref$3J = /*#__PURE__*/createElement("path", {
  d: "M12.5 11.5H20V4.674l-7.5.826zm7.5 2h-7.5v4.981l7.5 1.094zm-9.5 4.69l-6-.876v-3.813h6zm-6-6.69V6.381l6-.661v5.78z"
});

function SvgPlatformWindows$1(props) {
  return /*#__PURE__*/createElement("svg", _extends$3N({
    width: 24,
    height: 24,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 24 24"
  }, props), _ref$3J);
}

function _extends$3O() { _extends$3O = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3O.apply(this, arguments); }

var _ref$3K = /*#__PURE__*/createElement("path", {
  d: "M20.5 12H12V5.052l8.5-.936zm0 8.153L12 18.914V13h8.5zM11 18.768l-7-1.021V13h7zM11 12H4V5.934l7-.772z"
});

function SvgPlatformWindowsFilled$1(props) {
  return /*#__PURE__*/createElement("svg", _extends$3O({
    width: 24,
    height: 24,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 24 24"
  }, props), _ref$3K);
}

function _extends$3P() { _extends$3P = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3P.apply(this, arguments); }

var _ref$3L = /*#__PURE__*/createElement("path", {
  d: "M4.5 8v9.822L16.5 20l3-1V7.208L16.5 6z"
});

var _ref2$16 = /*#__PURE__*/createElement("path", {
  d: "M6.5 10.5v5.058l7 .942V9.788zm3-.303v5.761M6.5 13h7m-5-5.667V4.721c0-.43.275-.813.684-.95l1-.333a1 1 0 011.316.95v2.446m1.5-2.5l1.184-.395a1 1 0 011.316.948v1.28"
});

function SvgPlatformWindowsPhone$1(props) {
  return /*#__PURE__*/createElement("svg", _extends$3P({
    width: 24,
    height: 24,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 24 24"
  }, props), _ref$3L, _ref2$16);
}

function _extends$3Q() { _extends$3Q = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3Q.apply(this, arguments); }

var _ref$3M = /*#__PURE__*/createElement("path", {
  d: "M10 16.028V13.5h3.5v3l-3.5-.472zM6.5 13.5H9v2.394l-2.5-.337V13.5zM9 10.245V12.5H6.5v-2l2.5-.255zM9 4.72c0-.215.137-.406.342-.474l1-.333a.492.492 0 01.45.07.492.492 0 01.208.404V6.41l-2 .333V4.72zm4.5 5.068V12.5H10v-2.356l3.5-.356zm3.057-4.304L16 5.576v-.689c0-.488-.228-.932-.623-1.217a1.483 1.483 0 00-1.352-.205l-1.183.395.316.948 1.184-.395a.49.49 0 01.45.07.492.492 0 01.208.404v.856l-3 .5V4.387c0-.488-.227-.932-.623-1.217a1.483 1.483 0 00-1.352-.206l-1 .334A1.497 1.497 0 008 4.72v2.19l-4 .666V18.24l12.537 2.275L20 19.36V6.87l-3.443-1.386z"
});

function SvgPlatformWindowsPhoneFilled$1(props) {
  return /*#__PURE__*/createElement("svg", _extends$3Q({
    width: 24,
    height: 24,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 24 24"
  }, props), _ref$3M);
}

function _extends$3R() { _extends$3R = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3R.apply(this, arguments); }

var _ref$3N = /*#__PURE__*/createElement("path", {
  d: "M6.5 5v14L18 12z"
});

function SvgPlay$1(props) {
  return /*#__PURE__*/createElement("svg", _extends$3R({
    width: 24,
    height: 24,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 24 24"
  }, props), _ref$3N);
}

function _extends$3S() { _extends$3S = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3S.apply(this, arguments); }

var _ref$3O = /*#__PURE__*/createElement("path", {
  d: "M5 12h14m-7-7v14"
});

function SvgPlus$1(props) {
  return /*#__PURE__*/createElement("svg", _extends$3S({
    width: 24,
    height: 24,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 24 24"
  }, props), _ref$3O);
}

function _extends$3T() { _extends$3T = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3T.apply(this, arguments); }

var _ref$3P = /*#__PURE__*/createElement("path", {
  d: "M20.5 12a8.5 8.5 0 10-17.001.001A8.5 8.5 0 0020.5 12z"
});

var _ref2$17 = /*#__PURE__*/createElement("path", {
  d: "M16.5 8.5L11 15l-2.5-2.5"
});

function SvgPositive$1(props) {
  return /*#__PURE__*/createElement("svg", _extends$3T({
    width: 24,
    height: 24,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 24 24"
  }, props), _ref$3P, _ref2$17);
}

function _extends$3U() { _extends$3U = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3U.apply(this, arguments); }

var _ref$3Q = /*#__PURE__*/createElement("path", {
  d: "M11.03 15.738l-2.883-2.885.707-.707 2.115 2.116 5.149-6.085.764.645-5.851 6.916zM12 3a9 9 0 100 18 9 9 0 000-18z"
});

function SvgPositiveFilled$1(props) {
  return /*#__PURE__*/createElement("svg", _extends$3U({
    width: 24,
    height: 24,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 24 24"
  }, props), _ref$3Q);
}

function _extends$3V() { _extends$3V = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3V.apply(this, arguments); }

var _ref$3R = /*#__PURE__*/createElement("path", {
  d: "M20.5 12a8.5 8.5 0 10-17.001.001A8.5 8.5 0 0020.5 12zM12 16.5v.5-1z"
});

var _ref2$18 = /*#__PURE__*/createElement("path", {
  d: "M9.5 10c0-3.5 5-2.997 5-.5 0 2-2.5 2.037-2.5 4.5"
});

function SvgQuestion$1(props) {
  return /*#__PURE__*/createElement("svg", _extends$3V({
    width: 24,
    height: 24,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 24 24"
  }, props), _ref$3R, _ref2$18);
}

function _extends$3W() { _extends$3W = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3W.apply(this, arguments); }

var _ref$3S = /*#__PURE__*/createElement("path", {
  d: "M11 17.5a6.5 6.5 0 100-13 6.5 6.5 0 000 13z"
});

var _ref2$19 = /*#__PURE__*/createElement("path", {
  d: "M16.25 14.836l2.957 2.957a.999.999 0 11-1.414 1.414l-2.958-2.958"
});

function SvgSearch$2(props) {
  return /*#__PURE__*/createElement("svg", _extends$3W({
    width: 24,
    height: 24,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 24 24"
  }, props), _ref$3S, _ref2$19);
}

function _extends$3X() { _extends$3X = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3X.apply(this, arguments); }

var _ref$3T = /*#__PURE__*/createElement("path", {
  d: "M12 21c7.5-2.5 7.5-10.526 7.5-10.526V5.842L12 3 4.5 5.842v4.632S4.5 18.5 12 21z"
});

var _ref2$1a = /*#__PURE__*/createElement("path", {
  d: "M16 9l-4 5.5L9 12"
});

function SvgSecure$1(props) {
  return /*#__PURE__*/createElement("svg", _extends$3X({
    width: 24,
    height: 24,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 24 24"
  }, props), _ref$3T, _ref2$1a);
}

function _extends$3Y() { _extends$3Y = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3Y.apply(this, arguments); }

var _ref$3U = /*#__PURE__*/createElement("path", {
  d: "M18.5 6.5a2 2 0 10-4.001.001A2 2 0 0018.5 6.5zm0 11a2 2 0 10-4.001.001A2 2 0 0018.5 17.5zM8.5 12a2 2 0 10-4.001.001A2 2 0 008.5 12zm-.182.833l6.364 3.834m0-9.334l-6.364 3.833"
});

function SvgShare$1(props) {
  return /*#__PURE__*/createElement("svg", _extends$3Y({
    width: 24,
    height: 24,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 24 24"
  }, props), _ref$3U);
}

function _extends$3Z() { _extends$3Z = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3Z.apply(this, arguments); }

var _ref$3V = /*#__PURE__*/createElement("path", {
  d: "M9.5 8.5h5M4 12.5h5m6 2h5M17.5 20v-5.5m0-2.5V4M12 8.5V4m0 16v-9m-5.5 9v-7.5m0-2.5V4"
});

function SvgSliders$1(props) {
  return /*#__PURE__*/createElement("svg", _extends$3Z({
    width: 24,
    height: 24,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 24 24"
  }, props), _ref$3V);
}

function _extends$3_() { _extends$3_ = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3_.apply(this, arguments); }

var _ref$3W = /*#__PURE__*/createElement("path", {
  d: "M16.5 17V5m-9 2v12m5-10l4-4 4 4m-9 6l-4 4-4-4"
});

function SvgSort$1(props) {
  return /*#__PURE__*/createElement("svg", _extends$3_({
    width: 24,
    height: 24,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 24 24"
  }, props), _ref$3W);
}

function _extends$3$() { _extends$3$ = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3$.apply(this, arguments); }

var _ref$3X = /*#__PURE__*/createElement("path", {
  d: "M15 15.5L11 19v-3.5H5.5a1 1 0 01-1-1v-8a1 1 0 011-1h13a1 1 0 011 1v8a1 1 0 01-1 1H15z"
});

function SvgSpeechBubble$1(props) {
  return /*#__PURE__*/createElement("svg", _extends$3$({
    width: 24,
    height: 24,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 24 24"
  }, props), _ref$3X);
}

function _extends$40() { _extends$40 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$40.apply(this, arguments); }

var _ref$3Y = /*#__PURE__*/createElement("path", {
  d: "M12 4.392l2.239 4.538a1 1 0 00.753.546l5.008.728-3.623 3.533a.996.996 0 00-.288.884l.855 4.988-4.479-2.355a1 1 0 00-.93 0l-4.479 2.355.855-4.988a.998.998 0 00-.287-.884L4 10.204l5.008-.728a1 1 0 00.753-.546L12 4.392z"
});

function SvgStar$1(props) {
  return /*#__PURE__*/createElement("svg", _extends$40({
    width: 24,
    height: 24,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 24 24"
  }, props), _ref$3Y);
}

function _extends$41() { _extends$41 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$41.apply(this, arguments); }

var _ref$3Z = /*#__PURE__*/createElement("path", {
  d: "M15.5 8V5.5h-8l4 6.5-4 6.5h8V16"
});

function SvgSum$1(props) {
  return /*#__PURE__*/createElement("svg", _extends$41({
    width: 24,
    height: 24,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 24 24"
  }, props), _ref$3Z);
}

function _extends$42() { _extends$42 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$42.apply(this, arguments); }

var _ref$3_ = /*#__PURE__*/createElement("path", {
  d: "M18.5 19.5h-13a1 1 0 01-1-1v-13a1 1 0 011-1h13a1 1 0 011 1v13a1 1 0 01-1 1zM6 9.5h12m-12 5h12M9.5 6v12"
});

function SvgTable$1(props) {
  return /*#__PURE__*/createElement("svg", _extends$42({
    width: 24,
    height: 24,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 24 24"
  }, props), _ref$3_);
}

function _extends$43() { _extends$43 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$43.apply(this, arguments); }

var _ref$3$ = /*#__PURE__*/createElement("path", {
  d: "M16.5 19V5m-4 4l4-4 4 4m-10 3a3.5 3.5 0 10-7 0 3.5 3.5 0 007 0z"
});

var _ref2$1b = /*#__PURE__*/createElement("path", {
  d: "M7 10v2l1.5 1.5"
});

function SvgTimeAscending$1(props) {
  return /*#__PURE__*/createElement("svg", _extends$43({
    width: 24,
    height: 24,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 24 24"
  }, props), _ref$3$, _ref2$1b);
}

function _extends$44() { _extends$44 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$44.apply(this, arguments); }

var _ref$40 = /*#__PURE__*/createElement("path", {
  d: "M16.5 5v14m4-4l-4 4-4-4m-2-3a3.5 3.5 0 10-7 0 3.5 3.5 0 007 0z"
});

var _ref2$1c = /*#__PURE__*/createElement("path", {
  d: "M7 10v2l1.5 1.5"
});

function SvgTimeDescending$1(props) {
  return /*#__PURE__*/createElement("svg", _extends$44({
    width: 24,
    height: 24,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 24 24"
  }, props), _ref$40, _ref2$1c);
}

function _extends$45() { _extends$45 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$45.apply(this, arguments); }

var _ref$41 = /*#__PURE__*/createElement("path", {
  d: "M4 5.5h16M10.5 8v9m3-9v9m4-11.5v13a1 1 0 01-1 1h-9a1 1 0 01-1-1v-13m8 0v-2h-5v2"
});

function SvgTrash$1(props) {
  return /*#__PURE__*/createElement("svg", _extends$45({
    width: 24,
    height: 24,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 24 24"
  }, props), _ref$41);
}

function _extends$46() { _extends$46 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$46.apply(this, arguments); }

var _ref$42 = /*#__PURE__*/createElement("path", {
  d: "M12 21c7.5-2.5 7.5-10.526 7.5-10.526V5.842L12 3 4.5 5.842v4.632S4.5 18.5 12 21zM9 9l6 6m-6 0l6-6"
});

function SvgUnsecure$1(props) {
  return /*#__PURE__*/createElement("svg", _extends$46({
    width: 24,
    height: 24,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 24 24"
  }, props), _ref$42);
}

function _extends$47() { _extends$47 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$47.apply(this, arguments); }

var _ref$43 = /*#__PURE__*/createElement("path", {
  d: "M19.5 15v3.5a1 1 0 01-1 1h-13a1 1 0 01-1-1V15m7.5 0V5M7.5 9.5L12 5l4.5 4.5"
});

function SvgUpload$2(props) {
  return /*#__PURE__*/createElement("svg", _extends$47({
    width: 24,
    height: 24,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 24 24"
  }, props), _ref$43);
}

function _extends$48() { _extends$48 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$48.apply(this, arguments); }

var _ref$44 = /*#__PURE__*/createElement("path", {
  d: "M12 16.5v.5-1zm0-2.5V9m-.945-4.776l-7.346 13.65c-.481.894-.055 1.626.946 1.626h14.712c1.002 0 1.428-.733.945-1.627l-7.366-13.65c-.521-.964-1.371-.964-1.891.001z"
});

function SvgWarning$2(props) {
  return /*#__PURE__*/createElement("svg", _extends$48({
    width: 24,
    height: 24,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 24 24"
  }, props), _ref$44);
}

function _extends$49() { _extends$49 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$49.apply(this, arguments); }

var _ref$45 = /*#__PURE__*/createElement("path", {
  d: "M12.75 16.5a.75.75 0 11-1.5 0 .75.75 0 011.5 0zM11.5 14h1V9h-1v5zm9.252 3.636l-7.366-13.65C13.047 3.359 12.543 3 12 3c-.543.001-1.048.36-1.386.987L3.269 17.638c-.317.589-.341 1.19-.067 1.649.271.453.8.713 1.453.713h14.711c.655 0 1.185-.261 1.455-.714.274-.46.248-1.061-.069-1.65z"
});

function SvgWarningFilled$1(props) {
  return /*#__PURE__*/createElement("svg", _extends$49({
    width: 24,
    height: 24,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 24 24"
  }, props), _ref$45);
}

function _extends$4a() { _extends$4a = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4a.apply(this, arguments); }

var _ref$46 = /*#__PURE__*/createElement("path", {
  d: "M5 13.5h8l-1.5 6 7.5-9h-8l1.5-6z"
});

function SvgZap$1(props) {
  return /*#__PURE__*/createElement("svg", _extends$4a({
    width: 24,
    height: 24,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 24 24"
  }, props), _ref$46);
}

function _extends$4b() { _extends$4b = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4b.apply(this, arguments); }

var _ref$47 = /*#__PURE__*/createElement("path", {
  d: "M11 17.5a6.5 6.5 0 100-13 6.5 6.5 0 000 13z"
});

var _ref2$1d = /*#__PURE__*/createElement("path", {
  d: "M16.249 14.835l2.958 2.958a.999.999 0 11-1.414 1.414l-2.957-2.957M8 11h6m-3-3v6"
});

function SvgZoomIn$1(props) {
  return /*#__PURE__*/createElement("svg", _extends$4b({
    width: 24,
    height: 24,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 24 24"
  }, props), _ref$47, _ref2$1d);
}

function _extends$4c() { _extends$4c = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4c.apply(this, arguments); }

var _ref$48 = /*#__PURE__*/createElement("path", {
  d: "M8 11h6m-3 6.5a6.5 6.5 0 100-13 6.5 6.5 0 000 13z"
});

var _ref2$1e = /*#__PURE__*/createElement("path", {
  d: "M16.247 14.833l2.96 2.96a.999.999 0 11-1.414 1.414l-2.957-2.957"
});

function SvgZoomOut$1(props) {
  return /*#__PURE__*/createElement("svg", _extends$4c({
    width: 24,
    height: 24,
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 1,
    viewBox: "0 0 24 24"
  }, props), _ref$48, _ref2$1e);
}

var index$1$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    ArrowCircleLeft: SvgArrowCircleLeft$1,
    ArrowCircleRight: SvgArrowCircleRight$1,
    ArrowDown: SvgArrowDown$1,
    ArrowDownLeft: SvgArrowDownLeft$1,
    ArrowDownRight: SvgArrowDownRight$1,
    ArrowLeft: SvgArrowLeft$1,
    ArrowRight: SvgArrowRight$1,
    ArrowUp: SvgArrowUp$1,
    ArrowUpLeft: SvgArrowUpLeft$1,
    ArrowUpRight: SvgArrowUpRight$1,
    BarChartHorizontal: SvgBarChartHorizontal$1,
    BarChartVertical: SvgBarChartVertical$1,
    Bell: SvgBell$1,
    Calendar: SvgCalendar$1,
    Charts: SvgCharts$1,
    Check: SvgCheck$1,
    ChevronDown: SvgChevronDown$1,
    ChevronLeft: SvgChevronLeft$1,
    ChevronRight: SvgChevronRight$1,
    ChevronUp: SvgChevronUp$1,
    Clipboard: SvgClipboard$2,
    Clock: SvgClock$1,
    Code: SvgCode$1,
    CogWheel: SvgCogWheel$1,
    Copy: SvgCopy$1,
    Cross: SvgCross$1,
    Data: SvgData$1,
    Document: SvgDocument$1,
    DotsHorizontal: SvgDotsHorizontal$1,
    DotsHorizontalFilled: SvgDotsHorizontalFilled$1,
    DotsVertical: SvgDotsVertical$1,
    DotsVerticalFilled: SvgDotsVerticalFilled$1,
    Download: SvgDownload$2,
    DrillDown: SvgDrillDown$1,
    Edit: SvgEdit$1,
    Eye: SvgEye$1,
    EyeClosed: SvgEyeClosed$1,
    Filter: SvgFilter$1,
    FilterActive: SvgFilterActive$1,
    Flag: SvgFlag$1,
    Folder: SvgFolder$1,
    Globe: SvgGlobe$1,
    Heart: SvgHeart$1,
    Image: SvgImage$1,
    Info: SvgInfo$1,
    InfoFilled: SvgInfoFilled$1,
    Kpi: SvgKpi$1,
    KpiCalculated: SvgKpiCalculated$1,
    KpiEvent: SvgKpiEvent$1,
    LettersAscending: SvgLettersAscending$1,
    LettersDescending: SvgLettersDescending$1,
    LineChart: SvgLineChart$1,
    LinkExternal: SvgLinkExternal$1,
    LockClosed: SvgLockClosed$1,
    LockOpen: SvgLockOpen$1,
    LogIn: SvgLogIn$1,
    LogOut: SvgLogOut$1,
    Mail: SvgMail$1,
    Maximize: SvgMaximize$1,
    Megaphone: SvgMegaphone$1,
    Menu: SvgMenu$1,
    Minimize: SvgMinimize$1,
    Minus: SvgMinus$1,
    Move: SvgMove$1,
    Negative: SvgNegative$1,
    NegativeFilled: SvgNegativeFilled$1,
    Network: SvgNetwork$1,
    NoImage: SvgNoImage$1,
    NotFound: SvgNotFound$1,
    NumbersAscending: SvgNumbersAscending$1,
    NumbersDescending: SvgNumbersDescending$1,
    Office: SvgOffice$1,
    Pause: SvgPause$1,
    Pencil: SvgPencil$1,
    Person: SvgPerson$1,
    PieChart: SvgPieChart$1,
    PlatformAndroid: SvgPlatformAndroid$1,
    PlatformAndroidFilled: SvgPlatformAndroidFilled$1,
    PlatformIos: SvgPlatformIos$1,
    PlatformIosFilled: SvgPlatformIosFilled$1,
    PlatformWeb: SvgPlatformWeb$1,
    PlatformWebFilled: SvgPlatformWebFilled$1,
    PlatformWindows: SvgPlatformWindows$1,
    PlatformWindowsFilled: SvgPlatformWindowsFilled$1,
    PlatformWindowsPhone: SvgPlatformWindowsPhone$1,
    PlatformWindowsPhoneFilled: SvgPlatformWindowsPhoneFilled$1,
    Play: SvgPlay$1,
    Plus: SvgPlus$1,
    Positive: SvgPositive$1,
    PositiveFilled: SvgPositiveFilled$1,
    Question: SvgQuestion$1,
    Search: SvgSearch$2,
    Secure: SvgSecure$1,
    Share: SvgShare$1,
    Sliders: SvgSliders$1,
    Sort: SvgSort$1,
    SpeechBubble: SvgSpeechBubble$1,
    Star: SvgStar$1,
    Sum: SvgSum$1,
    Table: SvgTable$1,
    TimeAscending: SvgTimeAscending$1,
    TimeDescending: SvgTimeDescending$1,
    Trash: SvgTrash$1,
    Unsecure: SvgUnsecure$1,
    Upload: SvgUpload$2,
    Warning: SvgWarning$2,
    WarningFilled: SvgWarningFilled$1,
    Zap: SvgZap$1,
    ZoomIn: SvgZoomIn$1,
    ZoomOut: SvgZoomOut$1
});

function preserveStrokeWidth(size, baseSize, stroke) {
    /**
     * The base size of all icons is 24px × 24px for medium icons and 16px × 16px for small icons.
     * Currently there is no way to scale an SVG image and preserving its stroke width.
     * In order to render the intended stroke width, we need to calculate it.
     **/
    return stroke * (baseSize / size);
}
function getStrokeWidth(size, weight) {
    if (weight === 'thin') {
        switch (size) {
            case 'small':
                return preserveStrokeWidth(16, 16, 1);
            case 'medium':
                return preserveStrokeWidth(24, 24, 1);
            case 'large':
                return preserveStrokeWidth(32, 24, 1);
        }
    }
    if (weight === 'bold') {
        switch (size) {
            case 'small':
                return preserveStrokeWidth(16, 16, 2);
            case 'medium':
                return preserveStrokeWidth(24, 24, 2);
            case 'large':
                return preserveStrokeWidth(32, 24, 2);
        }
    }
    // eslint-disable-next-line no-console
    console.warn(`Icon: Provided size or weight is invalid`);
    return 2;
}
function getIconSize(size) {
    switch (size) {
        case 'small':
            return 16;
        case 'medium':
            return 24;
        case 'large':
            return 32;
    }
}
function getIconColor(iconColor, isDarkMode) {
    const colorTokens = color;
    if (iconColor) {
        if (!Object.prototype.hasOwnProperty.call(colorTokens, iconColor)) {
            // eslint-disable-next-line no-console
            console.warn(`Icon: Provided color "${iconColor}" is invalid`);
        }
        else {
            return colorTokens[iconColor];
        }
    }
    return isDarkMode ? ColorNeutral10 : ColorNeutral160;
}
const IconComponent = ({ name, size = 'medium', weight = 'thin', color, 'aria-label': ariaLabel, ...rest }) => {
    const colorScheme = useContext(ColorSchemeContext);
    const isDarkMode = colorScheme === 'dark';
    const className = classnames({
        [style.Icon]: true
    });
    const iconColor = getIconColor(color, isDarkMode);
    const isFilledIcon = name.includes('Filled');
    const stroke = !isFilledIcon ? iconColor : 'none';
    const fill = isFilledIcon ? iconColor : 'none';
    const Icon = size === 'small' ? index$1[name] : index$1$1[name];
    return (React__default.createElement(Icon, Object.assign({ "aria-label": ariaLabel, className: className, role: "img", fillRule: "evenodd", style: {
            strokeWidth: getStrokeWidth(size, weight),
            stroke,
            fill,
            width: getIconSize(size),
            height: getIconSize(size)
        } }, filterDataProps(rest))));
};
const Icon = withCSS(IconComponent);

var css_248z$k = ".IconButton_IconButton__G8XBw {\n  display: inline-flex;\n  flex-shrink: none;\n  position: relative;\n  margin: 0;\n  padding: 0 8px;\n  vertical-align: middle;\n  font-family: BlinkMacSystemFont, -apple-system, \"Segoe UI\", Roboto, Arial, sans-serif;\n  font-weight: 500;\n  text-decoration: none;\n  -webkit-appearance: none;\n     -moz-appearance: none;\n          appearance: none;\n  border-radius: 4px;\n  border: 0;\n  cursor: default;\n  transition: background-color 120ms ease-out, box-shadow 120ms ease-out; }\n  .IconButton_IconButton__G8XBw .IconButton_IconButton__icon__2WvJM {\n    display: inline-flex;\n    align-self: center;\n    position: relative; }\n  .IconButton_IconButton--small__1yYwj {\n    padding: 4px; }\n  .IconButton_IconButton--medium__gXSKB {\n    padding: 4px; }\n  .IconButton_IconButton__G8XBw:not(:disabled) {\n    cursor: pointer; }\n  .IconButton_IconButton__G8XBw, .IconButton_IconButton__G8XBw:link, .IconButton_IconButton__G8XBw:visited {\n    background-color: transparent;\n    box-shadow: none; }\n  .IconButton_IconButton__G8XBw:hover {\n    background-color: #eceef4;\n    box-shadow: none;\n    transition-duration: 75ms; }\n  .IconButton_IconButton__G8XBw:active {\n    background-color: #e0e2ec;\n    box-shadow: none; }\n  .IconButton_IconButton__G8XBw:focus {\n    outline: none; }\n  .IconButton_IconButton__G8XBw[data-focus-visible-added] .IconButton_focusRing__yQi2j {\n    display: block;\n    position: absolute;\n    left: -6px;\n    top: -6px;\n    bottom: -6px;\n    right: -6px;\n    border-radius: 8px;\n    border: 2px solid #1a62ff;\n    z-index: 1;\n    pointer-events: none; }\n  .IconButton_IconButton__G8XBw:disabled {\n    opacity: 0.4;\n    pointer-events: none; }\n  .IconButton_IconButton--darkMode__1d50u, .IconButton_IconButton--darkMode__1d50u:link, .IconButton_IconButton--darkMode__1d50u:visited {\n    background-color: transparent;\n    box-shadow: none; }\n  .IconButton_IconButton--darkMode__1d50u:hover {\n    background-color: #2a2f45;\n    box-shadow: none; }\n  .IconButton_IconButton--darkMode__1d50u:active {\n    background-color: #21253a;\n    box-shadow: none; }\n";
var style$1 = {"IconButton":"IconButton_IconButton__G8XBw","IconButton__icon":"IconButton_IconButton__icon__2WvJM","IconButton--small":"IconButton_IconButton--small__1yYwj","IconButton--medium":"IconButton_IconButton--medium__gXSKB","focusRing":"IconButton_focusRing__yQi2j","IconButton--darkMode":"IconButton_IconButton--darkMode__1d50u"};
          styleInject(css_248z$k);

const getIconColor$1 = (isHighlighted, colorScheme) => {
    if (isHighlighted) {
        return 'ColorPrimary80';
    }
    if (colorScheme === 'dark') {
        return 'ColorNeutral60';
    }
    return 'ColorNeutral80';
};
const IconButtonComponent = ({ type = 'button', size = 'medium', isHighlighted = false, onMouseLeave, onMouseEnter, onFocus, onClick, onBlur, iconName, disabled, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledby, ...rest }) => {
    const colorScheme = useContext(ColorSchemeContext);
    const className = classnames({
        [style$1['IconButton']]: true,
        [style$1['IconButton--small']]: size === 'small',
        [style$1['IconButton--medium']]: size === 'medium',
        [style$1['IconButton--darkMode']]: colorScheme === 'dark'
    });
    if (!ariaLabel && !ariaLabelledby) {
        // eslint-disable-next-line no-console
        console.warn(`This component doesn't have an associated label. Please provide one of the following props to make this element accessible: "aria-label", "aria-labelledby". More information can be found at https://atlas.adjust.com/docs/components/accessibility#accessibility-of-form-elements-input-textarea-switch-etc`);
    }
    return (React__default.createElement("button", Object.assign({ type: type, onClick: onClick, disabled: disabled, className: className, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onFocus: onFocus, onBlur: onBlur, "aria-label": ariaLabel, "aria-labelledby": ariaLabelledby }, filterDataProps(rest)),
        React__default.createElement("span", { className: style$1['IconButton__icon'] },
            React__default.createElement(Icon, { name: iconName, color: getIconColor$1(isHighlighted, colorScheme), size: size })),
        React__default.createElement("span", { className: style$1.focusRing })));
};
const IconButton = withCSS(IconButtonComponent);

var css_248z$l = ".MenuButton-module_container__2Pf9p {\n  display: inline-flex;\n  align-items: center;\n  cursor: pointer; }\n  .MenuButton-module_container__2Pf9p button:focus {\n    background-color: initial; }\n  .MenuButton-module_container__2Pf9p button:hover {\n    background-color: #eceef4; }\n  .MenuButton-module_container__2Pf9p button:active {\n    background-color: #e0e2ec; }\n\n.MenuButton-module_logo__1sewL {\n  height: 19px;\n  margin-left: 4px; }\n";
var styles$2 = {"container":"MenuButton-module_container__2Pf9p","logo":"MenuButton-module_logo__1sewL"};
styleInject(css_248z$l);

const MenuButton = ({ onClick, ariaLabel, dataTestId }) => (React__default.createElement("div", { className: styles$2.container, onClick: onClick, "data-testid": dataTestId },
    React__default.createElement(IconButton, { iconName: "Menu", "aria-label": ariaLabel }),
    React__default.createElement(SvgIcon, { name: IconName.LogotypeBlack, className: styles$2.logo })));

var css_248z$m = ".ErrorPage-module_layout__3Uo8b {\n  display: flex;\n  flex-direction: column;\n  flex: 1 1 auto; }\n\n.ErrorPage-module_navbar__bs3I2 {\n  display: flex;\n  flex: 0 0 auto;\n  align-items: center;\n  position: relative;\n  min-height: 48px;\n  padding: 8px 0 8px 16px;\n  background-color: #f3f4f6; }\n  .ErrorPage-module_navbar__bs3I2 a {\n    font-size: 0; }\n\n.ErrorPage-module_container__1PtO7 {\n  display: flex;\n  flex-direction: column;\n  flex: 1 1 0%;\n  overflow: auto;\n  background-color: #f3f4f6; }\n\n.ErrorPage-module_errorLogo__FzLbi {\n  flex: 0 0 auto;\n  margin-top: 90px;\n  position: relative;\n  text-align: center; }\n  .ErrorPage-module_errorLogo__FzLbi > svg {\n    fill: #5d6a8c; }\n    @media screen and (min-width: 1024px) {\n      .ErrorPage-module_errorLogo__FzLbi > svg {\n        height: 500px; } }\n\n.ErrorPage-module_errorCode__2kcSy {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  font-size: 50px;\n  line-height: 122px;\n  font-family: \"Droid Sans Mono\", monospace;\n  font-weight: normal;\n  text-align: center;\n  color: #4b577e; }\n  @media screen and (min-width: 1024px) {\n    .ErrorPage-module_errorCode__2kcSy {\n      font-size: 80px;\n      line-height: 206px; } }\n\n.ErrorPage-module_content__1yQR- {\n  flex: 2;\n  flex-shrink: 0;\n  min-height: 300px;\n  text-align: center;\n  background-color: #4b577e;\n  color: #fff; }\n  .ErrorPage-module_content__1yQR- h2 {\n    margin: 50px 0 5px 0;\n    text-transform: uppercase;\n    font-weight: 400;\n    color: #fff; }\n  .ErrorPage-module_content__1yQR- p {\n    max-width: 600px;\n    margin-left: auto;\n    margin-right: auto;\n    color: #96a1bd; }\n    @media screen and (min-width: 1024px) {\n      .ErrorPage-module_content__1yQR- p {\n        max-width: 900px; } }\n\n.ErrorPage-module_preLine__31Iad {\n  white-space: pre-line; }\n\n.ErrorPage-module_backButton__3Z3o5 {\n  display: inline-block;\n  padding: 8px 10px;\n  border-radius: 2px;\n  font-size: 0.9em;\n  text-transform: uppercase;\n  background-color: #96a1bd;\n  transition: background-color 0.3s ease-in-out;\n  color: #fff; }\n  .ErrorPage-module_backButton__3Z3o5:hover {\n    color: #fff;\n    background-color: #8693b3; }\n";
var styles$3 = {"layout":"ErrorPage-module_layout__3Uo8b","navbar":"ErrorPage-module_navbar__bs3I2","container":"ErrorPage-module_container__1PtO7","errorLogo":"ErrorPage-module_errorLogo__FzLbi","errorCode":"ErrorPage-module_errorCode__2kcSy","content":"ErrorPage-module_content__1yQR-","preLine":"ErrorPage-module_preLine__31Iad","backButton":"ErrorPage-module_backButton__3Z3o5"};
styleInject(css_248z$m);

const ErrorPage = ({ backUrl, errorCode, title, description, buttonLabel }) => (React__default.createElement("div", { className: styles$3.layout },
    React__default.createElement("nav", { className: styles$3.navbar },
        React__default.createElement("a", { href: backUrl },
            React__default.createElement(SvgIcon, { name: IconName.LogoBlack, height: 24 }))),
    React__default.createElement("div", { className: styles$3.container },
        React__default.createElement("div", { className: styles$3.errorLogo },
            React__default.createElement(SvgIcon, { name: IconName.ErrorElephant, height: 300 }),
            React__default.createElement("span", { className: styles$3.errorCode }, errorCode)),
        React__default.createElement("section", { className: styles$3.content },
            React__default.createElement("h2", null, title),
            React__default.createElement("p", { className: styles$3.preLine },
                React__default.createElement(HtmlString, null, description)),
            React__default.createElement("p", null,
                React__default.createElement("a", { className: styles$3.backButton, href: backUrl }, buttonLabel))))));

const ServerErrorPage = ({ backUrl }) => (React__default.createElement(ErrorPage, { backUrl: backUrl, errorCode: 503, title: t('internal-server-error.title'), description: t('internal-server-error.description'), buttonLabel: t('action.back-to-the-dashboard') }));

var css_248z$n = ".ToggleButton-module_button__10qat {\n  padding: 5px 8px;\n  border: 1px solid;\n  border-radius: 2px;\n  text-transform: none;\n  font-size: 12px;\n  line-height: 14px;\n  font-weight: normal;\n  font-family: MavenPro-Regular, Maven, Sans, sans-serif; }\n  .ToggleButton-module_button__10qat, .ToggleButton-module_button__10qat:focus {\n    color: #8a95b3;\n    border-color: #8a95b3;\n    background: #f3f4f6; }\n    .ToggleButton-module_button__10qat .ToggleButton-module_icon__2vYQV, .ToggleButton-module_button__10qat:focus .ToggleButton-module_icon__2vYQV {\n      fill: #8a95b3; }\n  .ToggleButton-module_button__10qat:hover {\n    color: #4d567e;\n    border-color: #4d567e;\n    background: #f3f4f6; }\n    .ToggleButton-module_button__10qat:hover .ToggleButton-module_icon__2vYQV {\n      fill: #4d567e; }\n  .ToggleButton-module_button--selected__1qUE3, .ToggleButton-module_button--selected__1qUE3:focus {\n    color: #f3f4f6;\n    border-color: #4d567e;\n    background: #4d567e; }\n    .ToggleButton-module_button--selected__1qUE3 .ToggleButton-module_icon__2vYQV, .ToggleButton-module_button--selected__1qUE3:focus .ToggleButton-module_icon__2vYQV {\n      fill: #f3f4f6; }\n  .ToggleButton-module_button--selected__1qUE3:hover {\n    color: #8a95b3;\n    border-color: #4d567e;\n    background: #4d567e; }\n    .ToggleButton-module_button--selected__1qUE3:hover .ToggleButton-module_icon__2vYQV {\n      fill: #8a95b3; }\n  .ToggleButton-module_button__10qat .ToggleButton-module_icon__2vYQV {\n    width: 12px;\n    margin-right: 5px; }\n";
var styles$4 = {"button":"ToggleButton-module_button__10qat","icon":"ToggleButton-module_icon__2vYQV","button--selected":"ToggleButton-module_button--selected__1qUE3"};
styleInject(css_248z$n);

const ToggleButton = ({ children, isActive, onClick, dataTestId }) => {
    const buttonClasses = classnames({
        [styles$4.button]: true,
        [styles$4['button--selected']]: isActive,
    });
    return (React__default.createElement("button", { className: buttonClasses, onClick: onClick, "data-testid": dataTestId, type: "button" },
        isActive && React__default.createElement(SvgIcon, { name: IconName.Checkmark, className: styles$4.icon }),
        children));
};

export { Alert, AppIcon, AutoConfirmedAlert, BreadcrumbGenericItem, Confirm, ConfirmPassword, CopyClipboard, DebouncedInputField, ErrorPage, FadeTooltip, FieldWithDebounce, FieldWithLabel, HtmlString, IconName, InputField, InputFieldBase, Language, MainMenu, MenuButton, Modal, ModalActions, OverlaySpinner, OverlaySpinnerType, PlatformItem, Platforms, SearchField, SearchFieldWithDebounce, SelectField, SelectFieldFormAdapter, SelectFieldWithLabel, SelectSearchField, SelectSearchFieldWithLabel, ServerErrorPage, SidebarContext, SidebarDirection, SidebarModalType, SimpleSidebar, SvgIcon, Switcher, SwitcherField, Tag, TaggingField, TaggingFieldWithLabel, TileToggle, ToggleButton, Upload, UploadWithLabel, classicRedirectToSuite, ctvStores, getHelpCenterUrl, getParent, getSuiteHost, sanitize, stores, usePrefixId, useTimeoutWhen, webPlatform, withBreadcrumbsContext, withFieldProps, withLoading, withSidebarModal };
